/* eslint-disable */
/* eslint-disable */
/**
 * Auto-generated by GraphQL Code Generator from the texture-supergraph API schema.
 * Do not edit manually; run `yarn codegen` to regenerate.
 */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: number | string; output: number | string; }
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
  Long: { input: string; output: string; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: string; output: string; }
  /** Represents NULL values */
  Void: { input: null; output: null; }
};

/** Input for AI-powered device query using Elasticsearch Query DSL */
export type AiDeviceQueryInput = {
  /** Elasticsearch aggregations to perform */
  aggregations?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * When true, this query counts against the per-caller AI query rate limit.
   * Defaults to false: only the Explore AI assistant opts in. Board block
   * resolution and other callers leave this unset and are never rate limited.
   */
  applyRateLimit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Offset for pagination (default: 0) */
  from?: InputMaybe<Scalars['Int']['input']>;
  /** Elasticsearch Query DSL object. The workspace filter is automatically applied. */
  query?: InputMaybe<Scalars['JSON']['input']>;
  /** Maximum number of results to return (default: 20, max: 100) */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Workspace ID to scope the query to (required for security) */
  workspaceId: Scalars['ID']['input'];
};

/** Input for resolving the Texture devices downstream of a set of grid elements. */
export type AiDownstreamDevicesForGridElementsInput = {
  /** Cap on metered leaves scanned per root before device matching (default 500). */
  limitPerRoot?: InputMaybe<Scalars['Int']['input']>;
  /** Root grid elements by their `elementGuid` (gs_guid). Devices anywhere in each root's subtree are returned. */
  rootElementGuids: Array<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for AI-powered grid-element query using Elasticsearch Query DSL. */
export type AiGridElementQueryInput = {
  /** Elasticsearch aggregations to perform. */
  aggregations?: InputMaybe<Scalars['JSON']['input']>;
  /** Offset for pagination (default: 0). */
  from?: InputMaybe<Scalars['Int']['input']>;
  /** Elasticsearch Query DSL object. The workspace filter is applied automatically. */
  query?: InputMaybe<Scalars['JSON']['input']>;
  /** Maximum number of results to return (default: 20, max: 100). */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Elasticsearch sort clauses, e.g. [{ "ratedKva": { "order": "desc" } }]. Script sorts are rejected. */
  sort?: InputMaybe<Scalars['JSON']['input']>;
  /** Workspace ID to scope the query to (required for security). */
  workspaceId: Scalars['ID']['input'];
};

/**
 * Input for an Elasticsearch-backed site aggregation/query. The workspace filter
 * is always applied server-side and cannot be widened by the caller.
 */
export type AiSiteQueryInput = {
  /** Elasticsearch aggregations to perform (e.g. terms, date_histogram, stats) */
  aggregations?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * When true, this query counts against the per-caller AI query rate limit.
   * Defaults to false: only the Explore AI assistant opts in. Board block
   * resolution and other callers leave this unset and are never rate limited.
   */
  applyRateLimit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Offset for pagination (default: 0) */
  from?: InputMaybe<Scalars['Int']['input']>;
  /** Elasticsearch Query DSL object. The workspace filter is automatically applied. */
  query?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Maximum number of document hits to return (default: 20, max: 100). Aggregation
   * blocks typically pass 0 since only buckets/stats are needed.
   */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Workspace ID to scope the query to (required for security) */
  workspaceId: Scalars['ID']['input'];
};

export type AcceptInvitationInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptWorkspaceInvitationInput = {
  invitationId: Scalars['ID']['input'];
};

/** Input for acknowledging command execution by a manufacturer. */
export type AcknowledgeCommandInput = {
  /** The API key ID that is acknowledging this command (for authorization validation). */
  apiKeyId: Scalars['String']['input'];
  /** The unique identifier of the command being acknowledged. */
  commandId: Scalars['ID']['input'];
  /** When the command was actually executed by the manufacturer. */
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional reason or error message, especially for FAILED status. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The execution status of the command (COMPLETED or FAILED). */
  status: CommandAcknowledgmentStatus;
  /** The workspace ID of the requesting API key; used for authorization scoping. */
  workspaceId: Scalars['String']['input'];
};

export type ActorType =
  | 'AGENT'
  | 'HUMAN'
  | 'SYSTEM';

export type AddCanonicalOrganizationContactForAutomationInput = {
  actorId: Scalars['ID']['input'];
  automation: ContactAutomationInput;
  canonicalOrganizationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  name: Scalars['NonEmptyString']['input'];
  /** Written only when the contact shows no phone. */
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for `addCanonicalOrganizationContact`. */
export type AddCanonicalOrganizationContactInput = {
  canonicalOrganizationId: Scalars['ID']['input'];
  /** The person's own email address; shared inboxes are refused. */
  email: Scalars['String']['input'];
  /** Display name, used only when the contact has no name yet. */
  name: Scalars['NonEmptyString']['input'];
  /**
   * Optional phone number, stored as the person's manually entered phone (see
   * `setCanonicalContactPhone`). Refused with `INVALID_INPUT`
   * (`extensions.field` = `phone`) when it is not a phone number.
   */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Optional role at the organization; fills a missing role only. */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Optional job title at the organization; fills a missing title only. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AddConferenceAttendanceInput = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  instanceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AttendanceRole>;
  status?: InputMaybe<AttendanceStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddConferenceMilestoneInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  dueDateTz?: InputMaybe<Scalars['String']['input']>;
  dueTime?: InputMaybe<Scalars['String']['input']>;
  instanceId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: MilestoneType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddCorpusIngestSourceMappingInput = {
  crmOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Drive folder id, Slack PUBLIC channel id (`C…`), or Notion data source id. */
  externalId: Scalars['String']['input'];
  kind: CorpusIngestSourceMappingKind;
};

export type AddCrmEventMembersInput = {
  eventId: Scalars['ID']['input'];
  members: Array<CrmEventMemberInput>;
  /** Existing members take the given status (and note, organization) instead of being left as they were. */
  overwriteStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for creating an operator-defined custom field on a lifecycle definition. */
export type AddCustomFieldInput = {
  /** Optional type-specific configuration (e.g., select options) */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Human-readable label */
  displayName: Scalars['String']['input'];
  /** Which entity this field collects data about (CONTACT, SITE, DEVICE, ENROLLMENT) */
  entityType: Scalars['String']['input'];
  /** The data bag key (lowercase snake_case, unique per definition) */
  factKey: Scalars['String']['input'];
  /** The data type (text, email, phone, boolean, number, date, select, etc.) */
  fieldType: Scalars['String']['input'];
  /** The lifecycle definition to scope this field to */
  lifecycleDefinitionId: Scalars['ID']['input'];
};

/** Input type for associating a customer with a device. */
export type AddCustomerToDeviceInput = {
  /** The ID of the customer to associate with the device */
  customerId: Scalars['ID']['input'];
  /** The ID of the device to associate with the customer */
  deviceId: Scalars['ID']['input'];
  /** Where this link came from. Omit it if you cannot name the origin truthfully. */
  source?: InputMaybe<DeclarableClaimSource>;
  /**
   * The row this link came from — a link session, an enrollment, a sync grant, a
   * connection. Free-form because those rows live in different services. Requires
   * `source`: a pointer to an origin we did not name is unreadable.
   */
  sourceRecordId?: InputMaybe<Scalars['String']['input']>;
};

export type AddCustomersToWorkspaceProgramInput = {
  autoAssociateDeviceTypes?: InputMaybe<Array<DeviceType>>;
  customerIds: Array<Scalars['ID']['input']>;
  enrollmentGroupId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for adding an existing device to a workspace */
export type AddDeviceToWorkspaceInput = {
  /** Whether the device is connected (defaults to false) */
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional connection ID that created this device-workspace association */
  connectionId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the canonical device to add */
  deviceId: Scalars['ID']['input'];
  /** External reference ID for the device in this workspace (required) */
  referenceId: Scalars['String']['input'];
  /** Optional site profile ID to associate the device with */
  siteProfileId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional tags to apply to the device */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The workspace to add the device to */
  workspaceId: Scalars['ID']['input'];
};

export type AddRequirementInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The data bag key for this requirement (preferred over slug) */
  factKey?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
};

export type AddRequirementsInput = {
  requirements: Array<AddRequirementsItemInput>;
  stageId: Scalars['ID']['input'];
};

export type AddRequirementsItemInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The data bag key for this requirement (preferred over slug) */
  factKey: Scalars['String']['input'];
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AddSsoExemptionInput = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AddStageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  lifecycleDefinitionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Array<StageRequirementInput>>;
  slug: Scalars['String']['input'];
  transitions?: InputMaybe<Array<StageTransitionInput>>;
  userFacingConfig?: InputMaybe<StageUserFacingConfigInput>;
};

export type AddTagToEnrollmentsInput = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for adding a new transition to a stage */
export type AddTransitionInput = {
  action?: InputMaybe<LifecycleActionInput>;
  /** Criteria rule for this transition (null = default transition) */
  rule?: InputMaybe<Scalars['JSON']['input']>;
  stageId: Scalars['ID']['input'];
  targetStageSlug: Scalars['String']['input'];
};

export type AddUploadToEnrollmentInput = {
  documentType: Scalars['String']['input'];
  enrollmentId: Scalars['String']['input'];
  uploadId: Scalars['ID']['input'];
};

export type AddVirtualSiteEventsInput = {
  events: Array<VirtualSiteEventInput>;
  siteId: Scalars['ID']['input'];
  workspaceId: Scalars['String']['input'];
};

export type AddWorkspaceSystemConnectionInput = {
  customerId: Scalars['ID']['input'];
  manufacturer: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  systemId: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type Address = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetOne: Scalars['String']['input'];
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetOne: Scalars['String']['input'];
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCreateInvitationInput = {
  email: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  role: Role;
  /**
   * Teams to assign the invitee to on acceptance. Optional (omit or empty →
   * GENERAL). Validated same-org server-side against organizationId.
   */
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * How an `adminDeviceByAnyId` lookup matched the input ID. Mirrors the
 * resolver's lookup order; new fallbacks should be appended.
 */
export type AdminDeviceMatchedVia =
  | 'BATCH_ID'
  | 'COMMAND_ID'
  | 'DEVICE_ID'
  | 'DEVICE_ON_WORKSPACE_ID'
  | 'MANUFACTURER_DEVICE_ID'
  | 'MANUFACTURER_USER_ID';

export type AdminWorkspacesInput = {
  /** Specify at most one sort field. Defaults to createdAt descending. */
  orderBy?: InputMaybe<WorkspacesOrderBy>;
  /** Defaults to page 1 and 20 workspaces; perPage must be between 1 and 100. */
  pagination?: InputMaybe<OffsetPagination>;
  personal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Partial, case-insensitive match on workspace ID/name or organization name/domain. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdvanceStageInput = {
  instanceId: Scalars['ID']['input'];
};

export type AffiliateCanonicalContactForAutomationInput = {
  actorId: Scalars['ID']['input'];
  automation: ContactAutomationInput;
  canonicalContactId: Scalars['ID']['input'];
  canonicalOrganizationId: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateCanonicalContactInput = {
  canonicalContactId: Scalars['ID']['input'];
  canonicalOrganizationId: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** One affiliation row's editable values. */
export type AffiliationRowValuesInput = {
  affiliationId: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleSource?: InputMaybe<ContactDataSource>;
};

export type AgentEvalRunFilter = {
  /** Runs that included this agent. */
  agent?: InputMaybe<Scalars['String']['input']>;
  /** Runs that included this workspace profile. */
  workspace?: InputMaybe<Scalars['String']['input']>;
};

export type AgentEvalRunsInput = {
  /** Opaque cursor from a previous page's `pageInfo.endCursor`. Runs are newest first. */
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AgentEvalRunFilter>;
  /** Number of records to return (max 200, default 50). */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Binary explicit feedback on one response. Two points rather than a scale
 * because a five-point rating of a chat answer collapses to its endpoints in
 * practice, leaving three of the five carrying no signal.
 */
export type AgentExchangeRating =
  | 'DOWN'
  | 'UP';

/**
 * One provider API call. A single user question fans out to as many of these as the
 * agent's tool loop needed, grouped into one exchange by exchangeSeq.
 */
export type AgentModelCallInput = {
  /** UniversalAgentAction objects; not present in provider content blocks or tool results. */
  actions?: InputMaybe<Scalars['JSON']['input']>;
  /** The visible assistant text with block fences stripped. The queryable projection. */
  assistantText?: InputMaybe<Scalars['String']['input']>;
  cacheCreationTokens: Scalars['Int']['input'];
  cacheReadTokens: Scalars['Int']['input'];
  /** Provider-native content blocks, verbatim and fences included. The fidelity record. */
  content: Scalars['JSON']['input'];
  errorClass?: InputMaybe<Scalars['String']['input']>;
  exchangeSeq: Scalars['Int']['input'];
  /** How many history messages the route's alternation repair discarded before this call. */
  historyDropped: Scalars['Int']['input'];
  inputTokens: Scalars['Int']['input'];
  iteration: Scalars['Int']['input'];
  latencyMs?: InputMaybe<Scalars['Int']['input']>;
  occurredAt: Scalars['DateTime']['input'];
  outputTokens: Scalars['Int']['input'];
  route: Scalars['NonEmptyString']['input'];
  stopReason?: InputMaybe<Scalars['String']['input']>;
  toolErrorCount: Scalars['Int']['input'];
  toolNames: Array<Scalars['String']['input']>;
  toolResults?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * The caller clipped an over-long history message before this call. Describes the
   * caller's own input, never what we stored — the storage-side fact is reported
   * back as `AgentModelCall.payloadTruncated`, which this service decides.
   */
  truncated: Scalars['Boolean']['input'];
  /** Only set on iteration 0 — later iterations are tool round-trips with no new user input. */
  userText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Filters for `agentSessions`.
 *
 * `workspaceId` and `route` resolve against AgentModelCall, never AgentSession. A
 * conversation survives a workspace switch, so the session's own workspace is only
 * where it started — filtering on it would file one workspace's tool output, which
 * is raw device and customer rows, under a different workspace's heading.
 */
export type AgentSessionFilter = {
  /** True selects sessions whose newest exchange failed; false selects those that did not. */
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sessions with at least one call on this route. Combined with workspaceId, both
   * must hold for the *same* call — "what was asked on /explore in workspace X",
   * not "touched /explore at some point and workspace X at some other point".
   */
  route?: InputMaybe<Scalars['String']['input']>;
  startedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  surface?: InputMaybe<AgentSurface>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Sessions with at least one call scoped to this workspace. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Only sessions where no call carried a workspace — the platform questions asked
   * with nothing selected. Composes with `route`, so "asked on /explore with nothing
   * selected" is answerable. Ignored only when `workspaceId` is also set, which
   * contradicts it outright.
   */
  workspaceless?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgentSessionOrderBy = {
  direction?: PaginatedQueryOrderBy;
  field?: AgentSessionOrderField;
};

/**
 * Session rollups a list can be ordered by. Every value is a column on the session
 * row, so ordering never touches the calls table.
 */
export type AgentSessionOrderField =
  /** Provider calls across every exchange, including tool-loop iterations. */
  | 'CALL_COUNT'
  /** User questions in the conversation. */
  | 'EXCHANGE_COUNT'
  | 'INPUT_TOKENS'
  /** When the newest exchange was recorded. */
  | 'LAST_TURN_AT'
  | 'OUTPUT_TOKENS'
  /** When the conversation began. */
  | 'STARTED_AT';

export type AgentSessionsInput = {
  /**
   * Opaque cursor from a previous page's `pageInfo.endCursor`. A cursor is only
   * meaningful under the `orderBy` it was minted with; change the order and start
   * again from the first page.
   */
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AgentSessionFilter>;
  /** Number of records to return (max 200, default 50). */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Defaults to newest conversation first. */
  orderBy?: InputMaybe<AgentSessionOrderBy>;
};

export type AgentSurface =
  | 'UNIVERSAL_AGENT';

/** Options for aggregating metric data across devices. */
export type AggregationOptions = {
  /**
   * Include count of devices that contributed data to each bucket.
   * Useful for participation tracking in program reporting.
   */
  includeDeviceCounts?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Board facet request: the registry field paths to fetch distinct values for.
 * Only the domain's terms-aggregatable columns are honored; other fields are ignored.
 */
export type AlertBoardFacetsInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** Alert date columns a time facet can bucket on via `date_trunc`. */
export type AlertDateField =
  | 'acknowledgedAt'
  | 'createdAt'
  | 'resolvedAt'
  | 'updatedAt';

/**
 * Terms-aggregatable alert columns for a facet `GROUP BY` (mirrors the MR-1
 * registry `categoryFields`). Exactly one of `field` or `dateField` is supplied
 * on an `AlertFacetInput`.
 */
export type AlertFacetField =
  | 'deviceId'
  | 'severity'
  | 'sourceSystem'
  | 'status'
  | 'subtype'
  | 'type';

/**
 * A single alert facet request. Provide EITHER a terms `field` (optionally
 * capped by `limit`) OR a `dateField` together with an `interval`; supplying
 * both, or neither, is rejected. The optional filter fields mirror
 * `AlertsFilter` so a chart or KPI scopes to the same population as the list.
 */
export type AlertFacetInput = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  dateField?: InputMaybe<AlertDateField>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<AlertFacetField>;
  interval?: InputMaybe<DateInterval>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Severity>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
  subtype?: InputMaybe<AlertSubtype>;
  type?: InputMaybe<AlertType>;
  workspaceId: Scalars['String']['input'];
};

export type AlertGroupsFilter = {
  monitorId?: InputMaybe<Scalars['ID']['input']>;
  requiresAction?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type AlertGroupsInput = {
  filter: AlertGroupsFilter;
  pagination?: InputMaybe<ListPagination>;
};

export type AlertOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type AlertSubtype =
  | 'BATTERY_FAULT'
  | 'BATTERY_METER_COMMS'
  | 'CONTACTOR_FAULT'
  | 'CONTROL_AGENT_CRASHED'
  | 'EXCESSIVE_VOLTAGE_DROP'
  | 'EXTERNAL_SWITCH_SHUTDOWN'
  | 'FREQUENCY_DEVIATION'
  | 'GENERATOR_FAULT'
  | 'GPIO_SHUTDOWN'
  | 'GRID_FOLLOWING'
  | 'GRID_FORMING'
  | 'GRID_RESYNC_FAILED'
  | 'INVERTER_COMMS'
  | 'INVERTER_FAULT'
  | 'LOW_SOE'
  | 'METER_DISCONNECTED'
  | 'OPTICASTER_EXE_FAILED'
  | 'PERFORMANCE_BELOW_EXPECTATION'
  | 'POWER_FACTOR_LIMITED'
  | 'PV_INVERTER_COMMS'
  | 'RAMP_RATE_LIMITED'
  | 'SITE_CONTROLLER_COMMS'
  | 'SITE_MAX_LIMITED'
  | 'SITE_MIN_LIMITED'
  | 'SLEEP_MODE'
  | 'TEMPERATURE_SENSOR_FAULT'
  | 'WAIT_FOR_SOLAR';

export type AlertType =
  | 'COMMUNICATIONS'
  | 'CONFIGURATION'
  | 'FIRMWARE_UPDATE'
  | 'GENERATOR'
  | 'GRID_STATUS'
  | 'HARDWARE_FAULT'
  | 'ISLANDING'
  | 'PERFORMANCE_DEGRADED'
  | 'POWER_LIMIT'
  | 'SAFETY'
  | 'SENSOR'
  | 'SITE_LEVEL'
  | 'SOFTWARE_PROCESS'
  | 'STATE_OF_ENERGY'
  | 'SYSTEM_SHUTDOWN'
  | 'TEMPERATURE'
  | 'UNKNOWN'
  | 'VOLTAGE_FREQUENCY';

export type AlertsFilter = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Only alerts in this alert group. */
  groupId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  manufacturerDeviceId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether the alert's monitor asks for someone to act on it. The alerts page
   * filters on true by default; the device page and the map do not filter on it.
   */
  requiresAction?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<Severity>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
  subtype?: InputMaybe<AlertSubtype>;
  type?: InputMaybe<AlertType>;
  workspaceId: Scalars['String']['input'];
};

export type AlertsInput = {
  filter: AlertsFilter;
  orderBy?: InputMaybe<AlertOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
};

/** Filter options for all users query */
export type AllUsersFilter = {
  /** Filter by Texture employee status */
  isTextureEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by email or name (partial match) */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input for querying all users */
export type AllUsersInput = {
  filter?: InputMaybe<AllUsersFilter>;
  pagination?: InputMaybe<ListPagination>;
};

export type ApiKeyCredentialsInput = {
  apiKey: Scalars['String']['input'];
  connectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRole =
  | 'ADMIN'
  | 'VIEWER';

export type ApiKeyType =
  | 'API'
  | 'CONNECT'
  | 'MANAGEMENT'
  | 'MANUFACTURER'
  | 'SCOPED'
  | 'SERVER';

export type ApiKeysFilter = {
  workspaceId: Scalars['ID']['input'];
};

export type ApiKeysInput = {
  filter: ApiKeysFilter;
  pagination?: InputMaybe<ListPagination>;
};

/** App categories for organization and filtering */
export type AppCategory =
  | 'CRM'
  | 'DEVICE_DATA'
  | 'EMISSIONS'
  | 'GIS'
  | 'GRID_SERVICES'
  | 'MARKET_ACCESS'
  | 'METER_DATA_MANAGEMENT'
  | 'PERMITS'
  | 'REBATES_AND_INCENTIVES'
  | 'SITE_INTELLIGENCE'
  | 'TEXTURE_APPS'
  | 'UTILITY_DATA'
  | 'WEATHER';

/** App provider types */
export type AppProvider =
  | 'FIRST_PARTY'
  | 'THIRD_PARTY';

export type AppProvidersForWorkspacesInput = {
  providers: Array<Scalars['String']['input']>;
  workspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AppProvidersOptions = {
  concealCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for applying a cached AI suggestion to a staged record issue. */
export type ApplyAiSuggestionInput = {
  /** The ID of the issue to apply the suggestion for. */
  issueId: Scalars['ID']['input'];
  /** The ID of the staged record the issue belongs to. */
  recordId: Scalars['ID']['input'];
};

/** Input for approving an organization access request */
export type ApproveOrganizationAccessRequestInput = {
  /** The role to assign to the user upon approval */
  assignedRole: Role;
  /** The token of the request to approve */
  token: Scalars['String']['input'];
};

export type ApproveOrganizationDomainInput = {
  /** A domain this organization has claimed and not yet verified. */
  domain: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  /**
   * Why the claim is approved without DNS proof (1-500 characters); kept with the approval and shown in the
   * organization's audit log.
   */
  reason: Scalars['String']['input'];
};

export type ArithmeticFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type AsPaginatedQueryOptions = {
  type?: InputMaybe<PaginationType>;
};

export type AssignCanonicalOrganizationTerritoryInput = {
  /** The `CanonicalOrganization` to attach the claim to. */
  canonicalOrganizationId: Scalars['ID']['input'];
  /**
   * CommonGrid `Utility.slug`, as returned by `commonGridUtilitySearch`. The sole
   * identity input to an assignment.
   *
   * The utility's UUID, display name, EIA id, territory slug and bounding box are
   * all resolved server-side from this slug. An earlier revision also accepted the
   * UUID and the display name; it was removed because accepting both identifiers
   * independently let a caller pair one utility's stable id with another utility's
   * territory, and the live-utility unique index would then block assigning the
   * correct row until the corrupted one was revoked.
   */
  commonGridUtilitySlug: Scalars['String']['input'];
  /**
   * Force this claim to become the primary, demoting the current one. Omit and a
   * claim becomes primary only when the organization has none — so the first
   * assignment frames the map and a later one does not silently move it.
   *
   * Setting it on a utility this organization ALREADY claims promotes that
   * existing claim and returns `PROMOTED_TO_PRIMARY`. That is the only way to
   * change which territory is primary; there is no separate primary-setting
   * mutation.
   */
  makePrimary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignCanonicalOrganizationTerritoryOutcome =
  /** This organization already holds a live claim on this utility. Nothing written. */
  | 'ALREADY_ASSIGNED'
  /** A new live claim was inserted. */
  | 'ASSIGNED'
  /** No such CanonicalOrganization, after following its merge chain. */
  | 'CANONICAL_NOT_FOUND'
  /**
   * This organization already held a live claim on this utility, and
   * `makePrimary` promoted it. No new row was written.
   */
  | 'PROMOTED_TO_PRIMARY'
  /** CommonGrid has no utility for this slug. */
  | 'UTILITY_NOT_FOUND';

export type AttachToTicketInput = {
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
  ticketId: Scalars['ID']['input'];
  visibility: TicketAttachmentVisibility;
};

export type AttendanceRole =
  | 'ATTENDEE'
  | 'EXHIBITOR'
  | 'ORGANIZER'
  | 'SPEAKER'
  | 'SPONSOR';

export type AttendanceStatus =
  | 'ATTENDED'
  | 'CANCELLED'
  | 'CONFIRMED'
  | 'NO_SHOW'
  | 'PLANNED'
  | 'REGISTERED';

/**
 * Input for querying audit logs via user authentication.
 * Requires the user to be an admin of the specified organization.
 */
export type AuditLogsInput = {
  /** Filter by action type (e.g., 'workspace.create', 'apiKey.revoke'). */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Filter by actor ID (userId or apiKeyId). */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by actor type ('user' or 'apiKey'). */
  actorType?: InputMaybe<Scalars['String']['input']>;
  /** Only return logs created on or before this date (ISO 8601). */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The organization to query audit logs for. Must match the authenticated user's organization. */
  organizationId: Scalars['String']['input'];
  /** Page number (1-indexed). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Results per page. Defaults to 50, max 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by specific resource ID. */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by resource type (e.g., 'Workspace', 'ApiKey'). */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Only return logs created on or after this date (ISO 8601). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthProviderLogsInput = {
  pagination?: InputMaybe<ListPagination>;
};

/** Authentication types supported by apps */
export type AuthType =
  | 'API_KEY'
  | 'BASIC_AUTH'
  | 'CUSTOM'
  | 'OAUTH2';

export type AuthenticateByApiKeyInput = {
  apiKey: Scalars['String']['input'];
};

export type AuthenticateByEmailPasswordInput = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

/** Input for querying auto-fix log (issue.auto_resolved events). */
export type AutoFixLogInput = {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by fix type: "rule" or "ai" (matches metadata.fixType). */
  fixType?: InputMaybe<Scalars['String']['input']>;
  /** Scope results to a single staged record issue. */
  issueId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Scope results to a single staged record. Used by the review detail panel
   * to batch-fetch `issue.auto_resolved` events for every issue on a record in
   * a single query.
   */
  recordId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for backfill of device states */
export type BackfillDeviceStateInput = {
  /** Reason for archiving existing data (for audit trail) */
  archiveReason?: InputMaybe<Scalars['String']['input']>;
  /** Battery state data points (for battery devices only) */
  batteryStates?: InputMaybe<Array<BatteryStateInput>>;
  /** End of the time range to replace (exclusive) */
  endDate: Scalars['DateTime']['input'];
  /** Inverter state data points (for inverter devices only) */
  inverterStates?: InputMaybe<Array<InverterStateInput>>;
  /** The device manufacturer slug (e.g., "franklinwh", "tesla") */
  manufacturer: Scalars['String']['input'];
  /** The manufacturer's device ID (unique per manufacturer) */
  manufacturerDeviceId: Scalars['String']['input'];
  /**
   * Refresh continuous aggregates after insert (default: false).
   * For bulk operations, leave false and refresh CAGGs once at the end via /admin/cagg/refresh.
   */
  refreshCaggs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start of the time range to replace (inclusive) */
  startDate: Scalars['DateTime']['input'];
  /** Thermostat state data points (for thermostat devices only) */
  thermostatStates?: InputMaybe<Array<ThermostatStateInput>>;
};

export type BatchSourceInput = {
  tagScheduleId?: InputMaybe<Scalars['String']['input']>;
  workspaceProgramEventId?: InputMaybe<Scalars['String']['input']>;
};

export type BatchStatus =
  | 'active'
  | 'completed'
  | 'draft'
  | 'pending';

export type BatteryBatchCommandInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  setBatteryReserve?: InputMaybe<SetBatteryReserveInput>;
  setOperatingMode?: InputMaybe<SetBatteryOperatingModeInput>;
  slug: BatteryCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type BatteryChargingState =
  | 'charging'
  | 'discharging'
  | 'idle'
  | 'unknown';

export type BatteryCommandInput = {
  id: Scalars['ID']['input'];
  setBatteryReserve?: InputMaybe<SetBatteryReserveInput>;
  setOperatingMode?: InputMaybe<SetBatteryOperatingModeInput>;
  slug: BatteryCommandSlug;
};

export type BatteryCommandSlug =
  | 'battery_set_operating_mode'
  | 'battery_set_reserve';

export type BatteryIntervalEnergyDataInput = {
  intervalEnd: Scalars['DateTime']['input'];
  intervalStart: Scalars['DateTime']['input'];
  mappings: Array<MeterDeviceMappingInput>;
  /**
   * Ceiling on one interval's absolute energy, in kWh. Overrides the per-device ceiling derived
   * from each battery's rated power. Leave unset in normal use — one number cannot be right for
   * a fleet mixing 8 kW and 12 kW packs.
   */
  maxIntervalKwh?: InputMaybe<Scalars['Float']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** Battery state input. Matches BatteryState DB schema. */
export type BatteryStateInput = {
  backupReserve?: InputMaybe<Scalars['Float']['input']>;
  charge: Scalars['Float']['input'];
  chargePercentage: Scalars['Float']['input'];
  chargeRate?: InputMaybe<Scalars['Float']['input']>;
  chargingState: BatteryChargingState;
  createdAt: Scalars['DateTime']['input'];
  gridEnergy?: InputMaybe<Scalars['Int']['input']>;
  gridPower?: InputMaybe<Scalars['Int']['input']>;
  gridStatus?: InputMaybe<GridStatus>;
  isStormModeActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStormModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  loadEnergy?: InputMaybe<Scalars['Float']['input']>;
  loadPower?: InputMaybe<Scalars['Float']['input']>;
  strategy?: InputMaybe<BatteryStrategy>;
  whConsumed?: InputMaybe<Scalars['Float']['input']>;
};

export type BatteryStrategy =
  | 'backup'
  | 'self_consumption'
  | 'time_of_use'
  | 'unknown';

export type BeginRelayAgentTurnInput = {
  /** A uuid; a retry with the same value returns the same turn. */
  clientTurnId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  model: Scalars['String']['input'];
  promptVersion: Scalars['String']['input'];
  scopeOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
  uploadIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BillingPortalSessionInput = {
  organizationId: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Where a blocker attribute originates from. */
export type BlockerSource =
  /** Attribute provided by user input (form fields) */
  | 'REQUIREMENT'
  /** Attribute resolved by platform systems (device checks, account validation) */
  | 'SYSTEM';

/** Who owns a board, and therefore who may see and edit it. */
export type BoardOwnerType =
  /** An organization. Every member sees it; admins, the organization owner and its creator edit it. */
  | 'ORGANIZATION'
  /** A team. Every member sees and edits it. */
  | 'TEAM'
  /** One user. Only they see and edit it. */
  | 'USER';

/** Which status a bulk change applies. Snoozing and reopening stay per alert. */
export type BulkAlertAction =
  | 'ACKNOWLEDGE'
  | 'RESOLVE';

/** Input for bulk-applying cached AI suggestions across one or more staged records. */
export type BulkApplyAiSuggestionsInput = {
  /**
   * Minimum confidence required for a suggestion to be applied. Omit to use
   * the workspace's configured AI threshold (falling back to the platform
   * default of 0.85). A suggestion with `confidence < minConfidence` is
   * silently skipped rather than reported as an error.
   */
  minConfidence?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Staged record IDs to apply Smart Fix to. All records must belong to
   * workspaces the caller has write access on.
   */
  recordIds: Array<Scalars['ID']['input']>;
};

/**
 * Which alerts a bulk status change covers. The parts are ANDed. At least one of
 * groupId, ids, or a full createdAfter + createdBefore range is required, so a
 * request can never cover a whole workspace by accident.
 */
export type BulkChangeAlertStatusInput = {
  action: BulkAlertAction;
  /** Inclusive bounds on when the alert was raised. */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Every alert one evaluation run created. */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** Specific alerts, such as a selection on the alerts page. At most 5,000. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** The rows to import. Exactly one branch must be set. */
export type BulkImportDataInput = {
  /** Row objects keyed by the profile's field names. At most 1,000 per call. */
  rows?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** A file landed through `POST /v1/bulk-upload/uploads`. Not implemented yet. */
  uploadJobId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkImportJobStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'PROCESSING';

/**
 * Where a programmatic import came from, e.g. type "franklinwh-device-sync", key "<workspaceId>:2026-09-30".
 * The pair is the idempotency key for `startBulkImport` within a workspace.
 */
export type BulkImportOriginInput = {
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type BulkMeterTelemetryInput = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  /** FIVE_MINUTES is not supported (raw, unbounded); use FIFTEEN_MINUTES or coarser. */
  bucketSize: TelemetryBucketSize;
  /**
   * Per-bucket statistic, mirroring telemetryQuery's bucketStat (default AVG). Energy metrics
   * (e.g. kwh_usage) MUST pass SUM: a CAGG bucket folds multiple raw readings, so AVG understates
   * per-bucket energy by the reading count. LATEST is raw-only and unsupported here.
   */
  bucketStat?: InputMaybe<TelemetryBucketStat>;
  /**
   * A page of DeviceOnWorkspace ids to fetch. Page the fleet in chunks — a per-call cell budget
   * (meters x metrics x buckets) bounds memory; oversized pages are rejected with BAD_USER_INPUT.
   */
  deviceOnWorkspaceIds: Array<Scalars['ID']['input']>;
  /** Canonical metric names from the Metric table (e.g. kwh_usage, kvarh_usage). */
  metrics: Array<Scalars['String']['input']>;
  /** Workspace whose meters to read. Authorization is enforced against this workspace. */
  workspaceId: Scalars['ID']['input'];
};

/** Input for bulk reviewing (approving or rejecting) multiple staged records. */
export type BulkReviewStagedRecordsInput = {
  action: Scalars['String']['input'];
  recordIds: Array<Scalars['ID']['input']>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
};

export type CancelBatchCommandInput = {
  batchId: Scalars['ID']['input'];
};

export type CancelCommandInput = {
  commandId: Scalars['ID']['input'];
};

export type CancelWorkspaceInvitationInput = {
  invitationId: Scalars['ID']['input'];
};

export type CancelWorkspaceProgramEventDispatchInput = {
  dispatchId: Scalars['ID']['input'];
};

/**
 * What one cancel attempt established.
 *
 * The discriminant answers "what is true now", not "did the call succeed" — an
 * operator acts on these differently, which is why they are reported rather than
 * collapsed into an error. **No member of this enum means the event has stopped.**
 */
export type CancelWorkspaceProgramEventDispatchOutcome =
  /**
   * The provider accepted. The event is **stopping, not stopped**: the vendor
   * documents a delay between accepting a cancellation and it reaching devices, so
   * the dispatch moves to `canceling` and the poll confirms `canceled`. The window
   * reservation stays held until it does.
   */
  | 'CANCELING'
  /**
   * Another attempt owns this cancel and will report its own outcome. Not the same
   * as nothing happening — the event may be stopping right now.
   */
  | 'NOT_AUTHORITATIVE'
  /** The adapter refused to ask. Nothing changed; the event is still running. */
  | 'REFUSED'
  /** The provider refused the stop. Nothing changed; the event is still running. */
  | 'REJECTED'
  /**
   * The stop may or may not have landed. The dispatch is moved to `canceling` and
   * polled immediately, because the poll settles it in either direction — it writes
   * `canceled` if the stop arrived, and maps the vendor's live state back over
   * `canceling` if it did not.
   */
  | 'UNDETERMINED'
  /**
   * Provably nothing was sent, so the event is untouched and **still running**.
   * The dispatch is unchanged and the attempt can simply be repeated.
   */
  | 'UNREACHABLE';

export type CancelWorkspaceProgramEventInput = {
  workspaceProgramEventId: Scalars['ID']['input'];
};

/**
 * Affiliation block accepted by `ensureCanonicalContactByEmail`. Mirrors the
 * write shape of the ThirdParty dual-write path so backfills (e.g. the TAOS
 * Notion contacts import) can link a contact to its organization in one call.
 */
export type CanonicalContactAffiliationInput = {
  /**
   * CanonicalOrganization id for the same organization — the durable link,
   * covering prospects as well as customers. Stamped on the affiliation row so
   * canonical-org reads do not need the legacy `organizationId` bridge. Required
   * when `organizationId` is omitted.
   */
  canonicalOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Whether the contact takes part in CORD through this organization. Only
   * `true` has an effect: it sets the flag on a new affiliation and moves a
   * matched active affiliation's flag from false to true. `false` or null never
   * clears it.
   */
  cordMember?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional identity Organization id the contact is affiliated with — the
   * legacy bridge column, which only customer/tenant organizations have. It must
   * be a real `identity.Organization` id: a domain's own organization key (e.g.
   * crm's `commongrid:…` / `canonical:…` `CrmOrganization.organizationId`) is NOT
   * one and must be omitted here. At least one of `organizationId` /
   * `canonicalOrganizationId` is required; supplying neither fails with
   * `extensions.code = INVALID_INPUT`.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When true, `title` replaces a different title that the same `source`
   * recorded on one of the contact's active affiliations with the organization
   * (the one whose title is reported). A title another source recorded is never
   * replaced. Defaults to fill-only.
   */
  replaceTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional free-form role at the organization (e.g. `CEO`, `Board
   * Member`). Never overwrites a role already recorded on an active
   * affiliation.
   */
  role?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional job title at the organization. Stored on a new affiliation, and
   * fills the title when none of the contact's active affiliations with the
   * organization holds one; a title already recorded is kept unless
   * `replaceTitle` applies. Blank is treated as absent.
   */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Why `ensureCanonicalContactByEmail` wrote no affiliation. */
export type CanonicalContactAffiliationSkipReason =
  /** A person ended this contact's affiliation with the organization; automated sources never restart it. */
  | 'MANUALLY_ENDED';

/** Filter options for `canonicalContacts`. */
export type CanonicalContactFilter = {
  /** Exact-match filter on any active email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Case-insensitive substring search against firstName, lastName, preferredName,
   * and any active email address.
   */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** When `ensureCanonicalContactByEmail` writes the offered name claim. */
export type CanonicalContactNameClaimPolicy =
  | 'ALWAYS'
  | 'WHEN_UNNAMED';

/** Input for the `canonicalContacts` paginated list query. */
export type CanonicalContactsInput = {
  /** Opaque cursor from a previous page's `pageInfo.endCursor`. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Optional filters. */
  filter?: InputMaybe<CanonicalContactFilter>;
  /** Number of records to return (max 200, default 50). */
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CanonicalOrganizationFilter = {
  /** Exact-match filter on primaryDomain. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Exclude these organization ids. */
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** true: only organizations with an owner; false: only unassigned ones. */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to these organization ids. An explicitly empty list matches nothing. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by one or more lead statuses (any of). */
  leadStatus?: InputMaybe<Array<OrganizationLeadStatus>>;
  /** Filter by one or more lifecycle stages. */
  lifecycleStage?: InputMaybe<Array<OrganizationLifecycleStage>>;
  /** Restrict to organizations owned by this identity user. */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Restrict to organizations bound to this regional business manager (exact match on rbmId). */
  rbmId?: InputMaybe<Scalars['ID']['input']>;
  /** Case-insensitive substring match on displayName, legalName or slug. */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by one or more segment values. `segmentMatch` picks the semantics:
   * ALL (default) keeps organizations carrying every listed segment, ANY keeps
   * those carrying at least one.
   */
  segment?: InputMaybe<Array<OrganizationSegment>>;
  /** How `segment` combines its values; ALL when omitted. */
  segmentMatch?: InputMaybe<CanonicalOrganizationSegmentMatch>;
  /** Filter by one or more operational statuses. */
  status?: InputMaybe<Array<OrganizationStatus>>;
  /** Filter by one or more organization types. */
  type?: InputMaybe<Array<OrganizationType>>;
};

/**
 * Optional create-time attributes for a find-or-create call. Best-effort
 * projection inputs only — the authoritative truth for any multi-source
 * field still flows through the source-event log and the resolution
 * policy. Ignored on a match.
 */
export type CanonicalOrganizationHintsInput = {
  /** Display name for the projection on create. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Formal entity name when known. */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Hot-read primary domain pointer on create. */
  primaryDomain?: InputMaybe<Scalars['String']['input']>;
};

export type CanonicalOrganizationSalesStatus =
  | 'CUSTOMER'
  | 'DISQUALIFIED'
  | 'NONE'
  | 'PARTNER'
  | 'PROSPECT'
  | 'QUALIFIED';

/** How a multi-value segment filter combines its values. */
export type CanonicalOrganizationSegmentMatch =
  /** The organization must carry every listed segment. */
  | 'ALL'
  /** The organization must carry at least one listed segment. */
  | 'ANY';

export type CanonicalOrganizationSort =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DISPLAY_NAME_ASC'
  | 'UPDATED_AT_DESC';

export type CanonicalOrganizationsInput = {
  /** Opaque cursor from a previous page's `pageInfo.endCursor`. */
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CanonicalOrganizationFilter>;
  /** Number of records to return (max 200, default 50). */
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CanonicalOrganizationSort>;
};

export type CaptureLifecycleDataInput = {
  data: Scalars['JSON']['input'];
  instanceId: Scalars['ID']['input'];
};

export type ChangeAlertStatusInput = {
  acknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  ignore?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for querying change log (promotions and data updates). */
export type ChangeLogInput = {
  /** Scope results to a single staged batch. */
  batchId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  /** Scope results to a single staged record. */
  recordId?: InputMaybe<Scalars['ID']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type ChangePasswordInput = {
  email: Scalars['String']['input'];
};

export type ChargerBatchCommandInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  setOperatingMode?: InputMaybe<SetChargerOperatingModeInput>;
  slug: ChargerCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type ChargerCommandInput = {
  id: Scalars['ID']['input'];
  setOperatingMode?: InputMaybe<SetChargerOperatingModeInput>;
  slug: ChargerCommandSlug;
};

export type ChargerCommandSlug =
  | 'charger_set_operating_mode';

/** Lifecycle state of an EV charging session. */
export type ChargingSessionStatus =
  | 'ACTIVE'
  | 'COMPLETED'
  | 'ERROR'
  | 'INTERRUPTED'
  | 'SCHEDULED'
  | 'SYNTHETICALLY_CLOSED';

/**
 * Where a stored claim came from, as recorded. The full stored set, unlike
 * `DeclarableClaimSource`: a reader sees every value, including `BACKFILL` and
 * `AUTO_LINK`. Absent (null) means no origin was recorded — "unknown, do not trust".
 */
export type ClaimSource =
  | 'AUTO_LINK'
  | 'BACKFILL'
  | 'BULK_IMPORT'
  | 'CONNECT_FLOW'
  | 'ENROLLMENT'
  | 'MANUAL_API';

export type ClearWorkspaceInput = {
  /** The ID of the workspace to clear */
  workspaceId: Scalars['ID']['input'];
};

/** The type of entity that created a collection */
export type CollectionCreatedByType =
  | 'API_KEY'
  | 'USER';

/** Input for collection criteria */
export type CollectionCriteriaInput = {
  /** The rules that define what should be included in the collection */
  filters: Array<CollectionRuleInput>;
};

export type CollectionCriteriaInputV2 = {
  /** For a nested AND group. The array contains more criteria inputs. */
  and?: InputMaybe<Array<CollectionCriteriaInputV2>>;
  /** For a nested OR group. The array contains more criteria inputs. */
  or?: InputMaybe<Array<CollectionCriteriaInputV2>>;
  /** For a simple leaf node rule. Use this OR one of the logical operators below. */
  rule?: InputMaybe<CollectionRuleInput>;
};

/** Error codes specific to collection operations */
export type CollectionErrorCode =
  | 'COLLECTION_NOT_FOUND'
  | 'DUPLICATE_NAME'
  | 'INVALID_CRITERIA'
  | 'INVALID_INPUT'
  | 'UNAUTHORIZED';

export type CollectionMembershipsPaginationInput = {
  pagination?: InputMaybe<ListPagination>;
};

/** Input for a collection rule */
export type CollectionRuleInput = {
  /** The field to apply the rule to */
  attribute: Scalars['String']['input'];
  /** The operator to use for comparison */
  operator: CollectionRuleOperator;
  /** The value to compare against */
  value: Scalars['JSON']['input'];
};

/** The operators available for collection rules */
export type CollectionRuleOperator =
  | 'EQUALS'
  | 'IN'
  | 'NOT_EQUALS';

/** The type of entity constituting the collection */
export type CollectionType =
  | 'CUSTOMER'
  | 'DEVICE'
  | 'SITE';

/** Filter criteria for collections */
export type CollectionsFilter = {
  /** Optional collection types to filter by */
  collectionType?: InputMaybe<Array<CollectionType>>;
  /** The workspace ID to filter collections by */
  workspaceId: Scalars['String']['input'];
};

/** Command execution status reported by the manufacturer. */
export type CommandAcknowledgmentStatus =
  /** Command was successfully executed. */
  | 'COMPLETED'
  /** Command execution failed. */
  | 'FAILED';

/**
 * How a command is dispatched.
 *   - ASYNC (default): publish command.issued and return the pending command; the result
 *     is delivered later via a command.executed event.
 *   - SYNC: execute the command synchronously via the OEM adapter and return the resolved
 *     command with its output inline. Currently honoured only for the read-only
 *     vehicle:check-pairing-status command; any other command is dispatched ASYNC.
 */
export type CommandExecutionMode =
  | 'ASYNC'
  | 'SYNC';

export type CommandSlug =
  | 'battery_set_operating_mode'
  | 'battery_set_reserve'
  | 'charger_set_operating_mode'
  | 'thermostat_pause_schedule'
  | 'thermostat_resume_schedule'
  | 'thermostat_set_fan_mode'
  | 'thermostat_set_operating_mode'
  | 'vehicle_check_pairing_status'
  | 'vehicle_set_charge_limit'
  | 'vehicle_set_operating_mode';

export type CommandStatus =
  | 'canceled'
  | 'completed'
  | 'delivered'
  | 'failed'
  | 'pending'
  | 'scheduled';

export type ComposeWorkspaceProgramEventDispatchInput = {
  populationMode: DispatchPopulationMode;
  providerConfig?: InputMaybe<Scalars['JSON']['input']>;
  workspaceProgramEventId: Scalars['ID']['input'];
  workspaceProgramIntegrationId: Scalars['ID']['input'];
};

export type ConferenceAttendancesInput = {
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  role?: InputMaybe<AttendanceRole>;
  status?: InputMaybe<AttendanceStatus>;
};

export type ConferenceAttendeeCostsInput = {
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
};

export type ConferenceInstanceStatus =
  | 'CANCELLED'
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'UPCOMING';

export type ConferenceInstancesInput = {
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  planningStatus?: InputMaybe<ConferencePlanningStatus>;
  status?: InputMaybe<ConferenceInstanceStatus>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ConferencePhase =
  | 'ANNOUNCED'
  | 'CALL_FOR_CONTENT'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'REGISTRATION_OPEN'
  | 'UPCOMING';

export type ConferencePlanningStatus =
  | 'ATTENDING'
  | 'ATTENDING_SPEAKING'
  | 'AWAITING_COMMITTEE'
  | 'NOT_ATTENDING'
  | 'RESEARCHING'
  | 'TBD';

export type ConferenceRegion =
  | 'MIDWEST'
  | 'MOUNTAIN_WEST'
  | 'NATIONAL'
  | 'NORTHEAST'
  | 'SOUTH'
  | 'WEST';

export type ConferenceSeriesQueryInput = {
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<ConferenceRegion>;
};

/**
 * @oneOf input: exactly one branch is populated and selects the strategy. The
 * resolver dispatches to the matching strategy handler. Adding a strategy =
 * adding a branch here + a handler module under strategies/<name>/.
 */
export type ConfigureOrganizationSsoInput = {
  okta?: InputMaybe<ConfigureSsoOktaInput>;
  samlp?: InputMaybe<ConfigureSsoSamlpInput>;
};

export type ConfigureSsoOktaInput = {
  /** OIDC client ID from the Okta OIDC app. */
  clientId: Scalars['String']['input'];
  /** OIDC client secret from the Okta OIDC app. Forwarded to Auth0 and never persisted. */
  clientSecret: Scalars['String']['input'];
  /** Okta tenant domain, e.g. "acme.okta.com" (without protocol). */
  domain: Scalars['String']['input'];
  /** One or more email domains owned by this organization. */
  domains: Array<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};

export type ConfigureSsoSamlpInput = {
  /** One or more email domains owned by this organization. */
  domains: Array<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  signInUrl: Scalars['String']['input'];
  signOutUrl?: InputMaybe<Scalars['String']['input']>;
  /** PEM-encoded X.509 signing certificate (textarea paste from IdP). */
  signingCert: Scalars['String']['input'];
};

export type ConnectLinkMode =
  | 'HEADLESS'
  | 'STANDARD';

export type ConnectSessionStatus =
  | 'AUTHORIZING_MANUFACTURER'
  | 'DUPLICATE_CONNECTION'
  | 'ENTERING_CUSTOMER_INFO'
  | 'ENTERING_SYSTEM_INFO'
  | 'ERROR'
  | 'EXPIRED'
  | 'EXTERNAL_ACTION'
  | 'PENDING'
  | 'SELECTING_MANUFACTURER'
  | 'STARTED'
  | 'SUCCESS'
  | 'UNSUPPORTED_MANUFACTURER';

export type ConnectSessionsFilterInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ConnectSessionStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type ConnectSessionsInput = {
  filter: ConnectSessionsFilterInput;
  orderBy?: InputMaybe<ConnectSessionsOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
};

export type ConnectSessionsOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type ConnectionMethodKind =
  | 'CREDENTIALS'
  | 'OAUTH'
  | 'SYSTEM_IDENTIFIER';

export type ConnectionMethodsInput = {
  /** Base manufacturer slugs. Defaults to every manufacturer shown in Connect. */
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Read consistency mode for the `device(id)` point-read.
 *
 * - EVENTUAL (default): route to the read replica. Cheap; correct for the vast
 *   majority of read paths; may miss a very recently committed write while the
 *   primary→replica lag is non-zero. This matches CIR-541's routing.
 * - STRICT: route to the primary. Write-adjacent callers that just performed
 *   an upsert and immediately need to read the same row (e.g. identity's
 *   `addCustomerToDevice` verifying the device that apps-api just wrote) must
 *   opt into STRICT to avoid a replica-lag NOT_FOUND (BOLT-1493).
 *
 * Prefer EVENTUAL unless you are read-your-own-write.
 */
export type ConsistencyMode =
  | 'EVENTUAL'
  | 'STRICT';

/** The proposal row an automation contact write applies; the idempotency key with the operation. */
export type ContactAutomationInput = {
  proposalId: Scalars['ID']['input'];
  rowId: Scalars['ID']['input'];
  via: ContactAutomationVia;
};

/** Who asked for an automation contact write. */
export type ContactAutomationVia =
  | 'RELAY_AGENT';

/** Source system that observed a claim. */
export type ContactDataSource =
  | 'AUTH0'
  | 'FORUM'
  | 'HUBSPOT'
  | 'IMPORT'
  | 'INTERCOM'
  | 'MANUAL_ENTRY'
  | 'NISC_INTEL'
  | 'OEM_PARTNER'
  | 'SALESFORCE'
  | 'THIRD_PARTY'
  | 'UNKNOWN'
  | 'USER_SELF_SIGNUP'
  | 'USER_VERIFIED';

/** A value the caller read before deciding; `value` null means it read none. */
export type ContactExpectedValueInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A contact's projected name parts, as a guard. */
export type ContactNamePartsInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

/** Who wrote the phone a contact shows (`Query.organizationContactPhones`). */
export type ContactPhoneWriter =
  | 'AUTOMATION'
  | 'PERSON';

export type ContactSnapshotForAutomationInput = {
  actorId: Scalars['ID']['input'];
  canonicalContactId: Scalars['ID']['input'];
  canonicalOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type for filtering contacts by name or email. */
export type ContactsFilter = {
  /** Filter contacts by email (partial match). */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filter contacts by name (partial match). */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for specifying filters and pagination when querying contacts. */
export type ContactsInput = {
  /** Filtering options for contacts. */
  filter: ContactsFilter;
  /** Pagination options for the contact list. */
  pagination?: InputMaybe<ListPagination>;
};

/**
 * Which ingest source a mailbox allowlist entry belongs to. Distinct consents:
 * a Gmail grant never implies a Calendar grant or vice versa.
 */
export type CorpusIngestMailboxSource =
  | 'CALENDAR'
  | 'GMAIL';

/**
 * Where an ingestion run read from. MAINTENANCE covers the corpus re-embed and the
 * CRM seed; NISC is every row of the NISC sync-run table whatever its kind; OTHER
 * is any historical ad-hoc kind the registry does not know.
 */
export type CorpusIngestRunSource =
  | 'CALENDAR'
  | 'DRIVE'
  | 'FIREFLIES'
  | 'GMAIL'
  | 'MAINTENANCE'
  | 'NISC'
  | 'NOTION'
  | 'OTHER'
  | 'SLACK';

export type CorpusIngestRunStatus =
  /**
   * Stopped before the end and not resumable. A Fireflies relink stopped by its
   * time limit ends here (stats.stopReason = time_limit): the next relink starts
   * over and finishes the work, so this row owes nothing.
   */
  | 'CANCELLED'
  | 'COMPLETE'
  | 'FAILED'
  /** Stopped on purpose (a time limit, the daily budget or the page cap) and resumable. */
  | 'PAUSED'
  | 'RUNNING';

/**
 * Which external scope a mapping gates. One consent per source: a Drive grant
 * never implies a Slack or Notion one.
 */
export type CorpusIngestSourceMappingKind =
  | 'DRIVE_FOLDER'
  | 'NOTION_DB'
  | 'SLACK_CHANNEL';

/**
 * Which corpus surface a document came from. Mirrors the persisted CorpusSource
 * enum one-for-one. NOT interchangeable with CorpusIngestRunSource, which names
 * the same surfaces differently (DRIVE/CALENDAR there, GDRIVE/GCAL here) because
 * it labels ingestion RUNS rather than documents.
 */
export type CorpusSource =
  | 'FIREFLIES'
  | 'GCAL'
  | 'GDRIVE'
  | 'GMAIL'
  | 'NISC'
  | 'NOTION'
  | 'SLACK'
  | 'UPLOAD';

/** Review state of an internal-reference triage row. Decisions are sticky. */
export type CorpusTriageStatus =
  | 'CONFIRMED'
  | 'PENDING'
  | 'REJECTED';

export type CreateAlertInput = {
  alertType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  severity: Severity;
  siteId?: InputMaybe<Scalars['String']['input']>;
  sourceSystem: Scalars['String']['input'];
  subtype?: InputMaybe<AlertSubtype>;
  title: Scalars['String']['input'];
  type?: InputMaybe<AlertType>;
  workspaceId: Scalars['String']['input'];
};

export type CreateApiKeyInput = {
  /** Required when type is MANUFACTURER. The list of manufacturer IDs this key can access. */
  manufacturerScope?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  /** Required when type is MANAGEMENT. The ID of the user who owns this key. */
  ownerId?: InputMaybe<Scalars['String']['input']>;
  role?: ApiKeyRole;
  type: ApiKeyType;
  workspaceId: Scalars['String']['input'];
};

export type CreateAppAuthenticationSessionInput = {
  appProviderGrantId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  /** The duration in seconds or the datetime that the session should be valid for. Defaults to 24 hours. */
  expiration?: InputMaybe<ExpirationInput>;
};

/**
 * Input for createAssociationGrant. `associationId` names the pair; `grantorWorkspaceId`
 * must be a workspace of an organization that is a party of the association — the grantee
 * is the OTHER party, derived, never input. `filters` run the same registry-typed
 * fences as a team grant; `all: true` (with zero rows) is the whole workspace. The grant
 * mints UNLANDED: the receiver lands it with relandAssociationGrant.
 */
export type CreateAssociationGrantInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  associationId: Scalars['ID']['input'];
  filters: Array<PermissionGrantFilterInput>;
  grantorWorkspaceId: Scalars['ID']['input'];
  mode: PermissionGrantMode;
  resourceType: PermissionGrantResourceType;
};

/**
 * Input for createAssociation: the two organizations to pair, `organizationId` the side the
 * association is answered from.
 */
export type CreateAssociationInput = {
  organizationId: Scalars['ID']['input'];
  otherOrganizationId: Scalars['ID']['input'];
};

export type CreateBatchInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  payload: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateBatteryBatchInput = {
  setBatteryReserve?: InputMaybe<SetBatteryReserveInput>;
  setOperatingMode?: InputMaybe<SetBatteryOperatingModeInput>;
  slug: BatteryCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateBoardInput = {
  composition: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** A user id (must be the viewer), a team id, or the organization id, per `ownerType`. */
  ownerId: Scalars['ID']['input'];
  ownerType: BoardOwnerType;
  workspaceId: Scalars['ID']['input'];
};

export type CreateChargerBatchInput = {
  setOperatingMode?: InputMaybe<SetChargerOperatingModeInput>;
  slug: ChargerCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for creating a new collection */
export type CreateCollectionInput = {
  /** The type of collection */
  collectionType: CollectionType;
  /**
   * The criteria used to define what belongs in the collection. The default value
   * for the criteria is a collection that includes all entities of the
   * collectionType in the workspace. The value is replaced with the provided
   * workspaceId.
   */
  criteria?: InputMaybe<CollectionCriteriaInput>;
  /** Optional description of the collection */
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** The name of the collection */
  name: Scalars['NonEmptyString']['input'];
  /** The workspace ID this collection belongs to */
  workspaceId: Scalars['ID']['input'];
};

export type CreateCollectionInputV2 = {
  collectionType: CollectionType;
  criteria: CollectionCriteriaInputV2;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name: Scalars['NonEmptyString']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateConferenceInstanceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  edition?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nrtcOrgWide?: InputMaybe<Scalars['Boolean']['input']>;
  planningStatus?: InputMaybe<ConferencePlanningStatus>;
  rbmId?: InputMaybe<Scalars['ID']['input']>;
  registrationUrl?: InputMaybe<Scalars['String']['input']>;
  seriesId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  venueName?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type CreateConferenceSeriesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizer?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<ConferenceRegion>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConferenceWithInstanceInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  edition?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  instanceName: Scalars['String']['input'];
  instanceWebsite?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  nrtcOrgWide?: InputMaybe<Scalars['Boolean']['input']>;
  organizer?: InputMaybe<Scalars['String']['input']>;
  planningStatus?: InputMaybe<ConferencePlanningStatus>;
  rbmId?: InputMaybe<Scalars['ID']['input']>;
  region?: InputMaybe<ConferenceRegion>;
  registrationUrl?: InputMaybe<Scalars['String']['input']>;
  seriesName: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
  venueName?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type CreateConnectLinkForEnrollmentInput = {
  enrollmentId: Scalars['ID']['input'];
};

export type CreateConnectLinkForLifecycleInstanceInput = {
  /**
   * Headless only: one of the connect requirement's methods for the manufacturer. Defaults to its only method;
   * without configured methods, connect's legacy choice applies.
   */
  connectionMethod?: InputMaybe<Scalars['String']['input']>;
  lifecycleInstanceId: Scalars['ID']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  selectedManufacturer?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConnectLinkInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Headless only: a method id from connectionMethods. Without it the session uses identifier entry when that is the
   * manufacturer's only listed method, else its sign-in, else identifier entry.
   */
  connectionMethod?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerInfo?: InputMaybe<CustomerInfoInput>;
  manufacturerFilters?: InputMaybe<ManufacturerFiltersInput>;
  mode?: InputMaybe<ConnectLinkMode>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateCrmEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  kind: CrmEventKind;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCrmEventStatusInput = {
  countsAsAttended?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
};

export type CreateCrmPropertyDefinitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entityType: CrmPropertyEntityType;
  label: Scalars['String']['input'];
  numberFormat?: InputMaybe<CrmPropertyNumberFormat>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  type: CrmPropertyType;
};

export type CreateCustomerInput = {
  /** The customer's utility account number. */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** An external ID to link the Customer to an external system. */
  referenceId: Scalars['String']['input'];
  /** The Site of the customer to be created. */
  site?: InputMaybe<CreateSiteInput>;
  /**
   * An existing siteId to link the customer to an existing workspace site.
   * referenceId to be updated
   */
  siteId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Where the customer's link to the site came from. Only has an effect when the
   * mutation links a site (`site` or `siteId`). Omit it if you cannot name the
   * origin truthfully.
   */
  source?: InputMaybe<DeclarableClaimSource>;
  /**
   * The row this link came from — a link session, an enrollment, a sync grant, a
   * connection. Free-form because those rows live in different services. Requires
   * `source`: a pointer to an origin we did not name is unreadable.
   */
  sourceRecordId?: InputMaybe<Scalars['String']['input']>;
  /** The workspaceId of the workspace the customer belongs to. */
  workspaceId: Scalars['String']['input'];
};

export type CreateDataProviderInput = {
  /** Display name of the data provider */
  name: Scalars['String']['input'];
  /** Unique slug identifier for the data provider (e.g., "xeal", "solaredge") */
  slug: Scalars['String']['input'];
};

export type CreateDealInput = {
  arr?: InputMaybe<Scalars['Float']['input']>;
  carr?: InputMaybe<Scalars['Float']['input']>;
  closeDate?: InputMaybe<Scalars['Date']['input']>;
  /** Contacts on the deal (at most 20, each once); at most one primary, which also sets primaryContactId. */
  contacts?: InputMaybe<Array<DealContactInput>>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  dealType?: InputMaybe<DealType>;
  /** Further organizations on the deal (at most 10); one naming the primary organization is skipped. */
  linkedOrganizations?: InputMaybe<Array<DealOrganizationLinkInput>>;
  name: Scalars['String']['input'];
  nextStep?: InputMaybe<Scalars['String']['input']>;
  nextStepDate?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  /**
   * Optional: a deal on an organization is owned by the organization's owner, so
   * Relay leaves this out and the deal takes that owner (unassigned when the
   * organization has none yet). Imports and agents may still name one.
   */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  partner?: InputMaybe<DealPartner>;
  partnerContactId?: InputMaybe<Scalars['ID']['input']>;
  primaryContactId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<DealStage>;
};

export type CreateDeviceManufacturerInput = {
  /** Whether this manufacturer is available in Texture Connect */
  availableInTextureConnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name of the manufacturer */
  name: Scalars['String']['input'];
  /** Unique slug identifier for the manufacturer (e.g., "tesla", "enphase") */
  slug: Scalars['String']['input'];
  /** Support level for this manufacturer */
  supportLevel: SupportLevel;
  /** Whether this manufacturer supports grid services */
  supportsGridServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this manufacturer supports OAuth-based headless connect flows */
  supportsHeadlessConnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDeviceModelInput = {
  /** ID of the manufacturer this model belongs to */
  manufacturerId: Scalars['ID']['input'];
  /** Display name of the device model */
  name: Scalars['String']['input'];
  /** Unique slug identifier for the device model */
  slug: Scalars['String']['input'];
  /** Support level for this device model */
  supportLevel: SupportLevel;
  /** Type of device (battery, vehicle, charger, etc.) */
  type: DeviceType;
};

export type CreateDeviceScheduleInput = {
  deviceId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  rules: Array<CreateRuleInput>;
  schedule: CreateScheduleInput;
};

export type CreateEmailDestinationInput = {
  deviceType: DeviceTypeScope;
  email: Scalars['String']['input'];
  eventTypes: Array<EventType>;
  label: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateEnrollmentGroupInput = {
  name: Scalars['String']['input'];
  workspaceProgramId: Scalars['ID']['input'];
};

export type CreateEnrollmentInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  eligibilityReason?: InputMaybe<Scalars['String']['input']>;
  eligibilityStatus?: InputMaybe<EligibilityStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentId?: InputMaybe<Scalars['ID']['input']>;
  enrollmentStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identificationType: IdentificationType;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Leads are retired; kept only until recorded client operations stop using it; ignored. Removal tracked in ALL-3445. */
  leadId?: InputMaybe<Scalars['ID']['input']>;
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  programSpecificFields?: InputMaybe<Scalars['JSON']['input']>;
  referenceDescription?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type CreateGrantInput = {
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  pollingCronPattern?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateInvitationInput = {
  email: Scalars['String']['input'];
  /** @deprecated We are moving to sourcing this from the auth token */
  organization?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  /**
   * Teams to assign the invitee to on acceptance. Optional (omit or empty →
   * GENERAL). Validated same-org server-side; ids outside the inviting org are
   * rejected, never trusted from the client.
   */
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateKafkaDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes: Array<EventType>;
  kafkaConfig: Scalars['JSON']['input'];
  label: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateLeadAndCheckProgramEligibilityInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  event?: InputMaybe<CreateLeadEventInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CreateLeadEventInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  type: LeadEventType;
};

export type CreateLeadInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<LeadSource>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  workspaceId: Scalars['String']['input'];
};

/** Input for creating a management audit log entry. */
export type CreateManagementAuditLogInput = {
  /** The action performed (e.g., 'workspace.create', 'apiKey.revoke'). */
  action: Scalars['String']['input'];
  /** The ID of the actor (userId or apiKeyId). */
  actorId: Scalars['String']['input'];
  /** The type of actor ('user' or 'apiKey'). */
  actorType: Scalars['String']['input'];
  /** Additional metadata (request method, path, IP, user agent). */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The organization this action belongs to. */
  organizationId: Scalars['String']['input'];
  /** The ID of the affected resource. */
  resourceId: Scalars['String']['input'];
  /** The type of resource affected (e.g., 'Workspace', 'ApiKey'). */
  resourceType: Scalars['String']['input'];
  /** The workspace this action relates to, if applicable. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManufacturerCredentialInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  generateConnectLink?: InputMaybe<GenerateConnectLinkForCredentialInput>;
  manufacturer: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ManufacturerCredentialParamsInput>;
  workspaceId: Scalars['ID']['input'];
};

/** Error codes for manufacturer device creation */
export type CreateManufacturerDeviceErrorCode =
  | 'DEVICE_MODEL_MANUFACTURER_MISMATCH'
  | 'DEVICE_MODEL_NOT_FOUND'
  | 'MANUFACTURER_NOT_FOUND'
  | 'PARAMETER_MISMATCH'
  | 'SITE_NOT_FOUND'
  | 'UNAUTHORIZED';

/** Input for creating a manufacturer device via dashboard */
export type CreateManufacturerDeviceInput = {
  /** The ID of the device model */
  deviceModelId: Scalars['ID']['input'];
  /** The manufacturer's unique identifier for this device */
  manufacturerDeviceId: Scalars['String']['input'];
  /** ID of the manufacturer this device belongs to */
  manufacturerId: Scalars['ID']['input'];
  /** Optional friendly name for the device */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the site where the device is installed */
  siteId: Scalars['ID']['input'];
};

/** Input for creating a manufacturer device model */
export type CreateManufacturerDeviceModelInput = {
  /** ID of the manufacturer this model belongs to */
  manufacturerId: Scalars['ID']['input'];
  /** Display name of the device model */
  name: Scalars['String']['input'];
  /**
   * Unique slug identifier for the device model.
   * Auto-generated from name if not provided.
   */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Support level for this device model.
   * Defaults to development for new OEM models.
   */
  supportLevel?: InputMaybe<SupportLevel>;
  /** Type of device (battery, vehicle, charger, etc.) */
  type: DeviceType;
};

export type CreateManufacturerIntegrationInput = {
  /** Configuration fields as JSON */
  configurationFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Rich text description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Documentation blocks as JSON */
  documentationBlocks?: InputMaybe<Scalars['JSON']['input']>;
  /** Learn more URL for documentation */
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** ID of the manufacturer this integration belongs to */
  manufacturerId: Scalars['ID']['input'];
  /** Display name */
  name: Scalars['String']['input'];
  /** Unique slug identifier (e.g., "tesla", "enphase") */
  slug: Scalars['String']['input'];
  /** Support level for this integration */
  supportLevel: SupportLevel;
};

export type CreateMonitorInput = {
  bindings?: InputMaybe<Array<MonitorBindingInput>>;
  defaultParameterization: MonitorParameterizationInput;
  /**
   * Optional. Omit to default to LIVE — today's behavior. Pass SHADOW to
   * stage the monitor against live data without paging on-call.
   */
  deliveryMode?: InputMaybe<MonitorDeliveryMode>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional for now: inferred from the targets when omitted. Cannot be
   * changed after create.
   */
  entityType?: InputMaybe<MonitorEntityType>;
  family: MonitorFamily;
  name: Scalars['String']['input'];
  notifyPer?: InputMaybe<MonitorNotifyPer>;
  parameterizationOverrides?: InputMaybe<Array<MonitorParameterizationOverrideInput>>;
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Delivery policy. All optional; omitted fields default to requiresAction
   * true, notifyPer NONE, urgency NORMAL and no recipients.
   */
  requiresAction?: InputMaybe<Scalars['Boolean']['input']>;
  rule: MonitorRuleInput;
  targets: Array<MonitorTargetInput>;
  templateSlug?: InputMaybe<Scalars['String']['input']>;
  urgency?: InputMaybe<MonitorUrgency>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateOAuthApplicationInput = {
  allowedScopes: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  redirectUris: Array<Scalars['String']['input']>;
  type: OAuthApplicationType;
  workspaceId: Scalars['ID']['input'];
};

/** Input for creating an OEM-provisioned device */
export type CreateOemDeviceInput = {
  /** The manufacturer IDs the API key is allowed to create devices for */
  allowedManufacturerIds: Array<Scalars['String']['input']>;
  /** The API key ID that's creating this device (for audit) */
  createdByApiKeyId: Scalars['String']['input'];
  /** The ID of the device model */
  deviceModelId: Scalars['String']['input'];
  /** The manufacturer's unique identifier for this device */
  manufacturerDeviceId: Scalars['String']['input'];
  /** Optional friendly name for the device */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the site where the device is installed */
  siteId: Scalars['String']['input'];
  /** The workspace ID of the requesting API key; used for site access scoping */
  workspaceId: Scalars['String']['input'];
};

/** Input for creating an organization access request */
export type CreateOrganizationAccessRequestInput = {
  /** The ID of the organization to request access to */
  organizationId: Scalars['ID']['input'];
};

/** Input for creating an organization affiliation. */
export type CreateOrganizationAffiliationInput = {
  affiliatedOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateOrganizationInput = {
  domain: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  preferredTemperatureUnit?: InputMaybe<PreferredTemperatureUnit>;
};

export type CreateOutpostDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes: Array<EventType>;
  label: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateProgramInput = {
  active: Scalars['Boolean']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  programTerms?: InputMaybe<Scalars['String']['input']>;
  public: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
  states: Array<Scalars['String']['input']>;
  /**
   * Which generation of the program-operations surfaces activations of this program
   * should render. **Defaults to v2** — every net-new program is a v2 program,
   * whichever create flow produced it. Pass `v1` only when reconstructing a legacy
   * program (imports, fixtures, backfills) that must stay on the legacy surfaces.
   * Independent of the enrollment form.
   */
  surfaceVersion?: InputMaybe<ProgramSurfaceVersion>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProgramInput_Old = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  eligibilityCriteria: Scalars['String']['input'];
  programTerms: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateProgramVariantInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  programTerms?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateRelayAgentUploadInput = {
  byteSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  pageCount?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  truncated: Scalars['Boolean']['input'];
};

/**
 * Input for creating a resolution rule.
 * Pass `workspaceId: null` for platform-wide defaults (super-admin only).
 */
export type CreateResolutionRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  issueType: Scalars['String']['input'];
  matcher: Scalars['JSON']['input'];
  minConfidence?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  transform: Scalars['JSON']['input'];
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateRuleInput = {
  daysOfWeek: Array<Scalars['Int']['input']>;
  deviceOperatingMode: Scalars['JSON']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CreateScheduleInput = {
  cleanupDeviceOperatingMode?: InputMaybe<Scalars['JSON']['input']>;
  defaultDeviceOperatingMode: Scalars['JSON']['input'];
  deviceTimezone?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateScopedApiKeyInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Required when creating a scoped API key. The referenceId specifies the scope of access for the API key. */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  role?: ApiKeyRole;
  workspaceId: Scalars['String']['input'];
};

/** Possible error codes that can occur during site creation */
export type CreateSiteErrorCode =
  /** Error occurred in the location service */
  | 'LOCATION_SERVICE_ERROR'
  /** Site already exists at this location in this workspace */
  | 'SITE_ALREADY_EXISTS'
  /** Error occurred in the site repository */
  | 'SITE_REPOSITORY_ERROR';

export type CreateSiteInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetOne: Scalars['String']['input'];
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSmsDestinationInput = {
  deviceType: DeviceTypeScope;
  eventTypes: Array<EventType>;
  label: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateTagScheduleInput = {
  deviceType: ScheduleSupportedDeviceType;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  rules: Array<CreateRuleInput>;
  schedule: TagScheduleInput;
  tag: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateTeamInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/**
 * Input for createTeamPermissionGrant. For DEVICE, `filters` are registry-typed
 * rows (workspaceId and organizationId are not filterable — the grant's
 * workspace is the scope). For COLLECTION, exactly one row
 * `{ field: "collectionId", operator: EQUALS, value: <id> }` and no `all`.
 * `all: true` is the whole-workspace grant and requires zero rows.
 */
export type CreateTeamPermissionGrantInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Array<PermissionGrantFilterInput>;
  mode: PermissionGrantMode;
  resourceType: PermissionGrantResourceType;
  teamId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateThermostatBatchInput = {
  pauseSchedule?: InputMaybe<PauseThermostatScheduleInput>;
  resumeSchedule?: InputMaybe<ResumeThermostatScheduleInput>;
  setFanMode?: InputMaybe<SetThermostatFanModeInput>;
  setOperatingMode?: InputMaybe<SetThermostatOperatingModeInput>;
  slug: ThermostatCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateTicketInput = {
  alertIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  assigneeLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  priority?: InputMaybe<TicketPriority>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<TicketSubjectType>;
  title: Scalars['String']['input'];
  watchers?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateVehicleBatchInput = {
  setChargeLimit?: InputMaybe<SetVehicleChargeLimitInput>;
  setOperatingMode?: InputMaybe<SetVehicleOperatingModeInput>;
  slug: VehicleCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateVirtualAccountInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<VirtualAccountType>;
  workspaceId: Scalars['String']['input'];
};

export type CreateVirtualDeviceInput = {
  accountId: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: VirtualDeviceType;
};

export type CreateVirtualSiteDeviceInput = {
  accountId: Scalars['String']['input'];
  deviceType: VirtualDeviceType;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Location defaults to the preset's; latitude and longitude come as a pair, with a timezone. */
export type CreateVirtualSiteInput = {
  devices?: InputMaybe<Array<CreateVirtualSiteDeviceInput>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  presetId: Scalars['String']['input'];
  /** Defaults to a random seed. */
  seed?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to now. */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to the preset's latest version. */
  version?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type CreateWebhookDestinationInput = {
  deviceType: DeviceTypeScope;
  eventTypes: Array<EventType>;
  headers?: InputMaybe<Scalars['JSON']['input']>;
  includeWeather?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  /** PII categories removed from every payload delivered to this destination. Defaults to none. */
  redactCategories?: InputMaybe<Array<RedactionCategory>>;
  secret?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

/** Input for creating a new workflow */
export type CreateWorkflowInput = {
  /** JSON configuration conforming to workflow schema */
  config: Scalars['JSON']['input'];
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the workflow is enabled */
  enabled?: Scalars['Boolean']['input'];
  /** Name of the workflow */
  name: Scalars['String']['input'];
  /** ID of the workspace this workflow belongs to */
  workspaceId: Scalars['String']['input'];
};

export type CreateWorkspaceInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type CreateWorkspaceProgramEventInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  type: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type CreateWorkspaceProgramInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  programSlug: Scalars['String']['input'];
  programTerms?: InputMaybe<Scalars['String']['input']>;
  programVariantId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type CreateWorkspaceProgramIntegrationInput = {
  authority?: InputMaybe<Scalars['String']['input']>;
  capabilityConfig?: InputMaybe<Scalars['JSON']['input']>;
  credentialModel?: InputMaybe<Scalars['String']['input']>;
  enabledCapabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalStatus?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  providerGrantId?: InputMaybe<Scalars['String']['input']>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type CrmBriefsInput = {
  generator?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
};

export type CrmContactsInput = {
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A contract's journey stage, from the Notion Contracts table. Named with the Crm
 * prefix so it can never collide with another subgraph's vocabulary.
 */
export type CrmContractJourneyStage =
  | 'ADOPTION'
  | 'ADVOCACY'
  | 'CHURNED'
  | 'GO_LIVE'
  | 'ONBOARDING'
  | 'PAUSED'
  | 'VALUE_REALIZATION';

export type CrmCursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A customer account's journey stage, from the Notion Customers table. Separate
 * from CrmContractJourneyStage: an account's lifecycle is not one contract's.
 */
export type CrmCustomerJourneyStage =
  | 'ADOPTION'
  | 'ADVOCACY'
  | 'AWARENESS'
  | 'CHURN'
  | 'EXPANSION'
  | 'ONBOARDING'
  | 'RENEWAL'
  | 'VALUE_REALIZATION';

/** Inclusive calendar-day bounds (YYYY-MM-DD, UTC). Set at least one; from may not be after to. */
export type CrmDateRangeInput = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type CrmEventKind =
  | 'CONFERENCE'
  | 'MEETING'
  | 'OTHER'
  | 'WEBINAR';

export type CrmEventMemberInput = {
  canonicalOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  /** With overwriteStatus: refuses STALE_RECORD unless the existing member still carries this updatedAt. */
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  statusId: Scalars['ID']['input'];
};

export type CrmEventStreamInput = {
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CrmEventsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeRetired?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Inclusive decimal bounds. Set at least one; min may not exceed max. */
export type CrmFloatRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** A health rating, worst last: RED is worse than ORANGE, which is worse than GREEN. */
export type CrmHealthRating =
  | 'GREEN'
  | 'ORANGE'
  | 'RED';

/** Inclusive integer bounds. Set at least one; min may not exceed max. */
export type CrmIntRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type CrmMoveDirection =
  | 'DOWN'
  | 'UP';

export type CrmNetworksInput = {
  kind?: InputMaybe<NetworkKind>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
};

export type CrmNiscActivityInput = {
  recentAnalysisLimit?: InputMaybe<Scalars['Int']['input']>;
  topThreadLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CrmNiscContactSortBy =
  | 'NAME'
  | 'RECENT_LOGIN'
  | 'TOTAL_POSTS';

export type CrmNiscContactsInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use organizationId instead */
  crmOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Sorting is handled server-side */
  sortBy?: InputMaybe<CrmNiscContactSortBy>;
};

export type CrmNiscForumsInput = {
  groupName?: InputMaybe<Scalars['String']['input']>;
};

export type CrmNiscOrgMapStatus =
  | 'AMBIGUOUS'
  | 'AUTOLINKED'
  | 'CONFIRMED'
  | 'REJECTED'
  | 'UNMATCHED';

export type CrmNiscRepliesInput = {
  pagination?: InputMaybe<CrmCursorPaginationInput>;
};

export type CrmNiscThreadSortBy =
  | 'RECENT'
  | 'REPLIES'
  | 'SCORE';

export type CrmNiscThreadUrgency =
  | 'COLD'
  | 'HOT'
  | 'WARM';

export type CrmNiscThreadsInput = {
  authorNiscId?: InputMaybe<Scalars['Int']['input']>;
  crmOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  forumId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CrmNiscThreadSortBy>;
  /**
   * Restrict results to threads whose deep-analysis urgency is one of the given
   * values. Used by the Hot Now tab to page HOT/WARM threads server-side instead
   * of over-fetching a fixed window and filtering on the client.
   */
  urgencyIn?: InputMaybe<Array<CrmNiscThreadUrgency>>;
};

export type CrmOrganizationOrderInput = {
  direction: RelayListSortDirection;
  key: CrmOrganizationOrderKey;
};

/** The facts CRM can order organizations by (identity cannot sort on them). */
export type CrmOrganizationOrderKey =
  | 'DATE_CONNECTED'
  | 'NEXT_STEP_DUE_DATE';

export type CrmOrganizationsInput = {
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<UtilitySegment>;
};

export type CrmPropertyEntityType =
  | 'CONTACT'
  | 'DEAL'
  | 'ORGANIZATION';

export type CrmPropertyFilterInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  definitionId: Scalars['ID']['input'];
  max?: InputMaybe<Scalars['String']['input']>;
  /** RANGE bounds: a number or a YYYY-MM-DD date; empty or null is open. */
  min?: InputMaybe<Scalars['String']['input']>;
  op: CrmPropertyFilterOp;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CrmPropertyFilterOp =
  | 'IS'
  | 'IS_EMPTY'
  | 'IS_NOT'
  | 'IS_SET'
  | 'RANGE';

export type CrmPropertyNumberFormat =
  | 'CURRENCY_USD'
  | 'PERCENT'
  | 'PLAIN';

export type CrmPropertyOptionRenameInput = {
  label: Scalars['String']['input'];
  optionId: Scalars['ID']['input'];
};

export type CrmPropertyType =
  | 'BOOLEAN'
  | 'DATE'
  | 'EMAIL'
  | 'LONG_TEXT'
  | 'MULTI_SELECT'
  | 'NUMBER'
  | 'SELECT'
  | 'TEXT'
  | 'URL';

export type CrmPropertyValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  number?: InputMaybe<Scalars['Float']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CrmQueriesInput = {
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  threadId?: InputMaybe<Scalars['ID']['input']>;
};

export type CrmRbmTerritoriesInput = {
  networkId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  rbmId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CrmRbmsInput = {
  networkId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  /** Filter to RBMs covering this two-letter state code. */
  state?: InputMaybe<Scalars['String']['input']>;
  territoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type CrmRecordSource =
  | 'AGENT'
  | 'HUMAN'
  | 'IMPORT';

export type CrmSignalsInput = {
  minScore?: InputMaybe<Scalars['Float']['input']>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Members to add to and remove from a set-valued field. A value in both lists is rejected. */
export type CrmStringSetPatch = {
  add?: InputMaybe<Array<Scalars['String']['input']>>;
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrmTouchpointsInput = {
  kind?: InputMaybe<TouchpointKind>;
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for cursor-based pagination. */
export type CursorPagination = {
  /** Returns items after this cursor. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Returns items before this cursor. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** The number of items to return from the beginning of the list. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items to return from the end of the list. */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Request the live values for a set of customer board filter fields. Unsupported
 * fields are ignored. Currently supports `referenceId` and `email`.
 */
export type CustomerBoardFacetsInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** A date column a customer time facet buckets on via `date_trunc`. */
export type CustomerDateField =
  | 'createdAt'
  | 'updatedAt';

/**
 * A terms-aggregatable customer field for a category facet (SQL `GROUP BY`).
 * Mirrors the customer field-registry entries carrying `aggregate: terms`.
 * `connectedSiteIds` and `connectedDeviceIds` are not columns — a customer's
 * connected resources are resolved through the ThirdPartyClaim join
 * (resourceType=Site / Device, claim=CONNECTED), so a customer contributes to each
 * connected resource's bucket (expanded, like an unnested array field), and a
 * customer with no such claim contributes nothing.
 */
export type CustomerFacetField =
  | 'connectedDeviceIds'
  | 'connectedSiteIds'
  | 'email'
  | 'id'
  | 'referenceId';

/**
 * Workspace-wide customer facet aggregation (SQL `GROUP BY`). Provide EITHER a
 * `field` (a terms facet) OR a `dateField` + `interval` (a date-bucket facet), not
 * both. The optional filters mirror CustomersFilter so a chart honors the board's
 * filters, and the workspace scope + soft-delete exclusion are enforced the same
 * way as the customers read path. `exploreFilter` is intentionally excluded in v1
 * (parity with the count KPI, which fails closed on it).
 */
export type CustomerFacetInput = {
  /**
   * Restrict the aggregated population to customers connected to these device IDs
   * (ThirdPartyClaim resourceType=Device), mirroring CustomersFilter. Intersects
   * with connectedSiteIds when both are given.
   */
  connectedDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  connectedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Inclusive createdAt window (half-open ranges allowed — either bound is
   * optional), mirroring CustomersFilter so a chart scopes like the list/KPI.
   */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Date-bucket facet column. Requires `interval`. Provide this OR `field`. */
  dateField?: InputMaybe<CustomerDateField>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms facet field. Provide this OR (dateField + interval). */
  field?: InputMaybe<CustomerFacetField>;
  /** Mirrors CustomersFilter.hasDevices. */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Bucket width for a date-bucket facet. Required when `dateField` is set. */
  interval?: InputMaybe<DateInterval>;
  /**
   * Max number of buckets for a terms facet (top-N by count), mirroring an
   * Elasticsearch `terms` size. Ignored for date-bucket facets. Omitted → unbounded.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};

export type CustomerInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type CustomersFilter = {
  /**
   * Restrict to customers connected to these device IDs. Resolved through
   * ThirdPartyClaim (resourceType=Device, claim=CONNECTED) — the exact reverse of
   * Customer.connectedDeviceIds. Combined with connectedSiteIds it intersects: a
   * customer must be claimed to one of the sites AND one of the devices.
   */
  connectedDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Restrict to customers connected to these site IDs (Explore Customers tab).
   * Resolved through ThirdPartyClaim (resourceType=Site). Not for contact-info
   * filtering.
   */
  connectedSiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Inclusive createdAt window (half-open ranges allowed — either bound is
   * optional). Scopes to customers created within the window.
   */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Restrict to customers connected to the sites matching this Explore filter.
   * Resolved server-side: the filter is forwarded to the device domain's
   * exploreSiteIds to get matching site IDs, then joined via ThirdPartyClaim
   * (resourceType=Site). Prefer this over connectedSiteIds so large workspaces
   * don't ship the full site-ID set from the client.
   */
  exploreFilter?: InputMaybe<ExploreFilterNode>;
  /**
   * true: customers with at least one live CONNECTED device claim; false: customers
   * with none. A closed claim (moved out) is not a device. Omitted → no filter.
   */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};

export type CustomersForWorkspaceFilter = {
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};

export type CustomersForWorkspaceFilterInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type CustomersForWorkspaceInput = {
  filter: CustomersForWorkspaceFilter;
  orderBy?: InputMaybe<CustomerOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<CustomersForWorkspaceSearch>;
};

export type CustomersForWorkspaceSearch = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomersInput = {
  filter: CustomersFilter;
  orderBy?: InputMaybe<CustomerOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<CustomersSearch>;
};

export type CustomersSearch = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

/** `date_trunc` bucket width for a date facet. */
export type DateInterval =
  | 'day'
  | 'month'
  | 'week';

export type DateRangeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type DealActivityKind =
  | 'CALL'
  | 'EMAIL'
  | 'MEETING'
  | 'NOTE'
  | 'SYSTEM';

export type DealAuditEventType =
  | 'CLOSED_LOST'
  | 'CLOSED_WON'
  | 'CONTACT_ADDED'
  | 'CONTACT_PRIMARY_CHANGED'
  | 'CONTACT_REMOVED'
  | 'CONTACT_ROLE_CHANGED'
  | 'CREATED'
  | 'DELETED'
  | 'FIELD_CHANGE'
  | 'ORGANIZATION_LINKED'
  | 'ORGANIZATION_ROLE_CHANGED'
  | 'ORGANIZATION_UNLINKED'
  | 'OWNER_REASSIGNED'
  | 'PRIMARY_ORGANIZATION_CHANGED'
  | 'STAGE_TRANSITION';

export type DealAuditFilter = {
  eventType?: InputMaybe<Array<DealAuditEventType>>;
};

/** The deal contact row a reviewed change saw; role and isPrimary are ignored when onDeal is false. */
export type DealContactExpectation = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  onDeal: Scalars['Boolean']['input'];
  role?: InputMaybe<DealContactRole>;
};

/** One contact a deal is created with. */
export type DealContactInput = {
  canonicalContactId: Scalars['ID']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<DealContactRole>;
};

export type DealContactRole =
  | 'CHAMPION'
  | 'DECISION_MAKER'
  | 'EXECUTIVE_SPONSOR'
  | 'INFLUENCER'
  | 'PROCUREMENT'
  | 'TECHNICAL_EVAL';

export type DealFilter = {
  /**
   * Deals on this canonical organization, as primary or linked (primaryOnly
   * restricts it to the primary). Preferred org filter for the relay org pages.
   */
  canonicalOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Deals linked (primary or not) to any of these canonical organizations; at most 100. */
  canonicalOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  dealType?: InputMaybe<Array<DealType>>;
  hasCloseDate?: InputMaybe<Scalars['Boolean']['input']>;
  hasNextStep?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legacy crm organization key; matches the primary organization only. */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Restrict the canonical organization filters to each deal's primary organization. */
  primaryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Array<DealStage>>;
};

export type DealLostCategory =
  | 'BUDGET'
  | 'INTERNAL_BLOCKER'
  | 'LOST_TO_COMPETITOR'
  | 'NO_DECISION'
  | 'OTHER'
  | 'PRICING'
  | 'TECHNICAL_FIT'
  | 'TIMING';

/**
 * The link a reviewed change saw. When the link differs inside the write, the
 * write is refused with DEAL_ORGANIZATION_LINK_MOVED.
 */
export type DealOrganizationLinkExpectation = {
  linked: Scalars['Boolean']['input'];
  role?: InputMaybe<DealOrganizationRole>;
};

export type DealOrganizationLinkInput = {
  canonicalOrganizationId: Scalars['ID']['input'];
  role?: InputMaybe<DealOrganizationRole>;
};

/** How a linked organization takes part in a deal. */
export type DealOrganizationRole =
  | 'INFLUENCER'
  | 'OTHER'
  | 'PARTICIPANT'
  | 'PARTNER';

export type DealPartner =
  | 'NRTC';

export type DealSort =
  | 'ARR_DESC'
  | 'CLOSE_DATE_ASC'
  | 'STAGE_THEN_CLOSE_DATE'
  | 'UPDATED_AT_DESC';

export type DealStage =
  | 'CHAMPION_ESTABLISHED'
  | 'CLOSED_LOST'
  | 'CLOSED_WON'
  | 'CONTRACT_NEGOTIATION'
  | 'EVALUATION_COMMITTED'
  | 'QUALIFIED'
  | 'VENDOR_SELECTED';

export type DealStageFunnelFilter = {
  enteredAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  enteredAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  segment?: InputMaybe<UtilitySegment>;
};

export type DealStageHistorySource =
  | 'DEAL_AUDIT'
  | 'NOTION_BACKFILL'
  | 'TRANSITION';

export type DealType =
  | 'EXPANSION'
  | 'NEW_BUSINESS'
  | 'RENEWAL';

export type DealWonCategory =
  | 'EXPANSION'
  | 'NEW_LOGO'
  | 'RENEWAL'
  | 'WINBACK';

/**
 * Where a customer's link to a resource came from, as declared by the caller.
 *
 * Identity cannot infer this: every first-party service reaches these mutations
 * through the supergraph with the same client credentials, so the caller is the
 * only thing that knows. Declaring it is not a privilege: the values an external
 * caller could plausibly assert (`ENROLLMENT`, `MANUAL_API`) sit in the same trust
 * tier under D16, so there is nothing to gain by lying between them.
 *
 * Narrower than the stored `ClaimSource` on purpose — `BACKFILL` is never
 * declarable, it belongs to the commands that write history.
 *
 * Omitting it records no origin, which reads as "unknown, do not trust". That is
 * the right answer for a caller that genuinely cannot name its origin — a wrong
 * origin is worse than no origin, which is the whole reason the column exists
 * (D15/D16).
 */
export type DeclarableClaimSource =
  /**
   * The platform linked the customer itself, on a device event that named them.
   * Declared by the services that relay those events — it says the link was made
   * automatically, and deliberately does not claim to know what put the customer on
   * that connection in the first place.
   */
  | 'AUTO_LINK'
  /**
   * Arrived through a non-interactive batch path: a utility sync, a file import, a
   * scripted bulk create.
   */
  | 'BULK_IMPORT'
  /** The interactive connect flow named the customer. */
  | 'CONNECT_FLOW'
  /** Inferred while someone enrolled in a program. */
  | 'ENROLLMENT'
  /**
   * A direct call against this API by a person or an integration: the REST API, the
   * dashboard, a partner's own script.
   */
  | 'MANUAL_API';

export type DeclineWorkspaceInvitationInput = {
  invitationId: Scalars['ID']['input'];
};

export type DeleteBatchInput = {
  batchId: Scalars['ID']['input'];
};

export type DeleteCustomerInput = {
  deleteRelatedDevices?: InputMaybe<Scalars['Boolean']['input']>;
  deleteRelatedSites?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteDeviceInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDevicesInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteInvitationInput = {
  id: Scalars['String']['input'];
};

export type DeleteMembershipInput = {
  id: Scalars['String']['input'];
};

/** Input type for deleting a site and optionally its related resources */
export type DeleteSiteInput = {
  /** Whether to also delete customers associated with this site. If false, customers will be preserved. */
  deleteRelatedCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to also delete devices associated with this site. If false, devices will be preserved. */
  deleteRelatedDevices?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier of the site to delete */
  id: Scalars['ID']['input'];
};

/** Input type for bulk deleting sites */
export type DeleteSitesInputForWorkspaceInput = {
  /** Workspace ID to delete all sites from */
  workspaceId: Scalars['ID']['input'];
};

export type DeleteTagSchedulesByTagInput = {
  tag: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type DeleteWorkspaceProgramEventInput = {
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
  workspaceProgramEventId: Scalars['ID']['input'];
};

export type DeleteWorkspaceSystemConnectionInput = {
  id: Scalars['ID']['input'];
};

/** Input for denying an organization access request */
export type DenyOrganizationAccessRequestInput = {
  /** The token of the request to deny */
  token: Scalars['String']['input'];
};

/** Sortable columns for the candidate list. */
export type DerCandidateOrderField =
  | 'FIRST_DETECTED_AT'
  | 'LAST_SEEN_AT'
  | 'PROBABILITY'
  | 'RAW_SCORE'
  | 'SERIAL_NUMBER'
  | 'STATUS';

/** Sort order for the candidate list. */
export type DerCandidateSortDirection =
  | 'ASC'
  | 'DESC';

/** Human review status of a candidate. Owned by reviewers — detection runs never change it, so a re-run cannot clobber a customer's label. Confirmed/rejected labels become training data for the next model version. */
export type DerCandidateStatus =
  | 'CONFIRMED_EV'
  | 'CONTACTED'
  | 'NOT_EV'
  | 'SUGGESTED';

/** Lifecycle of a detection run. */
export type DerDetectionRunStatus =
  | 'FAILED'
  | 'RUNNING'
  | 'SUCCEEDED';

/** What a detection run decided about one meter. The first seven are the scoring loop's own verdict, reported verbatim rather than re-derived, so this can never describe a decision a run would not have made. The rest describe identifier resolution, which happens before a meter reaches a gate. */
export type DerMeterDisposition =
  | 'AMBIGUOUS'
  | 'COMMERCIAL_PEAK'
  | 'COMMERCIAL_SPIKE'
  | 'GENERATION_METER'
  | 'LOW_COVERAGE'
  | 'METER_HAS_NO_SITE'
  | 'NOT_A_METER'
  | 'NOT_FOUND'
  | 'NO_SERIES'
  | 'NO_SESSIONS'
  | 'SCORED'
  | 'UNKNOWN_MANUFACTURER';

/** Which identifier the introspection values are. A closed set rather than a caller-supplied column name. DEVICE_ON_WORKSPACE_ID and MANUFACTURER_DEVICE_ID resolve through a filtered device query; SERIAL_NUMBER and GRID_ELEMENT_GUID have no device-query filter and so scan the workspace, which is correct but much slower and reported as a warning. GRID_ELEMENT_GUID matches case-insensitively, because each GIS export sets its own casing; every other identifier is matched verbatim. */
export type DerMeterIdentifierField =
  | 'DEVICE_ON_WORKSPACE_ID'
  | 'GRID_ELEMENT_GUID'
  | 'MANUFACTURER_DEVICE_ID'
  | 'SERIAL_NUMBER';

/** Ask what a detection run would decide about specific meters. Reads what a run reads and writes nothing — no run row, no candidates — so it is safe to call while a run is in flight, which is when the question usually comes up. */
export type DerMeterIntrospectionInput = {
  /** Window start, ISO instant. Whole days only. */
  after: Scalars['String']['input'];
  /** Window end, ISO instant. Use the SAME window as the run you are explaining — a different window scores different recurrence features and can reach a different verdict. */
  before: Scalars['String']['input'];
  /** Which identifier `values` are. */
  identifierField: DerMeterIdentifierField;
  /** Bucket size: 15, 30 or 60. */
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Residential peak ceiling (kW). Omit to use the same server default a run uses — a different ceiling here would explain a gate the run never applied. */
  maxPeakKw?: InputMaybe<Scalars['Float']['input']>;
  /** The meters' native channel interval. Must match the run's. */
  sourceIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Territory centroid latitude for weather features; pass both or neither. */
  territoryLat?: InputMaybe<Scalars['Float']['input']>;
  /** Territory centroid longitude. */
  territoryLon?: InputMaybe<Scalars['Float']['input']>;
  /** IANA timezone for the fleet's local clock. Must match the run's. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Up to 50 identifiers. Over the cap is an error, not a truncation: silently scoring the first 50 of 60 answers a question you did not ask. Duplicates are collapsed. */
  values: Array<Scalars['String']['input']>;
  /** Workspace owning the meters. */
  workspaceId: Scalars['ID']['input'];
};

export type DestinationType =
  | 'EMAIL'
  | 'KAFKA'
  | 'MANUFACTURER_COMMAND'
  | 'OUTPOST'
  | 'SMS'
  | 'WEBHOOK';

export type DestinationsInput = {
  filter: DestinationsInputFilter;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<DestinationsInputSearchInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type DestinationsInputFilter = {
  destinationType?: InputMaybe<DestinationType>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type DestinationsInputSearchInput = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operator?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type DetermineEligibilityForEnrollmentInput = {
  enrollmentId: Scalars['ID']['input'];
  requirements?: InputMaybe<Array<Requirement>>;
};

export type DeviceCommandsFilter = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<CommandStatus>>;
  /**
   * The workspace the caller is browsing. For the device's owner it is the
   * device's own workspace. For a caller who reaches the device through an
   * association grant, it is their landing workspace: it keys the
   * effective-filter fallback when Oso denies the device. Either way every
   * command on the device is returned. Untrusted on its own — it grants nothing.
   */
  workspaceId: Scalars['ID']['input'];
};

export type DeviceCommandsInput = {
  filter: DeviceCommandsFilter;
  pagination?: InputMaybe<ListPagination>;
};

export type DeviceLocationFilter = {
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Meter classification for a metered Device.
 *
 * - `CONSUMER` — consumption meter (always-positive readings).
 * - `PRODUCTION` — net meter in front of a solar house; nets consumption against generation.
 * - `GENERATION` — solar-only generation meter.
 */
export type DeviceMeterType =
  | 'CONSUMER'
  | 'GENERATION'
  | 'PRODUCTION';

export type DeviceMetricsInput = {
  /** The workspace-facing device id (federated Device.id), not the canonical Device.id. */
  deviceOnWorkspaceId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type DeviceOrderByInput = {
  connectedAt?: InputMaybe<PaginatedQueryOrderBy>;
  displayModelName?: InputMaybe<PaginatedQueryOrderBy>;
  manufacturer?: InputMaybe<PaginatedQueryOrderBy>;
  model?: InputMaybe<PaginatedQueryOrderBy>;
  name?: InputMaybe<PaginatedQueryOrderBy>;
  type?: InputMaybe<PaginatedQueryOrderBy>;
};

export type DeviceScanInput = {
  /** Opaque cursor from a previous page's nextCursor. Omit for the first page. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Page size (default 1000, max 5000). */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Optional device type filter, e.g. ["meter"]. Omit for all types. */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Workspace whose devices to enumerate. Authorization is enforced against this workspace. */
  workspaceId: Scalars['ID']['input'];
};

export type DeviceScheduleForDeviceInput = {
  deviceId: Scalars['String']['input'];
};

export type DeviceSearchInput = {
  displayModelName?: InputMaybe<PaginatedQuerySearchInput>;
  manufacturer?: InputMaybe<PaginatedQuerySearchInput>;
  /**
   * The manufacturer's own identifier for the device. For meters this is the meter
   * number printed on the unit (it equals MeterStaticState.meterId).
   */
  manufacturerDeviceId?: InputMaybe<PaginatedQuerySearchInput>;
  name?: InputMaybe<PaginatedQuerySearchInput>;
  referenceId?: InputMaybe<PaginatedQuerySearchInput>;
  serialNumber?: InputMaybe<PaginatedQuerySearchInput>;
  tags?: InputMaybe<PaginatedQuerySearchInput>;
};

/**
 * Numeric DeviceState fields the threshold scan can target.
 *
 * Enum/boolean fields (chargingState, gridStatus, connected, …) live on
 * child state tables and aren't supported in v1 — see the explore-AI
 * historical-state-queries spec for the v2 follow-on.
 */
export type DeviceStateField =
  | 'batteryCharge'
  | 'batteryChargePercentage'
  | 'batteryChargeRate'
  | 'batteryGridEnergy'
  | 'batteryGridPower'
  | 'batteryLoadEnergy'
  | 'batteryLoadPower'
  | 'inverterGeneratedEnergy'
  | 'inverterGridEnergy'
  | 'inverterGridPower'
  | 'inverterLifetimeEnergyGenerated'
  | 'inverterLoadEnergy'
  | 'inverterLoadPower'
  | 'inverterPower';

export type DeviceStateFilter = {
  ambientTemperature?: InputMaybe<ArithmeticFilter>;
  backupReserve?: InputMaybe<ArithmeticFilter>;
  charge?: InputMaybe<ArithmeticFilter>;
  chargeLimit?: InputMaybe<ArithmeticFilter>;
  chargePercentage?: InputMaybe<ArithmeticFilter>;
  chargeRate?: InputMaybe<ArithmeticFilter>;
  chargerCurrent?: InputMaybe<ArithmeticFilter>;
  chargerVoltage?: InputMaybe<ArithmeticFilter>;
  chargerWattage?: InputMaybe<ArithmeticFilter>;
  chargingState?: InputMaybe<Array<BatteryChargingState>>;
  coolTarget?: InputMaybe<ArithmeticFilter>;
  gridEnergy?: InputMaybe<ArithmeticFilter>;
  gridPower?: InputMaybe<ArithmeticFilter>;
  gridStatus?: InputMaybe<Array<GridStatus>>;
  heatTarget?: InputMaybe<ArithmeticFilter>;
  power?: InputMaybe<ArithmeticFilter>;
  range?: InputMaybe<ArithmeticFilter>;
};

export type DeviceStateHistoryFilter = {
  from: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The active workspace the caller is browsing. Optional and UNTRUSTED — it
   * grants nothing on its own. When the device is denied by Oso and the
   * effective-filter fallback runs, the caller's composed filter for this
   * workspace is what may admit a shared cross-org device whose home is another
   * org. Omit it for the home-keyed behavior.
   */
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeviceStateHistoryInput = {
  filter: DeviceStateHistoryFilter;
  pagination?: InputMaybe<ListPagination>;
};

/**
 * Static state input for device configuration.
 * Fields are used based on device type:
 * - Battery: capacity, maxChargeRate, maxDischargeRate, numberOfBatteries
 * - Inverter: power
 */
export type DeviceStaticStateInput = {
  /** Battery capacity in watt-hours (Wh). Required for battery devices. */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum charge rate in watts (W). Optional for battery devices. */
  maxChargeRate?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum discharge rate in watts (W). Optional for battery devices. */
  maxDischargeRate?: InputMaybe<Scalars['Float']['input']>;
  /** Number of battery units in the system. Optional for battery devices. */
  numberOfBatteries?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum power output in watts (W). Required for inverter devices. */
  power?: InputMaybe<Scalars['Float']['input']>;
};

/** Tag changes for one device, applied atomically: removals first, then additions. Tags keep their case. */
export type DeviceTagChangesInput = {
  add?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The DeviceOnWorkspace id */
  id: Scalars['ID']['input'];
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Remove every tag starting with one of these, e.g. "cluster_name:" to replace a key:value tag together with add */
  removePrefixes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeviceType =
  | 'battery'
  | 'charger'
  | 'inverter'
  | 'meter'
  | 'other'
  | 'sensor'
  | 'thermostat'
  | 'unknown'
  | 'vehicle'
  | 'water_heater';

export type DeviceTypeScope =
  | 'ALL'
  | 'BATTERIES'
  | 'CHARGERS'
  | 'OTHER'
  | 'SOLAR_INVERTERS'
  | 'THERMOSTATS'
  | 'UNKNOWN'
  | 'VEHICLES';

export type DevicesFilter = {
  collectionMembership?: InputMaybe<Array<Scalars['ID']['input']>>;
  connected?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /**
   * Filter by the Connect connectionId currently stamped on the DeviceOnWorkspace.
   * See BOLT-1558.
   */
  connectionId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use model and manufacturer instead */
  displayModelName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by device IDs (DeviceOnWorkspace IDs) */
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<DeviceLocationFilter>;
  manufacturer?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerDeviceId?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerUserId?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<DeviceStateFilter>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<DeviceType>>;
  workspaceId: Scalars['ID']['input'];
};

export type DevicesInput = {
  filter: DevicesFilter;
  orderBy?: InputMaybe<DeviceOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<DeviceSearchInput>;
  /** Data source override. Pass "db" to query Postgres directly instead of Elasticsearch. */
  source?: InputMaybe<Scalars['String']['input']>;
  /**
   * Generic, registry-validated filter expression evaluated in addition to
   * `filter`. Supports the full operator vocabulary (including neq/nin) and
   * nested AND/OR groups. Additive: when omitted, behavior is identical to
   * today. Translated to Elasticsearch by default, or to Postgres when
   * `source: "db"`.
   */
  where?: InputMaybe<FilterExpression>;
};

export type DisableEnrollmentReportInput = {
  workspaceProgramId: Scalars['ID']['input'];
};

export type DisableOrganizationSsoInput = {
  organizationId: Scalars['String']['input'];
};

/** Input for disabling a dashboard pack for an organization */
export type DisablePackInput = {
  /** The ID of the organization to disable the pack for */
  organizationId: Scalars['ID']['input'];
  /** The type of pack to disable */
  pack: PackType;
};

export type DiscardLifecycleDraftInput = {
  /** The lifecycle definition whose draft to restore from its published snapshot. */
  definitionId: Scalars['ID']['input'];
};

export type DispatchPopulationMode =
  | 'FILTERED'
  | 'WHOLE_PROGRAM';

/**
 * What moved a dispatch. Becomes the `actor` on its `transitions` entry when the
 * caller is not a person; a real Texture user id wins when there is one, so a
 * value here answers "which machine did this" rather than replacing "who".
 *
 * **This is a label, not a permission.** Every caller picks its own value and the
 * mutations accept client credentials, so nothing may be granted on the strength
 * of it — an earlier revision let `ADMIN` name terminal `expectedStatuses` and that
 * was a hole, because the adapter could simply send `ADMIN`. Authorization is the
 * directive plus the per-record checks; this is forensics.
 *
 * Each value names a caller that does not exist yet — RH-11 and RH-12 are the
 * tickets that will send them — so treat these as the contract those sweeps are
 * being written against.
 */
export type DispatchRecordSource =
  /**
   * A back-of-house admin endpoint driven by a Texture operator (RH-12's exits:
   * adopt an id, abandon and release the window, force a sync). Distinguishes an
   * operator-initiated change from an automated one in the transition log.
   *
   * Note the operator usually arrives through the adapter's admin route, so the
   * call still carries client credentials and there may be no user id to record —
   * which is exactly why this value exists, and exactly why it cannot be trusted
   * as evidence of one.
   */
  | 'ADMIN'
  /**
   * The poll sweep in `adapters/program` (RH-11). Selects due work from
   * `workspaceProgramEventDispatchesDueForPoll`, reads
   * `GET /vpp/v2/events/{id}?poll=true`, maps the provider's `EventState` onto our
   * status, and sets `nextPollAt` from the response's `polling_hint` — or marks
   * `stalled` once the provider's fixed `poll_end` has passed.
   *
   * The results ladder is the same sweep and the same source: it calls
   * `recordWorkspaceProgramEventDispatchResults` at end +12/24/36/48h until a
   * payload appears.
   */
  | 'POLL'
  /**
   * The reconciliation probe in `adapters/program` (RH-12), which runs for a
   * dispatch stuck at `unknown` — one where a provider event may exist and we hold
   * no id for it. It pages `GET /vpp/v2/events`, filters out terminal candidates,
   * and adopts an `externalId` only on exactly one non-terminal match; two or more
   * stops and alerts. It is also what terminalizes a dispatch to `error` once its
   * window has fully passed with every probe empty.
   */
  | 'RECONCILE';

/**
 * What kind of change to a corpus document fires a workflow. LINKED means the
 * document gained or changed its organization link; CATEGORY_CHANGED tracks
 * docType. A document without a canonical organization never fires anything.
 */
export type DocumentEvent =
  | 'CATEGORY_CHANGED'
  | 'CONTENT_CHANGED'
  | 'CREATED'
  | 'LINKED';

/**
 * Which document attribute a trigger filter reads. Each field is only populated by
 * some sources (Gmail has no folder, Notion has no participants), and a trigger
 * naming a field none of its sources populate is rejected at write time.
 */
export type DocumentFilterField =
  | 'BODY'
  | 'CATEGORY'
  | 'DRIVE_FOLDER'
  | 'FROM'
  | 'NOTION_DATABASE'
  | 'PARTICIPANT'
  | 'PARTICIPANT_DOMAIN'
  | 'SENDER_DOMAIN'
  | 'SLACK_CHANNEL'
  | 'TITLE';

export type DocumentFilterInput = {
  field: DocumentFilterField;
  op: DocumentFilterOp;
  values: Array<Scalars['String']['input']>;
};

/**
 * How a filter compares its values. CONTAINS, NOT_CONTAINS and EQUALS are
 * case-insensitive. NOT_CONTAINS keeps a document none of whose values mention
 * any listed text (an empty field passes), on TITLE, BODY, FROM and PARTICIPANT.
 */
export type DocumentFilterOp =
  | 'CONTAINS'
  | 'EQUALS'
  | 'IS_ONE_OF'
  | 'MATCHES_DOMAIN'
  | 'NOT_CONTAINS';

/**
 * Which recent activity a scheduled population requires. SINCE_LAST_REVIEW is
 * activity newer than this workflow's last answered review of the organization
 * (or, never reviewed, anything in the lookback); WITHIN_LOOKBACK is anything in
 * the lookback window; ANY requires none.
 */
export type DocumentWorkflowActivityFilter =
  | 'ANY'
  | 'SINCE_LAST_REVIEW'
  | 'WITHIN_LOOKBACK';

/**
 * One create a person changed. `values` REPLACES the entry's whole object when it
 * is present and leaves it alone when absent, so an acknowledgement can be sent on
 * its own; `remove` is a toggle, never a delete.
 */
export type DocumentWorkflowDraftCreateInput = {
  duplicateAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  ref: Scalars['String']['input'];
  remove?: InputMaybe<Scalars['Boolean']['input']>;
  templateKey: Scalars['String']['input'];
  values?: InputMaybe<Scalars['JSON']['input']>;
};

/** One field entry a person changed. A null `value` is the "Don't write this" toggle. */
export type DocumentWorkflowDraftFieldInput = {
  fieldKey: Scalars['String']['input'];
  ref: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type DocumentWorkflowDraftInput = {
  creates: Array<DocumentWorkflowDraftCreateInput>;
  fields: Array<DocumentWorkflowDraftFieldInput>;
};

/**
 * Which record a catalog field lives on, and which record a proposal row points
 * at. CONTACT arrives with the record templates (a contact a session creates);
 * a USER is never one of these — see DocumentWorkflowTemplateRefEntity.
 */
export type DocumentWorkflowFieldEntity =
  | 'CONTACT'
  | 'DEAL'
  | 'ORGANIZATION';

/**
 * How a catalog field's value is validated and rendered. TEXT is a string, DATE a
 * YYYY-MM-DD day, NUMBER a JSON number, INTEGER a whole JSON number, BOOLEAN a JSON
 * true or false, and ENUM one of the field's `enumValues`. REF is a record template
 * field whose value names another record (the template field's `refEntity` says
 * which kind); a session resolves it to an id, and the model never supplies one.
 */
export type DocumentWorkflowFieldValueType =
  | 'BOOLEAN'
  | 'DATE'
  | 'ENUM'
  | 'INTEGER'
  | 'NUMBER'
  | 'REF'
  | 'TEXT';

export type DocumentWorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  instructions: Scalars['String']['input'];
  /**
   * What runs this workflow. Immutable: an update naming a different kind than
   * the stored row is refused rather than honoured.
   */
  kind?: DocumentWorkflowKind;
  /**
   * Any model id the deployment's provider serves, or null for the deployment's
   * default. Checked for shape only (at most 200 characters of letters, digits
   * and . _ - : / @ + ~); testDocumentWorkflowModel checks one actually answers.
   */
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Required for a SCHEDULED workflow and refused for every other kind. */
  schedule?: InputMaybe<DocumentWorkflowScheduleInput>;
  targets: Array<DocumentWorkflowTargetInput>;
  /**
   * Required for a DOCUMENT workflow and refused for every other kind: a PROMPTED
   * one is run by a person and a SCHEDULED one by its schedule.
   */
  trigger?: InputMaybe<DocumentWorkflowTriggerInput>;
};

/**
 * What runs a workflow. A DOCUMENT workflow is fired by corpus document updates
 * and carries a trigger; a PROMPTED one is run by a person pasting text into a
 * session, writes only what that person confirms, and carries no trigger at all;
 * a SCHEDULED one fires on a recurring schedule and reviews a population of
 * organizations each time, carrying a schedule and no trigger. Immutable after
 * create.
 */
export type DocumentWorkflowKind =
  | 'DOCUMENT'
  | 'PROMPTED'
  | 'SCHEDULED';

/** Which week of the month a WEEKDAY_OF_MONTH recurrence takes. LAST covers a fifth one. */
export type DocumentWorkflowMonthWeek =
  | 'FIRST'
  | 'FOURTH'
  | 'LAST'
  | 'SECOND'
  | 'THIRD';

/**
 * How a monthly recurrence picks its day: a day number (29-31 clamp to the
 * month's last day) or the Nth weekday, such as the first Monday.
 */
export type DocumentWorkflowMonthlyMode =
  | 'DAY_OF_MONTH'
  | 'WEEKDAY_OF_MONTH';

/** Whether a scheduled population requires an empty next step, a non-empty one, or either. */
export type DocumentWorkflowNextStepFilter =
  | 'ANY'
  | 'EMPTY'
  | 'NOT_EMPTY';

/** Whether a scheduled population requires, forbids or ignores open deals. */
export type DocumentWorkflowOpenDealsFilter =
  | 'ANY'
  | 'WITHOUT_OPEN_DEALS'
  | 'WITH_OPEN_DEALS';

/**
 * Omitted fields take their defaults: any status but PARTNER and DISQUALIFIED,
 * any segment, deals and next step ignored, activity since the last review.
 */
export type DocumentWorkflowPopulationInput = {
  activity?: InputMaybe<DocumentWorkflowActivityFilter>;
  /** Omitted means [PARTNER, DISQUALIFIED]; an empty list excludes nothing. */
  excludedSalesStatuses?: InputMaybe<Array<CanonicalOrganizationSalesStatus>>;
  nextStep?: InputMaybe<DocumentWorkflowNextStepFilter>;
  openDeals?: InputMaybe<DocumentWorkflowOpenDealsFilter>;
  /** 1-500 ids, or null for every organization. */
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  salesStatuses?: InputMaybe<Array<CanonicalOrganizationSalesStatus>>;
  segments?: InputMaybe<Array<UtilitySegment>>;
};

/**
 * Where one proposed field value stands. AUTO_APPLIED was written by the workflow
 * itself; APPLIED was written by a person accepting it. BLOCKED is the
 * deterministic gate's record of a suggestion it refused — visible and inert.
 */
export type DocumentWorkflowProposalStatus =
  | 'APPLIED'
  | 'AUTO_APPLIED'
  | 'BLOCKED'
  | 'PROPOSED'
  | 'REJECTED'
  | 'REVERTED';

/** The recurrence, validated as a whole; omitted optional fields take their documented defaults. */
export type DocumentWorkflowRecurrenceInput = {
  /** 1-1000. */
  endAfterOccurrences?: InputMaybe<Scalars['Int']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  frequency: DocumentWorkflowScheduleFrequency;
  /** 1-99; default 1. */
  interval?: InputMaybe<Scalars['Int']['input']>;
  monthDay?: InputMaybe<Scalars['Int']['input']>;
  monthWeek?: InputMaybe<DocumentWorkflowMonthWeek>;
  monthWeekday?: InputMaybe<DocumentWorkflowWeekday>;
  /** Required for MONTHLY, refused otherwise. */
  monthlyMode?: InputMaybe<DocumentWorkflowMonthlyMode>;
  /** Between 2020 and 2100. */
  startsOn: Scalars['Date']['input'];
  /** 24-hour HH:mm. */
  timeOfDay: Scalars['String']['input'];
  /** An IANA time zone, such as America/Denver. */
  timeZone: Scalars['String']['input'];
  /** WEEKLY only, at least one, no repeats. */
  weekdays?: InputMaybe<Array<DocumentWorkflowWeekday>>;
};

/**
 * What code made of one candidate string the model named. CREATE is the person's
 * own answer — make this record rather than pick an existing one — and is never
 * something the model can ask for.
 */
export type DocumentWorkflowResolutionStatus =
  | 'AMBIGUOUS'
  | 'CREATE'
  | 'RESOLVED'
  | 'UNRESOLVED';

/**
 * What happened to one attempt at one (workflow, organization) pair. DECLINED and
 * SKIPPED both wrote nothing: DECLINED is a verdict (the documents held no
 * change), SKIPPED is a refusal before any model call (capped, disabled, revoked).
 */
export type DocumentWorkflowRunStatus =
  | 'COMPLETED'
  | 'DECLINED'
  | 'ERROR'
  | 'PARSE_ERROR'
  | 'RUNNING'
  | 'SKIPPED';

/** Omitted fields take their defaults: FIREFLIES, GMAIL, SLACK, GDRIVE and GCAL, no filters, touchpoints included. */
export type DocumentWorkflowScheduleDocumentsInput = {
  filters?: InputMaybe<Array<DocumentFilterInput>>;
  includeTouchpoints?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<CorpusSource>>;
};

/** How often a scheduled workflow's recurrence repeats. */
export type DocumentWorkflowScheduleFrequency =
  | 'DAILY'
  | 'MONTHLY'
  | 'WEEKLY';

export type DocumentWorkflowScheduleInput = {
  documents?: InputMaybe<DocumentWorkflowScheduleDocumentsInput>;
  /** 1-90; default 14. */
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  /** 1-500; default 200. */
  maxOrgsPerOccurrence?: InputMaybe<Scalars['Int']['input']>;
  population?: InputMaybe<DocumentWorkflowPopulationInput>;
  recurrence: DocumentWorkflowRecurrenceInput;
};

/**
 * Where one prompted session stands. CONFIRMING is the claim one confirm holds
 * while it writes, never a resting state; CONFIRMED is terminal whether every
 * write landed or not (the session's errorMessage and its proposal rows say what
 * did); ABANDONED is a draft nobody finished. A session is never deleted.
 */
export type DocumentWorkflowSessionStatus =
  | 'ABANDONED'
  | 'CONFIRMED'
  | 'CONFIRMING'
  | 'DRAFT';

export type DocumentWorkflowTargetInput = {
  fieldKey: Scalars['String']['input'];
  mode: DocumentWorkflowTargetMode;
};

/** Whether a workflow may write a field itself or only ever propose it to a person. */
export type DocumentWorkflowTargetMode =
  | 'APPLY'
  | 'PROPOSE';

/**
 * Which kind of record a template REF names. Wider than
 * DocumentWorkflowFieldEntity by exactly USER: no proposal row is ever written
 * about a user, but `deal.create.ownerId` is a reference to one, so every
 * deal-creating session carries a USER resolution.
 */
export type DocumentWorkflowTemplateRefEntity =
  | 'CONTACT'
  | 'DEAL'
  | 'ORGANIZATION'
  | 'USER';

/** Omitted fields take their documented defaults; null organizationIds/documentIds mean "any". */
export type DocumentWorkflowTriggerInput = {
  debounceMinutes?: InputMaybe<Scalars['Int']['input']>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  events?: InputMaybe<Array<DocumentEvent>>;
  filters?: InputMaybe<Array<DocumentFilterInput>>;
  maxRunsPerDay?: InputMaybe<Scalars['Int']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sources: Array<CorpusSource>;
};

/** A day of the week. Weeks start on Monday when "every N weeks" is counted. */
export type DocumentWorkflowWeekday =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type DomainVerificationFailureReason =
  /** Another organization has already verified this domain. */
  | 'CLAIMED_BY_ANOTHER_ORGANIZATION'
  /** The DNS lookup failed; try again. */
  | 'DNS_LOOKUP_FAILED'
  /** The DNS lookup timed out; try again. */
  | 'DNS_TIMEOUT'
  /** Texture and consumer email domains cannot be verified by an organization. */
  | 'INELIGIBLE_DOMAIN'
  /** TXT records exist at the record name, but none carries this domain's value. */
  | 'RECORD_MISMATCH'
  /** No TXT record exists at the verification record name. */
  | 'RECORD_NOT_FOUND'
  /** A Texture admin cannot approve a domain for an organization they belong to. */
  | 'SELF_APPROVAL';

export type DriveFolderCatchUpStatus =
  /** Superseded by a newer link change, or the mapping went away. */
  | 'CANCELLED'
  | 'COMPLETE'
  | 'FAILED'
  /** Stopped at its time slice; the worker resumes it. */
  | 'PAUSED'
  /** Queued; the ingest worker has not picked it up yet. */
  | 'QUEUED'
  | 'RUNNING';

/** Input for listing duplicate candidates for a workspace. */
export type DuplicateCandidatesInput = {
  /**
   * When true, dismissed candidates are included in the results.
   * Defaults to false (only active / undismissed candidates returned).
   */
  includeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum number of candidates to return. Defaults to 50. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of candidates to skip (for offset-based pagination). Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for checking duplicate devices by manufacturerUserId. */
export type DuplicateDeviceCheckInput = {
  /** The manufacturer's unique identifier for the user (e.g., Tesla account ID) */
  manufacturerUserId: Scalars['String']['input'];
  /** The workspace to check for duplicate devices */
  workspaceId: Scalars['ID']['input'];
};

/** One edit of a definition and its options; every part is validated together and applied all or nothing. */
export type EditCrmPropertyDefinitionInput = {
  /** Matched case-insensitively against the options as they were before this edit; retired matches are revived. */
  addOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  numberFormat?: InputMaybe<CrmPropertyNumberFormat>;
  renameOptions?: InputMaybe<Array<CrmPropertyOptionRenameInput>>;
  restoreOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  retireOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EligibilityCheckStatus =
  | 'failure'
  | 'pending'
  | 'success';

export type EligibilityStatus =
  | 'approved'
  | 'candidate'
  | 'eligible'
  | 'ineligible'
  | 'rejected'
  | 'submitted'
  | 'unenrolled'
  | 'unenrolling';

export type EnableEnrollmentReportInput = {
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for enabling a dashboard pack for an organization */
export type EnablePackInput = {
  /** The ID of the organization to enable the pack for */
  organizationId: Scalars['ID']['input'];
  /** The type of pack to enable */
  pack: PackType;
};

export type EndCanonicalContactAffiliationForAutomationInput = {
  actorId: Scalars['ID']['input'];
  affiliationId: Scalars['ID']['input'];
  automation: ContactAutomationInput;
  /** The active row ids the caller reviewed; another active row of the pair, or none still active → `AFFILIATION_MOVED`, nothing ends. */
  expectedAffiliationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Undo of the apply that started `affiliationId`: only that row ends, and not as a person's removal. */
  restoresProposalId?: InputMaybe<Scalars['ID']['input']>;
  restoresRowId?: InputMaybe<Scalars['ID']['input']>;
};

export type EndCanonicalContactAffiliationInput = {
  /** Any active row of the (contact, organization) pair. */
  affiliationId: Scalars['ID']['input'];
};

export type EnergyUsageInput = {
  /** The end date of the period. */
  endDate: Scalars['DateTime']['input'];
  /** The start date of the period. */
  startDate: Scalars['DateTime']['input'];
  /** The workspace this Meter belongs to. */
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type EnphaseGridServicesEnrollmentsInput = {
  manufacturerSiteId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Enrollment board facet request (workspace-scoped): registry field paths to fetch
 * distinct values for. Only terms-aggregatable enrollment columns are honored.
 */
export type EnrollmentBoardFacetsInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** A date column an enrollment time facet buckets on via `date_trunc`. */
export type EnrollmentDateField =
  | 'createdAt'
  | 'enrollmentStartDate'
  | 'updatedAt';

/**
 * A terms-aggregatable enrollment field for a category facet (SQL `GROUP BY`).
 * Mirrors the enrollment field-registry entries carrying `aggregate: terms`.
 * manufacturerSlugs / tags are array columns — a row contributes to each value's
 * bucket (unnested).
 */
export type EnrollmentFacetField =
  | 'eligibilityStatus'
  | 'identificationType'
  | 'manufacturerSlugs'
  | 'tags';

/**
 * Workspace-wide enrollment facet aggregation (SQL `GROUP BY`). Provide EITHER a
 * `field` (a terms facet) OR a `dateField` + `interval` (a date-bucket facet), not
 * both. The optional filters mirror WorkspaceEnrollmentsInput so a chart honors the
 * board's filters, and the workspace scope + soft-delete exclusion are enforced the
 * same way as workspaceEnrollments.
 */
export type EnrollmentFacetInput = {
  /**
   * Inclusive createdAt window (half-open ranges allowed — either bound is
   * optional), mirroring WorkspaceEnrollmentsInput so a chart scopes like the list.
   */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Membership over several customers, for when a name resolved to more than one
   * contact record (duplicate contacts sharing an email are common). Combines with
   * `customerId` as an intersection, so passing both narrows rather than widens;
   * an empty list is read as "no filter", like the other list filters here.
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Date-bucket facet column. Requires `interval`. Provide this OR `field`. */
  dateField?: InputMaybe<EnrollmentDateField>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  enrollmentGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Terms facet field. Provide this OR (dateField + interval). */
  field?: InputMaybe<EnrollmentFacetField>;
  /**
   * Presence predicate over the same column as `deviceIds`: false selects
   * enrollments with no attached device, true those with at least one.
   */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bucket width for a date-bucket facet. Required when `dateField` is set. */
  interval?: InputMaybe<DateInterval>;
  /**
   * Max number of buckets for a terms facet (top-N by count), mirroring an
   * Elasticsearch `terms` size. Ignored for date-bucket facets. Omitted → unbounded.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<EligibilityStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
  /** Optional: narrow the workspace-wide scope to a single program. */
  workspaceProgramId?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentInput = {
  pagination?: InputMaybe<OffsetPagination>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentOrderByField =
  | 'createdAt'
  | 'eligibilityStatus'
  | 'enrollmentStartDate'
  | 'updatedAt';

export type EnrollmentOrderByInput = {
  direction?: InputMaybe<PaginatedQueryOrderBy>;
  field: EnrollmentOrderByField;
};

/**
 * Input for `ensureCanonicalContactByEmail`. Mirrors the service-layer
 * args of `findOrCreateCanonicalContactByEmail` plus optional name /
 * external-id claim fields so a caller can do match-or-create + claim
 * attach in one round trip.
 */
export type EnsureCanonicalContactByEmailInput = {
  /**
   * Optional organization affiliation to record in the same transaction.
   * Writes one CanonicalContactAffiliation (+ an AFFILIATION_STARTED source
   * event) attributed to `source` / `sourceRecordId` / `observedAt`. Idempotent
   * on an existing active affiliation for the same organization — matched on
   * `organizationId` when one is supplied, otherwise on `canonicalOrganizationId`:
   * a match is reused and only its null `role` / `canonicalOrganizationId` /
   * `organizationId` are filled in (with an AFFILIATION_UPDATED event); an ended
   * affiliation is not revived — a new row is started.
   */
  affiliation?: InputMaybe<CanonicalContactAffiliationInput>;
  /**
   * Email to find-or-create by. Normalized internally; role addresses
   * (e.g. `info@…`) are rejected with `ROLE_ADDRESS_NOT_AUTO_LINKABLE`.
   */
  email: Scalars['String']['input'];
  /**
   * Optional external-id value (e.g. `nisc_forum:12345`). Must be set
   * together with `externalIdSource`. Idempotent on `(source, externalId)`
   * — ON CONFLICT DO NOTHING.
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional external-id source for the audit-trail claim (e.g.
   * `NISC_INTEL`). Must be set together with `externalId`, and is held to the
   * same allowlist as `source`.
   */
  externalIdSource?: InputMaybe<ContactDataSource>;
  /**
   * Optional first-name claim. When set together with `lastName` /
   * `preferredName`, all three land on a single CanonicalContactNameClaim
   * row plus a NAME_CLAIMED source event.
   */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Optional last-name claim. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * When the name claim is written. Defaults to `ALWAYS`; `WHEN_UNNAMED`
   * writes it only for a contact with no resolved name.
   */
  nameClaim?: InputMaybe<CanonicalContactNameClaimPolicy>;
  /**
   * When the source data was observed. Stamped onto every claim +
   * audit row written by this call.
   */
  observedAt: Scalars['DateTime']['input'];
  /** Optional preferred-name claim (free-form display string). */
  preferredName?: InputMaybe<Scalars['String']['input']>;
  /**
   * When true, refuse with `CANONICAL_CONTACT_REMOVED` (writing nothing) if the address belongs to a
   * deleted or redacted contact whose email claim still holds it.
   */
  refuseRemovedContact?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, refuse with `CANONICAL_ORGANIZATION_NOT_FOUND` (writing nothing) if the affiliation's
   * `canonicalOrganizationId` is missing, deleted or merged away. Requires `affiliation.canonicalOrganizationId`.
   */
  requireLiveCanonicalOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Source enum value for attribution on every claim + audit row
   * written by this call. Must be one of `NISC_INTEL`, `IMPORT`, `THIRD_PARTY`,
   * `HUBSPOT` or `MANUAL_ENTRY`; any other value fails with `BAD_USER_INPUT`
   * before anything is written.
   */
  source: ContactDataSource;
  /**
   * Optional source-system record id (NISC contact id, HubSpot row id,
   * …). Stored on every claim + audit row written by this call.
   */
  sourceRecordId?: InputMaybe<Scalars['String']['input']>;
};

export type EnsurePremiseSiteInput = {
  /**
   * ID of the premise Location the Site must belong to. Keyed on the Location, never on an
   * address — deriving one from address text creates Sites at the wrong premise.
   */
  locationId: Scalars['String']['input'];
  /** ID of the workspace the WorkspaceSite belongs to. Must have a configured premise policy. */
  workspaceId: Scalars['String']['input'];
};

/**
 * Why a premise was refused a Site. A refusal is a normal outcome, not an error: the meter
 * stays orphaned and the refusal is counted.
 */
export type EnsurePremiseSiteRefusal =
  /** The premise lacks the street address or postal code needed to justify a Site. */
  | 'INSUFFICIENT_EVIDENCE'
  /** The locationId does not resolve to a Location. */
  | 'LOCATION_NOT_FOUND'
  /** The workspace has no configured premise-site policy. */
  | 'NO_PREMISE_POLICY'
  /** The premise is outside the state the policy requires. */
  | 'OUT_OF_STATE'
  /** The premise is outside the policy's service territory, or has no usable coordinates. */
  | 'OUT_OF_TERRITORY'
  /** The Site or WorkspaceSite write failed. */
  | 'SITE_REPOSITORY_ERROR';

/**
 * The kinds of entity page whose layout an admin can configure (M4 MR-5).
 *
 * A Prisma enum on the storage side too, so a garbage `entityType` is unwritable at the
 * database rather than only at the validator. The trade is knowing: a new composed page costs a
 * migration in `identity`.
 */
export type EntityPageType =
  /** The collection detail page. */
  | 'COLLECTION'
  /** The customer detail page. */
  | 'CUSTOMER'
  /** The device detail page. */
  | 'DEVICE'
  /** The grid element detail page. */
  | 'GRID_ELEMENT'
  /** The monitor detail page. */
  | 'MONITOR'
  /** The program event detail page. */
  | 'PROGRAM_EVENT'
  /** The site detail page. */
  | 'SITE';

export type ErrorCode =
  | 'INVALID_INPUT';

export type EvaluateLifecycleInstanceInput = {
  lifecycleInstanceId: Scalars['String']['input'];
};

/** Why evaluation stopped. */
export type EvaluationOutcome =
  | 'ADVANCED'
  | 'ALREADY_TERMINAL'
  | 'LOOP_GUARD'
  | 'NO_PASSING_TRANSITION'
  | 'PARTIAL'
  | 'REQUIREMENTS_NOT_MET'
  /** An enrollment-first instance follows its status, so the engine held its passing transitions */
  | 'STATUS_AUTHORITATIVE'
  | 'TERMINAL';

export type EventCategory =
  | 'ALERT'
  | 'COMMAND'
  | 'CONNECTION'
  | 'CUSTOMER'
  | 'DEVICE'
  | 'ENROLLMENT'
  | 'SITE';

export type EventFacetInterval =
  | 'DAY'
  | 'HOUR'
  | 'MONTH'
  | 'WEEK';

/**
 * Filters mirror EventsFeedInput so the histogram stays in lockstep with the
 * feed. `eventTypes` wins over `categories` when both are provided (same
 * precedence as the feed).
 */
export type EventFacetsInput = {
  afterTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  beforeTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  categories?: InputMaybe<Array<EventCategory>>;
  eventTypes?: InputMaybe<Array<EventType>>;
  interval: EventFacetInterval;
};

export type EventInput = {
  eventTypes?: InputMaybe<Array<InputMaybe<EventType>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type EventOrderByField =
  | 'EVENT_TYPE'
  | 'TIMESTAMP';

export type EventOrderByInput = {
  direction?: SortDirection;
  field?: EventOrderByField;
};

export type EventStreamRefType =
  | 'BRIEF'
  | 'COMMONGRID_DQ_REJECTED'
  | 'COMMONGRID_SOFT_DELETED'
  | 'CONTACT'
  | 'MERGE_REMAPPED'
  | 'NISC_ANALYSIS'
  | 'NISC_REPLY'
  | 'NISC_THREAD'
  | 'QUERY'
  | 'SIGNAL'
  | 'TOUCHPOINT';

export type EventType =
  | 'ALERT_CREATED'
  | 'ALERT_UPDATED'
  | 'COMMAND_FAILED'
  | 'COMMAND_OVERRIDDEN'
  | 'COMMAND_SCHEDULED'
  | 'COMMAND_SUCCEEDED'
  | 'CONNECTION_FAILED'
  | 'CUSTOMER_CREATED'
  | 'CUSTOMER_DELETED'
  | 'CUSTOMER_UPDATED'
  | 'DEVICE_CONNECTED'
  | 'DEVICE_DISCONNECTED'
  | 'DEVICE_DISCOVERED'
  | 'DEVICE_UPDATED'
  | 'ENROLLMENT_APPROVED'
  | 'ENROLLMENT_REJECTED'
  | 'ENROLLMENT_SUBMITTED'
  | 'SITE_CREATED'
  | 'SITE_DELETED'
  | 'SITE_UPDATED';

export type EventsFeedInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  afterTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  beforeTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  categories?: InputMaybe<Array<EventCategory>>;
  eventTypes?: InputMaybe<Array<EventType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EventOrderByInput>;
};

export type ExchangeApiKeyForOwnerTokenInput = {
  apiKey: Scalars['String']['input'];
};

export type ExecuteBatchInput = {
  batchId: Scalars['ID']['input'];
};

/** Input for executing a workflow with parameters */
export type ExecuteWorkflowInput = {
  /** Runtime parameters to pass to the workflow execution */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** Trigger context information */
  triggerContext?: InputMaybe<Scalars['JSON']['input']>;
};

export type ExpirationInput = {
  /** The iso8601 date time string that the session should expire at. */
  at?: InputMaybe<Scalars['DateTime']['input']>;
  /** The duration in seconds that the session should be valid for. */
  in?: InputMaybe<Scalars['Int']['input']>;
};

/** Result entity to explore. Determines which ES index is queried. */
export type ExploreEntity =
  | 'DEVICES'
  | 'SITES';

export type ExploreFacetsInput = {
  entity: ExploreEntity;
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<ExploreFilterNode>;
  workspaceId: Scalars['ID']['input'];
};

/** A single leaf condition: field + operator + JSON value. */
export type ExploreFilterCondition = {
  field: Scalars['String']['input'];
  operator: ExploreFilterOperator;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * Recursive filter expression. Provide exactly one of: leaf, and, or, not.
 *
 * - leaf  → single field condition
 * - and   → all children must match (ES bool.filter)
 * - or    → any child must match (ES bool.should + minimum_should_match: 1)
 * - not   → child must NOT match (ES bool.must_not)
 */
export type ExploreFilterNode = {
  and?: InputMaybe<Array<ExploreFilterNode>>;
  leaf?: InputMaybe<ExploreFilterCondition>;
  not?: InputMaybe<ExploreFilterNode>;
  or?: InputMaybe<Array<ExploreFilterNode>>;
};

/** Filter operator for a leaf condition. */
export type ExploreFilterOperator =
  | 'CONTAINS'
  | 'EQ'
  | 'EXISTS'
  | 'IN'
  | 'NOT_EQ'
  | 'RANGE';

export type ExploreInput = {
  entity: ExploreEntity;
  filters?: InputMaybe<ExploreFilterNode>;
  orderBy?: InputMaybe<ExploreOrderByInput>;
  pagination?: InputMaybe<ExplorePaginationInput>;
  workspaceId: Scalars['ID']['input'];
};

export type ExploreOrderByInput = {
  direction: ExploreSortDirection;
  field: Scalars['String']['input'];
};

export type ExplorePaginationInput = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ExplorePhaseColorsInput = {
  a: Scalars['String']['input'];
  b: Scalars['String']['input'];
  c: Scalars['String']['input'];
};

export type ExploreScanInput = {
  /** Opaque cursor from the previous page's nextCursor. Omit for the first page. */
  after?: InputMaybe<Scalars['String']['input']>;
  entity: ExploreEntity;
  /**
   * Registry field paths to project into each row — the bound columns. Omit to return whole
   * documents, which is what makes an export expensive: the average device document is ~2.9 KB
   * across 39 fields, and a CSV needs a handful of them.
   */
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Same filter grammar as `explore`. Omit for the whole workspace. */
  filters?: InputMaybe<ExploreFilterNode>;
  /** Page size (default 1000, max 5000). */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Workspace whose rows to enumerate. Authorization is enforced against this workspace. */
  workspaceId: Scalars['ID']['input'];
};

export type ExploreSortDirection =
  | 'ASC'
  | 'DESC';

/**
 * Whether `totalCount` is exact or a lower bound. Workspaces with more
 * matches than the track_total_hits cap come back as GTE so the UI can
 * render "10,000+" instead of an inaccurate exact number.
 */
export type ExploreTotalCountRelation =
  | 'EQ'
  | 'GTE';

/** The type of entity a lifecycle field collects data about */
export type FactEntity =
  /** A customer contact */
  | 'CONTACT'
  /** A connected device */
  | 'DEVICE'
  /** A program enrollment */
  | 'ENROLLMENT'
  /** A physical site/location */
  | 'SITE';

export type FetchOrCreateScopedApiKeyForCustomerInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type FieldSearchInput = {
  query: Scalars['String']['input'];
  type: PaginatedQuerySearchTypeEnum;
};

/** Whether a field is defined by the platform registry or by an operator */
export type FieldSource =
  /** Operator-defined custom field scoped to a lifecycle definition */
  | 'CUSTOM'
  /** Built-in field from the Texture platform field registry */
  | 'PLATFORM';

/**
 * A generic, registry-validated filter expression. `conditions` are combined
 * with `logic` (AND/OR/NOT/NOR/NAND). NOT is unary (exactly one condition,
 * negated); NOR matches when none of the conditions match; NAND matches when at
 * least one condition doesn't match. Each condition is either a leaf
 * (field/operator/value) or a nested `group`. Workspace scoping is always
 * applied by the server and is not expressible here.
 */
export type FilterExpression = {
  conditions: Array<FilterNode>;
  logic: FilterLogic;
};

/**
 * Boolean combination logic for a FilterExpression's conditions:
 * - AND: all conditions match
 * - OR: at least one condition matches
 * - NOT: unary negation — exactly one condition, negated
 * - NOR: none of the conditions match
 * - NAND: not all of the conditions match
 */
export type FilterLogic =
  | 'AND'
  | 'NAND'
  | 'NOR'
  | 'NOT'
  | 'OR';

/**
 * A node in a FilterExpression: either a leaf condition (set field, operator and
 * value) OR a nested group (set group). Do not set both.
 */
export type FilterNode = {
  field?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<FilterExpression>;
  operator?: InputMaybe<FilterOperator>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * Comparison operator for a single filter condition. Supported per field type
 * (validated against the field registry): keyword/string fields accept
 * eq/neq/in/nin/contains/startsWith; numeric and date fields accept
 * eq/gt/gte/lt/lte; ID and boolean fields accept eq/neq (and in/nin for IDs).
 */
export type FilterOperator =
  | 'contains'
  | 'eq'
  | 'gt'
  | 'gte'
  | 'in'
  | 'lt'
  | 'lte'
  | 'neq'
  | 'nin'
  | 'startsWith';

/**
 * Threshold-crossing scan over per-device historical state. Returns the
 * devices whose `field` crossed the threshold at any point in [from, to).
 * One row per matching device, capturing the first in-window snapshot that
 * satisfied the condition.
 *
 * Population scoping is optional and additive — by default the scan covers
 * every device in the workspace, with the partial index on the chosen
 * column acting as an implicit device-type filter (only matching device
 * types have that denormalized column populated). Pass `baseQuery` or
 * `deviceIds` to narrow further (e.g. Tesla batteries, a specific tag).
 */
export type FindDevicesWithStateCrossingInput = {
  /**
   * Optional Elasticsearch query DSL to narrow the population. Resolved
   * server-side against the device search index (workspace-scoped). Up to
   * 1000 matching device IDs are fed into the SQL scan.
   */
  baseQuery?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Optional explicit device IDs to scan. Combined with `baseQuery` if
   * both are provided (only IDs that match both are scanned).
   */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  field: DeviceStateField;
  /** Lower bound of the scan window (inclusive). */
  from: Scalars['DateTime']['input'];
  /** Cap on returned matches. Default 100, max 500. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  operator: StateCrossingOperator;
  /** Upper bound of the scan window (exclusive). Max 90-day window. */
  to: Scalars['DateTime']['input'];
  value: Scalars['Float']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * Input for `findOrCreateCanonicalOrganizationByDomain`. The domain is
 * normalized server-side (lowercase, strip scheme / path / port /
 * userinfo / `www.` / trailing dot, IDN → punycode); callers can pass
 * the raw value as observed upstream.
 */
export type FindOrCreateCanonicalOrganizationByDomainInput = {
  /**
   * Raw domain or URL. Normalized by the service before lookup +
   * insert.
   */
  domain: Scalars['String']['input'];
  /**
   * Caller-supplied attributes used only when this call lands on the
   * create branch.
   */
  hints?: InputMaybe<CanonicalOrganizationHintsInput>;
  /** Per-run migration batch tag for rollback-by-tag. */
  migrationBatchId?: InputMaybe<Scalars['String']['input']>;
  /** Upstream source enum value for the domain claim and the audit row. */
  source: OrgDataSource;
};

/**
 * Input for `findOrCreateCanonicalOrganizationByExternalId`. Mirrors the
 * service-layer args one-to-one so the resolver is a thin pass-through.
 */
export type FindOrCreateCanonicalOrganizationByExternalIdInput = {
  /**
   * Foreign system's stable identifier for the org. The pair
   * `(source, externalId)` is the unique idempotency key on
   * `CanonicalOrganizationExternalId`.
   */
  externalId: Scalars['String']['input'];
  /**
   * Caller-supplied attributes used only when this call lands on the
   * create branch. Hints are never re-applied on a match.
   */
  hints?: InputMaybe<CanonicalOrganizationHintsInput>;
  /**
   * Per-run migration batch tag for rollback-by-tag. Threaded into the
   * create-only `migrationBatchId` column when this call inserts a fresh
   * CanonicalOrganization row.
   */
  migrationBatchId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Upstream source enum value (COMMONGRID, HUBSPOT, NISC, NOTION_TAOS, …).
   * Combined with `externalId` to form the unique idempotency key.
   */
  source: OrgDataSource;
  /**
   * Optional source-system record id (HubSpot row id, Salesforce 18-char
   * id, …). Stored on the ExternalId row and on the audit event.
   */
  sourceRecordId?: InputMaybe<Scalars['String']['input']>;
};

export type FinishRelayAgentTurnInput = {
  assistantText?: InputMaybe<Scalars['String']['input']>;
  blocks?: InputMaybe<Scalars['JSON']['input']>;
  citations?: InputMaybe<Scalars['JSON']['input']>;
  digest?: InputMaybe<Scalars['String']['input']>;
  errorClass?: InputMaybe<Scalars['String']['input']>;
  status: RelayAgentTurnStatus;
  steps: Scalars['Int']['input'];
  stopReason?: InputMaybe<Scalars['String']['input']>;
  turnId: Scalars['ID']['input'];
  /** Turn totals; stored counters never decrease. */
  usage: RelayAgentUsageInput;
};

export type FleetHealthDeviceFilterInput = {
  /** Filter by device type */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** Filter by health status */
  status?: InputMaybe<FleetHealthStatusFilter>;
};

/**
 * Filter input for fleet health report.
 * Supports configurable time windows (30, 60, 90 days or custom date range).
 */
export type FleetHealthFilterInput = {
  /** Device-level filters (optional) */
  deviceFilters?: InputMaybe<FleetHealthDeviceFilterInput>;
  /** Program scope determines which programs to include */
  programScope: ProgramScopeInput;
  /** Time scope for metrics calculation (optional - defaults to 30 days) */
  timeScope?: InputMaybe<TimeScopeInput>;
  /** Workspace context for authorization and data scoping */
  workspaceId: Scalars['ID']['input'];
};

export type FleetHealthIssue =
  | 'LONG_RESPONSE_TIMES'
  | 'LOW_SUCCESS'
  | 'OFFLINE_OVER_7_DAYS';

export type FleetHealthStatus =
  | 'OFFLINE'
  | 'ONLINE';

export type FleetHealthStatusFilter =
  | 'ALL'
  | 'NEEDS_ATTENTION'
  | 'OFFLINE'
  | 'ONLINE';

export type FoldCrmOrganizationInput = {
  /** Compute the whole fold in a transaction and roll it back. */
  dryRun: Scalars['Boolean']['input'];
  /** The canonical organization whose crm profile is folded away. */
  loserCanonicalOrganizationId: Scalars['ID']['input'];
  /** The canonical organization whose crm profile survives. */
  winnerCanonicalOrganizationId: Scalars['ID']['input'];
};

/** What one call to `foldCrmOrganization` did, or would have done. */
export type FoldCrmOrganizationOutcome =
  /** The fold was applied. */
  | 'FOLDED'
  /** No crm organization holds the loser canonical, so there is nothing to fold. */
  | 'NO_LOSER_ROW'
  /** No crm organization holds the winner canonical, so there is nothing to fold into. */
  | 'NO_WINNER_ROW'
  /** A dry run: the fold was computed in full and rolled back. */
  | 'PLANNED'
  /** The fold declined and wrote nothing. `message` says why. */
  | 'REFUSED';

export type ForceReconnectManufacturerConnectionInput = {
  /** The OAuth app clientId that owns the connection. */
  clientId: Scalars['String']['input'];
  manufacturer: Scalars['String']['input'];
  manufacturerUserId: Scalars['String']['input'];
  /** Optional audit reason. Defaults to a self-service force reconnect reason. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ForceReconnectManufacturerConnectionStatus =
  | 'CONNECTION_NOT_FOUND'
  | 'HEALTHY_CONNECTION_REFUSED'
  | 'INTERNAL_SERVER_ERROR'
  | 'RECONNECT_REQUIRED'
  | 'UNAUTHORIZED';

export type GenerateConnectLinkForCredentialInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerInfo?: InputMaybe<CustomerInfoInput>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateStatementDownloadUrlInput = {
  provider: Scalars['String']['input'];
  statementId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

/** Input for getting collections for a workspace */
export type GetCollectionsForWorkspaceInput = {
  /** Filter criteria for collections */
  filter: CollectionsFilter;
  /** Optional pagination parameters */
  pagination?: InputMaybe<ListPagination>;
};

export type GetEntitiesByCollectionIdInput = {
  /** Optional pagination parameters */
  pagination?: InputMaybe<ListPagination>;
};

/**
 * The read an effective filter is composed for. Every field is required — the
 * filter is scoped to exactly one workspace, resource type and mode.
 */
export type GetMyEffectiveFilterInput = {
  mode: PermissionGrantMode;
  resourceType: PermissionGrantResourceType;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Narrowing for getMyPermissionGrants. Every field is optional and filters the
 * caller's rows: workspaceId keeps grants into that workspace; resourceType and
 * mode keep grants of that kind. The fence — the caller's live team memberships
 * in the session's organization — applies regardless.
 */
export type GetMyPermissionGrantsInput = {
  mode?: InputMaybe<PermissionGrantMode>;
  resourceType?: InputMaybe<PermissionGrantResourceType>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Optional filters for getSharedCollections. */
export type GetSharedCollectionsInput = {
  collectionType?: InputMaybe<CollectionType>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Input for getTeamGrantedResources. workspaceId narrows ALERT-style grants
 * (whose resourceId is a workspaceId); PROGRAM grants carry workspace-program
 * ids, so PROGRAM lookups pass no workspaceId.
 */
export type GetTeamGrantedResourcesInput = {
  resourceType: SharedResourceType;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type GisCoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GisLayerKind =
  | 'SERVICE_TERRITORY';

export type GisLayerUploadInput = {
  checksumSha256: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

/** Exactly one of coordinate or address is required. */
export type GisTerritoryQueryInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  coordinate?: InputMaybe<GisCoordinateInput>;
  workspaceId: Scalars['ID']['input'];
};

export type GisTerritoryResultStatus =
  | 'INSIDE'
  | 'NO_BOUNDARY'
  | 'OUTSIDE'
  | 'UNRESOLVED_ADDRESS';

export type GisTerritorySource =
  | 'COMMONGRID'
  | 'UPLOADED_OVERRIDE';

export type GisUploadStatus =
  | 'ASSESSING'
  | 'AWAITING_UPLOAD'
  | 'CONVERTING'
  | 'EXPIRED'
  | 'FAILED'
  | 'QUEUED'
  | 'READY'
  | 'STORING';

/** Input for granting app access. */
export type GrantAppAccessInput = {
  /** App slug (lowercase alphanumeric with optional hyphens), e.g. \"relay\". */
  app: Scalars['String']['input'];
  /** Optional expiration for time-boxed access. Null = indefinite. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional reason for the grant. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user to grant access to. */
  userId: Scalars['ID']['input'];
};

/** A device grant not yet made, as createTeamPermissionGrant takes its rows. */
export type GrantReachDraftInput = {
  /** The all-grant: no rows, the whole workspace. */
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /** The association the draft would join; with it, the draft reads OWN and answers only what it would add. */
  associationId?: InputMaybe<Scalars['ID']['input']>;
  filters: Array<PermissionGrantFilterInput>;
  mode: PermissionGrantMode;
  scope: GrantReachScope;
  workspaceId: Scalars['ID']['input'];
};

/** The subject of grantReachFilter: exactly one of these. */
export type GrantReachFilterInput = {
  /** A device grant not yet made, read as it would reach. */
  draft?: InputMaybe<GrantReachDraftInput>;
  /** A team or association grant, read over the devices it gives, landed or not; a revoked one reaches nothing. */
  grantId?: InputMaybe<Scalars['ID']['input']>;
  /** A landed association grant, read as what its landing workspace would lose to its revoke. */
  revokeAssociationGrantId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * OWN reads a draft over its workspace's own devices; REACHABLE adds what
 * associations landed in the workspace.
 */
export type GrantReachScope =
  | 'OWN'
  | 'REACHABLE';

/** Input for granting super admin access */
export type GrantSuperAdminInput = {
  /** Optional expiration date for the grant. If not provided, the grant is indefinite. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional reason for granting access */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user to grant super admin access to */
  userId: Scalars['ID']['input'];
};

export type GridElementCoordinatesByGuidsInput = {
  /**
   * Up to 2000 gs_guids. Exceeding the limit is an error rather than a silent
   * truncation. Guids that do not resolve, or that have no usable geometry, are
   * omitted rather than returned with null coordinates.
   */
  gsGuids: Array<Scalars['String']['input']>;
  /** Workspace to scope the query to (required for security). */
  workspaceId: Scalars['ID']['input'];
};

export type GridElementDeviceBindingsInput = {
  /** DeviceOnWorkspace ID returned as nextCursor for this workspace and GUID group. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** One to 300 grid element GUIDs. UUID case and surrounding braces are normalized. */
  elementGuids: Array<Scalars['String']['input']>;
  /** Page size from 1 to 300; larger values are rejected. */
  take?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Input for `gridElementFacets`. `fields` is the allow-list of registry field
 * paths to facet on (categorical + numeric); omit to facet every aggregatable field.
 */
export type GridElementFacetsInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Ordering for the grid element list. A combined enum rather than a
 * field/direction pair because the default is a composite (substation → feeder →
 * name) that a single field cannot express. Numbers stored as text are ordered
 * numerically; nulls sort last in both directions.
 */
export type GridElementListSort =
  | 'CAPACITY_KVA_ASC'
  | 'CAPACITY_KVA_DESC'
  | 'DOWNSTREAM_CONSUMERS_ASC'
  | 'DOWNSTREAM_CONSUMERS_DESC'
  | 'DOWNSTREAM_GENERATORS_ASC'
  | 'DOWNSTREAM_GENERATORS_DESC'
  | 'FEEDER_NUMBER_ASC'
  | 'FEEDER_NUMBER_DESC'
  | 'HIERARCHY'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'PHASE_ASC'
  | 'PHASE_DESC'
  | 'SUBSTATION_NUMBER_ASC'
  | 'SUBSTATION_NUMBER_DESC'
  /** Only meaningful for SUBSTATION — rejected for TRANSFORMER and FEEDER, whose nominalVoltage is always absent. */
  | 'VOLTAGE_KV_ASC'
  | 'VOLTAGE_KV_DESC';

export type GridElementLoadInput = {
  /** Bare grid-model element GUIDs (substation / feeder-breaker). */
  elementGuids: Array<Scalars['String']['input']>;
  /** Trailing window in days (default 365, capped at 365). */
  windowDays?: InputMaybe<Scalars['Int']['input']>;
  /** Workspace to scope the read to. */
  workspaceId: Scalars['ID']['input'];
};

export type GridElementRefreshInputsInput = {
  /**
   * When true, each valid transformer bank appears once, keyed by its bank guid, in place
   * of its member units; units outside a valid bank are unchanged. The paging keyset and
   * `totalCount` follow the same inventory.
   */
  bankAware?: InputMaybe<Scalars['Boolean']['input']>;
  /** Keyset cursor — pass the previous page's nextCursor. Null starts the sweep. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Page size. Defaults to 500, hard-capped server-side at 2000. */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** Workspace to scope the query to (required for security). */
  workspaceId: Scalars['ID']['input'];
};

export type GridElementTelemetryInput = {
  /** Canonical Metric names to read. Defaults to [real_power_3_phase]. */
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Trailing window in days for `series`. Defaults to 1, capped at 365. Widening
   * it coarsens the bucket (≤ 1d → 15m, ≤ 30d → 1h, beyond → 1d) so the read stays
   * inside the aggregate that is still being refreshed at that depth.
   */
  seriesWindowDays?: InputMaybe<Scalars['Int']['input']>;
  /** Trailing window in days for the aggregate readings. Defaults to 7, capped at 365. */
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Mirror of the location subgraph's GridElementType enum — every kind of
 * grid element a Consumer's ancestor can be. Used as the rollup-target
 * type when groupBy = GRID_ANCESTOR. SOURCE / OVERCURRENT_DEVICE /
 * TRANSFORMER hit the denormalised slots on GridElementSubtreeConsumer
 * for fast lookup; the other values resolve via the typed ancestorPath.
 */
export type GridElementType =
  | 'CAPACITOR'
  /**
   * Consumers represent meters and will always be at the bottom of the
   * hierarchy, connecting to a Site.
   */
  | 'CONSUMER'
  /**
   * Cartographic leader line; display-only. Never a rollup ancestor — defined
   * for federation value consistency with the location subgraph.
   */
  | 'DEVICE_LEADER'
  | 'GENERATOR'
  | 'MOTOR'
  | 'NODE'
  | 'OVERCURRENT_DEVICE'
  | 'OVERHEAD_LINE'
  | 'REGULATOR'
  /**
   * Sources represent substations and will always be at the top of the
   * hierarchy.
   */
  | 'SOURCE'
  | 'SUPPORT_STRUCTURE'
  | 'SWITCH'
  | 'TRANSFORMER'
  /**
   * Texture-synthesized transformer-bank grouping. Not yet supported as a
   * rollup ancestor (the resolver's allowlist rejects it with BAD_USER_INPUT);
   * defined here because federation requires enum values to match across the
   * subgraphs sharing GridElementType.
   */
  | 'TRANSFORMER_BANK'
  | 'UNDERGROUND_LINE';

export type GridElementsByGuidsInput = {
  /** When true, a member unit's guid hydrates its bank instead, deduplicated. Defaults to false. */
  bankAware?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Up to 2000 gs_guids. Exceeding the limit is an error rather than a silent
   * truncation, so a hydrated page can never be quietly incomplete. Guids that do
   * not resolve are omitted, not returned as holes.
   */
  gsGuids: Array<Scalars['String']['input']>;
  /** Same contract as `GridElementsInput.metadataKeys`; the hydrated rows carry the same columns as a listed page. */
  metadataKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Workspace to scope the query to (required for security). */
  workspaceId: Scalars['ID']['input'];
};

export type GridElementsInput = {
  /**
   * TRANSFORMER only. When true, each valid transformer bank is listed once, in place of
   * its member units, with the summed census of its members; `gsGuids` naming a member
   * select its bank. Defaults to false.
   */
  bankAware?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restrict to a single feeder by its breaker's GIS guid. Prefer this over
   * `feederNumber`, which is a per-substation index rather than an identifier —
   * "3" names a different circuit under every substation carrying it. Matches the
   * denormalized ancestor column, so it selects the feeder and everything beneath it.
   */
  feederBreakerGsGuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to a single feeder (matches the source utility's feeder number). */
  feederNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Restrict the list to these GIS guids. A FILTER, not a page — more guids than
   * `take` may be supplied, and the same predicate narrows `totalCount`, so the
   * count and the rows can never disagree. Resolved upstream by the search domain
   * from the Explore filter tree, which is the only place the full grid-element
   * filter vocabulary is implemented.
   *
   * An empty list matches nothing; omitting the field means no constraint. These are
   * different answers and must not be conflated — an empty list is a filter that
   * resolved to zero matches.
   *
   * Carries no ordering. Rows come back in `sort` order, never in the order supplied.
   * Capped at 10000 per request.
   */
  gsGuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Source-property keys to project onto each row's `metadata` — raw GeoJSON property
   * names as imported (e.g. VEC's `gs_facility_id`), falling back to the STD
   * `elementData` key of the same name. Lets a tenant-specific table column read a
   * field that was never promoted to a typed column. Omitted or empty → `metadata` is
   * null on every row. At most 25 keys.
   */
  metadataKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Case-insensitive substring match on the element's raw name. */
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: GridElementListSort;
  /** Restrict to a single substation (matches the source utility's substation number). */
  substationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Page size. Defaults to 500, hard-capped server-side at 2000. */
  take?: InputMaybe<Scalars['Int']['input']>;
  type: GridEntityType;
  /** Workspace to scope the query to (required for security). */
  workspaceId: Scalars['ID']['input'];
};

/**
 * Which kind of grid infrastructure to list. Maps to an `elementType` (plus, for
 * FEEDER, the self-feeder-breaker identity).
 */
export type GridEntityType =
  | 'FEEDER'
  | 'SUBSTATION'
  | 'TRANSFORMER';

/** Input for a grid-impact (power-flow) analysis of a feeder or substation. */
export type GridImpactInput = {
  /** Circuit/feeder number (resolves the feeder breaker anchor). */
  feeder?: InputMaybe<Scalars['String']['input']>;
  /** Assumed head voltage (p.u.) when no SCADA monitors this feeder. The result stays flagged anchored: false. */
  headPu?: InputMaybe<Scalars['Float']['input']>;
  /** ISO instant whose containing clock hour is solved (HOUR mode only). Omit to use the most recent hour with meter data. */
  loadAt?: InputMaybe<Scalars['String']['input']>;
  /** ISO date ending the load window (the meter feed lags ~weeks). */
  loadBefore?: InputMaybe<Scalars['String']['input']>;
  /** Telemetry look-back window in days (default 14). */
  loadDays?: InputMaybe<Scalars['Int']['input']>;
  /** WINDOW_AVERAGE (default): mean demand over the loadDays window. HOUR: solve one real clock hour — loadAt's containing hour, or the freshest hour with meter data — falling back per-transformer to the window mean where the hour has no reading. */
  loadMode?: InputMaybe<GridLoadMode>;
  /** Explicit element anchor (a breaker, span, or transformer GUID). At least one of feeder, substation, or rootElementGuid is required. */
  rootElementGuid?: InputMaybe<Scalars['String']['input']>;
  /** Reactive power for the scenario (kVAr). */
  scenarioKvar?: InputMaybe<Scalars['Float']['input']>;
  /** What-if injection: >0 load, <0 generation. Omit/0 for a baseline-only run. */
  scenarioKw?: InputMaybe<Scalars['Float']['input']>;
  /** gridElementGuid to inject at; defaults to the baseline's worst node. */
  scenarioNode?: InputMaybe<Scalars['String']['input']>;
  /** Multi-injection scenario, applied together in one re-solve. Mutually exclusive with scenarioKw/scenarioNode/scenarioKvar. */
  scenarios?: InputMaybe<Array<GridScenarioInjectionInput>>;
  /** Substation number. */
  substation?: InputMaybe<Scalars['String']['input']>;
  /** Workspace to scope the query to (required). */
  workspaceId: Scalars['ID']['input'];
};

/** How the per-transformer loads for the solve are derived. */
export type GridLoadMode =
  | 'HOUR'
  | 'WINDOW_AVERAGE';

/** One what-if injection at a grid element, in device-perspective units. */
export type GridScenarioInjectionInput = {
  /** Defaults to CUSTOM. */
  kind?: InputMaybe<GridScenarioKind>;
  /** Reactive power (kVAr), same device-perspective sign as kw. Default 0. */
  kvar?: InputMaybe<Scalars['Float']['input']>;
  /** LOAD: kW consumed (>= 0). SOLAR_PV: kW generated (>= 0). BATTERY: kW discharged (< 0 charges). CUSTOM: raw engine sign (+ load, - generation). */
  kw: Scalars['Float']['input'];
  /** gridElementGuid to inject at; must exist in the solved scope. */
  nodeGuid: Scalars['String']['input'];
  /** Smart-inverter volt-var behavior (Stage 2). Ignored on the current engine; the run reports diagnostics.voltVarIgnored when requested. */
  voltVar?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Device kind of a scenario injection; fixes the sign convention for kw/kvar. */
export type GridScenarioKind =
  | 'BATTERY'
  | 'CUSTOM'
  | 'LOAD'
  | 'SOLAR_PV';

export type GridStatus =
  | 'exporting'
  | 'idle'
  | 'importing'
  | 'unknown';

/** Direction of a grid-topology traversal relative to the scope anchor. */
export type GridTopologyDirection =
  /** The anchor element plus everything electrically below it. */
  | 'DOWNSTREAM'
  /** The anchor element's ancestors in path order (feeder head first), then the anchor itself. */
  | 'UPSTREAM';

/**
 * Input for a complete, consistent grid-topology read. Exactly one scope anchor
 * (rootElementGuid | feederBreakerGsGuid | substationGsGuid) must be provided.
 */
export type GridTopologyInput = {
  direction: GridTopologyDirection;
  /** Anchor on a whole feeder via its breaker GUID (DOWNSTREAM only). */
  feederBreakerGsGuid?: InputMaybe<Scalars['String']['input']>;
  /** Include model JSON in downstream reads. False projects only compact topology columns. */
  includeElementData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional elementType allowlist (e.g. omit 14 to exclude poles). */
  includeTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Cap on returned elements (default 10000, hard cap 25000). Exceeding it sets truncated. */
  maxElements?: InputMaybe<Scalars['Int']['input']>;
  /** Count before loading rows and return no elements if the scope exceeds maxElements. DOWNSTREAM only. */
  requireComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Anchor on an arbitrary element (a breaker, a mid-feeder span, a transformer). */
  rootElementGuid?: InputMaybe<Scalars['String']['input']>;
  /** Anchor on a whole substation via its source GUID (DOWNSTREAM only). */
  substationGsGuid?: InputMaybe<Scalars['String']['input']>;
  /** Workspace ID to scope the query to (required for security). */
  workspaceId: Scalars['ID']['input'];
};

export type GridTopologyPageInput = {
  /** Active element ID returned as nextCursor for this scope; requires revision. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Revision returned by the first page. A mismatch requires restarting pagination. */
  revision?: InputMaybe<Scalars['String']['input']>;
  rootElementGuid: Scalars['String']['input'];
  /** Page size from 1 to 500 (default 500). Larger values are rejected. */
  take?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type GridTopologySummaryInput = {
  rootElementGuid: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/** Input type for growth statistics queries */
export type GrowthStatsInput = {
  /** End date for the growth stats period */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Start date for the growth stats period */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The workspace ID to fetch growth stats for */
  workspaceId: Scalars['ID']['input'];
};

/** Health status indicators */
export type HealthStatus =
  | 'DEGRADED'
  | 'HEALTHY'
  | 'UNHEALTHY'
  | 'UNKNOWN';

/**
 * Which level of the hierarchy to group results by when rolling up.
 * SOURCE = no rollup, one series per source.
 * SCADA_PARENT = SCADA scope: aggregate to immediate ScadaGridNode parent.
 * SCADA_ANCESTOR = SCADA scope: aggregate to the subtree root.
 * GRID_PARENT = gridElementSubtree scope: aggregate to each Consumer's
 *   immediate grid parent (the deepest entry in the typed ancestorPath).
 * GRID_ANCESTOR = gridElementSubtree scope: aggregate to a named ancestor
 *   type (set ancestorElementType to any GridElementType; SOURCE /
 *   OVERCURRENT_DEVICE / TRANSFORMER use denormalised fast paths, every
 *   other value walks the typed ancestorPath).
 * METER_ROLE = gridElementSubtree scope: aggregate each leaf by meter role into
 *   two series — groupKey "consumption" (CONSUMER + PRODUCTION + null/missing
 *   meterType) and "generation" (GENERATION). Bounded to <=2 series regardless
 *   of cohort size.
 * METER_ROLE_NET = gridElementSubtree scope: one groupKey "net" series, the
 *   consumption role minus the generation role. Generation meters report export
 *   as a positive magnitude, so the generation role is subtracted, per fine
 *   bucket when combined with `fine` (the coincident net peak). Requires
 *   reducer SUM.
 * TOTAL = aggregate every source into a single groupKey "total" series.
 *   The single-group coincident sum — combine with `fine` for coincident
 *   peak demand. Valid for gridElementSubtree cohorts and for device /
 *   deviceOnWorkspace scopes (e.g. one meter's series pair). Role-blind: on a
 *   cohort with generation meters it adds their export to load (see
 *   METER_ROLE_NET).
 */
export type HierarchyGroupBy =
  | 'GRID_ANCESTOR'
  | 'GRID_PARENT'
  | 'METER_ROLE'
  | 'METER_ROLE_NET'
  | 'SCADA_ANCESTOR'
  | 'SCADA_PARENT'
  | 'SOURCE'
  | 'TOTAL';

/**
 * How to combine values from multiple sources when rolling up a hierarchy.
 * Applied when multiple child nodes are aggregated to a parent — e.g.,
 * summing meter loads to get total transformer load, or taking the max
 * voltage across phases.
 * Example: SUM the real_power of 3 meters to get the transformer's total load;
 * AVG voltage readings across child nodes; MAX to find the worst-case value.
 */
export type HierarchyReducer =
  | 'AVG'
  | 'MAX'
  | 'SUM';

export type IdentificationType =
  | 'customerId'
  | 'customerInfo'
  | 'enrollmentId'
  | 'leadId';

export type ImportWorkspaceProgramEventDispatchInput = {
  errorReason?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's event id. Required — it is what makes the import idempotent. */
  externalId: Scalars['String']['input'];
  /** The vendor's own forecast for the event, stored as sent. */
  providerData: Scalars['JSON']['input'];
  requestedEndAt: Scalars['DateTime']['input'];
  requestedStartAt: Scalars['DateTime']['input'];
  /** The vendor's settled results, or null if it never published any. */
  results?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * TERMINAL statuses only. Anything that holds the window reservation is refused:
   * importing it would reserve a window nothing here dispatched into, blocking the
   * whole vendor program. A live vendor event belongs to reconciliation.
   */
  status: WorkspaceProgramEventDispatchStatus;
  /**
   * What the provider's event DID, in this platform's vocabulary — `curtail` for a
   * thermostat shed, `discharge` for a battery, and so on.
   *
   * Required, and supplied by the caller because only the adapter knows how a given
   * vendor's event maps. Without it an imported event inherits the `discharge`
   * fallback meant for events with no catalogue entry, so a thermostat curtailment
   * would report itself as a battery discharge.
   */
  type: Scalars['String']['input'];
  /** The integration whose vendor program this event belongs to. */
  workspaceProgramIntegrationId: Scalars['ID']['input'];
};

/**
 * What an import did to one vendor event. Outcomes rather than a boolean, because
 * "already there" splits into cases that must not be conflated — and because two of
 * them mean "somebody else owns this", which a caller has to act on differently
 * from "done".
 */
export type ImportWorkspaceProgramEventDispatchOutcome =
  /** Created the event and its dispatch. */
  | 'IMPORTED'
  /** Already imported; its results were refreshed from the vendor's latest. */
  | 'REFRESHED'
  /**
   * The vendor id already belongs to a dispatch under a DIFFERENT integration.
   *
   * Reachable because the uniqueness key is `(provider, externalProgramId,
   * externalId)` and nothing stops two workspace programs naming the same vendor
   * program — integration creation takes `externalId` from the caller. Only the
   * input integration's program was authorized, so the row is left alone rather
   * than refreshed: touching it would mutate another workspace's history behind a
   * check that passed for this one.
   */
  | 'SKIPPED_FOREIGN_INTEGRATION'
  /**
   * The vendor id already belongs to a dispatch this system sent. Left untouched:
   * overwriting it would replace a real operator action, and its audit trail, with
   * a copy of what the vendor says about it.
   */
  | 'SKIPPED_OURS'
  /**
   * A dispatch that may already BE this vendor event is still unresolved — it holds
   * an overlapping window on this vendor program with no `externalId`, which is the
   * ambiguous create reconciliation exists to settle.
   *
   * Scoped to the vendor program, NOT to the caller's integration, because the
   * uniqueness key and the window reservation are scoped that way too: a live
   * dispatch under any integration naming this vendor program genuinely conflicts.
   * So the blocking row may belong to another workspace, and is never returned.
   *
   * Importing past it would mint a second dispatch and claim the vendor id, after
   * which reconciliation's adoption hits the unique index and the operator's own
   * dispatch is stranded on a held window, with the grid action they took
   * attributed to the imported row. Re-run the import once reconciliation has
   * decided.
   */
  | 'SKIPPED_UNRECONCILED'
  /**
   * This vendor id is already imported, but against a DIFFERENT window.
   *
   * Refused rather than resolved either way: applying the new window would rewrite
   * indexed columns and the parent event under a row reached by id, and ignoring it
   * would leave the record's window and its payload describing different hours while
   * the caller is told the refresh landed. The same vendor id describing a different
   * window is a question for a human.
   */
  | 'WINDOW_CONFLICT';

export type InitLifecycleInstanceInput = {
  /** Which config the instance runs. Defaults to PUBLISHED; DRAFT previews the unpublished draft end to end. */
  configSource?: InputMaybe<LifecycleConfigSource>;
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for initiating authentication */
export type InitiateAuthenticationInput = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

/** Inverter state input. Matches InverterState DB schema. */
export type InverterStateInput = {
  createdAt: Scalars['DateTime']['input'];
  generatedEnergy?: InputMaybe<Scalars['Float']['input']>;
  gridEnergy?: InputMaybe<Scalars['Int']['input']>;
  gridPower?: InputMaybe<Scalars['Int']['input']>;
  gridStatus?: InputMaybe<GridStatus>;
  lifetimeEnergyGenerated?: InputMaybe<Scalars['Float']['input']>;
  loadEnergy?: InputMaybe<Scalars['Float']['input']>;
  loadPower?: InputMaybe<Scalars['Float']['input']>;
  power: Scalars['Int']['input'];
};

export type InvitationStatus =
  | 'ACCEPTED'
  | 'PENDING'
  | 'REVOKED';

export type IssueStatus =
  | 'IGNORED'
  | 'OPEN'
  | 'RESOLVED';

export type JoinOrganizationInput = {
  userId: Scalars['String']['input'];
};

export type LandSharedCollectionInput = {
  /** The ID of the SharedResource (the offered share) to land */
  sharedResourceId: Scalars['ID']['input'];
  /** The workspace to land the shared collection into (the recipient's current workspace) */
  workspaceId: Scalars['ID']['input'];
};

export type LeadEventType =
  | 'ENROLLMENT_SUBMITTED'
  | 'IP_ADDRESS_CAPTURED'
  | 'TERMS_AGREED';

export type LeadForWorkspaceOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type LeadSource =
  | 'COLD_CALL'
  | 'EVENT'
  | 'PROGRAM'
  | 'REFERRAL'
  | 'WEBSITE';

export type LeadStatus =
  | 'CONTACTED'
  | 'CONVERTED'
  | 'LOST'
  | 'NEW'
  | 'QUALIFIED';

export type LeadsForWorkspaceFilter = {
  workspaceId: Scalars['String']['input'];
};

export type LeadsForWorkspaceInput = {
  filter: LeadsForWorkspaceFilter;
  orderBy?: InputMaybe<LeadForWorkspaceOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<LeadsForWorkspaceSearch>;
};

export type LeadsForWorkspaceSearch = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Write shape for an action. GraphQL inputs cannot be interfaces, so the payload
 * fields of every kind live here as nullable and the domain's discriminated-union
 * schema is the single arbiter of which combination is valid for a given `type` —
 * an unsupported `type`, or a `redirect` with no `url`, is rejected there.
 */
export type LifecycleActionInput = {
  /** Stage-attached actions only; ignored on a transition action. */
  condition?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  /** Optional for 'redirect'; defaults to same_tab. */
  target?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  /** Required when type is 'redirect'. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Which config a lifecycle instance runs. */
export type LifecycleConfigSource =
  /** The unpublished draft. Never pinned, so it follows edits until the instance finishes. */
  | 'DRAFT'
  /** A published version, pinned per stage. */
  | 'PUBLISHED';

export type LifecycleDefinitionEntityType =
  | 'PROGRAM';

export type LifecycleInstanceEntityType =
  | 'ENROLLMENT';

/** Pass exactly one of organizationId (legacy crm id) and canonicalOrganizationId. */
export type LinkOrgToInstanceInput = {
  canonicalOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  instanceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  relationship: OrgConferenceRelationship;
};

/** Pass exactly one of organizationId (legacy crm id) and canonicalOrganizationId. */
export type LinkOrgToSeriesInput = {
  canonicalOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  relationship: OrgConferenceRelationship;
  seriesId: Scalars['ID']['input'];
};

export type LinkOrganizationDriveFolderInput = {
  /** Required to move a folder already mapped to another organization (or to none) onto this one. */
  confirmRepoint?: InputMaybe<Scalars['Boolean']['input']>;
  folderId: Scalars['ID']['input'];
};

export type LinkOrganizationDriveFoldersInput = {
  canonicalOrganizationId: Scalars['ID']['input'];
  folders: Array<LinkOrganizationDriveFolderInput>;
};

export type LinkOrganizationToCanonicalOrganizationForAutomationInput = {
  /** The user the caller acts for, if any. Recorded on the audit event; it authorizes nothing. */
  actorId?: InputMaybe<Scalars['ID']['input']>;
  /** A merged-away id is followed to its surviving record. */
  canonicalOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type LinkOrganizationToCanonicalOrganizationInput = {
  /**
   * The `CanonicalOrganization` to link it to. A merged-away id is followed to
   * its surviving record rather than rejected.
   */
  canonicalOrganizationId: Scalars['ID']['input'];
  /** The identity `Organization` to link. */
  organizationId: Scalars['ID']['input'];
};

/**
 * Why a link attempt ended the way it did.
 *
 * Only `LINKED` writes anything; every other value means nothing was written.
 * The two conflict cases are ordinary situations an operator has to resolve, not
 * errors — `Organization.canonicalOrganizationId` is unique, so two Organization
 * rows for the same real-world utility genuinely cannot both hold it.
 */
export type LinkOrganizationToCanonicalOrganizationOutcome =
  /** It already pointed at this same canonical. Nothing written. */
  | 'ALREADY_LINKED'
  /** The canonical is already claimed by another Organization. */
  | 'CANONICAL_CLAIMED_BY_OTHER_ORGANIZATION'
  /** No such CanonicalOrganization, after following its merge chain. */
  | 'CANONICAL_NOT_FOUND'
  /** The organization now points at the canonical. */
  | 'LINKED'
  /**
   * This organization already points at a DIFFERENT canonical. Re-pointing it
   * would orphan every claim hanging off the old one, so it is refused here.
   */
  | 'ORGANIZATION_ALREADY_LINKED_ELSEWHERE'
  /** No such identity Organization. */
  | 'ORGANIZATION_NOT_FOUND';

export type LinkSessionConfigDefaultsInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  manufacturerFilters?: InputMaybe<ManufacturerFiltersInput>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for specifying pagination using either offset or cursor-based strategies. */
export type ListPagination = {
  /** Cursor-based pagination options. */
  cursor?: InputMaybe<CursorPagination>;
  /** Offset-based pagination options. */
  offset?: InputMaybe<OffsetPagination>;
};

/** The resources a customer claim can be read for by `liveCustomerClaims`. */
export type LiveCustomerClaimResourceType =
  | 'Device'
  | 'Site';

/** Pass exactly one of `resourceIds` and `changedSince`. */
export type LiveCustomerClaimsInput = {
  /**
   * Every resource of `resourceType` whose customers may have changed after this
   * instant: a claim written or closed, or a claiming customer edited or deleted.
   * More than 5000 such resources is refused with `TOO_MANY_CHANGED_RESOURCES`;
   * the caller should recompute in full.
   */
  changedSince?: InputMaybe<Scalars['DateTime']['input']>;
  /** The resources to read, at most 500 distinct ids. Echoed back as the result's `resourceIds`. */
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  resourceType: LiveCustomerClaimResourceType;
};

export type LocationInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetOne: Scalars['String']['input'];
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type LogDealActivityInput = {
  body: Scalars['String']['input'];
  contactId?: InputMaybe<Scalars['ID']['input']>;
  kind: DealActivityKind;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * An engagement a person logs by hand onto an organization timeline (manual
 * engagement logging, step one). Written as a normal touchpoint with
 * sourceSystem "manual" and a generated sourceId, so it shows on
 * crmEngagementTimeline and counts toward crmOrgEngagementStats like any other.
 */
export type LogEngagementInput = {
  /** The contact it was with, when known. */
  contactId?: InputMaybe<Scalars['ID']['input']>;
  /** EMAIL, CALL, MEETING, NOTE or LINKEDIN_MESSAGE. The ingest-only kinds are rejected. */
  kind: TouchpointKind;
  /** When the engagement happened. Defaults to now. */
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** What happened, in the rep's words. Required; becomes the entry's summary. */
  summary: Scalars['String']['input'];
};

export type LoggedUserInvitationsInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<InvitationStatus>;
};

/** Routing decision for the email-first sign-in interstitial. */
export type LoginRoutingDecision =
  | 'password'
  | 'sso';

/** Input for querying management audit logs with optional filters and pagination. */
export type ManagementAuditLogsInput = {
  /** Filter by action type (e.g., 'workspace.create', 'apiKey.revoke'). */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Filter by actor ID (userId or apiKeyId). */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** Only return logs created on or before this date (ISO 8601). */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The organization to query audit logs for. */
  organizationId: Scalars['String']['input'];
  /** Page number (1-indexed). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Results per page. Defaults to 50, max 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by specific resource ID. */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by resource type (e.g., 'Workspace', 'ApiKey'). */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Only return logs created on or after this date (ISO 8601). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ManufacturerCredentialParamsInput = {
  allowedSystemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  pollingInterval?: InputMaybe<PollingInterval>;
  rateLimitPerMin?: InputMaybe<Scalars['Int']['input']>;
};

export type ManufacturerCredentialStatus =
  | 'ACTIVE'
  | 'EXHAUSTED';

export type ManufacturerCredentialsInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for filtering manufacturer device models */
export type ManufacturerDeviceModelsFilter = {
  /** Search by name or slug (partial match) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by support level */
  supportLevel?: InputMaybe<SupportLevel>;
  /** Filter by device type */
  type?: InputMaybe<DeviceType>;
};

/** Status of a manufacturer device based on telemetry activity */
export type ManufacturerDeviceStatus =
  /** Telemetry received within the last 24 hours */
  | 'ACTIVE'
  /** Has telemetry history, but not within the last 24 hours */
  | 'INACTIVE'
  /** No telemetry has ever been received */
  | 'NEVER_CONNECTED';

/** Input for filtering manufacturer devices */
export type ManufacturerDevicesFilter = {
  /** Filter by device model ID */
  deviceModelId?: InputMaybe<Scalars['ID']['input']>;
  /** Search by manufacturerDeviceId, serialNumber, or device name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by device status */
  status?: InputMaybe<ManufacturerDeviceStatus>;
};

export type ManufacturerFiltersInput = {
  deviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ManufacturerIntegrationFilters = {
  /** Filter by whether the integration has configuration fields (is configurable) */
  isConfigurable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by manufacturer IDs */
  manufacturerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by manufacturer slugs */
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search query for name, description, or slug */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific integration slugs */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by support level */
  supportLevel?: InputMaybe<SupportLevel>;
};

/** Input for querying recent telemetry events. */
export type ManufacturerRecentTelemetryInput = {
  /** Maximum number of events to return (default 20) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The manufacturer ID to get recent telemetry for */
  manufacturerId: Scalars['ID']['input'];
};

/** Input for querying manufacturer telemetry statistics. */
export type ManufacturerTelemetryStatsInput = {
  /** End date for filtering active devices and telemetry counts */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The manufacturer ID to get stats for */
  manufacturerId: Scalars['ID']['input'];
  /** Start date for filtering active devices and telemetry counts */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for querying manufacturer telemetry time series. */
export type ManufacturerTelemetryTimeSeriesInput = {
  /** Number of days to include (default 7) */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** The manufacturer ID to get time series data for */
  manufacturerId: Scalars['ID']['input'];
};

export type ManufacturerUserConnectionInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Look up by ID directly */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Look up by unique key — all three required together if id is not provided */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type MergeCanonicalContactsInput = {
  /**
   * Merged-away CanonicalContact id. After merge: `mergedIntoId` points at
   * the winner, `mergedAt` is set to the merge timestamp, claim FKs all
   * moved off this row, but the row itself stays so cursor identity in
   * paginated connections is preserved.
   */
  loserId: Scalars['ID']['input'];
  /**
   * Optional override for the resolution policy that re-runs on the winner
   * after the claim move. Defaults to `v1_trust_recency_verified`.
   */
  policyVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-form reason for the merge. Surfaces verbatim on both CONTACTS_MERGED
   * audit rows so support can answer "why did this merge happen?" without
   * reading code.
   */
  reason: Scalars['String']['input'];
  /**
   * Surviving CanonicalContact id. After merge: claims fan-in here, every
   * ThirdParty backlink that pointed at the loser repoints to this id,
   * resolution re-runs on this row.
   */
  winnerId: Scalars['ID']['input'];
};

/** Input for `mergeCanonicalOrganizations`. */
export type MergeCanonicalOrganizationsInput = {
  /**
   * First CanonicalOrganization id. The merge service redirect-normalises
   * both ids, so callers may pass loser ids from prior merges.
   */
  aId: Scalars['ID']['input'];
  /** Second CanonicalOrganization id. */
  bId: Scalars['ID']['input'];
  /**
   * When true, runs winner selection + read-only cascade simulation and
   * returns predicted counts / conflicts WITHOUT writing anything.
   * Dry-run is always allowed, even when the feature flag is off.
   * Defaults to false.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Caller-provided idempotency key. Two merges with the same key against
   * the same terminal pair return the stored result — no re-mutation.
   */
  idempotencyKey: Scalars['String']['input'];
  /**
   * Free-form reason for the merge. Stamped verbatim on both
   * ORGANIZATIONS_MERGED audit rows.
   */
  reason: Scalars['String']['input'];
  /**
   * Optional explicit winner pick. Must point at one of the two terminal
   * ids after redirect-normalisation; the customer-org block must still be
   * satisfied.
   */
  requestedWinnerId?: InputMaybe<Scalars['ID']['input']>;
};

/** External meter ID to canonical device ID mapping for interval energy queries. */
export type MeterDeviceMappingInput = {
  deviceId: Scalars['ID']['input'];
  meterId: Scalars['ID']['input'];
};

export type MeterIntervalInput = {
  /** The end date of the period. */
  endDate: Scalars['DateTime']['input'];
  /** The start date of the period. */
  startDate: Scalars['DateTime']['input'];
  /** The size which the intervals period should be grouped by. */
  timeFrame?: InputMaybe<Scalars['String']['input']>;
};

/** Interval length for meter data collection */
export type MeterIntervalLength =
  | 'FIFTEEN_MINUTE'
  | 'FIVE_MINUTE'
  | 'ONE_HOUR'
  | 'ONE_MINUTE'
  | 'THIRTY_MINUTE'
  | 'TWENTY_FOUR_HOUR';

export type MeterIntervalOverlapInput = {
  channelInterval: Scalars['String']['input'];
  channelMode: Scalars['String']['input'];
  meters: Array<MeterIntervalRangeInput>;
  metric: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

/**
 * A single interval reading to write for one meter (ALL-3057 — the
 * `METER_INTERVAL` bulk-upload shape). `ts` must already be a resolved UTC
 * instant — this mutation does no timezone math.
 */
export type MeterIntervalPointInput = {
  ts: Scalars['DateTime']['input'];
  value: Scalars['Float']['input'];
};

/**
 * One meter's date range to check for pre-existing meter-interval-import data
 * before a replace-on-overlap write (ALL-3057 preview step).
 */
export type MeterIntervalRangeInput = {
  manufacturerDeviceId: Scalars['String']['input'];
  rangeEnd: Scalars['DateTime']['input'];
  rangeStart: Scalars['DateTime']['input'];
};

export type MetricQueryFilter = {
  deviceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  range?: InputMaybe<MetricQueryRange>;
  siteId?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<DeviceType>>;
  workspaceId: Scalars['ID']['input'];
};

export type MetricQueryInput = {
  /**
   * Options for aggregating metric data across devices.
   * When specified, data will be aggregated according to these options.
   */
  aggregation?: InputMaybe<AggregationOptions>;
  filter: MetricQueryFilter;
  groupBy?: InputMaybe<MetricsQueryGroupByFacet>;
  window?: InputMaybe<MetricsQueryWindow>;
};

export type MetricQueryRange = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  relative?: InputMaybe<Scalars['String']['input']>;
};

export type MetricUnit =
  | 'AMPERE'
  | 'CELSIUS'
  | 'DAY'
  | 'FAHRENHEIT'
  | 'HOUR'
  | 'KILOMETER'
  | 'KILOMETER_PER_HOUR'
  | 'METER'
  | 'MILE'
  | 'MILE_PER_HOUR'
  | 'MINUTE'
  | 'MONTH'
  | 'PERCENT'
  | 'POUNDS_CO2'
  | 'SECOND'
  | 'STRING'
  | 'TIMESTAMP'
  | 'UNIT'
  | 'VOLT'
  | 'WATT'
  | 'WATT_HOURS'
  | 'WEEK'
  | 'YEAR';

export type MetricsQueryGroupByFacet =
  | 'CUSTOMER'
  | 'SITE';

export type MetricsQueryWindow = {
  size?: InputMaybe<WindowSize>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type MilestoneType =
  | 'ABSTRACT_DEADLINE'
  | 'AGENDA_PUBLISHED'
  | 'CALL_FOR_SPEAKERS'
  | 'EARLY_BIRD_REGISTRATION'
  | 'HOTEL_BLOCK_DEADLINE'
  | 'OTHER'
  | 'REGISTRATION_DEADLINE'
  | 'SPONSOR_DEADLINE';

export type ModelInput = {
  manufacturerSlug?: InputMaybe<Scalars['String']['input']>;
};

export type MonitorActorType =
  | 'API_KEY'
  | 'CLIENT'
  | 'SCOPED_KEY'
  | 'USER';

export type MonitorAlertEvidenceInput = {
  entityId: Scalars['ID']['input'];
  groupKey?: InputMaybe<Scalars['String']['input']>;
  monitorId: Scalars['ID']['input'];
  transitionedAt: Scalars['DateTime']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type MonitorBindingInput = {
  /** How the rest of the monitor refers to it, e.g. "nominal". */
  name: Scalars['String']['input'];
  /** Resolved against the binding-source registry, e.g. "deviceTag.__sys.voltage_nominal". */
  path: Scalars['String']['input'];
};

/** Why an entity's binding could not be read as a number (spec 4 § 2). */
export type MonitorBindingUnresolvedReason =
  | 'AMBIGUOUS'
  | 'MALFORMED'
  | 'NO_VALUE'
  | 'OUT_OF_DOMAIN';

/**
 * Request the live values for a set of monitor board filter fields. Unsupported
 * fields are ignored. Currently supports `templateSlug`.
 */
export type MonitorBoardFacetsInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type MonitorChangeKind =
  | 'ARCHIVED'
  | 'CREATED'
  | 'DISABLED'
  | 'ENABLED'
  | 'UPDATED';

export type MonitorComparator =
  | 'ABSENT'
  | 'CHANGE_PCT'
  | 'EQ'
  | 'GT'
  | 'GTE'
  | 'LT'
  | 'LTE'
  | 'NEQ';

/** Which Monitor timestamp a date-bucketed facet groups on. */
export type MonitorDateField =
  | 'createdAt'
  | 'updatedAt';

/**
 * Whether a monitor's evaluation results reach live alert consumers.
 * LIVE = standard alerting. SHADOW = evaluator persists transitions but
 * alert emission is suppressed downstream, so operators can stage new
 * monitors against live data without paging anyone.
 */
export type MonitorDeliveryMode =
  | 'LIVE'
  | 'SHADOW';

/**
 * How a rule's duration is counted: one unbroken run of hours, or any hours
 * within the window added up.
 */
export type MonitorDurationMode =
  | 'CONSECUTIVE'
  | 'CUMULATIVE';

export type MonitorEntityStateFilters = {
  entityType?: InputMaybe<Array<MonitorEntityType>>;
  state?: InputMaybe<Array<MonitorState>>;
};

export type MonitorEntityType =
  | 'DEVICE'
  /**
   * A SCADA-instrumented grid element (breaker, regulator, transformer, …),
   * identified by its GIS gsGuid. Entity states and transitions for grid
   * monitors carry the gsGuid as their entityId.
   */
  | 'GRID_ELEMENT'
  | 'SITE'
  | 'TRANSFORMER';

/**
 * A categorical dimension for monitorFacets.
 * - state: counts ENTITIES grouped by their current MonitorEntityState.
 * - severity: counts MONITORS grouped by the default parameterization severity.
 * - family / deliveryMode / templateSlug: counts MONITORS grouped by the Monitor
 *   column. templateSlug drops the null bucket (ad-hoc monitors have no template).
 */
export type MonitorFacetDimension =
  | 'deliveryMode'
  | 'family'
  | 'severity'
  | 'state'
  | 'templateSlug';

/**
 * Input for the monitorFacets query. Provide EXACTLY ONE of `dimension`
 * (a terms facet) or `dateField` (a date-bucketed facet). By default only
 * active monitors are counted (enabled, non-archived, and — for delivery mode
 * — non-SHADOW); the `include*` flags relax that for non-alerting dashboards.
 * The optional `family` / `severity` / `state` filters mirror
 * MonitorFiltersInput and further narrow which monitors qualify.
 */
export type MonitorFacetInput = {
  dateField?: InputMaybe<MonitorDateField>;
  dimension?: InputMaybe<MonitorFacetDimension>;
  family?: InputMaybe<Array<MonitorFamily>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  includeShadow?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<DateInterval>;
  /** Top-N cap for terms facets (by descending count). Ignored for date facets. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Array<MonitorSeverity>>;
  state?: InputMaybe<Array<MonitorState>>;
  workspaceId: Scalars['ID']['input'];
};

export type MonitorFamily =
  | 'CHANGE'
  | 'FRESHNESS'
  | 'STATUS_CHECK'
  | 'THRESHOLD';

/** Input for a single DEVICE_FILTER clause. */
export type MonitorFilterClauseInput = {
  field: MonitorFilterField;
  op: MonitorFilterOp;
  /**
   * String for EQ, string[] for IN, string[] for CONTAINS_ANY/CONTAINS_ALL.
   * Validated server-side against the Zod grammar.
   */
  value: Scalars['JSON']['input'];
};

/**
 * Supported fields for a DEVICE_FILTER clause. All fields are already
 * denormalized on texture-monitor-* in v1. Adding a new field requires
 * a mapping + enricher change before it can be used here.
 */
export type MonitorFilterField =
  | 'CITY'
  | 'COLLECTION_IDS'
  | 'DEVICE_TYPE'
  | 'MANUFACTURER'
  | 'PROGRAM_IDS'
  | 'SITE_ID'
  | 'STATE';

/**
 * Operators supported in DEVICE_FILTER clauses.
 * EQ / IN apply to scalar-singleton fields.
 * CONTAINS_ANY / CONTAINS_ALL apply to array fields (collectionIds, programIds).
 */
export type MonitorFilterOp =
  | 'CONTAINS_ALL'
  | 'CONTAINS_ANY'
  | 'EQ'
  | 'IN';

export type MonitorFiltersInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryMode?: InputMaybe<Array<MonitorDeliveryMode>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  family?: InputMaybe<Array<MonitorFamily>>;
  search?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Array<MonitorSeverity>>;
  state?: InputMaybe<Array<MonitorState>>;
};

export type MonitorNoDataBehavior =
  | 'ALERT'
  | 'LAST_KNOWN'
  | 'OK';

/**
 * How a monitor's alerts are delivered: one message per alert, one summary
 * per evaluation run, or no messages.
 */
export type MonitorNotifyPer =
  | 'ALERT'
  | 'NONE'
  | 'RUN';

export type MonitorParameterizationInput = {
  evaluationWindowMs: Scalars['Int']['input'];
  noDataBehavior?: InputMaybe<MonitorNoDataBehavior>;
  recoveryDelayMs?: InputMaybe<Scalars['Int']['input']>;
  recoveryThreshold?: InputMaybe<Scalars['Float']['input']>;
  severity: MonitorSeverity;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  thresholdBinding?: InputMaybe<Scalars['String']['input']>;
  thresholdMode?: InputMaybe<MonitorThresholdMode>;
  triggerDelayMs?: InputMaybe<Scalars['Int']['input']>;
};

export type MonitorParameterizationOverrideInput = {
  evaluationWindowMs: Scalars['Int']['input'];
  noDataBehavior?: InputMaybe<MonitorNoDataBehavior>;
  recoveryDelayMs?: InputMaybe<Scalars['Int']['input']>;
  recoveryThreshold?: InputMaybe<Scalars['Float']['input']>;
  scope: Scalars['String']['input'];
  severity: MonitorSeverity;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  thresholdBinding?: InputMaybe<Scalars['String']['input']>;
  thresholdMode?: InputMaybe<MonitorThresholdMode>;
  triggerDelayMs?: InputMaybe<Scalars['Int']['input']>;
};

export type MonitorPreviewInput = {
  /** Validated exactly as createMonitor does, so a clean preview cannot be followed by a rejected save. */
  bindings?: InputMaybe<Array<MonitorBindingInput>>;
  defaultParameterization: MonitorParameterizationInput;
  /**
   * Optional; inferred from the targets when omitted. The wizard sends it so
   * the stored type never depends on inference.
   */
  entityType?: InputMaybe<MonitorEntityType>;
  family: MonitorFamily;
  rule: MonitorRuleInput;
  targets: Array<MonitorTargetInput>;
  workspaceId: Scalars['ID']['input'];
};

export type MonitorRuleInput = {
  /** Required. Nullable in the schema for compatibility; a write without one is rejected. */
  comparator?: InputMaybe<MonitorComparator>;
  /**
   * Set together with durationMode, and only on a signal whose source
   * supports duration. The evaluation window must cover it.
   */
  durationHours?: InputMaybe<Scalars['Int']['input']>;
  durationMode?: InputMaybe<MonitorDurationMode>;
  signal: Scalars['String']['input'];
  statusValueBool?: InputMaybe<Scalars['Boolean']['input']>;
  statusValueString?: InputMaybe<Scalars['String']['input']>;
};

export type MonitorSeverity =
  | 'CRITICAL'
  | 'HIGH'
  | 'INFO'
  | 'LOW'
  | 'MEDIUM';

export type MonitorState =
  | 'NO_DATA'
  | 'OK'
  | 'PENDING'
  | 'RECOVERING'
  | 'TRIGGERED';

/** Input for the structured predicate on a DEVICE_FILTER target. */
export type MonitorTargetFilterInput = {
  /** AND-conjuncted clauses. 1–10 entries. */
  clauses: Array<MonitorFilterClauseInput>;
  /** Schema version. Must be 1 in v1. */
  version: Scalars['Int']['input'];
};

export type MonitorTargetInput = {
  entityCount?: InputMaybe<Scalars['Int']['input']>;
  /** Required for DEVICE_FILTER targets; must be null for all other types. */
  targetFilter?: InputMaybe<MonitorTargetFilterInput>;
  targetType: MonitorTargetType;
  /**
   * For DEVICE_TYPE / COLLECTION / SITE / PROGRAM: the corresponding value or ID.
   * For WORKSPACE: omit (null).
   * For DEVICE_FILTER: must be null or omitted; the predicate goes in targetFilter.
   */
  targetValue?: InputMaybe<Scalars['String']['input']>;
};

export type MonitorTargetType =
  | 'COLLECTION'
  /**
   * Property-based device filter. The target set is defined by a structured
   * predicate (DeviceFilterPredicate) rather than a single ID. Requires
   * targetFilter to be set; targetValue must be null.
   */
  | 'DEVICE_FILTER'
  | 'DEVICE_TYPE'
  /**
   * A SCADA-instrumented grid element, identified by its GIS guid (bare or
   * brace-wrapped accepted). A null targetValue means every instrumented
   * element in the workspace. Grid targets cannot be combined with other
   * target types.
   */
  | 'GRID_ELEMENT'
  | 'PROGRAM'
  | 'SITE'
  /**
   * Every SCADA-instrumented grid element anchored to the given substation
   * (targetValue = the substation's GIS guid). Membership tracks the grid
   * model's substation anchors, so newly instrumented equipment is picked up
   * automatically. Cannot be combined with non-grid target types.
   */
  | 'SUBSTATION'
  | 'TRANSFORMER'
  | 'WORKSPACE';

/**
 * How `threshold` is read. ABSOLUTE compares the raw number; the others
 * reinterpret it against the value `thresholdBinding` resolves to.
 */
export type MonitorThresholdMode =
  | 'ABSOLUTE'
  /** `threshold` is an absolute delta in the metric's unit. */
  | 'OFFSET_FROM'
  /** `threshold` is a percentage of the bound value. */
  | 'PERCENT_OF';

/**
 * Which notification channels are used. HIGH is email, SMS and in-app
 * immediately; NORMAL is in-app and email.
 */
export type MonitorUrgency =
  | 'HIGH'
  | 'NORMAL';

/**
 * Filters for `myAgentSessions`.
 *
 * Deliberately has no `userId`: the caller is the scope, taken from the
 * authenticated subject, so there is no way to phrase a request for another user's
 * history. Otherwise identical in meaning to AgentSessionFilter.
 */
export type MyAgentSessionFilter = {
  /** True selects sessions whose newest exchange failed; false selects those that did not. */
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sessions with at least one call on this route, on the same call as workspaceId when both are set. */
  route?: InputMaybe<Scalars['String']['input']>;
  startedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  surface?: InputMaybe<AgentSurface>;
  /** Sessions with at least one call scoped to this workspace. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  /** Only sessions where no call carried a workspace. Ignored when workspaceId is also set. */
  workspaceless?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyAgentSessionsInput = {
  /** Opaque cursor from a previous page's `pageInfo.endCursor`. */
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MyAgentSessionFilter>;
  /** Number of records to return (max 200, default 50). */
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type MyAttendancesInput = {
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  status?: InputMaybe<AttendanceStatus>;
};

export type NetworkKind =
  /** Co-op networks (NRTC, TVPPA, NTCA, ECT, …). */
  | 'COOP'
  /** Trade associations (EEI, APPA, …). */
  | 'TRADE_ASSOC';

/**
 * What the automated next-step review did with one organization on one day.
 * APPLIED and PROPOSED both mean the model decided the next step should change;
 * they differ only in whether the sweep was allowed to write it (review mode).
 * DECLINED means the model saw no genuine movement. PARSE_ERROR means the model
 * answered in a shape that failed validation and nothing was written; ERROR means
 * the call itself failed. REVERTED means an APPLIED decision was undone by a human.
 */
export type NextStepReviewOutcome =
  | 'APPLIED'
  | 'DECLINED'
  | 'ERROR'
  | 'PARSE_ERROR'
  | 'PROPOSED'
  | 'REVERTED';

/**
 * Who last wrote a next step. HUMAN is a person typing in Relay; REVIEW is
 * automation (a document workflow, the retired Next-Step Review, or a person
 * accepting one of its proposals) — either way the sentence on the row is the
 * automation's to replace and to take back. IMPORT
 * is a program replaying an upstream system's own sentence (the TAOS Notion
 * import): it may replace its own earlier write, and only a HUMAN edit outranks it.
 */
export type NextStepSource =
  | 'HUMAN'
  | 'IMPORT'
  | 'REVIEW';

/** Notification preference categories. */
export type NotificationCategoryEnum =
  | 'admin'
  | 'devices'
  | 'organization'
  | 'reports'
  | 'security'
  | 'workspace';

export type OAuthApplicationType =
  | 'CONFIDENTIAL'
  | 'PUBLIC';

export type OAuthApplicationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
  workspaceId: Scalars['ID']['input'];
};

/** Error codes for OEM device creation */
export type OemDeviceErrorCode =
  | 'DEVICE_MODEL_MANUFACTURER_MISMATCH'
  | 'DEVICE_MODEL_NOT_FOUND'
  | 'PARAMETER_MISMATCH'
  | 'SITE_NOT_FOUND';

/** Input for getting OEM device info for telemetry ingestion. */
export type OemDeviceForTelemetryInput = {
  /** List of manufacturer IDs the caller is allowed to access */
  allowedManufacturerIds: Array<Scalars['ID']['input']>;
  /** The device ID to get info for */
  deviceId: Scalars['ID']['input'];
};

/** Error codes for OEM device telemetry lookup. */
export type OemDeviceTelemetryErrorCode =
  | 'DEVICE_NOT_ASSOCIATED'
  | 'DEVICE_NOT_FOUND'
  | 'DEVICE_NOT_OEM_DIRECT'
  | 'MANUFACTURER_NOT_ALLOWED';

/** Input for querying OEM devices for a manufacturer. */
export type OemDevicesInput = {
  /** Filter by device model slugs */
  deviceModel?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by device types */
  deviceType?: InputMaybe<Array<DeviceType>>;
  /** The manufacturer ID to get devices for */
  manufacturerId: Scalars['ID']['input'];
  /** Pagination options */
  pagination?: InputMaybe<ListPagination>;
  /** Search by name, serial number, or manufacturer device ID */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OemOverrideInput = {
  oemId: Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
};

/** Input type for offset-based pagination. */
export type OffsetPagination = {
  /** The page number to retrieve (1-based). */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items per page. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type OnlineStatus =
  | 'asleep'
  | 'offline'
  | 'online'
  | 'unknown';

export type OrderByInput = {
  direction: SortOrder;
  field: Scalars['String']['input'];
};

export type OrderDirection =
  | 'ASC'
  | 'DESC';

export type OrgConferenceRelationship =
  | 'ATTENDEE'
  | 'EXHIBITOR'
  | 'ORGANIZER'
  | 'SPEAKER'
  | 'SPONSOR';

/**
 * Data source enum for CanonicalOrganization claims and external IDs.
 * Mirrors the Prisma OrgDataSource enum.
 */
export type OrgDataSource =
  | 'COMMONGRID'
  | 'EIA'
  | 'HUBSPOT'
  | 'IDENTITY_ORG_LINK'
  | 'IMPORT'
  | 'MANUAL_ENTRY'
  | 'NISC'
  | 'NOTION_TAOS'
  | 'SALESFORCE'
  | 'UNKNOWN';

export type OrgLinkLevel =
  | 'INSTANCE'
  | 'SERIES';

/** Status of an organization access request */
export type OrganizationAccessRequestStatus =
  | 'APPROVED'
  | 'DENIED'
  | 'PENDING';

export type OrganizationDomainVerificationMethod =
  /** A TXT record at _texture-verification.<domain> matched the domain's token. */
  | 'DNS_TXT'
  /** Verified before DNS verification existed; grandfathered by migration. */
  | 'LEGACY'
  /** A Texture super admin approved the claim without DNS proof (approveOrganizationDomain). */
  | 'TEXTURE_ADMIN';

export type OrganizationDriveFolderLinkOutcome =
  | 'ALREADY_LINKED'
  | 'CREATED'
  | 'REPOINTED';

export type OrganizationInvitationsFilter = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationInvitationsInput = {
  filter: OrganizationInvitationsFilter;
  pagination?: InputMaybe<ListPagination>;
};

export type OrganizationLeadStatus =
  | 'ATTEMPTED_TO_CONTACT'
  | 'BAD_TIMING'
  | 'CONNECTED'
  | 'IN_PROGRESS'
  | 'NEW'
  | 'OPEN'
  | 'OPEN_DEAL'
  | 'UNQUALIFIED';

export type OrganizationLifecycleStage =
  | 'CUSTOMER'
  | 'EVANGELIST'
  | 'LEAD'
  | 'MQL'
  | 'OPPORTUNITY'
  | 'OTHER'
  | 'SQL'
  | 'SUBSCRIBER';

export type OrganizationMembersFilter = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationMembersInput = {
  filter: OrganizationMembersFilter;
  pagination?: InputMaybe<ListPagination>;
};

export type OrganizationSegment =
  | 'DERMS_PLATFORM'
  | 'EPC'
  | 'FINANCIER'
  | 'INSTALLER'
  | 'INTEGRATION_PARTNER'
  | 'OEM'
  | 'OEM_MFR'
  | 'OTHER'
  | 'O_AND_M'
  | 'TPO'
  /**
   * Community Choice Aggregator: a load-serving entity that procures power for a
   * jurisdiction still served by an incumbent utility's wires. Distinct from
   * UTILITY_MUNI and UTILITY_IOU, and it runs its own DER programs.
   */
  | 'UTILITY_CCA'
  | 'UTILITY_COOP'
  | 'UTILITY_IOU'
  | 'UTILITY_MUNI';

export type OrganizationStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'CHURNED'
  | 'DO_NOT_CONTACT'
  | 'INACTIVE';

/** Review state of an auto-create organization suggestion. Decisions are sticky. */
export type OrganizationSuggestionStatus =
  | 'CONFIRMED'
  /** A confirm is in flight for this row; it is not reviewable until it lands (CONFIRMED) or fails (back to PENDING). */
  | 'CONFIRMING'
  | 'DISMISSED'
  | 'PENDING';

export type OrganizationType =
  | 'COMPETITOR'
  | 'CUSTOMER'
  | 'PARTNER'
  | 'PROSPECT'
  | 'VENDOR';

export type OrganizationWorkspacesFilter = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationWorkspacesInput = {
  filter: OrganizationWorkspacesFilter;
  pagination?: InputMaybe<ListPagination>;
};

/** Filter options for organizations query */
export type OrganizationsFilter = {
  /** Filter by organization domain */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization industry */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by personal organization flag */
  personal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationsForLinkResolutionInput = {
  /** When set, `externalUsersActiveSinceCount` counts non-staff active members who signed in since then. */
  activeSince?: InputMaybe<Scalars['DateTime']['input']>;
  /** The previous page's `endCursor`. */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Email domains whose holders are staff (e.g. texturehq.com). At most 20. */
  excludeEmailDomains: Array<Scalars['String']['input']>;
  /** Page size, 1 to 200. Default 100. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for querying organizations */
export type OrganizationsInput = {
  filter?: InputMaybe<OrganizationsFilter>;
  orderBy?: InputMaybe<OrganizationsOrderBy>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<OrganizationsSearch>;
};

/** Sort options for organizations query */
export type OrganizationsOrderBy = {
  /** Sort by creation date */
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
  /** Sort by name */
  name?: InputMaybe<PaginatedQueryOrderBy>;
  /** Sort by updated date */
  updatedAt?: InputMaybe<PaginatedQueryOrderBy>;
};

/** Search options for organizations query */
export type OrganizationsSearch = {
  /** Search across name and domain */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type OutpostPortalTheme =
  | 'DARK'
  | 'LIGHT';

export type OverrideVerifyEmailInput = {
  email: Scalars['String']['input'];
};

/** Types of dashboard packs that can be enabled for an organization. */
export type PackType =
  /** Device Cloud dashboard for OEM device management. */
  | 'DEVICE_CLOUD'
  /** Program Cloud for accessing utility programs. */
  | 'PROGRAM_CLOUD'
  /** Program operations dashboard for utility program operators. */
  | 'PROGRAM_OPERATIONS'
  /** Texture Direct for direct program enrollment. */
  | 'TEXTURE_DIRECT';

export type PaginatedQueryOrderBy =
  | 'asc'
  | 'desc';

export type PaginatedQuerySearchInput = {
  query: Scalars['String']['input'];
  type: PaginatedQuerySearchTypeEnum;
};

export type PaginatedQuerySearchTypeEnum =
  | 'fullText'
  | 'partial';

export type PaginationType =
  | 'cursor'
  | 'offset';

export type ParticipationStatusFilter =
  | 'ALL'
  | 'DID_NOT_PARTICIPATE'
  | 'PARTICIPATED';

export type PatchCrmPropertyOptionsInput = {
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  definitionId: Scalars['ID']['input'];
  entityType: CrmPropertyEntityType;
  recordId: Scalars['ID']['input'];
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PauseThermostatScheduleInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * A filter row as submitted. Values are strings at the boundary and parsed by the
 * field's registry type, and a value is accepted only if it is ALREADY its own
 * canonical rendering — one that renders differently than it was written is
 * refused, with the canonical spelling named in the error, rather than silently
 * normalised. A number must be its own String(Number(v)) ("2020" and "20.5" are
 * accepted; "2020.0", "0x10", "2e3", " 2020 " are refused). A date must be a full
 * ISO-8601 instant that round-trips new Date(v).toISOString(), i.e.
 * "2024-01-02T03:04:05.000Z" — a date-only value, an offset form and a truncated
 * "Z" instant are refused, each having widened into an instant it is not.
 * Booleans are "true" or "false"; enums must be a declared value. For IN the
 * value is a JSON array string whose elements are JSON STRINGS — ["2020"], never
 * [2020] — and each element then runs the same scalar parser. The array must be
 * non-empty, and the set itself is normalised: deduplicated and sorted in UTF-8
 * byte order.
 */
export type PermissionGrantFilterInput = {
  field: Scalars['String']['input'];
  operator: PermissionGrantFilterOperator;
  value: Scalars['String']['input'];
};

/**
 * How a filter row compares its field to its value. IN carries a JSON array of
 * scalars as the value; EQUALS and NOT_EQUALS carry one scalar rendered as a
 * string.
 */
export type PermissionGrantFilterOperator =
  | 'EQUALS'
  | 'IN'
  | 'NOT_EQUALS';

/**
 * What a grant lets its holder do with the resources it reaches. MONITOR is the
 * read side (see state, telemetry, alerts); CONTROL adds the write side (issue
 * commands, change settings). CONTROL implies MONITOR.
 */
export type PermissionGrantMode =
  | 'CONTROL'
  | 'MONITOR';

/**
 * The kind of resource a grant reaches. DEVICE grants describe a device set by
 * filter rows over registry fields; COLLECTION grants point at one collection
 * whose live criteria are the predicate.
 */
export type PermissionGrantResourceType =
  | 'COLLECTION'
  | 'DEVICE';

/** Input for a phase-identification overlay of a substation, feeder, or subtree. */
export type PhaseOverlayInput = {
  /** ISO window end. Synchronous default: latest voltage. Background default: analysis-start UTC. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Voltage look-back in days (default 28, maximum 90; the method needs ~7 clean days). */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** Synchronous runs: clustering second opinion (default true). Background runs skip it. */
  ensemble?: InputMaybe<Scalars['Boolean']['input']>;
  /** Circuit/feeder number (resolves the feeder breaker). */
  feeder?: InputMaybe<Scalars['String']['input']>;
  /** Explicit element anchor. At least one of substation, feeder, or rootElementGuid is required. */
  rootElementGuid?: InputMaybe<Scalars['String']['input']>;
  /** Substation number. */
  substation?: InputMaybe<Scalars['String']['input']>;
  /** Workspace to scope the query to (required). */
  workspaceId: Scalars['ID']['input'];
};

export type PollableConnectionsInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  manufacturer: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PollingInterval =
  | 'FIFTEEN_MINUTES'
  | 'FIVE_MINUTES'
  | 'ONE_DAY'
  | 'ONE_HOUR'
  | 'ONE_MINUTE'
  | 'SIX_HOURS'
  | 'TEN_MINUTES'
  | 'THIRTY_MINUTES'
  | 'TWELVE_HOURS';

/** Bounding box for spatial queries, in EPSG:4326 (lng/lat degrees). */
export type PowerGridBoundsInput = {
  maxLat: Scalars['Float']['input'];
  maxLng: Scalars['Float']['input'];
  minLat: Scalars['Float']['input'];
  minLng: Scalars['Float']['input'];
};

export type PreferredTemperatureUnit =
  | 'CELSIUS'
  | 'FAHRENHEIT';

/**
 * Program board facet request. `workspaceId` is REQUIRED in practice (007-38): facets
 * are counted over the workspace's adopted programs, the same population the programs
 * board source lists. It was previously ignored in favour of an org-scoped count, which
 * offered filter values for programs the list would never show. Omitting it returns
 * empty facets rather than widening to the organization.
 */
export type ProgramBoardFacetsInput = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** A customer email a program can send (specs/program-emails). */
export type ProgramEmailKind =
  | 'APPLICATION_APPROVED'
  | 'APPLICATION_REJECTED'
  | 'APPLICATION_SUBMITTED'
  | 'ENROLLED'
  | 'EVENT_NOTICE'
  | 'EVENT_OPT_OUT'
  | 'EVENT_PARTICIPATION'
  | 'RETURN_TO_FUNNEL';

export type ProgramEmailPreviewInput = {
  /** Unsaved settings to preview. Omit to preview the saved settings. */
  draft?: InputMaybe<Scalars['JSON']['input']>;
  kind: ProgramEmailKind;
  workspaceProgramId: Scalars['ID']['input'];
};

export type ProgramEmailSendStatus =
  | 'CLAIMED'
  | 'FAILED'
  | 'SENT'
  | 'SKIPPED';

/** Where an enrollment's progress is authored for a program. */
export type ProgramProgressAuthority =
  /** An authored lifecycle: the engine drives the stage, and eligibilityStatus is projected from each stage it enters */
  | 'LIFECYCLE'
  /** No lifecycle, or the default one: eligibilityStatus drives the stage, which mirrors it */
  | 'STATUS';

/**
 * Unified filter input for all program reporting queries.
 * Replaces the need for separate portfolio/single-program/single-event queries.
 */
export type ProgramReportFilterInput = {
  /** Device-level filters (optional) */
  deviceFilters?: InputMaybe<ReportDeviceFilterInput>;
  /** Maximum number of events to return (default: 15) */
  maxEvents?: InputMaybe<Scalars['Int']['input']>;
  /** Program scope determines which programs/events to include */
  programScope: ProgramScopeInput;
  /** Time scope for filtering events (optional - defaults to all matching events) */
  timeScope?: InputMaybe<TimeScopeInput>;
  /** Workspace context for authorization and data scoping */
  workspaceId: Scalars['ID']['input'];
};

export type ProgramScopeInput = {
  /** Required when type is SINGLE_EVENT */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  /** Required when type is SINGLE_PROGRAM */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * PORTFOLIO: All programs in workspace
   * SINGLE_PROGRAM: Specific program by ID
   * SINGLE_EVENT: Specific event by ID
   */
  type: ProgramScopeType;
};

export type ProgramScopeType =
  | 'PORTFOLIO'
  | 'SINGLE_EVENT'
  | 'SINGLE_PROGRAM';

/**
 * Which generation of the program-operations surfaces an activated program renders.
 * Frozen per activation at creation time; never re-derived from lifecycle stages.
 */
export type ProgramSurfaceVersion =
  | 'v1'
  | 'v2';

export type ProgramsForWorkspaceFilter_Old = {
  workspaceId: Scalars['String']['input'];
};

export type ProgramsForWorkspaceInput_Old = {
  filter: ProgramsForWorkspaceFilter_Old;
  orderBy?: InputMaybe<ProgramsForWorkspaceOrderByInput_Old>;
  pagination?: InputMaybe<ListPagination>;
};

export type ProgramsForWorkspaceOrderByInput_Old = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type ProposeRelayAgentChangesInput = {
  rationale: Scalars['String']['input'];
  rows: Array<RelayAgentProposalRowInput>;
  skipped?: InputMaybe<Scalars['JSON']['input']>;
  sourceDocumentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tool: Scalars['String']['input'];
  turnId: Scalars['ID']['input'];
  webSources?: InputMaybe<Scalars['JSON']['input']>;
};

/** Provisioning type distinguishes how devices were created */
export type ProvisioningType =
  | 'OEM_DIRECT'
  | 'TEXTURE_MANAGED';

export type PublishLifecycleDefinitionInput = {
  /**
   * Set true to publish a version that drops fact keys the previous version used. Overrides `confirmedRemovedFactKeys`.
   * @deprecated Confirms removals nobody reviewed. Use confirmedRemovedFactKeys.
   */
  confirmFactKeyRemovals?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The fact keys the caller reviewed and accepts dropping, from a previous UNCONFIRMED_FACT_KEY_REMOVAL.
   * Publish still fails if the draft has since changed to drop any key not listed.
   */
  confirmedRemovedFactKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The lifecycle definition to publish. */
  definitionId: Scalars['ID']['input'];
  /** Optional free-text note stored with the version for audit. */
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PulseScope =
  | 'ALL'
  | 'OWNER'
  | 'TEAM';

export type RateAgentExchangeInput = {
  /** Client-minted conversation id, the same one recordAgentExchange was given. */
  conversationId: Scalars['NonEmptyString']['input'];
  /** Which response in that conversation. Matches AgentModelCall.exchangeSeq. */
  exchangeSeq: Scalars['Int']['input'];
  rating: AgentExchangeRating;
};

/** Organization recipient details for sharing */
export type RecipientOrgDetails = {
  /** Email address to identify the organization */
  email: Scalars['String']['input'];
};

export type RecordAgentEvalRunInput = {
  agents: Array<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  completedAt: Scalars['DateTime']['input'];
  digest?: InputMaybe<Scalars['JSON']['input']>;
  digestGeneratedAt?: InputMaybe<Scalars['DateTime']['input']>;
  digestJudge?: InputMaybe<Scalars['String']['input']>;
  gitSha?: InputMaybe<Scalars['String']['input']>;
  overallPassRate: Scalars['Float']['input'];
  runId: Scalars['NonEmptyString']['input'];
  startedAt: Scalars['DateTime']['input'];
  suiteDir: Scalars['NonEmptyString']['input'];
  tasks: Scalars['JSON']['input'];
  workspaces: Array<Scalars['String']['input']>;
};

export type RecordAgentEvalTrialInput = {
  agent: Scalars['NonEmptyString']['input'];
  completedAt: Scalars['DateTime']['input'];
  passed: Scalars['Boolean']['input'];
  runId: Scalars['NonEmptyString']['input'];
  skipped: Scalars['Boolean']['input'];
  startedAt: Scalars['DateTime']['input'];
  taskId: Scalars['NonEmptyString']['input'];
  transcript: Scalars['JSON']['input'];
  trial: Scalars['Int']['input'];
  verdicts: Scalars['JSON']['input'];
  workspace: Scalars['NonEmptyString']['input'];
};

export type RecordAgentExchangeInput = {
  calls: Array<AgentModelCallInput>;
  /** Client-minted conversation id. Scoped by userId server-side, so it is not a global key. */
  conversationId: Scalars['NonEmptyString']['input'];
  /**
   * A model-generated label for the conversation, sent only on its first exchange.
   * Optional and best-effort: when absent — generation failed, was skipped, or the
   * session already has one — the server derives a title from the opening prompt
   * instead. Recording never depends on it.
   */
  generatedTitle?: InputMaybe<Scalars['NonEmptyString']['input']>;
  model: Scalars['NonEmptyString']['input'];
  /** Which provider produced these blocks, so a reader knows which wire dialect content is in. */
  provider: Scalars['NonEmptyString']['input'];
  surface: AgentSurface;
  /** Null is valid: the agent answers platform questions with no workspace selected. */
  workspaceId?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type RecordRelayAgentToolCallInput = {
  args: Scalars['JSON']['input'];
  durationMs: Scalars['Int']['input'];
  errorCode?: InputMaybe<Scalars['String']['input']>;
  ordinal: Scalars['Int']['input'];
  outcome: RelayAgentToolOutcome;
  proposalId?: InputMaybe<Scalars['ID']['input']>;
  resultDigest?: InputMaybe<Scalars['String']['input']>;
  /** The step's model usage, on the step's first audit row only; added to the turn. */
  stepUsage?: InputMaybe<RelayAgentUsageInput>;
  tier: RelayAgentTier;
  tool: Scalars['String']['input'];
  turnId: Scalars['ID']['input'];
};

export type RecordWorkspaceProgramEventDispatchInput = {
  dispatchId: Scalars['ID']['input'];
  errorReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * The statuses the caller believed the row was in — a compare-and-swap.
   * Defaults to every status that holds the window reservation, which is the set
   * where an out-of-band write is meaningful at all: a terminal dispatch is one
   * nothing is watching any more, and resurrecting it from a late poll response
   * would contradict whatever made it terminal. A mismatch is a
   * `DISPATCH_STATUS_CONFLICT` error carrying the status actually found, never a
   * silent no-op.
   *
   * Only reservation-holding statuses may be named, from **any** source: naming a
   * terminal one would resurrect an event the provider already confirmed dead.
   * `source` is a label for the transition log, not a permission — correcting a
   * mistaken abandon arrives with RH-12's admin exits, as its own entry point with
   * its own authorization.
   */
  expectedStatuses?: InputMaybe<Array<WorkspaceProgramEventDispatchStatus>>;
  /**
   * The provider's event id, for the reconciliation that adopts one. **Adoption
   * is once**: it may be set on a dispatch holding none, and replayed with the
   * same value, but never replaced. Cancellation sends the persisted id to the
   * provider, so a replacement would leave the original live event unaddressable
   * and point cancel at a different one — refused as
   * `DISPATCH_EXTERNAL_ID_CONFLICT`. Omit to leave it alone; null and blank are
   * both refused outright — a blank id reads as "no id" to the cancel path, and
   * since adoption cannot be undone it would strand the live event permanently.
   */
  externalId?: InputMaybe<Scalars['ID']['input']>;
  /** Omit to leave the schedule alone; null to stop the ladder. */
  nextPollAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Free text for the transition log. Defaults to `source`. */
  reason?: InputMaybe<Scalars['String']['input']>;
  source: DispatchRecordSource;
  /**
   * The observed status. **`draft` is refused**, here and in `expectedStatuses`:
   * it asserts "never reserved, never sent", which no out-of-band process can
   * establish, and three separate mechanisms act on it — the window exclusion
   * does not cover `draft`, the compose upsert's arbiter matches it, and event
   * deletion removes drafts. Recording it on a live dispatch would release its
   * reservation and invite the next compose to rewrite a request already sent.
   */
  status: WorkspaceProgramEventDispatchStatus;
};

export type RecordWorkspaceProgramEventDispatchResultsInput = {
  dispatchId: Scalars['ID']['input'];
  /** Omit to leave the schedule alone; null to end the results ladder. */
  nextPollAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Must be a JSON **object**, and must still be one after a round trip through
   * JSON. Arrays, scalars, and values that serialize to either are refused: the
   * column does not round-trip them, so a later read would return a different
   * shape than was written. Refused on a `draft` dispatch too — it has never been
   * sent, so there is no run for results to describe.
   *
   * The normalized results payload plus its raw form. Program-aggregate only —
   * these are model estimates against a held-out control group and are never
   * attributable to a device, site, or enrollment.
   */
  results: Scalars['JSON']['input'];
  source: DispatchRecordSource;
};

export type RecoverOrphanedUserInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** A category of personally identifiable information that can be removed from delivered payloads. */
export type RedactionCategory =
  /** Customer name, email and phone. */
  | 'CONTACT'
  /** Site coordinates and address, and vehicle coordinates. */
  | 'LOCATION';

export type RefreshAuthenticationSessionInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Re-derives the pre-summed grid cohort aggregate (GridCohortHourly) for a
 * window. Resumable: each call processes at most 30 days
 * and returns a cursor — drive it to isComplete for larger windows. Run
 * after deep telemetry backfills or lineage migrations, and for initial
 * population. coverageExtended=false means the window was DISJOINT from
 * existing coverage: rows were written but dispatch will not serve them —
 * re-run contiguously from the gap.
 *
 * To extend coverage BACKWARD into history, pass `direction: BACKWARD` with
 * `before` at the roots' current `coveredFrom`. Batches are then taken from
 * `before` and chunks derived newest first, so each one abuts covered ground
 * and every merge extends it; re-invoke with the returned `nextBefore` until
 * `isComplete`. A window ending short of `coveredFrom` still leaves a gap
 * and is still refused as disjoint.
 */
export type RefreshGridCohortAggregateInput = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  /**
   * Defaults to FORWARD. Use BACKWARD to extend coverage into history, with
   * `before` at the roots' current `coveredFrom`.
   */
  direction?: InputMaybe<RefreshGridCohortDirection>;
  /** Restrict to specific feeder/substation roots (default: all). */
  rootGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Which end of the requested range each batch is taken from, and therefore
 * which cursor advances. FORWARD slices from `after` and returns
 * `nextAfter`; BACKWARD slices from `before` and returns `nextBefore`.
 * Batching direction must match the direction coverage is being extended: a
 * BACKWARD range sliced forward would put every batch except the last short
 * of the covered edge, writing rows the ledger refuses as disjoint.
 */
export type RefreshGridCohortDirection =
  | 'BACKWARD'
  | 'FORWARD';

/** Required data for creating a new canonical device */
export type RegisterCDeviceInput = {
  /** Data provider slug that identifies the source system */
  dataProviderSlug?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturer of the device */
  manufacturer: Scalars['String']['input'];
  /** The ID assigned to the device by the manufacturer */
  manufacturerDeviceId: Scalars['String']['input'];
  /** The model of the device */
  model: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Raw model string from the original data source */
  rawModel?: InputMaybe<Scalars['String']['input']>;
  /** Raw type string from the original data source */
  rawType?: InputMaybe<Scalars['String']['input']>;
  /** The serial number of the device */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of the device (e.g., sensor, actuator, etc.) */
  type: DeviceType;
};

/** Every write an agent proposal can make; each maps to the hand-edit path a person's edit takes. */
export type RelayAgentActionKind =
  | 'CONFERENCE_ATTENDANCE_ADD'
  | 'CONFERENCE_ATTENDANCE_REMOVE'
  | 'CONFERENCE_ATTENDANCE_UPDATE'
  | 'CONFERENCE_ATTENDEE_COST_REMOVE'
  | 'CONFERENCE_ATTENDEE_COST_UPSERT'
  | 'CONFERENCE_CREATE'
  | 'CONFERENCE_INSTANCE_CREATE'
  | 'CONFERENCE_INSTANCE_UPDATE'
  | 'CONFERENCE_LINK_ORG_INSTANCE'
  | 'CONFERENCE_LINK_ORG_SERIES'
  | 'CONFERENCE_MILESTONE_ADD'
  | 'CONFERENCE_MILESTONE_DELETE'
  | 'CONFERENCE_MILESTONE_UPDATE'
  | 'CONFERENCE_SERIES_UPDATE'
  | 'CONFERENCE_UNLINK_ORG'
  | 'CONTACT_ADD_TO_ORG'
  | 'CONTACT_AFFILIATE'
  | 'CONTACT_END_AFFILIATION'
  | 'CONTACT_SET_PROPERTY'
  | 'CONTACT_UPDATE'
  | 'CONTACT_UPDATE_AFFILIATION'
  | 'DEAL_ADD_CONTACT'
  | 'DEAL_CREATE'
  | 'DEAL_DELETE'
  | 'DEAL_LINK_ORG'
  | 'DEAL_LOG_ACTIVITY'
  | 'DEAL_REMOVE_CONTACT'
  | 'DEAL_SET_PRIMARY_ORG'
  | 'DEAL_SET_PROPERTY'
  | 'DEAL_SET_STAGE_GATE'
  | 'DEAL_TRANSITION_STAGE'
  | 'DEAL_UNLINK_ORG'
  | 'DEAL_UPDATE'
  | 'DEAL_UPDATE_ACTIVITY'
  | 'DRIVE_FOLDER_UNLINK'
  | 'EVENT_CREATE'
  | 'EVENT_MEMBER_ADD'
  | 'EVENT_MEMBER_REMOVE'
  | 'EVENT_MEMBER_UPDATE'
  | 'EVENT_STATUS_DEFINE'
  | 'EVENT_UPDATE'
  | 'INGEST_MAILBOX_REMOVE'
  | 'INGEST_MAPPING_REMOVE'
  | 'INGEST_MAPPING_SET_ENABLED'
  | 'INGEST_MAPPING_SET_ORGANIZATION'
  | 'LEARNED_SENDER_SET_ENABLED'
  | 'ORG_ASSIGN_RBM'
  | 'ORG_SET_GROUP_OWNER'
  | 'ORG_SET_NEXT_STEP'
  | 'ORG_SET_PARENT'
  | 'ORG_SET_PROPERTY'
  | 'ORG_SUGGESTION_CONFIRM'
  | 'ORG_SUGGESTION_DISMISS'
  | 'ORG_UPDATE_ALIASES'
  | 'ORG_UPDATE_SALES_FACTS'
  | 'ORG_UPDATE_SALES_METADATA'
  | 'ORG_UPDATE_SCOPING_DOMAINS'
  | 'PROPERTY_DEFINE'
  | 'PROPERTY_EDIT'
  | 'PROPERTY_RETIRE'
  | 'TRIAGE_CONFIRM'
  | 'TRIAGE_REJECT'
  | 'UPLOAD_ATTACH';

export type RelayAgentMatchCandidateInput = {
  confidence: Scalars['Float']['input'];
  evidence?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type RelayAgentModelInput = {
  /** An OpenRouter model id, exactly as OpenRouter spells it. */
  model: Scalars['String']['input'];
  /**
   * OpenRouter provider slug the agent is pinned to, with fallbacks off; null lets
   * OpenRouter route.
   */
  providerPin?: InputMaybe<Scalars['String']['input']>;
};

export type RelayAgentProposalRowInput = {
  agentNote?: InputMaybe<Scalars['String']['input']>;
  candidates?: InputMaybe<Array<RelayAgentMatchCandidateInput>>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  evidence?: InputMaybe<Scalars['String']['input']>;
  inputKey?: InputMaybe<Scalars['String']['input']>;
  kind: RelayAgentActionKind;
  /** The kind's arguments; `id` names the target and `organizationId` an organization a create or link names. */
  payload: Scalars['JSON']['input'];
};

/** A proposal row's lifecycle. EXPIRED and a stuck claim's FAILED are derived when read. */
export type RelayAgentProposalRowStatus =
  | 'APPLIED'
  | 'APPLYING'
  | 'EXPIRED'
  | 'FAILED'
  | 'PROPOSED'
  | 'REJECTED'
  | 'REVERTED'
  | 'REVERTING';

/** OPEN while any row awaits a decision. */
export type RelayAgentProposalState =
  | 'OPEN'
  | 'SETTLED';

export type RelayAgentTier =
  | 'EVERYDAY'
  | 'READ'
  | 'SUPER_ADMIN';

/** PENDING is only ever recorded for a web tool call (web_search, read_web_page), before the request leaves. */
export type RelayAgentToolOutcome =
  | 'ERROR'
  | 'OK'
  | 'PENDING'
  | 'REFUSED';

export type RelayAgentTurnStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'INTERRUPTED'
  | 'LIMITED'
  | 'RUNNING';

export type RelayAgentUsageInput = {
  cacheWriteTokens: Scalars['Int']['input'];
  cachedInputTokens: Scalars['Int']['input'];
  inputTokens: Scalars['Int']['input'];
  outputTokens: Scalars['Int']['input'];
  reasoningTokens: Scalars['Int']['input'];
};

/**
 * A saved view's definition. Names are trimmed and whitespace-collapsed, 1..80
 * characters, unique per list ignoring case; NAME sorts ascending only.
 */
export type RelayListSavedViewInput = {
  columnIds: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  filters: Array<RelayListViewFilterInput>;
  groupByOwner: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nestMembers: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: RelayListViewSortInput;
};

export type RelayListSortDirection =
  | 'ASC'
  | 'DESC';

export type RelayListViewFilterInput = {
  operator: RelayListViewFilterOperator;
  property: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

/**
 * How a saved-view filter reads its values. IS and IS_NOT are the usual "any of
 * these" / "none of these"; IS_ANY is relay's explicit "any of" for a property
 * whose plain IS means "all of" (the Segment filter).
 */
export type RelayListViewFilterOperator =
  | 'IS'
  | 'IS_ANY'
  | 'IS_NOT';

export type RelayListViewSortInput = {
  direction: RelayListSortDirection;
  key: RelayListViewSortKey;
};

/** What a shared saved view sorts a Relay list by. */
export type RelayListViewSortKey =
  | 'CREATED_AT'
  | 'DATE_CONNECTED'
  | 'NAME'
  | 'NEXT_STEP_DUE_DATE';

export type RelaySuperAdminSource =
  /** Listed in RELAY_SUPER_ADMIN_EMAILS; removable only there. */
  | 'CONFIG'
  /** Granted in Relay Settings. */
  | 'GRANT';

export type RemoveRequirementInput = {
  requirementId: Scalars['String']['input'];
  stageId: Scalars['ID']['input'];
};

export type RemoveTagFromEnrollmentsInput = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for removing a transition from a stage */
export type RemoveTransitionInput = {
  stageId: Scalars['ID']['input'];
  transitionId: Scalars['ID']['input'];
};

/** Input for reordering requirements within a stage (display order) */
export type ReorderRequirementsInput = {
  /**
   * Ordered list of requirement IDs - first = shown first. Must be a complete
   * permutation of the stage's existing requirement IDs.
   */
  requirementIds: Array<Scalars['ID']['input']>;
  stageId: Scalars['ID']['input'];
};

export type ReorderStagesInput = {
  lifecycleDefinitionId: Scalars['ID']['input'];
  stageIds: Array<Scalars['ID']['input']>;
};

/** Input for reordering transitions within a stage (priority order) */
export type ReorderTransitionsInput = {
  stageId: Scalars['ID']['input'];
  /** Ordered list of transition IDs - first = highest priority */
  transitionIds: Array<Scalars['ID']['input']>;
};

/**
 * Write (or re-write) a batch of interval readings for one meter. Replaces on
 * overlap: any existing points for this meter's dedicated import series within
 * the batch's own [min(ts), max(ts)] range are physically deleted before the
 * new points are inserted, atomically in one transaction — calling this again
 * for the same meter/points supersedes the prior values rather than
 * duplicating them (duplicate rows would otherwise double-count in SUM/AVG
 * telemetry rollups). Scoped to a dedicated provider slug
 * (`bulk-upload-interval-import`, keyed by the resolved deviceId) — never
 * touches telemetry an AMI/OEM pipeline wrote for the same device.
 */
export type ReplaceMeterIntervalReadingsInput = {
  /** TelemetryChannel.interval, e.g. 5 minutes. */
  channelInterval: Scalars['String']['input'];
  /** TelemetryChannel.mode, e.g. backfill. */
  channelMode: Scalars['String']['input'];
  /** The CSV's Source Id — resolved against Device.manufacturerDeviceId, scoped to workspaceId. */
  manufacturerDeviceId: Scalars['String']['input'];
  /** Canonical metric name, e.g. kwh_usage. */
  metric: Scalars['String']['input'];
  /** Points to insert. Chunked internally — no caller-side batching required. */
  points: Array<MeterIntervalPointInput>;
  workspaceId: Scalars['ID']['input'];
};

export type ReportDateRangeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type ReportDeviceDisplayType =
  | 'BATTERY'
  | 'EV'
  | 'INVERTER'
  | 'OTHER'
  | 'THERMOSTAT';

export type ReportDeviceFilterInput = {
  /** Filter to specific device IDs */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by device type */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** Filter by participation status */
  participationStatus?: InputMaybe<ParticipationStatusFilter>;
};

export type ReportEnergyFilterOptionsInput = {
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange: DateRangeInput;
  dimension: ReportFilterDimension;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  workspaceId: Scalars['ID']['input'];
};

export type ReportEnergyInput = {
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange: DateRangeInput;
  granularity: TimeGranularity;
  groupBySerial?: InputMaybe<Scalars['Boolean']['input']>;
  includeProfitability?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When false, skip the total-record COUNT query. That COUNT re-runs the full aggregation, so
   * skipping it roughly halves the query cost — use it for exports / paginated fetches that already
   * know the total. Defaults to true (metadata.totalRecords reflects the full result set); when
   * false, metadata.totalRecords falls back to the number of rows returned by this request.
   */
  includeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeValidationFlags?: InputMaybe<Scalars['Boolean']['input']>;
  includeWindowEnd?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measures?: InputMaybe<Array<ReportEnergyMeasure>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyValidData?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<OrderByInput>>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  validationFlags?: InputMaybe<ValidationFlagsFilter>;
  workspaceId: Scalars['ID']['input'];
};

export type ReportEnergyMeasure =
  | 'BATTERY_CHARGE_W'
  | 'BATTERY_CHARGE_WH'
  | 'BATTERY_DISCHARGE_W'
  | 'BATTERY_DISCHARGE_WH'
  | 'BATTERY_TO_GRID_W'
  | 'BATTERY_TO_GRID_WH'
  | 'BATTERY_TO_HOME_W'
  | 'BATTERY_TO_HOME_WH'
  | 'GRID_EXPORT_W'
  | 'GRID_EXPORT_WH'
  | 'GRID_IMPORT_W'
  | 'GRID_IMPORT_WH'
  | 'GRID_METER_EXPORT_DIFF_WH'
  | 'GRID_METER_IMPORT_DIFF_WH'
  | 'GRID_METER_NET_DIFF_WH'
  | 'GRID_NET_W'
  | 'GRID_NET_WH'
  | 'GRID_TO_BATTERY_W'
  | 'GRID_TO_BATTERY_WH'
  | 'GRID_TO_HOME_W'
  | 'GRID_TO_HOME_WH'
  | 'METER_EXPORT_WH'
  | 'METER_IMPORT_WH'
  | 'METER_NET_WH'
  | 'PV_GENERATION_W'
  | 'PV_GENERATION_WH'
  | 'PV_TO_BATTERY_W'
  | 'PV_TO_BATTERY_WH'
  | 'PV_TO_GRID_W'
  | 'PV_TO_GRID_WH'
  | 'PV_TO_HOME_W'
  | 'PV_TO_HOME_WH'
  | 'RECORD_COUNT'
  | 'SOC_AVG_PERCENT'
  | 'SOC_MAX_PERCENT'
  | 'SOC_MIN_PERCENT'
  | 'TOTAL_CONSUMPTION_W'
  | 'TOTAL_CONSUMPTION_WH';

export type ReportEnergyTagCategoriesInput = {
  workspaceId: Scalars['ID']['input'];
};

export type ReportEnergyTagOptionsInput = {
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  tagKey: Scalars['String']['input'];
  tags?: InputMaybe<Array<TagFilterInput>>;
  workspaceId: Scalars['ID']['input'];
};

export type ReportEventOptionsInput = {
  /** Maximum number of events to return (default: 50) */
  maxEvents?: InputMaybe<Scalars['Int']['input']>;
  programScope: ProgramScopeInput;
  workspaceId: Scalars['ID']['input'];
};

export type ReportFilterDimension =
  | 'CITY'
  | 'POSTAL_CODE'
  | 'SERIAL'
  | 'STATE';

export type ReportParticipationStatus =
  | 'DID_NOT_PARTICIPATE'
  | 'PARTICIPATED';

export type ReportPeriod =
  | 'LAST_7D'
  | 'LAST_24H'
  | 'LAST_30D'
  | 'LAST_60D'
  | 'LAST_90D';

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
};

export type RequestUploadInput = {
  enrollmentId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

export type RequeueAlertsInput = {
  alertIds: Array<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type Requirement =
  | 'location'
  | 'manufacturer'
  | 'utilityZone';

export type RescheduleWorkspaceProgramEventDispatchPollInput = {
  dispatchId: Scalars['ID']['input'];
  /**
   * When to look again. **Null stops the ladder.**
   *
   * Required and nullable rather than optional: the other writers use "omit to
   * leave the schedule alone" because they are primarily saying something else, and
   * a caller here that has nothing to say about the schedule has no reason to call
   * at all.
   */
  nextPollAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  source: DispatchRecordSource;
};

export type ResendInvitationInput = {
  invitationId: Scalars['String']['input'];
};

/** Input for resending MFA code */
export type ResendMfaCodeInput = {
  email: Scalars['String']['input'];
  mfaChallengeId: Scalars['String']['input'];
};

export type ResendVerificationEmailInput = {
  email: Scalars['String']['input'];
};

/** Possible errors that can occur during password reset */
export type ResetPasswordError =
  | 'INVALID_TOKEN'
  | 'PASSWORD_UPDATE_FAILED'
  | 'TOKEN_ALREADY_USED'
  | 'TOKEN_EXPIRED';

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Input for listing resolution rules for a workspace. */
export type ResolutionRulesInput = {
  /**
   * When true (default), platform-wide defaults (workspaceId IS NULL) are returned alongside
   * workspace-scoped rules.
   */
  includePlatformDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for resolving a staged record issue. */
export type ResolveStagedRecordIssueInput = {
  issueId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  resolution: Scalars['String']['input'];
};

export type ResumeThermostatScheduleInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for re-triggering grant events */
export type RetriggerGrantEventsInput = {
  /**
   * List of provider grant IDs to re-trigger events for.
   * Pass ["*"] to re-trigger for all non-deleted grants.
   */
  providerGrantIds: Array<Scalars['String']['input']>;
};

export type RetryCommandInput = {
  commandId: Scalars['ID']['input'];
};

/** Input for querying review log (approval/rejection decisions). */
export type ReviewLogInput = {
  /** Scope results to a single staged batch. */
  batchId?: InputMaybe<Scalars['ID']['input']>;
  decision?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Scope results to a single staged record. */
  recordId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for reviewing (approving or rejecting) a staged record. */
export type ReviewStagedRecordInput = {
  action: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
  reviewNote?: InputMaybe<Scalars['String']['input']>;
};

/** Input for revoking app access. */
export type RevokeAppAccessInput = {
  /** The app slug to revoke. */
  app: Scalars['String']['input'];
  /** Optional reason for the revocation. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user whose access is being revoked. */
  userId: Scalars['ID']['input'];
};

export type RevokeCanonicalOrganizationTerritoryInput = {
  /** `CanonicalOrganizationTerritory.id` of the claim to revoke. */
  territoryId: Scalars['ID']['input'];
};

export type RevokeCanonicalOrganizationTerritoryOutcome =
  /** The claim was already unlinked. Nothing written. */
  | 'ALREADY_REVOKED'
  /** No such claim. */
  | 'NOT_FOUND'
  /** The live claim was stamped as unlinked. */
  | 'REVOKED';

export type RevokeCollectionShareInput = {
  /** The ID of the SharedResource (collection share) to revoke */
  sharedResourceId: Scalars['ID']['input'];
};

export type RevokeInvitationInput = {
  id: Scalars['String']['input'];
};

export type RevokeSsoExemptionInput = {
  exemptionId: Scalars['String']['input'];
};

/** Input for revoking super admin access */
export type RevokeSuperAdminInput = {
  /** Optional reason for revoking access */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user to revoke super admin access from */
  userId: Scalars['ID']['input'];
};

export type RevokeWorkspaceAccessGrantInput = {
  workspaceAccessGrantId: Scalars['ID']['input'];
};

export type Role =
  | 'ADMIN'
  | 'OPERATOR'
  /**
   * No default access. Scoped users reach resources only through team membership
   * and the resources granted to their teams.
   */
  | 'SCOPED'
  | 'USER'
  | 'VIEWER';

/**
 * A filter over the imported GTM facts (`CanonicalOrganizationSalesFacts`), the
 * next step, and the CRM organization record's aliases and utility link. Every
 * member is optional and the members are AND-ed. An input with no member set is
 * rejected with INVALID_INPUT: an empty filter is never "every organization".
 * An empty list, a blank string in a list, a range with neither bound, an
 * inverted range and a date that is not a real YYYY-MM-DD day are rejected too.
 *
 * Only organizations CRM holds a row for can match. A presence flag set to false
 * means "rows CRM holds that lack it"; an organization with no CRM row matches
 * neither true nor false. Strings match the stored value exactly. Text counts as
 * present when it is neither null nor empty; every CRM write trims, so stored
 * text is never whitespace-only.
 */
export type SalesFactsFilterInput = {
  /** Organizations whose CRM aliases include any of these. */
  aliasesAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Utilities research AMI confidence: any of these values. */
  amiConfidence?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Utilities research AMI source date. */
  amiSourceDate?: InputMaybe<CrmDateRangeInput>;
  /** Utilities research AMI stage: any of these values. */
  amiStage?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Any of these values. */
  amiUpgradeType?: InputMaybe<Array<Scalars['String']['input']>>;
  amiUpgradeYear?: InputMaybe<CrmIntRangeInput>;
  /** Utilities research AMI vendor: any of these values. */
  amiVendor?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Organizations whose campaigns include any of these. */
  campaignsAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Organizations holding a live deal whose close date falls within these
   * calendar-day bounds. A deal with no close date never matches.
   */
  closeDate?: InputMaybe<CrmDateRangeInput>;
  /** Organizations holding a non-deleted contract in any of these journey stages. */
  contractJourneyStages?: InputMaybe<Array<CrmContractJourneyStage>>;
  /** Contracted ARR, as CrmContractStats sums it. Only organizations holding a contract can match. */
  contractedArr?: InputMaybe<CrmFloatRangeInput>;
  contributedToCord?: InputMaybe<Scalars['Boolean']['input']>;
  cordMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** Utilities research CP structure: any of these values. */
  cpStructure?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Utilities research current meter vendor: any of these values. */
  currentMeterVendor?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Organizations holding a non-deleted customer account of any of these types (Notion's Type option, exactly). */
  customerAccountTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Organizations holding a non-deleted customer account in any of these journey stages. */
  customerJourneyStages?: InputMaybe<Array<CrmCustomerJourneyStage>>;
  dateConnected?: InputMaybe<CrmDateRangeInput>;
  /**
   * Deal ARR summed over the organization's live deals, open and closed (the Deals
   * tab's Pipeline ARR). Only organizations holding a live deal can match.
   */
  dealArr?: InputMaybe<CrmFloatRangeInput>;
  /** Organizations holding a live deal in any of these stages. */
  dealStages?: InputMaybe<Array<DealStage>>;
  /** Organizations holding a live deal of any of these types. */
  dealTypes?: InputMaybe<Array<DealType>>;
  /** Utilities research generation value of demand response, dollars per kW. */
  drGenerationValuePerKw?: InputMaybe<CrmFloatRangeInput>;
  /** Utilities research transmission value of demand response, dollars per kW. */
  drTransmissionValuePerKw?: InputMaybe<CrmFloatRangeInput>;
  escDevicesCool?: InputMaybe<CrmIntRangeInput>;
  escDevicesHeat?: InputMaybe<CrmIntRangeInput>;
  escHomesCool?: InputMaybe<CrmIntRangeInput>;
  escHomesHeat?: InputMaybe<CrmIntRangeInput>;
  escMw1hCool?: InputMaybe<CrmFloatRangeInput>;
  escMw1hHeat?: InputMaybe<CrmFloatRangeInput>;
  escMw2hCool?: InputMaybe<CrmFloatRangeInput>;
  escMw2hHeat?: InputMaybe<CrmFloatRangeInput>;
  /** Utilities research forecasted batteries. */
  forecastedBatteries?: InputMaybe<CrmIntRangeInput>;
  /**
   * At least one active contract (true), or contracts none of which is active
   * (false); an organization holding no contract matches neither. Active is the
   * rule CrmContractStats states.
   */
  hasActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  /** Utilities research AMI evidence (true), or none (false). */
  hasAmiEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  /** A Utilities research AMI source URL (true), or none (false). */
  hasAmiSourceUrl?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Any estimated storage capacity figure stored, a stored 0 included (true), or
   * none of the eight (false; only rows CRM holds can match).
   */
  hasAnyEsc?: InputMaybe<Scalars['Boolean']['input']>;
  /** A Utilities research board minutes URL (true), or none (false). */
  hasBoardMinutesUrl?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * At least one non-deleted customer account (true), or customer accounts all of
   * which are deleted (false); an organization holding no account matches neither.
   */
  hasCustomerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * At least one live deal (true), or deals all of which are deleted (false); an
   * organization holding no deal matches neither.
   */
  hasDeal?: InputMaybe<Scalars['Boolean']['input']>;
  /** An internal Slack channel (true), or none (false). */
  hasInternalSlack?: InputMaybe<Scalars['Boolean']['input']>;
  /** A Linear URL (true), or none (false). */
  hasLinear?: InputMaybe<Scalars['Boolean']['input']>;
  /** A next step with a description (true), or none (false). */
  hasNextStep?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * At least one live deal in an open pipeline stage (true), or live deals none
   * of which is open (false); an organization holding no deal matches neither.
   */
  hasOpenDeal?: InputMaybe<Scalars['Boolean']['input']>;
  /** The CRM organization carries an EIA utility id (true), or does not (false). */
  hasUtilityLink?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * At least one utility program by either route, the Org relation or the EIA id
   * (true), or programs all of which are deleted (false); an organization no
   * program ever reached matches neither.
   */
  hasUtilityProgram?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any of these values. */
  headquarters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Any of these lead sources, matched exactly. */
  leadSource?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Due date of a next step that has a description; a step with no description never matches. */
  nextStepDueDate?: InputMaybe<CrmDateRangeInput>;
  /**
   * A next step with a description whose due date is before today, UTC (true), or
   * any row that is not overdue (false). A step due today is not overdue.
   */
  nextStepOverdue?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Provenance of a next step that has a description. A legacy row with a null
   * source matches no value.
   */
  nextStepSource?: InputMaybe<Array<NextStepSource>>;
  notionMeterCount?: InputMaybe<CrmIntRangeInput>;
  /**
   * Deal ARR summed over the organization's live deals in an open pipeline stage
   * (the organization page's open ARR). Only organizations holding a live deal can
   * match; one whose deals are all closed reads 0.
   */
  openDealArr?: InputMaybe<CrmFloatRangeInput>;
  /**
   * Number of the organization's live deals in an open pipeline stage (the
   * organization page's open deal count). Only organizations holding a live deal
   * can match; one whose deals are all closed reads 0.
   */
  openDealCount?: InputMaybe<CrmFloatRangeInput>;
  /**
   * Organizations holding a live deal whose PRA was sent within these calendar-day
   * bounds. A deal with no PRA sent date never matches.
   */
  praSentDate?: InputMaybe<CrmDateRangeInput>;
  /** Any of these values. */
  renewHomeSalesRep?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Organizations whose sales playbooks include any of these. */
  salesPlaybooksAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Organizations a live utility program of any of these asset types reaches. */
  utilityProgramAssetTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * How many live utility programs reach the organization. Only organizations at least one live program reaches can
   * match, so no range matches a count of 0.
   */
  utilityProgramCount?: InputMaybe<CrmIntRangeInput>;
  /** Organizations a live utility program naming any of these DERMS vendors reaches. */
  utilityProgramDermsVendors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Organizations a live utility program with any of these dispatch strategies reaches. */
  utilityProgramDispatchStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaveSharedExploreViewInput = {
  expectedRevision?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  state: Scalars['JSON']['input'];
};

/** Input for saving a workflow draft */
export type SaveWorkflowDraftInput = {
  /** JSON configuration conforming to workflow schema */
  config: Scalars['JSON']['input'];
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the workflow */
  name: Scalars['String']['input'];
};

export type ScadaSubstationTelemetryInput = {
  /**
   * When set, each element's telemetry is the latest reading at-or-before this
   * instant, ignoring readings older than the staleness horizon (60 min) so gaps
   * surface as NO DATA rather than stale values. Omit for live/latest behavior.
   */
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  /** Source/substation GUID (GridElement.substationGsGuid). */
  substationGsGuid: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type ScheduleSupportedDeviceType =
  | 'battery'
  | 'charger'
  | 'thermostat'
  | 'vehicle';

/**
 * Filter for searching devices via Elasticsearch. Supports all filter fields
 * including state, location, tags, and collection membership.
 */
export type SearchDevicesFilter = {
  collectionMembership?: InputMaybe<Array<Scalars['ID']['input']>>;
  connected?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** @deprecated Use model and manufacturer instead */
  displayModelName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by device IDs (DeviceOnWorkspace IDs) */
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<DeviceLocationFilter>;
  manufacturer?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerDeviceId?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerUserId?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<DeviceStateFilter>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<DeviceType>>;
  workspaceId: Scalars['ID']['input'];
};

export type SearchDevicesInput = {
  filter: SearchDevicesFilter;
  orderBy?: InputMaybe<DeviceOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<DeviceSearchInput>;
};

export type SendBatchCommandInput = {
  battery?: InputMaybe<BatteryBatchCommandInput>;
  charger?: InputMaybe<ChargerBatchCommandInput>;
  thermostat?: InputMaybe<ThermostatBatchCommandInput>;
  vehicle?: InputMaybe<VehicleBatchCommandInput>;
};

export type SendCommandInput = {
  battery?: InputMaybe<BatteryCommandInput>;
  charger?: InputMaybe<ChargerCommandInput>;
  thermostat?: InputMaybe<ThermostatCommandInput>;
  vehicle?: InputMaybe<VehicleCommandInput>;
};

export type SendProgramEmailTestInput = {
  draft?: InputMaybe<Scalars['JSON']['input']>;
  kind: ProgramEmailKind;
  workspaceProgramId: Scalars['ID']['input'];
};

export type SendWorkspaceInvitationInput = {
  recipientEmail: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

/** Authentication method used for a session */
export type SessionAuthMethod =
  | 'API_KEY'
  | 'EMAIL_PASSWORD'
  | 'MFA_VERIFICATION'
  | 'OAUTH'
  | 'REFRESH'
  | 'SUPER_ADMIN';

/** Input for querying user sessions */
export type SessionsInput = {
  pagination?: InputMaybe<ListPagination>;
};

export type SetBatteryOperatingModeInput = {
  dischargePowerPercent?: InputMaybe<Scalars['Float']['input']>;
  dischargePowerRate?: InputMaybe<Scalars['Float']['input']>;
  dischargeStrategy?: InputMaybe<Scalars['String']['input']>;
  enableGridInteraction?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  maximumBatteryReserve?: InputMaybe<Scalars['Float']['input']>;
  minimumBatteryReserve?: InputMaybe<Scalars['Float']['input']>;
  operatingMode: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetBatteryReserveInput = {
  chargePercentage: Scalars['Float']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetCanonicalContactEmailForAutomationInput = {
  actorId: Scalars['ID']['input'];
  automation: ContactAutomationInput;
  canonicalContactId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  expectedEmail: ContactExpectedValueInput;
};

export type SetCanonicalContactEmailInput = {
  canonicalContactId: Scalars['ID']['input'];
  /** The address to make primary; null clears the manual address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The address the contact showed (primary first, then newest). */
  expectedEmail?: InputMaybe<ContactExpectedValueInput>;
};

export type SetCanonicalContactNameForAutomationInput = {
  actorId: Scalars['ID']['input'];
  automation: ContactAutomationInput;
  canonicalContactId: Scalars['ID']['input'];
  expectedName: ContactNamePartsInput;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SetCanonicalContactNameInput = {
  canonicalContactId: Scalars['ID']['input'];
  expectedName?: InputMaybe<ContactNamePartsInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The full typed name; null or blank clears the manual name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SetCanonicalContactPhoneForAutomationInput = {
  actorId: Scalars['ID']['input'];
  automation: ContactAutomationInput;
  canonicalContactId: Scalars['ID']['input'];
  expectedPhone: ContactExpectedValueInput;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Input for `setCanonicalContactPhoneForWorkflow`. */
export type SetCanonicalContactPhoneForWorkflowInput = {
  canonicalContactId: Scalars['ID']['input'];
  /** The phone the caller read before deciding (E.164); null when it read none. */
  expectedPhone?: InputMaybe<Scalars['String']['input']>;
  /** The new phone number; null or blank clears the manually entered phone. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The crm Document Workflow writing, recorded on the source event. */
  workflowId: Scalars['ID']['input'];
};

/** Input for `setCanonicalContactPhone`. */
export type SetCanonicalContactPhoneInput = {
  canonicalContactId: Scalars['ID']['input'];
  /** The phone the caller read (primary first, then newest); refused with CONTACT_PHONE_MOVED when it differs. */
  expectedPhone?: InputMaybe<ContactExpectedValueInput>;
  /** The new phone number; null or blank clears the manually entered phone. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SetCanonicalOrganizationNextStepInput = {
  /** Description for the next step. Null clears the current next step. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional due date for the next step; cleared when description is null. */
  dueDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Input for `setCanonicalOrganizationOwnerForMany`. */
export type SetCanonicalOrganizationOwnerForManyInput = {
  /**
   * Send the owner-assigned email for the FIRST listed organization when it
   * genuinely changes hands to a new owner. Default false: a service propagating
   * an owner (nesting a member under a G&T) stays silent; Relay's Account card,
   * where a person is making the assignment, sets true.
   */
  notifyOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** The CanonicalOrganizations to reassign together. Merged-away ids are followed. */
  organizationIds: Array<Scalars['ID']['input']>;
  /** Identity `User` id to assign to every listed org, or null to unassign them all. */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for `setCanonicalOrganizationOwner`. */
export type SetCanonicalOrganizationOwnerInput = {
  /**
   * The CanonicalOrganization to reassign. Must reference an existing,
   * non-deleted canonical org row. Named `organizationId` to match Relay's org
   * detail route/input contract; it is the canonical organization id.
   */
  organizationId: Scalars['ID']['input'];
  /**
   * Identity `User` id to assign as owner. Omit to leave unchanged, pass `null`
   * to unassign (clear the owner), or pass a user id to assign. When non-null it
   * is stored verbatim on `CanonicalOrganization.ownerId`; the DB
   * `onDelete: SetNull` relation keeps it consistent if the user is later deleted.
   */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetChargerOperatingModeInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  operatingMode: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetCrmPropertyValueInput = {
  definitionId: Scalars['ID']['input'];
  entityType: CrmPropertyEntityType;
  /** Refuses STALE_VALUE when the record already holds a value. */
  expectAbsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Refuses STALE_VALUE unless the stored value still carries this updatedAt. */
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  recordId: Scalars['ID']['input'];
  /** Null clears the value. */
  value?: InputMaybe<CrmPropertyValueInput>;
};

export type SetThermostatFanModeInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  fanMode: ThermostatFanMode;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetThermostatOperatingModeInput = {
  coolTarget?: InputMaybe<Scalars['Float']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  heatTarget?: InputMaybe<Scalars['Float']['input']>;
  operatingMode: ThermostatMode;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetVehicleChargeLimitInput = {
  chargeLimit: Scalars['Int']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  homeRadiusMeters?: InputMaybe<Scalars['Float']['input']>;
  requireHomeLocation?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetVehicleOperatingModeInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  homeRadiusMeters?: InputMaybe<Scalars['Float']['input']>;
  operatingMode: Scalars['String']['input'];
  requireHomeLocation?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Replaces the scenario and clears checkpoints. `seed` and `startAt` are kept when omitted; `params` is replaced. */
export type SetVirtualSiteScenarioInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  presetId: Scalars['String']['input'];
  seed?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type SetWebhookDestinationEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type SetWorkspaceConnectConfigInput = {
  config: WorkspaceConnectConfigData;
  profile?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type SetWorkspaceProgramDispatchConfigInput = {
  /**
   * The dispatch plan, or null to clear it and return to default behavior.
   * Omitting the field is rejected — clearing must be explicit.
   */
  plan?: InputMaybe<Scalars['JSON']['input']>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type SetWorkspaceProgramNotificationsConfigInput = {
  /**
   * The settings, or null to clear them (the program then sends no customer
   * emails). Omitting the field is rejected: clearing must be explicit.
   */
  config?: InputMaybe<Scalars['JSON']['input']>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type SetWorkspaceProgramSurfacesInput = {
  /**
   * Whether `apps/onboard` may serve a **preview** of the form version this activation is not
   * currently serving, without changing what customers are served.
   *
   * The v1→v2 migration state: keep serving the bespoke v1 form to live customers while the v2
   * replacement is built and exercised, then flip `onboardingFormVersion` once it is proven.
   *
   * This gates a write, not just a render. Opening the v2 flow posts to `/api/lifecycle/init`
   * in a mount effect and creates a `LifecycleInstance` with a null `entityId`, so a
   * request-scoped query parameter alone would let anyone create draft rows against any live
   * program. Previewing therefore requires this stored opt-in *and* the request-side signal.
   *
   * Consumed by `apps/onboard` (BOLT-1702 part 2). Until that lands this marker is inert —
   * writing it changes nothing observable. Omit to leave unchanged.
   */
  enrollmentFormPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Ignored. The enrollment funnel was removed from the dashboard.
   * @deprecated The enrollment funnel was removed; this input is ignored.
   */
  enrollmentFunnel?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Which enrollment form `apps/onboard` serves to **customers** for this activation: `v2` the
   * lifecycle-driven flow, `v1` the bespoke per-customer form.
   *
   * The only axis here that changes what customers see, and it takes effect immediately for
   * in-flight enrollees — verify the target form first. Independent of `version` by design, so
   * a program can take the v2 authoring canvas while still serving its bespoke v1 form until
   * BOLT-1668 ports it. Omit to leave unchanged.
   */
  onboardingFormVersion?: InputMaybe<ProgramSurfaceVersion>;
  /**
   * Whether the lifecycle authoring canvas is available for this activation. `v2` routes the
   * Configuration row to the stage/requirement authoring surface; `v1` routes it to the legacy
   * settings form. Operator-facing only — enrollees see no difference. Setting this also stamps
   * the canonical program's default for future activations, when the program is reachable by at
   * most one tenant. Omit to leave unchanged.
   */
  version?: InputMaybe<ProgramSurfaceVersion>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type SettleRelayAgentToolCallInput = {
  durationMs: Scalars['Int']['input'];
  errorCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  outcome: RelayAgentToolOutcome;
  resultDigest?: InputMaybe<Scalars['String']['input']>;
};

export type SeveritiesInput = {
  critical: Scalars['Boolean']['input'];
  info: Scalars['Boolean']['input'];
  warning: Scalars['Boolean']['input'];
};

export type Severity =
  | 'CRITICAL'
  | 'INFO'
  | 'WARNING';

/** Input for sharing a collection with an invitee by email */
export type ShareCollectionByEmailInput = {
  /** The ID of the collection to share */
  collectionId: Scalars['ID']['input'];
  /** Email address of invitee */
  recipientEmail: Scalars['String']['input'];
};

/** Input for sharing a collection with an organization */
export type ShareCollectionWithOrgInput = {
  /** The ID of the collection to share */
  collectionId: Scalars['ID']['input'];
  /** Organization recipient information */
  recipientOrgDetails: RecipientOrgDetails;
};

/** Types of resources that can be shared */
export type SharedResourceType =
  | 'ALERT'
  | 'COLLECTION'
  | 'PROGRAM';

export type SignUpUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Input type for creating a site */
export type SiteCreateInput = {
  /** City where the site is located */
  city: Scalars['String']['input'];
  /** Country where the site is located */
  country: Scalars['String']['input'];
  /** Latitude coordinate of the site location */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude coordinate of the site location */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** User provided name for the site */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal code where the site is located */
  postalCode: Scalars['String']['input'];
  /** Customer reference ID this site belongs to */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** State/province where the site is located */
  state: Scalars['String']['input'];
  /** Primary street address of the site */
  streetOne: Scalars['String']['input'];
  /** Secondary street address of the site (optional) */
  streetTwo?: InputMaybe<Scalars['String']['input']>;
  /** ID of the workspace this site belongs to */
  workspaceId: Scalars['String']['input'];
};

/**
 * Numeric bounds for `SitesFilter.deviceCount`.
 *
 * Every operator is optional; the ones supplied are combined with AND.
 *
 * Three pairs are rejected rather than silently merged, because each is two bounds on the
 * same side with no single meaning: `lt` with `lte`, `gt` with `gte`, and `eq` with any of
 * the four range operators. Guessing one of them would change the query the caller wrote.
 *
 * `eq` with `ne` is **not** in that list and is accepted. It is redundant rather than
 * contradictory — an exact value that also excludes another — and refusing it would reject a
 * query that answers correctly.
 */
export type SiteDeviceCountFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for `siteDisplayLabels`. Ids outside `workspaceId` are dropped, and at
 * most 200 ids are labelled per call — this labels a picked set, it does not walk
 * a workspace.
 */
export type SiteDisplayLabelsInput = {
  ids: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type SiteLocationFilter = {
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Built by @asPaginatedQuery directive??? */
export type SiteOrderByInput = {
  city?: InputMaybe<PaginatedQueryOrderBy>;
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
  /**
   * How many devices are linked to the site. Sorts on the stored rollup, so it needs no
   * join — and it discriminates only at the top: [prod, 2026-09-13] 76.7% of sites hold
   * exactly one device and 20.4% hold two, so descending order is a jump to the ~166 sites
   * with ten or more rather than a general ordering.
   */
  deviceCount?: InputMaybe<PaginatedQueryOrderBy>;
  name?: InputMaybe<PaginatedQueryOrderBy>;
  state?: InputMaybe<PaginatedQueryOrderBy>;
};

export type SiteSearchInput = {
  address?: InputMaybe<FieldSearchInput>;
  name?: InputMaybe<FieldSearchInput>;
  referenceId?: InputMaybe<FieldSearchInput>;
  siteType?: InputMaybe<FieldSearchInput>;
};

/** Filter criteria for querying sites */
export type SitesFilter = {
  /**
   * Bounds on `Site.deviceCount`. Operators combine as AND, so `{ gte: 2, lte: 10 }` is a
   * range and `{ eq: 1, ne: 0 }` is accepted (redundantly) — what is refused is a pair with
   * no single meaning. See `SiteDeviceCountFilter`.
   *
   * Values are `Int`, so a fraction or a number outside the signed 32-bit range is a type
   * error rather than a filter. Sites with no stored rollup match nothing here, as with
   * `hasDevices`.
   */
  deviceCount?: InputMaybe<SiteDeviceCountFilter>;
  /**
   * Device types linked to the site, lowercase (`battery`, `meter`, …). Several values are
   * an OR: a site matches if it has a device of any listed type.
   */
  deviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Whether the site has any linked device. Matches the `Site.hasDevices` rollup, so it
   * carries that field's ~89% link coverage: a site whose only device lacks a site link is
   * returned by `hasDevices: false`, not by `true`.
   *
   * A site with no stored rollup (indexed before the rollup shipped, or not indexed yet)
   * matches neither value — "unknown" is not selectable, by design. Use it to narrow, not
   * to partition.
   */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the site has a device whose manufacturer connection has dropped. Read
   * `Site.hasOfflineDevices` before building on this: it is the integration link rather than
   * the equipment, it is silent on meter-only fleets, and a bulk-imported device can carry
   * it without ever having been connected.
   */
  hasOfflineDevices?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by site location attributes */
  location?: InputMaybe<SiteLocationFilter>;
  /** Array of site names to filter by */
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Program slugs the site is enrolled in. Several values are an OR. Only `approved`
   * enrollments are counted — see `Site.programSlugs`.
   */
  programSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array of customer reference IDs to filter by */
  referenceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID of the workspace to filter sites by */
  workspaceId: Scalars['ID']['input'];
};

/** Built by @asPaginatedQuery directive??? */
export type SitesInput = {
  filter: SitesFilter;
  orderBy?: InputMaybe<SiteOrderByInput>;
  /**
   * Offset or cursor. **Offset cannot reach past result 10,000** — the index's
   * result window — and a page that crosses it is refused rather than failing in
   * the cluster. Walk a workspace larger than that with the cursor shape
   * (`first` / `after`), which pages by the last row rather than by depth and has
   * no such limit; `meta.pagination.cursor.endCursor` carries the token. A cursor
   * is tied to the `orderBy` it was issued under: change the sort and start again.
   * `first` must be between 1 and 1,000, and defaults to 20 when omitted.
   */
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<SiteSearchInput>;
};

export type SlugOrIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type SortDirection =
  | 'ASC'
  | 'DESC';

export type SortOrder =
  | 'ASC'
  | 'DESC';

export type SsoCheckStatus =
  | 'error'
  | 'ok'
  | 'skip'
  | 'warn';

/**
 * Identifies an Auth0 enterprise connection strategy. Values map 1:1 to Auth0
 * Management API `strategy` strings, with underscores in place of hyphens to
 * fit GraphQL's enum-value grammar (`google_apps` → Auth0 `google-apps`).
 */
export type SsoStrategy =
  /** Reserved — schema slot only, not surfaced in v1. */
  | 'adfs'
  /** Reserved — schema slot only, not surfaced in v1. */
  | 'google_apps'
  /** Reserved — schema slot only, not surfaced in v1. */
  | 'oidc'
  | 'okta'
  /** Reserved — schema slot only, not surfaced in v1. */
  | 'onelogin'
  /** Reserved — schema slot only, not surfaced in v1. */
  | 'pingfederate'
  | 'samlp'
  /** Reserved — schema slot only, not surfaced in v1. */
  | 'waad';

export type StageEnrollmentStatusSource =
  /** Texture's default for this kind of stage */
  | 'DEFAULT'
  /** Set by the terminal stage's Outcome */
  | 'OUTCOME';

export type StageRequirementInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The canonical data bag key for this requirement. Preferred over slug. */
  factKey?: InputMaybe<Scalars['String']['input']>;
  fieldType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type StageTransitionInput = {
  action?: InputMaybe<LifecycleActionInput>;
  id: Scalars['ID']['input'];
  rule?: InputMaybe<Scalars['JSON']['input']>;
  targetStageSlug: Scalars['String']['input'];
};

export type StageUserFacingConfigInput = {
  actions?: InputMaybe<Array<LifecycleActionInput>>;
  displayMode: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  redirectButtonText?: InputMaybe<Scalars['String']['input']>;
  redirectButtonUrl?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type StagedBatchStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'PROFILING'
  | 'PROMOTING'
  | 'READY_FOR_REVIEW';

/** Input for listing staged batches. */
export type StagedBatchesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter by canonical source type. Must match one of the values defined by
   * STAGED_BATCH_SOURCE_TYPES in domains/identity/src/services/staging/sourceTypes.ts.
   */
  sourceType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StagedBatchStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type StagedRecordStatus =
  | 'APPROVED'
  | 'FAILED'
  | 'HAS_ISSUES'
  | 'PENDING'
  | 'PROMOTED'
  | 'REJECTED'
  | 'VALID';

/** Input for listing staged records. */
export type StagedRecordsInput = {
  batchId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StagedRecordStatus>;
};

export type StartBulkImportInput = {
  /** When false, the batch waits in Data Review for approval even if every record is clean. */
  autoPromote?: InputMaybe<Scalars['Boolean']['input']>;
  data: BulkImportDataInput;
  /**
   * Users notified when the batch is ready for review. Must be members of the workspace.
   * Defaults to the calling user; client callers default to nobody.
   */
  notifyUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  origin?: InputMaybe<BulkImportOriginInput>;
  /** Import profile key, e.g. "customer-site-device". */
  profile: Scalars['String']['input'];
  title: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type StartBulkImportStatus =
  /** A new job and staged batch were created. */
  | 'CREATED'
  /** The origin was already used in this workspace; the earlier job is returned. */
  | 'EXISTING'
  /** Every row's identifier already has a pending record in an open batch; nothing was created. */
  | 'SKIPPED';

/** Start a DER (EV) detection run over a workspace's meter fleet. */
export type StartDerDetectionRunInput = {
  /** Window start, ISO instant (e.g. 2026-05-26T00:00:00Z). */
  after: Scalars['String']['input'];
  /** Window end, ISO instant. 6-8 weeks is the validated window. */
  before: Scalars['String']['input'];
  /** Bucket size (minutes) handed to the detector: 15, 30 or 60. Omit to use the manufacturer default. Set with sourceIntervalMinutes to aggregate a fleet upward. */
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Residential peak-demand ceiling (kW): meters whose sustained peak exceeds this are treated as commercial/industrial and excluded before scoring. Omit to use the server default (~25 kW). Raise it to admit larger services; the excluded count lands in run telemetry. */
  maxPeakKw?: InputMaybe<Scalars['Float']['input']>;
  /** Write-time P(EV) floor (0-1): candidates scoring below this calibrated probability are not persisted. Omit to use the server default. A permissive detector writes ~27k sites with no floor, which overwhelms review — the floor keeps the list precision-first. */
  minProbability?: InputMaybe<Scalars['Float']['input']>;
  /** SMOKE-TEST ONLY, never a default: score a deterministic md5 sample of this many meters per manufacturer. Sampled runs carry sampled:true in telemetry so they are never mistaken for fleet runs, and they never emit dropped-out events. */
  sampleMeters?: InputMaybe<Scalars['Int']['input']>;
  /** The meters' NATIVE channel interval (15, 30 or 60). Required when a fleet's resolution differs from its manufacturer default — itron is 15-minute at one utility and 30-minute at another. Readings exist only on the native channel, so getting this wrong yields an all-empty fleet rather than an error. 30 minutes is served by the direct replica reader only; the gateway has no 30-minute bucket. */
  sourceIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Territory centroid latitude for weather (degree-day) features. Omit both to run without weather features (the run warns; weights are small). */
  territoryLat?: InputMaybe<Scalars['Float']['input']>;
  /** Territory centroid longitude. */
  territoryLon?: InputMaybe<Scalars['Float']['input']>;
  /** IANA timezone for the fleet's local clock, e.g. America/Chicago. Drives the overnight-charging features, so a wrong value degrades detection silently. Omit only to accept the server default (US Eastern), which the run reports as a warning. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Workspace whose meters to scan. */
  workspaceId: Scalars['ID']['input'];
};

export type StateCrossingOperator =
  | 'EQ'
  | 'GT'
  | 'GTE'
  | 'LT'
  | 'LTE'
  | 'NEQ';

export type Status =
  | 'ACKNOWLEDGED'
  | 'IGNORED'
  | 'OPEN'
  | 'RESOLVED';

export type SubmitConnectLinkInput = {
  linkToken: Scalars['String']['input'];
  values: Scalars['JSON']['input'];
};

export type SubmitEnrollmentCustomerInfoInput = {
  accountReference?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEnrollmentIdentificationType =
  | 'CUSTOMER_ID'
  | 'CUSTOMER_INFO';

export type SubmitEnrollmentInput = {
  address: AddressInput;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerInfo?: InputMaybe<SubmitEnrollmentCustomerInfoInput>;
  facts: Scalars['JSON']['input'];
  identificationType: SubmitEnrollmentIdentificationType;
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for recording thumbs up / thumbs down on a single suggestion. */
export type SubmitSuggestionFeedbackInput = {
  /** Whether the rated suggestion came from the rule engine or an AI model. */
  fixType: SuggestionFeedbackFixType;
  /** The StagedRecordIssue the suggestion applies to. */
  issueId: Scalars['ID']['input'];
  /** Optional free-text comment. Stored on ResolutionFeedback.operatorNote. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The thumb the operator clicked — `thumbs_up` or `thumbs_down`. */
  signal: SuggestionFeedbackSignal;
};

/**
 * Whether the suggestion came from the deterministic rule engine or an AI model.
 * Captured so analytics can partition feedback signal by source without joins.
 */
export type SuggestionFeedbackFixType =
  | 'ai'
  | 'rule';

/** Which side of an AI/rule suggestion the operator is rating. */
export type SuggestionFeedbackSignal =
  | 'thumbs_down'
  | 'thumbs_up';

/** Filter options for super admin grants query */
export type SuperAdminGrantsFilter = {
  /** Include revoked grants in the results */
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter grants by user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for querying super admin grants */
export type SuperAdminGrantsInput = {
  filter?: InputMaybe<SuperAdminGrantsFilter>;
  pagination?: InputMaybe<ListPagination>;
};

export type SupportLevel =
  | 'blocked'
  | 'development'
  | 'planned'
  | 'production'
  | 'uat';

export type TagFilterInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type TagScheduleFilterInput = {
  tag: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type TagScheduleInput = {
  defaultDeviceOperatingMode: Scalars['JSON']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  timezone: Scalars['String']['input'];
};

export type TagSchedulesForTagInput = {
  filter: TagScheduleFilterInput;
};

export type TagsFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type TeamTemplateGrantScope =
  | 'ALL_WORKSPACES';

/**
 * Code-defined team templates offered at org creation and in Settings → Roles.
 * Keys are stable identifiers; respelling to package ids rides with the
 * @texturehq/teams identity swap, not this surface.
 */
export type TeamTemplateKey =
  | 'ENGINEERING'
  | 'FIELD_OPS'
  | 'PROGRAMS'
  | 'SYSTEM_OPS';

export type TelemetryBoundsInput = {
  /**
   * Bucket granularity to read the bounds from. Any tier returns the same
   * available extent within its granularity; coarser tiers (HOUR/DAY) are the
   * cheapest scan.
   */
  bucketSize: TelemetryBucketSize;
  /** Canonical metric names from the Metric table */
  metrics: Array<Scalars['String']['input']>;
  sourceScope: TelemetrySourceScopeInput;
};

export type TelemetryBucketSize =
  | 'DAY'
  | 'FIFTEEN_MINUTES'
  | 'FIVE_MINUTES'
  | 'HOUR'
  /** Raw TelemetryPoint. The finest bucket; providers ingesting at 1 minute (EdgeZero) need it to be seen at native resolution. */
  | 'ONE_MINUTE';

/**
 * Which statistic to read from each time bucket.
 * Controls what value is extracted from the pre-aggregated CAGG data for each
 * metric within a single bucket period.
 * Example: AVG returns the average real_power over a 15-minute bucket;
 * MAX returns the peak value within that bucket.
 */
export type TelemetryBucketStat =
  | 'AVG'
  | 'COUNT'
  /** Most recent raw TelemetryPoint per series. Only valid with ONE_MINUTE or FIVE_MINUTES. */
  | 'LATEST'
  | 'MAX'
  | 'MIN'
  | 'SUM';

/**
 * Per-fine-bucket combination of two metrics before the stat reduction:
 * value = minuend − subtrahend on each fine bucket, sparse-absent treated
 * as 0 (a fine bucket is a gap only when BOTH metrics are absent). Both
 * metrics must appear in the query's `metrics` list. Example: minuend
 * kwh_usage, subtrahend kwh_received + stat MAX = resolution-invariant peak
 * net import for a net-metered meter (MIN = peak export).
 */
export type TelemetryFineDifferenceInput = {
  minuend: Scalars['String']['input'];
  /** Output key for the derived series in bucket values (default "net") */
  name?: InputMaybe<Scalars['String']['input']>;
  subtrahend: Scalars['String']['input'];
};

export type TelemetryQueryInput = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  bucketSize: TelemetryBucketSize;
  /** Which statistic to read from each time bucket for metrics (default: AVG) */
  bucketStat?: InputMaybe<TelemetryBucketStat>;
  /** txQL expressions for derived metrics (evaluated per-bucket) */
  expressions?: InputMaybe<Array<TxQlExpressionInput>>;
  /**
   * Canonical metric names from the Metric table, each read with bucketStat.
   * Optional only so selections can be sent instead; send exactly one of the two.
   */
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Client-supplied constants available as params.* in txQL expressions */
  params?: InputMaybe<Scalars['JSON']['input']>;
  rollup?: InputMaybe<TelemetryRollupInput>;
  /**
   * Alternative to metrics + bucketStat, able to vary the statistic across metrics and
   * to read one metric twice under different keys. Sent instead of metrics, never
   * alongside it, and evaluated by its own path — metrics + bucketStat is unchanged, so
   * the same request can be run both ways and the responses compared.
   * Not yet supported with rollup. The server never infers a statistic from the metric
   * registry: read it from deviceMetrics.aggregation and pass it here.
   */
  selections?: InputMaybe<Array<TelemetrySelectionInput>>;
  /**
   * Read one specific feed. A meter can be fed by two providers at once (an MDM
   * interval feed and a head-end feed of the same device); by default the server
   * returns the freshest single source per (device, metric) so values are never
   * blended. Set this to a providerSlug from meta.availableSources to pin the feed
   * instead. Unknown or absent providers resolve to no series, not an error.
   */
  sourceProvider?: InputMaybe<Scalars['String']['input']>;
  sourceScope: TelemetrySourceScopeInput;
};

/**
 * Coincident-aggregate mode for rollups. Values are first combined across
 * sources per FINE bucket (with the rollup's reducer), then the fine buckets
 * inside each display bucket are reduced with `stat`. Example: reducer SUM +
 * fine { bucketSize: HOUR, stat: MAX } at bucketSize DAY = the peak coincident
 * hourly demand within each day — resolution-invariant, unlike summing
 * per-source bucket maxima (non-coincident demand, which overstates the peak).
 */
export type TelemetryRollupFineInput = {
  /** Fine grid to combine sources on. Must be strictly finer than the query's bucketSize. */
  bucketSize: TelemetryBucketSize;
  /** Net two metrics per fine bucket before the stat reduction (see TelemetryFineDifferenceInput). */
  difference?: InputMaybe<TelemetryFineDifferenceInput>;
  /** How to reduce the fine buckets within each display bucket. MAX or MIN only. */
  stat: TelemetryBucketStat;
};

export type TelemetryRollupInput = {
  /**
   * Required when groupBy = GRID_ANCESTOR; selects which ancestor type the
   * rollup targets. SOURCE / OVERCURRENT_DEVICE / TRANSFORMER use the
   * denormalised slots; every other GridElementType walks the typed
   * ancestorPath. Ignored for other groupBy values.
   */
  ancestorElementType?: InputMaybe<GridElementType>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Coincident-aggregate mode (see TelemetryRollupFineInput). Supported on
   * the SQL rollup path: gridElementSubtree source scopes with a grid
   * rollup, or device / deviceOnWorkspace scopes with groupBy TOTAL.
   */
  fine?: InputMaybe<TelemetryRollupFineInput>;
  /** Which hierarchy level to group results at */
  groupBy: HierarchyGroupBy;
  /** How to combine child values (SUM for power, AVG for voltage, MAX for worst-case) */
  reducer: HierarchyReducer;
};

/**
 * One thing to return: which metric, reduced with which statistic, under which key.
 * Two selections may share a metric — voltage@AVG next to voltage@MAX asks for the
 * mean and the peak of the stored 1-minute means, which is a different quantity from
 * the voltage_max metric (the producer's true per-minute maximum over raw samples).
 * Read a metric's producer-side reduction from deviceMetrics.aggregation: averaging
 * stored minima is not the minimum, so voltage_min wants MIN where voltage wants AVG.
 * LATEST is not selectable here — it changes the query for the whole request.
 */
export type TelemetrySelectionInput = {
  aggregation: TelemetryBucketStat;
  /** Response key and txQL identifier. Defaults to metric; required to select one metric twice. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Canonical metric name from the Metric table */
  metric: Scalars['String']['input'];
};

export type TelemetrySourceScopeInput = {
  /** Canonical Device IDs for DER device queries. Requires workspaceId. */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * DeviceOnWorkspace IDs — the workspace-facing device identifier (the
   * federated Device.id). Prefer this over deviceIds for client/dashboard
   * callers, which hold the DeviceOnWorkspace id rather than the canonical
   * Device.id. Buckets group by the DeviceOnWorkspace id you pass (groupKey),
   * so multi-device results map back to your inputs. Requires workspaceId.
   */
  deviceOnWorkspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * TelemetrySource.externalId values for a market-source query (e.g. LZ_NORTH).
   * Requires providerSlug. groupKey in the response is the externalId.
   */
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Root GridElement gs_guid for a meter-cohort subtree query. Fetches
   * telemetry for every Consumer GridElement under the given root via the
   * location subgraph's consumerElementsForGridElementSubtree query, scoped
   * to the supplied workspaceId. Requires workspaceId.
   */
  gridElementSubtreeRootGuid?: InputMaybe<Scalars['String']['input']>;
  /** ScadaGridNode gsGuids for specific node queries */
  gsGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Market-scoped telemetry (e.g. ERCOT settlement-point prices). Use with
   * externalIds. No workspace — public market data, allowlisted providers only.
   */
  providerSlug?: InputMaybe<Scalars['String']['input']>;
  /** Root gsGuid for SCADA subtree queries (fetches all descendants) */
  subtreeRootGsGuid?: InputMaybe<Scalars['String']['input']>;
  /** Workspace ID — required when querying by deviceIds, deviceOnWorkspaceIds, or gridElementSubtreeRootGuid */
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type TerminateConnectionInput = {
  /** ID of the ManufacturerUserConnection to terminate. */
  manufacturerUserConnectionId: Scalars['ID']['input'];
  /** Optional reason for termination. Defaults to 'Manually terminated'. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Terminate a connection for a manufacturer account identified by manufacturer + manufacturerUserId + clientId. */
export type TerminateManufacturerConnectionsInput = {
  /** The OAuth app clientId that owns the connection. */
  clientId: Scalars['String']['input'];
  manufacturer: Scalars['String']['input'];
  manufacturerUserId: Scalars['String']['input'];
  /** Optional reason for termination. Defaults to 'Manually terminated'. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Input for the testRule dry-run mutation. */
export type TestRuleInput = {
  /** Optional field context (same as CreateResolutionRuleInput.field). */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Issue type the rule targets. */
  issueType: Scalars['String']['input'];
  /** Matcher discriminated-union JSON (same shape as CreateResolutionRuleInput.matcher). */
  matcher: Scalars['JSON']['input'];
  /** Minimum confidence threshold — rows below this are treated as unmatched. */
  minConfidence?: InputMaybe<Scalars['Float']['input']>;
  /** Sample rows to evaluate against. At least one required. */
  rows: Array<TestRuleRowInput>;
  /** Transform discriminated-union JSON (same shape as CreateResolutionRuleInput.transform). */
  transform: Scalars['JSON']['input'];
  /**
   * The workspace scope for authorization. Pass null for platform-wide rules
   * (super-admin only).
   */
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for a single sample data row in a testRule dry-run. */
export type TestRuleRowInput = {
  /** Key/value snapshot representing the record's normalizedData. */
  data: Scalars['JSON']['input'];
  /**
   * Optional issue type for this row. When provided and different from the rule's
   * issueType, the row is treated as unmatched.
   */
  issueType?: InputMaybe<Scalars['String']['input']>;
};

export type ThermostatBatchCommandInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pauseSchedule?: InputMaybe<PauseThermostatScheduleInput>;
  resumeSchedule?: InputMaybe<ResumeThermostatScheduleInput>;
  setFanMode?: InputMaybe<SetThermostatFanModeInput>;
  setOperatingMode?: InputMaybe<SetThermostatOperatingModeInput>;
  slug: ThermostatCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type ThermostatCommandInput = {
  id: Scalars['ID']['input'];
  pauseSchedule?: InputMaybe<PauseThermostatScheduleInput>;
  resumeSchedule?: InputMaybe<ResumeThermostatScheduleInput>;
  setFanMode?: InputMaybe<SetThermostatFanModeInput>;
  setOperatingMode?: InputMaybe<SetThermostatOperatingModeInput>;
  slug: ThermostatCommandSlug;
};

export type ThermostatCommandSlug =
  | 'thermostat_pause_schedule'
  | 'thermostat_resume_schedule'
  | 'thermostat_set_fan_mode'
  | 'thermostat_set_operating_mode';

export type ThermostatFanMode =
  | 'auto'
  | 'circulate'
  | 'off'
  | 'on'
  | 'unknown';

export type ThermostatMode =
  | 'auto'
  | 'cool'
  | 'eco'
  | 'heat'
  | 'off'
  | 'unknown';

/** Thermostat state input. Matches ThermostatState DB schema. */
export type ThermostatStateInput = {
  ambientTemperature: Scalars['Int']['input'];
  coolTarget: Scalars['Int']['input'];
  createdAt: Scalars['DateTime']['input'];
  fanMode: ThermostatFanMode;
  heatTarget: Scalars['Int']['input'];
  operatingMode: ThermostatMode;
};

export type TicketAssigneeKind =
  | 'CREW_OR_ORG'
  | 'USER';

export type TicketAttachmentVisibility =
  | 'CUSTOMER'
  | 'INTERNAL';

export type TicketCommentVisibility =
  | 'INTERNAL'
  | 'PUBLIC';

/** Ticket date columns a time facet can bucket on via `date_trunc`. */
export type TicketDateField =
  | 'createdAt'
  | 'dueAt'
  | 'resolvedAt'
  | 'updatedAt';

export type TicketEventType =
  | 'ALERT_LINKED'
  | 'ALERT_UNLINKED'
  | 'ASSIGNED'
  | 'ATTACHMENT_ADDED'
  | 'ATTACHMENT_REMOVED'
  | 'COMMENTED'
  | 'DELETED'
  | 'DUE_CHANGED'
  | 'ETR_SET'
  | 'PRIORITY_CHANGED'
  | 'REOPENED'
  | 'STATUS_CHANGED'
  | 'SUBJECT_SET'
  | 'TICKET_CREATED'
  | 'WATCHER_ADDED'
  | 'WATCHER_REMOVED';

/**
 * Terms-aggregatable ticket columns for a facet `GROUP BY` (mirrors
 * `AlertFacetField`). Exactly one of `field` or `dateField` is supplied on a
 * `TicketFacetInput`. `assigneeId` buckets on the opaque assignee id — callers
 * resolve a human label client-side (the ticket already exposes `assignee.label`).
 */
export type TicketFacetField =
  | 'assigneeId'
  | 'priority'
  | 'status'
  | 'subjectType';

/**
 * A single ticket facet request. Provide EITHER a terms `field` (optionally capped
 * by `limit`) OR a `dateField` together with an `interval`; supplying both, or
 * neither, is rejected. The optional filter fields mirror the structured columns of
 * `TicketsFilter` so a chart or KPI scopes to the same population as the list.
 *
 * `TicketsFilter.search` is intentionally NOT mirrored: it is a pg_trgm free-text
 * predicate (leading-wildcard ILIKE across title/description/subjectLabel/
 * externalWorkOrderId + a comment-body subquery) that has no equivalent in the raw
 * `GROUP BY` aggregation. Charts/KPIs scope by the structured filters only; a
 * search-narrowed list is therefore not reflected in facet counts by design.
 */
export type TicketFacetInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  dateField?: InputMaybe<TicketDateField>;
  dueAfter?: InputMaybe<Scalars['DateTime']['input']>;
  dueBefore?: InputMaybe<Scalars['DateTime']['input']>;
  field?: InputMaybe<TicketFacetField>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<DateInterval>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Array<TicketPriority>>;
  status?: InputMaybe<Array<TicketStatus>>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<TicketSubjectType>;
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type TicketOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
  dueAt?: InputMaybe<PaginatedQueryOrderBy>;
  priority?: InputMaybe<PaginatedQueryOrderBy>;
  status?: InputMaybe<PaginatedQueryOrderBy>;
  ticketNumber?: InputMaybe<PaginatedQueryOrderBy>;
  updatedAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type TicketPriority =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM'
  | 'URGENT';

export type TicketStatus =
  | 'BLOCKED'
  | 'CANCELLED'
  | 'DONE'
  | 'IN_PROGRESS'
  | 'OPEN';

export type TicketSubjectType =
  | 'ALERT'
  | 'CONTACT'
  | 'CUSTOMER'
  | 'DEVICE'
  | 'DISPATCH_EVENT'
  | 'ENROLLMENT'
  | 'GRID_ELEMENT'
  | 'NONE'
  | 'SITE';

export type TicketsFilter = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  dueAfter?: InputMaybe<Scalars['DateTime']['input']>;
  dueBefore?: InputMaybe<Scalars['DateTime']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Array<TicketPriority>>;
  /**
   * Free-text search. Case-insensitive substring match across a ticket's title,
   * description, subject label (the site/device/contact name snapshot), external
   * work-order id, and its comment bodies. A purely numeric query ("1042" or
   * "#1042") additionally matches that ticketNumber exactly.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TicketStatus>>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<TicketSubjectType>;
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type TicketsInput = {
  filter: TicketsFilter;
  orderBy?: InputMaybe<TicketOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
};

export type TimeGranularity =
  | 'DAY'
  | 'FIFTEEN_MINUTES'
  | 'HOUR'
  | 'MONTH'
  | 'TOTAL'
  | 'WEEK';

export type TimeScopeInput = {
  /** Required when type is DATE_RANGE */
  dateRange?: InputMaybe<ReportDateRangeInput>;
  /** Required when type is PERIOD */
  period?: InputMaybe<ReportPeriod>;
  /**
   * PERIOD: Relative time period (LAST_24H, LAST_7D, LAST_30D, LAST_60D, LAST_90D)
   * DATE_RANGE: Explicit start/end dates
   * EVENT_WINDOW: Use event's own time bounds (only valid for SINGLE_EVENT scope)
   */
  type: TimeScopeType;
};

export type TimeScopeType =
  | 'DATE_RANGE'
  | 'EVENT_WINDOW'
  | 'PERIOD';

export type TouchpointKind =
  | 'CALL'
  /** Chat message (Slack). Stored as TouchpointKind.CHAT since corpus Phase 5. */
  | 'CHAT'
  /** Not a touchpoint: the entry a Document Workflow run leaves on the organization timeline (EventStreamEntry kind document_workflow). */
  | 'DOCUMENT_WORKFLOW'
  | 'EMAIL'
  /** A website form submission relayed by HubSpot's notification email (Contact Us, Book a Demo). */
  | 'FORM_SUBMISSION'
  /** A LinkedIn message a rep logged by hand. Nothing ingests LinkedIn, so every one carries sourceSystem "manual". */
  | 'LINKEDIN_MESSAGE'
  | 'MEETING'
  | 'NOTE'
  | 'OTHER'
  | 'TASK';

export type TransformerHourlyLoadingStatus =
  | 'INCOMPLETE'
  | 'MEMBERSHIP_CHANGED'
  | 'NO_DATA'
  | 'READY';

export type TransformerHourlyMembershipBasis =
  | 'CURRENT_ROSTER';

export type TransformerHourlyRatingBasis =
  | 'LATEST_PUBLISHED';

export type TransformerLoadingFilter = {
  /**
   * Inclusive, in percentage points of `eligibleCoveragePct` — the share of the intervals
   * the row's period ASKED for that were eligible, not a share of what happened to be
   * measured. 80 keeps only rows supported by at least 80% of their period; for a full
   * ROLLING_365D row that is 7,008 eligible hours out of 8,760.
   *
   * The denominator is the row's own `windowStart`/`windowEnd` when it has them, and the
   * window's nominal length only for rows written before those were persisted — the same
   * precedence `eligibleCoveragePct` is displayed with, so the filter and the number it
   * filters on can never disagree.
   *
   * Applied across the whole population before ranking and pagination, so matchingCount,
   * the page and any export all describe the same filtered set.
   *
   * Rows of UNKNOWN coverage are EXCLUDED by any value of this filter, including 0 — an
   * unusable resolution or eligible count, a period that contradicts itself, or exactly
   * one of the two bounds present. They are not assumed to be 0%: unknown coverage cannot
   * satisfy a claim about how much of the period was measured. Omit the filter to keep them.
   *
   * This is an operator control, not a floor. Nothing is hidden, withheld or downgraded
   * when it is absent; every row is still returned and still discloses its own coverage.
   */
  minEligibleCoveragePct?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Inclusive, in percentage points.
   *
   * Retained unchanged. Equivalent to `overThreshold: { levelPct: 100, ... }` scaled to
   * a percentage, and kept because filters written against it already exist.
   */
  minPctTimeOverloaded?: InputMaybe<Scalars['Float']['input']>;
  /** Inclusive, in percentage points. 150 means at or above 150%. */
  minUtilizationPct?: InputMaybe<Scalars['Float']['input']>;
  /**
   * "Above `levelPct` of rating for more than `minFractionOfWindow` of the measured
   * window" — the question a single overload percentage cannot express, because its
   * denominator moves with the window while the threshold written against it does not.
   */
  overThreshold?: InputMaybe<TransformerLoadingOverThreshold>;
  ratingSources?: InputMaybe<Array<TransformerRatingSource>>;
  statuses?: InputMaybe<Array<TransformerLoadingStatus>>;
  /**
   * Restrict to these transformers — used to decorate a page whose order was
   * decided elsewhere, and the only way to filter by substation or feeder, whose
   * hierarchy lives in the location domain. This filters; it does not change
   * ordering, and rows come back in the query's own sort order, not the order
   * supplied here.
   */
  transformerGuids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TransformerLoadingGuidsInput = {
  filter?: InputMaybe<TransformerLoadingFilter>;
  window?: TransformerLoadingWindow;
  workspaceId: Scalars['ID']['input'];
};

export type TransformerLoadingHourlyInput = {
  /**
   * Floored to its UTC hour. If omitted, uses the workspace's latest published
   * ROLLING_7D source hour, not wall-clock now. No per-transformer fallback.
   * Pin subsequent batches with the returned hourStart to avoid mixing hours.
   */
  at?: InputMaybe<Scalars['DateTime']['input']>;
  /** 1–2,000 GUIDs. Duplicates are removed, preserving first occurrence order. */
  transformerGuids: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type TransformerLoadingInput = {
  /** Opaque keyset cursor from a previous page's endCursor. Pinned to that page's snapshot. */
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TransformerLoadingFilter>;
  /** Defaults to 2000, hard-capped server-side at 2000. */
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: TransformerLoadingSort;
  window?: TransformerLoadingWindow;
  workspaceId: Scalars['ID']['input'];
};

/**
 * An exceedance level paired with how much of the window must be spent above it.
 *
 * The level is fixed at derivation time — counting intervals above it means visiting
 * every interval — so only levels the rollup actually derives are accepted. The
 * fraction is free, because it compares two integers this row already stores.
 */
export type TransformerLoadingOverThreshold = {
  /**
   * Percentage of rating. Must be one of 100, 120, 150 or 200: 100 is nameplate, 120 is
   * the standard-practice band, 150 and 200 are the levels operators asked for. Any
   * other value is REJECTED rather than rounded to a neighbour — rounding would answer
   * a different question and report it as the one asked.
   */
  levelPct: Scalars['Int']['input'];
  /**
   * Share of `eligibleIntervals`, not of the window's length: 0.02 means more than 2%
   * of the intervals that were actually measurable. Unconstrained.
   */
  minFractionOfWindow: Scalars['Float']['input'];
};

/**
 * Every ordering ranks the whole materialized inventory, not a fetched page, and every
 * one places rows of unknown value LAST — so a row whose coverage could not be
 * established never occupies either end of a coverage ranking.
 */
export type TransformerLoadingSort =
  /**
   * Thinnest support first, by eligibleCoveragePct — a 1-of-8760 row leads. This is the
   * ordering that finds measurement gaps, and it is the counterpart to UTILIZATION_DESC,
   * whose leaders on a 365-day window are frequently single-hour peaks.
   *
   * Rows with unknown coverage still sort last here, not first: unknown is not the worst
   * coverage, it is the absence of a measurement of coverage.
   */
  | 'ELIGIBLE_COVERAGE_ASC'
  /** Best-supported first, by eligibleCoveragePct. "Show me the rows I can trust." */
  | 'ELIGIBLE_COVERAGE_DESC'
  | 'PCT_TIME_OVERLOADED_DESC'
  | 'PEAK_KVA_DESC'
  | 'UTILIZATION_DESC';

export type TransformerLoadingStatus =
  /**
   * No interval where every consumer element linked to the transformer reported, so
   * load is unknown rather than zero. Distinct from a missing rating.
   */
  | 'NO_DATA'
  /** At least one eligible interval under the current reporting rule. Not a measurement-quality guarantee. */
  | 'READY';

/**
 * Rolling windows, all ending 54 hours before the current hour rather than at now. Meter
 * ingest lag routinely exceeds a day, so a window ending at now would measure meters that
 * have not reported yet. Each row's sourceThrough carries the freshness actually achieved.
 */
export type TransformerLoadingWindow =
  | 'ROLLING_7D'
  | 'ROLLING_30D'
  | 'ROLLING_90D'
  | 'ROLLING_365D';

export type TransformerPeakDirection =
  | 'EXPORT'
  | 'IMPORT'
  | 'ZERO';

/**
 * How the active rating was obtained. SENTINEL means the source stored a
 * placeholder (1, 99, 99.9, 999) rather than a capacity — those loads match
 * 25 kVA units, so dividing by them under-reports and buries the transformer.
 */
export type TransformerRatingSource =
  | 'NAMEPLATE'
  | 'SENTINEL'
  | 'UNKNOWN';

export type TransitionToStageInput = {
  instanceId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
};

/** Input for triggering a data audit batch for a workspace. */
export type TriggerDataAuditInput = {
  /** The workspace whose entities should be collected into the audit batch. */
  workspaceId: Scalars['ID']['input'];
};

/**
 * Input for triggering a historical data backfill across one or more devices.
 *
 * All resolution happens at publish time inside the resolver — one fully
 * enriched `connection.backfill` Kafka event is published per device, so
 * the oem-adapter consumer never has to do cross-domain lookups.
 */
export type TriggerHistoricalBackfillInput = {
  /**
   * Texture-internal device IDs (Device.id, cuid) to backfill — NOT
   * OEM-side identifiers. Min 1, max 1000 per request to keep blast radius
   * bounded; bigger backfills should chunk on the caller's side.
   * Duplicate IDs are deduplicated server-side.
   */
  deviceIds: Array<Scalars['String']['input']>;
  /**
   * Exclusive ISO-8601 end of the backfill window. Must be strictly greater
   * than `startTime` and not in the future. Resolver also caps the total
   * range at 5 years to surface a readable error before the per-OEM
   * coordinator silently clamps to its retention limit.
   */
  endTime: Scalars['DateTime']['input'];
  /** Inclusive ISO-8601 start of the backfill window. */
  startTime: Scalars['DateTime']['input'];
  /**
   * Workspace that owns the devices being backfilled. Resolver enforces
   * `canUpdateOrThrow` against this workspace before any device lookups.
   */
  workspaceId: Scalars['String']['input'];
};

/**
 * A txQL (Texture Query Language) expression for computing derived metrics.
 * Expressions are evaluated per-bucket using a safe, sandboxed SQL-subset
 * expression engine. See txQL documentation for available functions and syntax.
 */
export type TxQlExpressionInput = {
  /** txQL expression string */
  expr: Scalars['String']['input'];
  /** Output field name for this expression */
  name: Scalars['String']['input'];
};

export type UnifiedCommandInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionMode?: InputMaybe<CommandExecutionMode>;
  id: Scalars['ID']['input'];
  payload: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The caller's ACTIVE workspace. Optional and UNTRUSTED — it grants nothing
   * on its own. When Oso denies the device and the effective-filter fallback
   * runs, the caller's composed CONTROL filter for this workspace is what may
   * admit a device shared from another organization. Omit it for the home-keyed
   * behavior.
   */
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UnlandSharedCollectionInput = {
  /** The ID of the SharedResource whose placement should be removed */
  sharedResourceId: Scalars['ID']['input'];
};

/** Only `UNLINKED` writes anything. */
export type UnlinkOrganizationFromCanonicalOrganizationOutcome =
  /** The current link was not written by the automation link mutation. */
  | 'NOT_LINKED_BY_AUTOMATION'
  /** The organization does not point at this canonical (after following its merge chain). */
  | 'NOT_LINKED_TO_CANONICAL'
  /** No such identity Organization. */
  | 'ORGANIZATION_NOT_FOUND'
  /** The organization no longer points at a canonical. */
  | 'UNLINKED';

export type UpcomingConferencesInput = {
  pagination?: InputMaybe<CrmCursorPaginationInput>;
  region?: InputMaybe<ConferenceRegion>;
  withinMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateApiKeyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type UpdateAppProviderGrantPollingCronPatternInput = {
  grantId: Scalars['ID']['input'];
  /** Standard cron expression for BullMQ repeat (e.g. "0 7 * * *"). Null clears override. */
  pollingCronPattern?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBatchInput = {
  batchId: Scalars['ID']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  payload: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateBatteryBatchInput = {
  batchId: Scalars['ID']['input'];
  setBatteryReserve?: InputMaybe<SetBatteryReserveInput>;
  setOperatingMode?: InputMaybe<SetBatteryOperatingModeInput>;
  slug: BatteryCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** Fields left out are kept as they are. */
export type UpdateBoardInput = {
  composition?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCanonicalContactAffiliationForAutomationInput = {
  actorId: Scalars['ID']['input'];
  affiliationId: Scalars['ID']['input'];
  automation: ContactAutomationInput;
  expected: Array<AffiliationRowValuesInput>;
  /** Undo: per-row values to put back. Each title source must match the one recorded on that apply's event. */
  restore?: InputMaybe<Array<AffiliationRowValuesInput>>;
  restoresProposalId?: InputMaybe<Scalars['ID']['input']>;
  restoresRowId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCanonicalContactAffiliationInput = {
  /** Any active row of the (contact, organization) pair. */
  affiliationId: Scalars['ID']['input'];
  /** Every active row of the pair as the caller read it. */
  expected?: InputMaybe<Array<AffiliationRowValuesInput>>;
  role?: InputMaybe<Scalars['String']['input']>;
  /** Omitted leaves it; null or blank clears it. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for `updateCanonicalOrganizationProfile`. Absent = untouched. */
export type UpdateCanonicalOrganizationProfileInput = {
  /** Null is rejected: the column has no unset state. */
  leadStatus?: InputMaybe<OrganizationLeadStatus>;
  organizationId: Scalars['ID']['input'];
  segmentsAdd?: InputMaybe<Array<OrganizationSegment>>;
  segmentsRemove?: InputMaybe<Array<OrganizationSegment>>;
  /** Null is rejected: the column has no unset state. */
  type?: InputMaybe<OrganizationType>;
};

/**
 * A patch of the GTM facts. Absent = untouched; null = clear. Text is trimmed;
 * a length bound, the two-decimal rule and a select vocabulary bind only a value
 * that changes, so an imported legacy value survives an edit of another field.
 */
export type UpdateCanonicalOrganizationSalesFactsInput = {
  /** At most 120 characters. */
  amiUpgradeType?: InputMaybe<Scalars['String']['input']>;
  /** A year, 1900 to 2100. */
  amiUpgradeYear?: InputMaybe<Scalars['Int']['input']>;
  /** Each added value must be exactly a live campaign option (`crmOrganizationFieldOptions.campaigns`). */
  campaigns?: InputMaybe<CrmStringSetPatch>;
  /** Null is rejected: the flag has no unknown state. */
  contributedToCord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Null is rejected: the flag has no unknown state. */
  cordMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** A calendar day, YYYY-MM-DD, 1900-01-01 to 2100-12-31. */
  dateConnected?: InputMaybe<Scalars['Date']['input']>;
  escDevicesCool?: InputMaybe<Scalars['Int']['input']>;
  escDevicesHeat?: InputMaybe<Scalars['Int']['input']>;
  escHomesCool?: InputMaybe<Scalars['Int']['input']>;
  escHomesHeat?: InputMaybe<Scalars['Int']['input']>;
  /** Megawatts, 0 to 100,000, at most 2 decimal places. */
  escMw1hCool?: InputMaybe<Scalars['Float']['input']>;
  escMw1hHeat?: InputMaybe<Scalars['Float']['input']>;
  escMw2hCool?: InputMaybe<Scalars['Float']['input']>;
  escMw2hHeat?: InputMaybe<Scalars['Float']['input']>;
  /** At most 200 characters. */
  headquarters?: InputMaybe<Scalars['String']['input']>;
  /** The channel name; one leading # is dropped. Lowercase letters, numbers, - and _, at most 80. */
  internalSlackChannel?: InputMaybe<Scalars['String']['input']>;
  /** An absolute http(s) URL, at most 2048 characters. */
  linearUrl?: InputMaybe<Scalars['String']['input']>;
  /** A whole number, 0 to 10,000,000. */
  notionMeterCount?: InputMaybe<Scalars['Int']['input']>;
  /** At most 120 characters. */
  renewHomeSalesRep?: InputMaybe<Scalars['String']['input']>;
  /** Research fields; only for an organization with a linked research page. */
  utilityResearch?: InputMaybe<UpdateCanonicalOrganizationUtilityResearchInput>;
};

export type UpdateCanonicalOrganizationSalesMetadataInput = {
  /** Sales-status classification. Omit to leave unchanged; null is invalid because storage is non-null. */
  salesStatus?: InputMaybe<CanonicalOrganizationSalesStatus>;
  /**
   * Lead source. A changed value must match a live lead-source option
   * (`crmOrganizationFieldOptions.leadSources`, case-insensitively) and is stored
   * as the option's value; an unchanged value is accepted as is. Omit to leave
   * unchanged; null or blank clears the source.
   */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** A patch of the AMI and DR research. Absent = untouched; null = clear. */
export type UpdateCanonicalOrganizationUtilityResearchInput = {
  /** One of `crmOrganizationFieldOptions.amiConfidences`. */
  amiConfidence?: InputMaybe<Scalars['String']['input']>;
  /** At most 5000 characters. */
  amiEvidence?: InputMaybe<Scalars['String']['input']>;
  amiSourceDate?: InputMaybe<Scalars['Date']['input']>;
  amiSourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** One of `crmOrganizationFieldOptions.amiStages`. */
  amiStage?: InputMaybe<Scalars['String']['input']>;
  /** At most 200 characters. */
  amiVendor?: InputMaybe<Scalars['String']['input']>;
  boardMinutesUrl?: InputMaybe<Scalars['String']['input']>;
  /** One of `crmOrganizationFieldOptions.cpStructures`. */
  cpStructure?: InputMaybe<Scalars['String']['input']>;
  /** At most 200 characters. */
  currentMeterVendor?: InputMaybe<Scalars['String']['input']>;
  /** Dollars per kW, 0 to 100,000, at most 2 decimal places. */
  drGenerationValuePerKw?: InputMaybe<Scalars['Float']['input']>;
  drTransmissionValuePerKw?: InputMaybe<Scalars['Float']['input']>;
  forecastedBatteries?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateChargerBatchInput = {
  batchId: Scalars['ID']['input'];
  setOperatingMode?: InputMaybe<SetChargerOperatingModeInput>;
  slug: ChargerCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateCollectionData = {
  /** New criteria for the collection */
  criteria?: InputMaybe<CollectionCriteriaInput>;
  /** New description for the collection */
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** Whether the collection is dynamic */
  dynamic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the collection is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the collection */
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type UpdateCollectionDataV2 = {
  /** New criteria for the collection */
  criteria?: InputMaybe<CollectionCriteriaInputV2>;
  /** New description for the collection */
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** Whether the collection is dynamic */
  dynamic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the collection is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the collection */
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** Input for updating an existing collection */
export type UpdateCollectionInput = {
  /** The data to update the collection with */
  data: UpdateCollectionData;
  /** The ID of the collection to update */
  id: Scalars['ID']['input'];
};

/** Input for updating an existing collection */
export type UpdateCollectionInputV2 = {
  /** The data to update the collection with */
  data: UpdateCollectionDataV2;
  /** The ID of the collection to update */
  id: Scalars['ID']['input'];
};

export type UpdateConferenceAttendanceInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AttendanceRole>;
  status?: InputMaybe<AttendanceStatus>;
};

export type UpdateConferenceInstanceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nrtcOrgWide?: InputMaybe<Scalars['Boolean']['input']>;
  planningStatus?: InputMaybe<ConferencePlanningStatus>;
  rbmId?: InputMaybe<Scalars['ID']['input']>;
  registrationUrl?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ConferenceInstanceStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  venueName?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConferenceMilestoneInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  dueDateTz?: InputMaybe<Scalars['String']['input']>;
  dueTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MilestoneType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConferenceSeriesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizer?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<ConferenceRegion>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCrmEventInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  /** Refuses STALE_RECORD unless the event still carries this updatedAt. */
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  kind?: InputMaybe<CrmEventKind>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCrmEventMemberInput = {
  canonicalOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  expectedUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCrmEventStatusInput = {
  countsAsAttended?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCrmPropertyDefinitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  numberFormat?: InputMaybe<CrmPropertyNumberFormat>;
};

/**
 * Input for editing an operator-defined custom field. `factKey`, `fieldType` and
 * `entityType` are immutable: requirements snapshot type and config into stage
 * JSON and reference the catalog only by `factKey`, so changing them would strand
 * live stages. Editing those means creating a new field.
 */
export type UpdateCustomFieldInput = {
  /**
   * Type-specific configuration (e.g., select options). Replaces the stored
   * config wholesale; omit to leave unchanged. Only affects fields added to a
   * stage after this edit — existing stage requirements keep their snapshot.
   */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Human-readable label. Omit to leave unchanged. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The custom field to edit */
  id: Scalars['ID']['input'];
};

export type UpdateCustomerInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDataProviderInput = {
  /** Display name of the data provider */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDealActivityInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<DealActivityKind>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateDealInput = {
  arr?: InputMaybe<Scalars['Float']['input']>;
  carr?: InputMaybe<Scalars['Float']['input']>;
  closeDate?: InputMaybe<Scalars['Date']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  dealType?: InputMaybe<DealType>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextStep?: InputMaybe<Scalars['String']['input']>;
  nextStepDate?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  partner?: InputMaybe<DealPartner>;
  partnerContactId?: InputMaybe<Scalars['ID']['input']>;
  /** Day the PRA was sent (YYYY-MM-DD); null clears it. Audited like any other field change. */
  praSentDate?: InputMaybe<Scalars['Date']['input']>;
  /** Day the PRA was signed (YYYY-MM-DD); null clears it. Audited like any other field change. */
  praSignedDate?: InputMaybe<Scalars['Date']['input']>;
  primaryContactId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeviceInput = {
  id: Scalars['ID']['input'];
  siteProfileId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDeviceManufacturerInput = {
  /** Whether this manufacturer is available in Texture Connect */
  availableInTextureConnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name of the manufacturer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support level for this manufacturer */
  supportLevel?: InputMaybe<SupportLevel>;
  /** Whether this manufacturer supports grid services */
  supportsGridServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this manufacturer supports OAuth-based headless connect flows */
  supportsHeadlessConnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeviceModelInput = {
  /** Display name of the device model */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support level for this device model */
  supportLevel?: InputMaybe<SupportLevel>;
  /** Type of device */
  type?: InputMaybe<DeviceType>;
};

export type UpdateDeviceScheduleInput = {
  rules: Array<UpdateRuleInput>;
  schedule: UpdateScheduleInput;
};

export type UpdateDeviceTagsInput = {
  /** At most 500 devices per call */
  devices: Array<DeviceTagChangesInput>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateEmailDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<Array<EventType>>;
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEnrollmentInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  eligibilityReason?: InputMaybe<Scalars['String']['input']>;
  eligibilityStatus?: InputMaybe<EligibilityStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentId?: InputMaybe<Scalars['ID']['input']>;
  enrollmentStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Leads are retired; kept only until recorded client operations stop using it; ignored. Removal tracked in ALL-3445. */
  leadId?: InputMaybe<Scalars['ID']['input']>;
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceDescription?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateEnrollmentReportConfigInput = {
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type UpdateKafkaDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes?: InputMaybe<Array<EventType>>;
  id: Scalars['String']['input'];
  kafkaConfig?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeadInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<LeadSource>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
};

export type UpdateLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetOne?: InputMaybe<Scalars['String']['input']>;
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManufacturerCredentialInput = {
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ManufacturerCredentialParamsInput>;
  status?: InputMaybe<ManufacturerCredentialStatus>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for updating a manufacturer device model */
export type UpdateManufacturerDeviceModelInput = {
  /** Display name of the device model */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support level for this device model */
  supportLevel?: InputMaybe<SupportLevel>;
};

export type UpdateManufacturerIntegrationInput = {
  /** Configuration fields as JSON */
  configurationFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Rich text description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Documentation blocks as JSON */
  documentationBlocks?: InputMaybe<Scalars['JSON']['input']>;
  /** Learn more URL for documentation */
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** Display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support level for this integration */
  supportLevel?: InputMaybe<SupportLevel>;
};

export type UpdateMembershipInput = {
  id: Scalars['String']['input'];
  role?: InputMaybe<Role>;
};

export type UpdateMonitorInput = {
  /** Replaces the whole binding list when provided. */
  bindings?: InputMaybe<Array<MonitorBindingInput>>;
  defaultParameterization?: InputMaybe<MonitorParameterizationInput>;
  /**
   * When provided, persisted on the monitor and bumps version like any other
   * config edit (optimistic-lock semantics).
   */
  deliveryMode?: InputMaybe<MonitorDeliveryMode>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyPer?: InputMaybe<MonitorNotifyPer>;
  parameterizationOverrides?: InputMaybe<Array<MonitorParameterizationOverrideInput>>;
  /** Replaces the whole recipient list when provided. */
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  requiresAction?: InputMaybe<Scalars['Boolean']['input']>;
  rule?: InputMaybe<MonitorRuleInput>;
  targets?: InputMaybe<Array<MonitorTargetInput>>;
  urgency?: InputMaybe<MonitorUrgency>;
};

/** Input for updating a notification preference. */
export type UpdateNotificationPreferenceInput = {
  /** The notification category to update. */
  category: NotificationCategoryEnum;
  /** Whether to enable or disable notifications for this category. */
  enabled: Scalars['Boolean']['input'];
};

export type UpdateOAuthApplicationInput = {
  allowedScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOrganizationExploreSettingsInput = {
  /** CommonGrid utility slug; omitted preserves the choice, null restores the linked canonical territory. */
  commonGridUtilitySlug?: InputMaybe<Scalars['String']['input']>;
  phaseColors?: InputMaybe<ExplorePhaseColorsInput>;
};

export type UpdateOrganizationInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mapStyleUrl?: InputMaybe<Scalars['String']['input']>;
  mfaEmailOtpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredTemperatureUnit?: InputMaybe<PreferredTemperatureUnit>;
  /** Auto-provision Texture User rows for first-time SSO sign-ins (JIT). */
  ssoAutoCreateUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Ignored. SSO auto-link is no longer configurable per organization.
   * @deprecated Ignored. SSO auto-link is always on and gated on verified organization domain ownership.
   */
  ssoAutoLinkEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Require SSO for org members (disables password fallback). Requires ssoEnabled=true. */
  ssoEnforced?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleLocationHistoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  viewCustomersInExplore?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOutpostDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes?: InputMaybe<Array<EventType>>;
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programTerms?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** Replaces the enforced eligibility checks. */
  requirements?: InputMaybe<Array<Requirement>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Canonical IANA timezone (e.g. America/Denver, not aliases like US/Mountain) or UTC. Null clears it. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProgramInput_Old = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  programTerms?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramVariantInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programTerms?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRequirementInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: kept for backward compatibility, ignored by resolver */
  fieldType?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** When true, the keys in `config` are merged into the stored config instead of replacing it */
  mergeConfig?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Retitles the requirement on this stage. Cannot be cleared — omit to leave
   * unchanged. This is the authoring-surface title; `label`, when set, overrides
   * it in the enrollee-facing form.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  requirementId: Scalars['String']['input'];
  /** Deprecated: kept for backward compatibility, ignored by resolver */
  slug?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
};

/** Input for updating a resolution rule. All fields optional; only provided fields are patched. */
export type UpdateResolutionRuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  issueType?: InputMaybe<Scalars['String']['input']>;
  matcher?: InputMaybe<Scalars['JSON']['input']>;
  minConfidence?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateRuleInput = {
  daysOfWeek: Array<Scalars['Int']['input']>;
  deviceOperatingMode: Scalars['JSON']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateScheduleInput = {
  cleanupDeviceOperatingMode?: InputMaybe<Scalars['JSON']['input']>;
  defaultDeviceOperatingMode: Scalars['JSON']['input'];
  deviceTimezone?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Possible error codes that can occur during site update */
export type UpdateSiteErrorCode =
  /** Error occurred in the location service */
  | 'LOCATION_SERVICE_ERROR'
  /** Site not found */
  | 'SITE_NOT_FOUND'
  /** Error occurred in the site repository */
  | 'SITE_REPOSITORY_ERROR';

/** Input type for updating a site */
export type UpdateSiteInput = {
  /** City where the site is located */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where the site is located */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the workspace site to update */
  id: Scalars['ID']['input'];
  /** Latitude coordinate of the site location */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude coordinate of the site location */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** User provided name for the site */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal code where the site is located */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Customer reference ID this site belongs to */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** State/province where the site is located */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Primary street address of the site */
  streetOne?: InputMaybe<Scalars['String']['input']>;
  /** Secondary street address of the site (optional) */
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSmsDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes?: InputMaybe<Array<EventType>>;
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Array<StageRequirementInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
  transitions?: InputMaybe<Array<StageTransitionInput>>;
  userFacingConfig?: InputMaybe<StageUserFacingConfigInput>;
};

/** Input for updating normalized data on a staged record. */
export type UpdateStagedRecordDataInput = {
  normalizedData: Scalars['JSON']['input'];
  recordId: Scalars['ID']['input'];
};

/**
 * Input for updateTeamPermissionGrant: the replacement row set, with the same
 * rules as creation for the grant's existing resourceType.
 */
export type UpdateTeamPermissionGrantInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Array<PermissionGrantFilterInput>;
  id: Scalars['ID']['input'];
};

export type UpdateThermostatBatchInput = {
  batchId: Scalars['ID']['input'];
  pauseSchedule?: InputMaybe<PauseThermostatScheduleInput>;
  resumeSchedule?: InputMaybe<ResumeThermostatScheduleInput>;
  setFanMode?: InputMaybe<SetThermostatFanModeInput>;
  setOperatingMode?: InputMaybe<SetThermostatOperatingModeInput>;
  slug: ThermostatCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateTicketInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedResolutionAt?: InputMaybe<Scalars['DateTime']['input']>;
  priority?: InputMaybe<TicketPriority>;
  status?: InputMaybe<TicketStatus>;
  ticketId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing transition */
export type UpdateTransitionInput = {
  /**
   * Navigation for this transition. Omitting it — or passing null, which is treated
   * the same — leaves any existing action unchanged. Use `clearAction` to remove one.
   */
  action?: InputMaybe<LifecycleActionInput>;
  /** Set true to remove an existing action. This is the only way to clear it. */
  clearAction?: InputMaybe<Scalars['Boolean']['input']>;
  rule?: InputMaybe<Scalars['JSON']['input']>;
  stageId: Scalars['ID']['input'];
  targetStageSlug?: InputMaybe<Scalars['String']['input']>;
  transitionId: Scalars['ID']['input'];
};

export type UpdateUserEmailInput = {
  newEmail: Scalars['String']['input'];
  oldEmail: Scalars['String']['input'];
};

export type UpdateUserInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Front of house field for api compatibility as we migrate to auth0 */
  supertokensId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingRole?: InputMaybe<Scalars['String']['input']>;
  preferredTemperatureUnit?: InputMaybe<PreferredTemperatureUnit>;
  preferredTimeZone?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating user settings */
export type UpdateUserSettingsInput = {
  /** The settings JSON blob to store */
  settings: Scalars['JSON']['input'];
};

export type UpdateVehicleBatchInput = {
  batchId: Scalars['ID']['input'];
  setChargeLimit?: InputMaybe<SetVehicleChargeLimitInput>;
  setOperatingMode?: InputMaybe<SetVehicleOperatingModeInput>;
  slug: VehicleCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** Omit `siteId` to keep the device's site. Omit `role` to keep it; null clears it so it derives from the device type. */
export type UpdateVirtualDevicePlacementInput = {
  deviceId: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type UpdateWebhookDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes?: InputMaybe<Array<EventType>>;
  headers?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  includeWeather?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** PII categories removed from every payload delivered to this destination. Replaces the current list when set. */
  redactCategories?: InputMaybe<Array<RedactionCategory>>;
  secret?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing workflow */
export type UpdateWorkflowInput = {
  /** JSON configuration conforming to workflow schema */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the workflow is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the workflow */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceProgramEventInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
  workspaceProgramId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkspaceProgramInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  programTerms?: InputMaybe<Scalars['String']['input']>;
  programVariantId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Canonical IANA timezone (e.g. America/Denver, not aliases like US/Mountain) or UTC. Null clears it. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceProgramIntegrationInput = {
  authority?: InputMaybe<Scalars['String']['input']>;
  capabilityConfig?: InputMaybe<Scalars['JSON']['input']>;
  credentialModel?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledCapabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalStatus?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  providerGrantId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for updating per-workspace auto-resolve tuning configuration.
 * Omitted fields retain their current value.
 */
export type UpdateWorkspaceResolutionConfigInput = {
  aiAutoApply?: InputMaybe<Scalars['Boolean']['input']>;
  aiThreshold?: InputMaybe<Scalars['Float']['input']>;
  perIssueOverrides?: InputMaybe<Scalars['JSON']['input']>;
  ruleAutoApply?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpsertConferenceAttendeeCostInput = {
  attendanceId: Scalars['ID']['input'];
  hotelCostCents?: InputMaybe<Scalars['Int']['input']>;
  mealCostCents?: InputMaybe<Scalars['Int']['input']>;
  miscCostCents?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  overrideCostCents?: InputMaybe<Scalars['Int']['input']>;
  registrationCostCents?: InputMaybe<Scalars['Int']['input']>;
  travelCostCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for upserting a device (create or find canonical device, then add to workspace) */
export type UpsertDeviceInput = {
  /** Whether the device is connected (defaults to false) */
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional connection ID that created this device-workspace association */
  connectionId?: InputMaybe<Scalars['String']['input']>;
  /** Data provider slug that identifies the source system */
  dataProviderSlug?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturer slug (e.g., 'solaredge', 'tesla') */
  manufacturer: Scalars['String']['input'];
  /** The manufacturer's unique device ID */
  manufacturerDeviceId: Scalars['String']['input'];
  /** The site ID in the manufacturer's system (e.g., AlsoEnergy siteId) */
  manufacturerSiteId?: InputMaybe<Scalars['String']['input']>;
  /** The user ID in the manufacturer's system (e.g., account email or ID) */
  manufacturerUserId?: InputMaybe<Scalars['String']['input']>;
  /** The device model string */
  model: Scalars['String']['input'];
  /** Optional display name for the device */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Raw model string from the original data source */
  rawModel?: InputMaybe<Scalars['String']['input']>;
  /** Raw type string from the original data source */
  rawType?: InputMaybe<Scalars['String']['input']>;
  /** External reference ID for the device in this workspace (required) */
  referenceId: Scalars['String']['input'];
  /** The serial number of the device */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional site profile ID to associate the device with */
  siteProfileId?: InputMaybe<Scalars['ID']['input']>;
  /** Static state configuration for the device (capacity, power ratings, etc.) */
  staticState?: InputMaybe<DeviceStaticStateInput>;
  /** Optional tags to apply to the device */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The device type */
  type: DeviceType;
  /** The workspace to add the device to */
  workspaceId: Scalars['ID']['input'];
};

export type UpsertFieldConfigurationInput = {
  configSchema?: InputMaybe<Scalars['JSON']['input']>;
  contexts?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityType: Scalars['String']['input'];
  factKey: Scalars['String']['input'];
};

/** Possible error codes that can occur during site upsert */
export type UpsertSiteErrorCode =
  /** Error occurred in the location service */
  | 'LOCATION_SERVICE_ERROR'
  /** Error occurred in the site repository */
  | 'SITE_REPOSITORY_ERROR';

/** Input type for upserting a site */
export type UpsertSiteInput = {
  /** City where the site is located */
  city: Scalars['String']['input'];
  /** Country where the site is located */
  country: Scalars['String']['input'];
  /** User provided name for the site */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal code where the site is located */
  postalCode: Scalars['String']['input'];
  /** Utility provider for the site */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Reference ID for the site (user-provided identifier) */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** State/province where the site is located */
  state: Scalars['String']['input'];
  /** Primary street address of the site */
  streetOne: Scalars['String']['input'];
  /** Secondary street address of the site (optional) */
  streetTwo?: InputMaybe<Scalars['String']['input']>;
  /** ID of the workspace this site belongs to */
  workspaceId: Scalars['String']['input'];
};

export type UtilitySegment =
  | 'COMMUNITY_CHOICE_AGGREGATOR'
  | 'DISTRIBUTION_COOPERATIVE'
  | 'FEDERAL'
  | 'GENERATION_TRANSMISSION_COOPERATIVE'
  | 'INVESTOR_OWNED'
  | 'MUNICIPAL'
  | 'OTHER'
  | 'POLITICAL_SUBDIVISION'
  | 'POWER_MARKETER'
  | 'STATE'
  | 'TRANSMISSION_OPERATOR';

export type UtilityStatus =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'MERGED'
  | 'UNKNOWN';

export type UtilityType =
  | 'COOPERATIVE'
  | 'INVESTOR_OWNED'
  | 'MUNICIPAL'
  | 'POLITICAL_SUBDIVISION'
  | 'UNKNOWN';

export type ValidateSsoConfigurationInput = {
  organizationId: Scalars['String']['input'];
  /**
   * Optional — when present, runs cert format and expiry checks against this
   * PEM. Only meaningful for the samlp strategy.
   */
  signingCert?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional strategy hint for pre-save validation. Ignored once SSO is
   * configured — persisted state then dictates which checks run.
   */
  strategy?: InputMaybe<SsoStrategy>;
};

/** Input for validating workflow configuration */
export type ValidateWorkflowInput = {
  /** JSON workflow configuration to validate */
  config: Scalars['JSON']['input'];
};

export type ValidationFlagsFilter = {
  batteryFlowReasonable?: InputMaybe<Scalars['Boolean']['input']>;
  energyBalanceOk?: InputMaybe<Scalars['Boolean']['input']>;
  exportHasSource?: InputMaybe<Scalars['Boolean']['input']>;
  importHasDest?: InputMaybe<Scalars['Boolean']['input']>;
  nonNegativeValues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VehicleBatchCommandInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  setChargeLimit?: InputMaybe<SetVehicleChargeLimitInput>;
  setOperatingMode?: InputMaybe<SetVehicleOperatingModeInput>;
  slug: VehicleCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type VehicleCommandInput = {
  id: Scalars['ID']['input'];
  setChargeLimit?: InputMaybe<SetVehicleChargeLimitInput>;
  setOperatingMode?: InputMaybe<SetVehicleOperatingModeInput>;
  slug: VehicleCommandSlug;
};

export type VehicleCommandSlug =
  | 'vehicle_check_pairing_status'
  | 'vehicle_set_charge_limit'
  | 'vehicle_set_operating_mode';

/** Input for verifying MFA code */
export type VerifyMfaCodeInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mfaChallengeId: Scalars['String']['input'];
};

export type VerifyOrganizationDomainInput = {
  /** A domain this organization has claimed (via configureOrganizationSso). */
  domain: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type VirtualAccountType =
  | 'DEFAULT'
  | 'OAUTH';

export type VirtualDeviceType =
  | 'battery'
  | 'charger'
  | 'inverter'
  | 'meter'
  | 'thermostat'
  | 'vehicle';

export type VirtualEventRecurrence =
  | 'daily'
  | 'weekdays'
  | 'weekends';

/** Scripted event types. Recorded commands also appear on a site's timeline, with their command type as `type`. */
export type VirtualScenarioEventType =
  | 'api_error'
  | 'charge_stall'
  | 'command_failure'
  | 'comms_dropout'
  | 'offline'
  | 'outage'
  | 'plug_in'
  | 'set_param'
  | 'set_soc'
  | 'trip'
  | 'unplug';

/** `at` and `endAt` are ISO timestamps or offsets from the site's `startAt` (`+PT14H`). */
export type VirtualSiteEventInput = {
  at: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  recurrence?: InputMaybe<VirtualEventRecurrence>;
  role?: InputMaybe<Scalars['String']['input']>;
  type: VirtualScenarioEventType;
};

export type VirtualSiteEventSource =
  | 'command'
  | 'scripted';

export type VisibilityLevel =
  | 'INTERNAL'
  | 'SHARED';

export type WebhookDeliveryStatus =
  | 'FAILED'
  | 'SUCCESS';

export type WebhookStatus =
  | 'ACTIVE'
  | 'DISABLED'
  | 'FAILING';

export type WindowSize =
  | 'DAY'
  | 'FIFTEEN_MINUTES'
  | 'HOUR'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

/** Filter criteria for workflow queries */
export type WorkflowFilter = {
  /** Filter by enabled status */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by name (partial match) */
  nameLike?: InputMaybe<Scalars['String']['input']>;
};

/** Workflow execution status */
export type WorkflowStatus =
  | 'CANCELLED'
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'RUNNING'
  | 'WAITING_MODAL';

/** Input for querying workflows */
export type WorkflowsInput = {
  /** Optional filter criteria */
  filter?: InputMaybe<WorkflowFilter>;
  /** Maximum number of results to return */
  limit?: Scalars['Int']['input'];
  /** Number of results to skip for pagination */
  offset?: Scalars['Int']['input'];
  /** ID of the workspace to query workflows from */
  workspaceId: Scalars['String']['input'];
};

export type WorkspaceAlertConfigInput = {
  enabled: Scalars['Boolean']['input'];
  oemOverrides: Array<OemOverrideInput>;
  severities: SeveritiesInput;
};

export type WorkspaceCommandsFilter = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<CommandStatus>>;
  /**
   * The workspace whose commands are listed: those on its own devices. The
   * caller must be able to read the workspace.
   */
  workspaceId: Scalars['ID']['input'];
};

export type WorkspaceCommandsInput = {
  filter: WorkspaceCommandsFilter;
  pagination?: InputMaybe<ListPagination>;
};

export type WorkspaceConnectConfigData = {
  linkSessionConfig?: InputMaybe<LinkSessionConfigDefaultsInput>;
};

export type WorkspaceConnectConfigInput = {
  profile?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type WorkspaceEnrollmentsInput = {
  /**
   * Inclusive createdAt window (half-open ranges allowed — either bound is
   * optional). Scopes to enrollments created within the window.
   */
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Membership over several customers, for when a name resolved to more than one
   * contact record (duplicate contacts sharing an email are common). Combines with
   * `customerId` as an intersection, so passing both narrows rather than widens;
   * an empty list is read as "no filter", like the other list filters here.
   */
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  enrollmentGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Presence predicate over the enrollment's attached devices — `false` selects
   * enrollments with no device, `true` those with at least one, omitted applies no
   * predicate. Distinct from `deviceIds`, which is membership over specific devices
   * and cannot express emptiness: `deviceIds: []` is read as "no filter" so that an
   * unset multi-select does not silently match nothing.
   */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<EnrollmentOrderByInput>;
  pagination?: InputMaybe<OffsetPagination>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<EligibilityStatus>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
  /** Optional: narrow the workspace-wide scope to a single program. */
  workspaceProgramId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkspaceInvitationStatus =
  | 'ACCEPTED'
  | 'CANCELLED'
  | 'PENDING';

export type WorkspaceProgramEventDispatchStatus =
  | 'active'
  | 'canceled'
  | 'canceling'
  | 'completed'
  | 'draft'
  | 'error'
  | 'pending'
  | 'scheduled'
  | 'stalled'
  | 'unknown';

/**
 * Selection for the poll sweep's due-work read.
 *
 * An input object rather than positional arguments because this is the one read
 * whose shape will keep growing — the sweep is the only consumer, and every future
 * narrowing (a provider set, a workspace, a status class) belongs here rather than
 * as another argument. Every field is optional and every default is the safe one, so
 * the object itself is optional too: a caller asking for "whatever is due" should not
 * have to send an empty one.
 */
export type WorkspaceProgramEventDispatchesDueForPollInput = {
  /**
   * Maximum dispatches to return. Defaults to 50 and is clamped to 200 — clamped
   * rather than refused, because a sweep that fails outright on a tuning mistake
   * stops polling every live dispatch.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Narrow to these integration contracts, e.g. `["renewhome:esc"]`. Omit or pass an
   * empty list for every provider.
   *
   * Filtered in the query rather than by the caller because the batch is bounded and
   * oldest-first: a sweep that discards foreign rows after the fetch has already
   * spent its budget on them, and enough of them starve the provider it can actually
   * poll. The adapter passes the set it has armed handlers for.
   */
  providers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkspaceProgramEventStatus =
  | 'active'
  /** Every target confirmed stopped. */
  | 'cancelled'
  /**
   * The operator asked and at least one provider has not confirmed. **Not stopped
   * yet** — the vendor documents a delay between accepting a cancellation and it
   * reaching devices, so an event can sit here while homes are still being shed.
   */
  | 'cancelling'
  | 'completed'
  | 'draft'
  /**
   * The operator asked, and something did not stop: a dispatch that refused its
   * cancel and still holds its window, or a batch whose commands could not be
   * cancelled. Its own status rather than a flavour of `cancelled`, because a
   * cancelled command cannot be un-cancelled — "2 of 3 stopped" is a state that
   * really exists, and the operator needs it to know which target to retry.
   *
   * **Retryable**, unlike the other two cancel statuses: see
   * `cancelWorkspaceProgramEvent`.
   */
  | 'partiallyCancelled'
  | 'pending';

export type WorkspaceSystemConnectionInput = {
  id: Scalars['ID']['input'];
};

export type WorkspaceSystemConnectionsInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination?: InputMaybe<ListPagination>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  systemId?: InputMaybe<Scalars['String']['input']>;
  systemIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type WorkspacesOrderBy = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
  name?: InputMaybe<PaginatedQueryOrderBy>;
  updatedAt?: InputMaybe<PaginatedQueryOrderBy>;
};

/** Input for writing lifecycle facts to an enrollment. */
export type WriteLifecycleFactInput = {
  enrollmentId: Scalars['ID']['input'];
  facts: Scalars['JSON']['input'];
  source: Scalars['String']['input'];
};

export type GetUsersCountForHomepageQueryVariables = Exact<{
  input: AllUsersInput;
}>;


export type GetUsersCountForHomepageQuery = { allUsers: { __typename?: 'UserPaginatedQueryPayload', meta: { __typename?: 'ListPayloadMeta', totalCount: number } | null } };

export type GetSuperAdminCountForHomepageQueryVariables = Exact<{
  input: SuperAdminGrantsInput;
}>;


export type GetSuperAdminCountForHomepageQuery = { superAdminGrants: { __typename?: 'SuperAdminGrantPaginatedQueryPayload', meta: { __typename?: 'ListPayloadMeta', totalCount: number } | null } };

export type UserForDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserForDetailQuery = { user: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, externalUserId: string | null, isTextureEmployee: boolean, profile: { __typename?: 'UserProfile', fullName: string | null, profilePhoto: string | null }, emails: Array<{ __typename?: 'Email', email: string, verified: boolean } | null> | null, memberships: Array<{ __typename?: 'Membership', id: string, role: Role, organization: { __typename?: 'Organization', id: string, name: string } | null } | null> | null } | null };

export type SuperAdminGrantsForUserQueryVariables = Exact<{
  input: SuperAdminGrantsInput;
}>;


export type SuperAdminGrantsForUserQuery = { superAdminGrants: { __typename?: 'SuperAdminGrantPaginatedQueryPayload', data: Array<{ __typename?: 'SuperAdminGrant', id: string, reason: string | null, expiresAt: string | null, revokedAt: string | null, revokedReason: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', fullName: string | null } }, grantedBy: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', fullName: string | null } }, revokedBy: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', fullName: string | null } } | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number } | null } };

export type GrantSuperAdminAccessMutationVariables = Exact<{
  input: GrantSuperAdminInput;
}>;


export type GrantSuperAdminAccessMutation = { grantSuperAdmin: { __typename?: 'SuperAdminGrant', id: string, user: { __typename?: 'User', id: string } } };

export type RevokeSuperAdminAccessMutationVariables = Exact<{
  input: RevokeSuperAdminInput;
}>;


export type RevokeSuperAdminAccessMutation = { revokeSuperAdmin: { __typename?: 'SuperAdminGrant', id: string, revokedAt: string | null } };

export type AllUsersQueryVariables = Exact<{
  input: AllUsersInput;
}>;


export type AllUsersQuery = { allUsers: { __typename?: 'UserPaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'User', id: string, createdAt: string, externalUserId: string | null, isTextureEmployee: boolean, profile: { __typename?: 'UserProfile', fullName: string | null, profilePhoto: string | null }, emails: Array<{ __typename?: 'Email', email: string, verified: boolean } | null> | null }> | null, meta: { __typename?: 'ListPayloadMeta', count: number, totalCount: number, totalPages: number, hasPreviousPage: boolean, hasNextPage: boolean, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null } };

export type GetAffiliatedByOrganizationsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAffiliatedByOrganizationsQuery = { organization: { __typename?: 'Organization', id: string, affiliatedByOrganizations: Array<{ __typename?: 'OrganizationAffiliation', id: string, organizationId: string, createdAt: string, organization: { __typename?: 'Organization', id: string, name: string, logo: string | null }, createdBy: { __typename?: 'UserProfile', fullName: string | null } | null }> } | null };

export type GetAllOrganizationsForGrowthQueryVariables = Exact<{
  input: OrganizationsInput;
}>;


export type GetAllOrganizationsForGrowthQuery = { organizations: { __typename?: 'OrganizationPaginatedQueryPayload', data: Array<{ __typename?: 'Organization', id: string, createdAt: string }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number } | null } };

export type GetRecentUsersForHomepageQueryVariables = Exact<{
  input: AllUsersInput;
}>;


export type GetRecentUsersForHomepageQuery = { allUsers: { __typename?: 'UserPaginatedQueryPayload', data: Array<{ __typename?: 'User', id: string, createdAt: string, profile: { __typename?: 'UserProfile', fullName: string | null, profilePhoto: string | null }, emails: Array<{ __typename?: 'Email', email: string } | null> | null, memberships: Array<{ __typename?: 'Membership', id: string, organization: { __typename?: 'Organization', id: string, name: string } | null } | null> | null }> | null } };

export type OrganizationAffiliationFieldsFragment = { __typename?: 'OrganizationAffiliation', id: string, organizationId: string, affiliatedOrganizationId: string, createdAt: string, affiliatedOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null }, createdBy: { __typename?: 'UserProfile', fullName: string | null } | null };

export type OrganizationAssociationFieldsFragment = { __typename?: 'Association', id: string, otherOrganizationId: string, otherOrganizationName: string, createdAt: string, grantsFromUs: Array<{ __typename?: 'AssociationGrant', id: string, grantorWorkspaceId: string, grantorWorkspaceName: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null, mode: PermissionGrantMode, resourceType: PermissionGrantResourceType, includesRelatedResources: boolean, createdAt: string, filters: Array<{ __typename?: 'PermissionGrantFilter', field: string, operator: PermissionGrantFilterOperator, value: string }> }>, grantsToUs: Array<{ __typename?: 'AssociationGrant', id: string, grantorWorkspaceId: string, grantorWorkspaceName: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null, mode: PermissionGrantMode, resourceType: PermissionGrantResourceType, includesRelatedResources: boolean, createdAt: string, filters: Array<{ __typename?: 'PermissionGrantFilter', field: string, operator: PermissionGrantFilterOperator, value: string }> }> };

export type AssociationGrantFieldsFragment = { __typename?: 'AssociationGrant', id: string, grantorWorkspaceId: string, grantorWorkspaceName: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null, mode: PermissionGrantMode, resourceType: PermissionGrantResourceType, includesRelatedResources: boolean, createdAt: string, filters: Array<{ __typename?: 'PermissionGrantFilter', field: string, operator: PermissionGrantFilterOperator, value: string }> };

export type GisLayerSettingsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GisLayerSettingsQuery = { workspaceGisLayerSettings: { __typename?: 'WorkspaceGisLayerSettings', uploadsEnabled: boolean, layer: { __typename?: 'WorkspaceGisLayer', id: string, workspaceId: string, activeUploadId: string | null, name: string } | null, requestedUpload: { __typename?: 'GisLayerUpload', id: string, filename: string, status: GisUploadStatus, errorMessage: string | null, sourceCrs: string | null } | null } };

export type RequestGisUploadMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  input: GisLayerUploadInput;
}>;


export type RequestGisUploadMutation = { requestServiceTerritoryUpload: { __typename?: 'GisUploadGrant', url: string, expiresAt: string, upload: { __typename?: 'GisLayerUpload', id: string, status: GisUploadStatus }, headers: Array<{ __typename?: 'GisUploadHeader', name: string, value: string }> } };

export type ConfirmGisUploadMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
}>;


export type ConfirmGisUploadMutation = { confirmGisLayerUpload: { __typename?: 'GisLayerUpload', id: string, status: GisUploadStatus } };

export type RetryGisUploadMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
}>;


export type RetryGisUploadMutation = { retryGisLayerUpload: { __typename?: 'GisLayerUpload', id: string, status: GisUploadStatus } };

export type RemoveGisLayerMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  layerId: Scalars['ID']['input'];
}>;


export type RemoveGisLayerMutation = { removeWorkspaceGisLayer: boolean };

export type CreateAssociationMutationVariables = Exact<{
  input: CreateAssociationInput;
}>;


export type CreateAssociationMutation = { createAssociation: { __typename?: 'Association', id: string, otherOrganizationId: string, otherOrganizationName: string, createdAt: string, grantsFromUs: Array<{ __typename?: 'AssociationGrant', id: string, grantorWorkspaceId: string, grantorWorkspaceName: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null, mode: PermissionGrantMode, resourceType: PermissionGrantResourceType, includesRelatedResources: boolean, createdAt: string, filters: Array<{ __typename?: 'PermissionGrantFilter', field: string, operator: PermissionGrantFilterOperator, value: string }> }>, grantsToUs: Array<{ __typename?: 'AssociationGrant', id: string, grantorWorkspaceId: string, grantorWorkspaceName: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null, mode: PermissionGrantMode, resourceType: PermissionGrantResourceType, includesRelatedResources: boolean, createdAt: string, filters: Array<{ __typename?: 'PermissionGrantFilter', field: string, operator: PermissionGrantFilterOperator, value: string }> }> } };

export type CreateAssociationGrantMutationVariables = Exact<{
  input: CreateAssociationGrantInput;
}>;


export type CreateAssociationGrantMutation = { createAssociationGrant: { __typename?: 'AssociationGrant', id: string, landingWorkspaceId: string | null } };

export type CreateOrganizationAffiliationMutationVariables = Exact<{
  input: CreateOrganizationAffiliationInput;
}>;


export type CreateOrganizationAffiliationMutation = { createOrganizationAffiliation: { __typename?: 'OrganizationAffiliation', id: string, organizationId: string, affiliatedOrganizationId: string, createdAt: string, affiliatedOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null }, createdBy: { __typename?: 'UserProfile', fullName: string | null } | null } };

export type EndAssociationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type EndAssociationMutation = { endAssociation: boolean };

export type RelandAssociationGrantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  landingWorkspaceId: Scalars['ID']['input'];
}>;


export type RelandAssociationGrantMutation = { relandAssociationGrant: { __typename?: 'AssociationGrant', id: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null } };

export type RemoveOrganizationAffiliationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveOrganizationAffiliationMutation = { removeOrganizationAffiliation: boolean };

export type RevokeAssociationGrantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeAssociationGrantMutation = { revokeAssociationGrant: boolean };

export type UnlandAssociationGrantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnlandAssociationGrantMutation = { unlandAssociationGrant: { __typename?: 'AssociationGrant', id: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null } };

export type GetOrganizationAffiliationsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOrganizationAffiliationsQuery = { organization: { __typename?: 'Organization', id: string, affiliatedOrganizations: Array<{ __typename?: 'OrganizationAffiliation', id: string, organizationId: string, affiliatedOrganizationId: string, createdAt: string, affiliatedOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null }, createdBy: { __typename?: 'UserProfile', fullName: string | null } | null }> } | null };

export type GetOrganizationAssociationsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOrganizationAssociationsQuery = { organization: { __typename?: 'Organization', id: string, name: string, associations: Array<{ __typename?: 'Association', id: string, otherOrganizationId: string, otherOrganizationName: string, createdAt: string, grantsFromUs: Array<{ __typename?: 'AssociationGrant', id: string, grantorWorkspaceId: string, grantorWorkspaceName: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null, mode: PermissionGrantMode, resourceType: PermissionGrantResourceType, includesRelatedResources: boolean, createdAt: string, filters: Array<{ __typename?: 'PermissionGrantFilter', field: string, operator: PermissionGrantFilterOperator, value: string }> }>, grantsToUs: Array<{ __typename?: 'AssociationGrant', id: string, grantorWorkspaceId: string, grantorWorkspaceName: string, landingWorkspaceId: string | null, landingWorkspaceName: string | null, mode: PermissionGrantMode, resourceType: PermissionGrantResourceType, includesRelatedResources: boolean, createdAt: string, filters: Array<{ __typename?: 'PermissionGrantFilter', field: string, operator: PermissionGrantFilterOperator, value: string }> }> }> | null } | null };

export type PlaceholderQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaceholderQueryQuery = { __typename: 'Query' };

export type GetAdminCommandQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAdminCommandQuery = { adminCommand: { __typename?: 'Command', id: string, status: CommandStatus, input: unknown | null, reason: string | null, startAt: string | null, endAt: string | null, createdAt: string, updatedAt: string | null, executedAt: string | null, acknowledgmentStatus: string | null, acknowledgmentReason: string | null, acknowledgmentReceivedAt: string | null, batchId: string | null, type: { __typename?: 'CommandType', slug: string, description: string, inputSchema: unknown | null }, device: { __typename?: 'Device', id: string, type: DeviceType, manufacturer: string, model: string, displayModelName: string | null, manufacturerProfile: { __typename?: 'DeviceManufacturerProfile', name: string, logo: string | null, icon: string | null, vectorIcon: string | null } } | null } | null };

export type GetAdminDeviceCommandsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  deviceId: Scalars['ID']['input'];
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminDeviceCommandsQuery = { adminDeviceCommands: { __typename?: 'DeviceCommandPaginatedQueryPayload', data: Array<{ __typename?: 'Command', id: string, status: CommandStatus, input: unknown | null, reason: string | null, createdAt: string, updatedAt: string | null, startAt: string | null, endAt: string | null, executedAt: string | null, acknowledgmentStatus: string | null, acknowledgmentReason: string | null, acknowledgmentReceivedAt: string | null, batchId: string | null, type: { __typename?: 'CommandType', slug: string, description: string } }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } | null } };

export type AdminDeviceByAnyIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeviceByAnyIdQuery = { adminDeviceByAnyId: { __typename?: 'AdminDeviceLookupResult', workspaceId: string | null, matchedVia: AdminDeviceMatchedVia | null, device: { __typename?: 'CDevice', id: string, manufacturerDeviceId: string, serialNumber: string | null, name: string | null, createdAt: string } | null, deviceOnWorkspace: { __typename?: 'Device', id: string, name: string | null, type: DeviceType, manufacturer: string, model: string, displayModelName: string | null, year: number | null, manufacturerDeviceId: string, manufacturerUserId: string, serialNumber: string | null, referenceId: string, connectedAt: string | null, disconnectedAt: string | null, createdAt: string, updatedAt: string | null, tags: Array<string>, location:
        | { __typename?: 'Location', latitude: number, longitude: number }
        | { __typename?: 'VehicleLocation', latitude: number | null, longitude: number | null }
       | null, site: { __typename?: 'Site', id: string, name: string | null, workspaceId: string, location: { __typename?: 'Location', id: string, streetOne: string | null, city: string | null, state: string | null, postalCode: string, fullAddress: string } } | null } | null } };

export type GetAdminDeviceStateHistoryQueryVariables = Exact<{
  deviceOnWorkspaceId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: InputMaybe<Scalars['DateTime']['input']>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAdminDeviceStateHistoryQuery = { adminDeviceStateHistory: { __typename?: 'DeviceStatePaginatedQueryPayload', error: string | null, data: Array<
      | { __typename: 'BatteryState', id: string, createdAt: string, ingestDate: string | null, charge: number | null, chargePercentage: number, chargeRate: number | null, chargingState: BatteryChargingState, backupReserve: number | null, isStormModeActive: boolean | null, isStormModeEnabled: boolean | null, strategy: BatteryStrategy | null, whConsumed: number, gridEnergy: number | null, gridPower: number | null, gridStatus: GridStatus }
      | { __typename: 'ChargerState', id: string, createdAt: string, ingestDate: string | null, chargingState: BatteryChargingState, isPluggedIn: boolean | null, chargerCurrent: number | null, chargerVoltage: number | null, chargerWattage: number | null }
      | { __typename: 'InverterState', id: string, createdAt: string, ingestDate: string | null, power: number, gridEnergy: number | null, gridPower: number | null, gridStatus: GridStatus }
      | { __typename: 'MeterState', id: string, createdAt: string, phaseAVoltage: number | null, phaseACurrent: number | null, phaseARealPower: number | null }
      | { __typename: 'ThermostatState', id: string, createdAt: string, ingestDate: string | null, ambientTemperature: number, operatingMode: ThermostatMode, coolTarget: number | null, heatTarget: number | null, fanMode: ThermostatFanMode }
      | { __typename: 'VehicleState', id: string, createdAt: string, ingestDate: string | null, charge: number | null, chargePercentage: number, chargeCompletedAt: string | null, chargeLimit: number | null, chargingState: BatteryChargingState, isPluggedIn: boolean | null, chargerCurrent: number | null, chargerVoltage: number | null, chargerWattage: number | null, range: number, latitude: number | null, longitude: number | null }
    > | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } | null } };

export type AdminCreateInvitationMutationVariables = Exact<{
  input: AdminCreateInvitationInput;
}>;


export type AdminCreateInvitationMutation = { adminCreateInvitation: { __typename?: 'Invitation', id: string, email: string, role: Role, status: InvitationStatus, createdAt: string, organization: { __typename?: 'Organization', id: string, name: string } | null } };

export type GetAdminWorkspacesQueryVariables = Exact<{
  input: AdminWorkspacesInput;
}>;


export type GetAdminWorkspacesQuery = { adminWorkspaces: { __typename?: 'WorkspacePaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'Workspace', id: string, name: string, organizationId: string, deletionProtection: boolean, createdAt: string, updatedAt: string, organization: { __typename?: 'Organization', id: string, name: string } | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, hasNextPage: boolean } | null } };

export type AdminAgentEvalRunsQueryVariables = Exact<{
  input: InputMaybe<AgentEvalRunsInput>;
}>;


export type AdminAgentEvalRunsQuery = { agentEvalRuns: { __typename?: 'AgentEvalRunConnection', totalCount: number, edges: Array<{ __typename?: 'AgentEvalRunEdge', cursor: string, node: { __typename?: 'AgentEvalRun', id: string, runId: string, recordedByUserId: string, startedAt: string, completedAt: string, gitSha: string | null, suiteDir: string, agents: Array<string>, workspaces: Array<string>, baseUrl: string | null, tasks: unknown, overallPassRate: number, trialCount: number, digestJudge: string | null, digestGeneratedAt: string | null, recordedAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string | null } } };

export type AdminAgentEvalRunQueryVariables = Exact<{
  runId: Scalars['NonEmptyString']['input'];
}>;


export type AdminAgentEvalRunQuery = { agentEvalRun: { __typename?: 'AgentEvalRunDetail', run: { __typename?: 'AgentEvalRun', id: string, runId: string, recordedByUserId: string, startedAt: string, completedAt: string, gitSha: string | null, suiteDir: string, agents: Array<string>, workspaces: Array<string>, baseUrl: string | null, tasks: unknown, overallPassRate: number, trialCount: number, digest: unknown | null, digestJudge: string | null, digestGeneratedAt: string | null, recordedAt: string, updatedAt: string }, trials: Array<{ __typename?: 'AgentEvalTrial', id: string, runId: string, taskId: string, agent: string, workspace: string, trial: number, startedAt: string, completedAt: string, transcript: unknown, verdicts: unknown, passed: boolean, skipped: boolean, payloadTruncated: boolean, recordedAt: string }> } | null };

export type AdminAgentSessionsQueryVariables = Exact<{
  input: InputMaybe<AgentSessionsInput>;
}>;


export type AdminAgentSessionsQuery = { agentSessions: { __typename?: 'AgentSessionConnection', totalCount: number, edges: Array<{ __typename?: 'AgentSessionEdge', cursor: string, node: { __typename?: 'AgentSession', id: string, surface: AgentSurface, userId: string, organizationId: string, workspaceId: string | null, clientConversationId: string, model: string, provider: string, routes: Array<string>, title: string | null, preview: string | null, exchangeCount: number, callCount: number, inputTokens: number, outputTokens: number, lastError: string | null, startedAt: string, lastTurnAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string | null } } };

export type AdminAgentSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminAgentSessionQuery = { agentSession: { __typename?: 'AgentSessionDetail', session: { __typename?: 'AgentSession', id: string, surface: AgentSurface, userId: string, organizationId: string, workspaceId: string | null, clientConversationId: string, model: string, provider: string, routes: Array<string>, title: string | null, exchangeCount: number, callCount: number, lastError: string | null, startedAt: string, lastTurnAt: string }, calls: Array<{ __typename?: 'AgentModelCall', exchangeSeq: number, iteration: number, route: string, workspaceId: string | null, userText: string | null, content: unknown, assistantText: string | null, toolResults: unknown | null, actions: unknown | null, errorClass: string | null, occurredAt: string, inputTokens: number, outputTokens: number, cacheReadTokens: number, cacheCreationTokens: number, latencyMs: number | null, stopReason: string | null, provider: string, payloadTruncated: boolean }> } | null };

export type GetAllWorkspacesViaOrganizationsQueryVariables = Exact<{
  input: OrganizationsInput;
}>;


export type GetAllWorkspacesViaOrganizationsQuery = { organizations: { __typename?: 'OrganizationPaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'Organization', id: string, name: string, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string, organizationId: string, deletionProtection: boolean, createdAt: string, updatedAt: string }> | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasPreviousPage: boolean, hasNextPage: boolean, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { createOrganization: { __typename?: 'Organization', id: string, name: string, domain: string | null, logo: string | null, industry: string | null, personal: boolean, createdAt: string, updatedAt: string } };

export type CreateProgramMutationVariables = Exact<{
  input: CreateProgramInput;
}>;


export type CreateProgramMutation = { createProgram: { __typename?: 'Program', id: string, slug: string, name: string } };

export type CreateDeviceModelMutationVariables = Exact<{
  input: CreateDeviceModelInput;
}>;


export type CreateDeviceModelMutation = { createDeviceModel: { __typename?: 'DeviceModelProfile', id: string | null, slug: string, name: string, logo: string | null, type: DeviceType | null, supportLevel: SupportLevel | null, manufacturerId: string | null } };

export type UpdateDeviceModelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDeviceModelInput;
}>;


export type UpdateDeviceModelMutation = { updateDeviceModel: { __typename?: 'DeviceModelProfile', id: string | null, slug: string, name: string, logo: string | null, type: DeviceType | null, supportLevel: SupportLevel | null, manufacturerId: string | null } };

export type DeleteDeviceModelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDeviceModelMutation = { deleteDeviceModel: boolean };

export type GetFieldConfigurationsQueryVariables = Exact<{
  entityType: InputMaybe<Scalars['String']['input']>;
  context: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFieldConfigurationsQuery = { fieldConfigurations: Array<{ __typename?: 'FieldConfiguration', id: string, factKey: string, entityType: string, contexts: Array<string>, configSchema: unknown, enabled: boolean, createdAt: string, updatedAt: string }> };

export type SearchPlatformFieldsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchPlatformFieldsQuery = { searchPlatformFields: Array<{ __typename?: 'PlatformField', factKey: string, displayName: string, fieldType: string, entityType: string, description: string | null, source: string }> };

export type UpsertFieldConfigurationMutationVariables = Exact<{
  input: UpsertFieldConfigurationInput;
}>;


export type UpsertFieldConfigurationMutation = { upsertFieldConfiguration: { __typename?: 'FieldConfiguration', id: string, factKey: string, entityType: string, contexts: Array<string>, configSchema: unknown, enabled: boolean, createdAt: string, updatedAt: string } };

export type ManufacturerAssignmentFieldsFragment = { __typename?: 'ManufacturerAssignment', id: string, organizationId: string, createdAt: string, createdBy: { __typename?: 'ManufacturerAssignmentCreatedBy', fullName: string | null } | null, manufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null } };

export type GetManufacturerAssignmentsForOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetManufacturerAssignmentsForOrganizationQuery = { manufacturerAssignmentsForOrganization: Array<{ __typename?: 'ManufacturerAssignment', id: string, organizationId: string, createdAt: string, createdBy: { __typename?: 'ManufacturerAssignmentCreatedBy', fullName: string | null } | null, manufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null } }> };

export type AssignManufacturerMutationVariables = Exact<{
  manufacturerId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type AssignManufacturerMutation = { assignManufacturer: { __typename?: 'ManufacturerAssignment', id: string, organizationId: string, createdAt: string, createdBy: { __typename?: 'ManufacturerAssignmentCreatedBy', fullName: string | null } | null, manufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null } } };

export type RevokeManufacturerAssignmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeManufacturerAssignmentMutation = { revokeManufacturerAssignment: boolean };

export type GetManufacturerModelsQueryVariables = Exact<{
  input: InputMaybe<ModelInput>;
}>;


export type GetManufacturerModelsQuery = { models: Array<{ __typename?: 'DeviceModelProfile', id: string | null, slug: string, name: string, logo: string | null, type: DeviceType | null, supportLevel: SupportLevel | null, manufacturerId: string | null }> };

export type CreateDeviceManufacturerMutationVariables = Exact<{
  input: CreateDeviceManufacturerInput;
}>;


export type CreateDeviceManufacturerMutation = { createDeviceManufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null, vectorIcon: string | null, supportLevel: SupportLevel | null, supportsGridServices: boolean | null, availableInTextureConnect: boolean | null } };

export type UpdateDeviceManufacturerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDeviceManufacturerInput;
}>;


export type UpdateDeviceManufacturerMutation = { updateDeviceManufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null, vectorIcon: string | null, supportLevel: SupportLevel | null, supportsGridServices: boolean | null, availableInTextureConnect: boolean | null } };

export type DeleteDeviceManufacturerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDeviceManufacturerMutation = { deleteDeviceManufacturer: boolean };

export type GetManufacturersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManufacturersQuery = { manufacturers: Array<{ __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null, vectorIcon: string | null, supportLevel: SupportLevel | null, supportsGridServices: boolean | null, availableInTextureConnect: boolean | null }> };

export type GetOAuthApplicationByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOAuthApplicationByIdQuery = { oauthApplication: { __typename?: 'OAuthApplication', id: string, clientId: string, name: string, description: string | null, redirectUris: Array<string>, allowedScopes: Array<string>, type: OAuthApplicationType, isFirstParty: boolean, createdAt: string, updatedAt: string } };

export type AdminOrgTeamsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminOrgTeamsQuery = { organization: { __typename?: 'Organization', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, kind: string | null, homepage: unknown | null, members: Array<{ __typename?: 'TeamMembership', id: string, membership: { __typename?: 'Membership', id: string, role: Role } }> }> | null } | null, teamTemplates: Array<{ __typename?: 'TeamTemplate', key: TeamTemplateKey, name: string, description: string, teamId: string | null }> };

export type AdminApplyTeamTemplateMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  templateKey: TeamTemplateKey;
}>;


export type AdminApplyTeamTemplateMutation = { applyTeamTemplate: { __typename?: 'ApplyTeamTemplatePayload', skipped: Array<string>, created: Array<{ __typename?: 'Team', id: string, name: string, kind: string | null }> } };

export type AdminDeleteTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminDeleteTeamMutation = { deleteTeam: boolean };

export type AdminRenameTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type AdminRenameTeamMutation = { renameTeam: { __typename?: 'Team', id: string, name: string } };

export type AdminAddTeamMemberMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
  membershipId: Scalars['ID']['input'];
}>;


export type AdminAddTeamMemberMutation = { addTeamMember: { __typename?: 'TeamMembership', id: string, teamId: string } };

export type AdminRemoveTeamMemberMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
  membershipId: Scalars['ID']['input'];
}>;


export type AdminRemoveTeamMemberMutation = { removeTeamMember: boolean };

export type GetOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationQuery = { me: { __typename?: 'LoggedUser', id: string, memberships: Array<{ __typename?: 'Membership', id: string, role: Role, isAdmin: boolean, organization: { __typename?: 'Organization', id: string } | null } | null> | null, authenticatedOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null, preferredTemperatureUnit: PreferredTemperatureUnit, industry: string | null, mfaEmailOtpEnabled: boolean, location: { __typename?: 'OrganizationLocation', country: string | null } | null } | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { updateOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null, preferredTemperatureUnit: PreferredTemperatureUnit, industry: string | null, mfaEmailOtpEnabled: boolean, location: { __typename?: 'OrganizationLocation', country: string | null } | null } };

export type UpdateOrganizationLocationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateLocationInput;
}>;


export type UpdateOrganizationLocationMutation = { updateOrganizationLocation: { __typename?: 'Organization', id: string, location: { __typename?: 'OrganizationLocation', country: string | null } | null } };

export type GetOrganizationByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOrganizationByIdQuery = { organization: { __typename?: 'Organization', id: string, name: string, logo: string | null, domain: string | null, url: string | null, industry: string | null, personal: boolean, billingId: string | null, mfaEmailOtpEnabled: boolean, ssoEnabled: boolean, ssoProvider: string | null, preferredTemperatureUnit: PreferredTemperatureUnit, enphaseGridServicesOrganizationToken: string | null, auth0OrganizationId: string | null, auth0OrganizationName: string | null, createdAt: string, updatedAt: string, location: { __typename?: 'OrganizationLocation', country: string | null, state: string | null, city: string | null, streetOne: string | null, streetTwo: string | null, postalCode: string | null } | null, ownerProfile: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null, profilePhoto: string | null } | null, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string }> | null, enabledPacks: Array<{ __typename?: 'OrganizationPack', id: string, pack: PackType, enabledAt: string, enabledBy: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null } | null }> } | null };

export type GetOrganizationMembersQueryVariables = Exact<{
  input: OrganizationMembersInput;
}>;


export type GetOrganizationMembersQuery = { organizationMembers: { __typename?: 'MembershipPaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'Membership', id: string, role: Role, owner: boolean, isAdmin: boolean, userId: string, organizationId: string, createdAt: string, updatedAt: string, userProfile: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null, profilePhoto: string | null } | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasPreviousPage: boolean, hasNextPage: boolean, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null } };

export type EnablePackMutationVariables = Exact<{
  input: EnablePackInput;
}>;


export type EnablePackMutation = { enablePack: { __typename?: 'OrganizationPack', id: string, pack: PackType, enabledAt: string, enabledBy: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null } | null } };

export type DisablePackMutationVariables = Exact<{
  input: DisablePackInput;
}>;


export type DisablePackMutation = { disablePack: boolean };

export type CanonicalOrganizationTerritoryFieldsFragment = { __typename?: 'CanonicalOrganizationTerritory', id: string, commonGridUtilityId: string, commonGridUtilitySlug: string, commonGridUtilityName: string | null, eiaId: string | null, territorySlug: string | null, isPrimary: boolean, source: OrgDataSource, observedAt: string, unlinkedAt: string | null, bbox: { __typename?: 'GeoBoundingBox', west: number, south: number, east: number, north: number } | null, assignedBy: { __typename?: 'User', id: string, fullName: string | null } | null };

export type GetOrganizationTerritoryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetOrganizationTerritoryQuery = { organization: { __typename?: 'Organization', id: string, name: string, canonical: { __typename?: 'CanonicalOrganization', id: string, displayName: string, slug: string | null, primaryDomain: string | null, externalIds: Array<{ __typename?: 'CanonicalOrganizationExternalId', source: OrgDataSource, externalId: string }>, territories: Array<{ __typename?: 'CanonicalOrganizationTerritory', id: string, commonGridUtilityId: string, commonGridUtilitySlug: string, commonGridUtilityName: string | null, eiaId: string | null, territorySlug: string | null, isPrimary: boolean, source: OrgDataSource, observedAt: string, unlinkedAt: string | null, bbox: { __typename?: 'GeoBoundingBox', west: number, south: number, east: number, north: number } | null, assignedBy: { __typename?: 'User', id: string, fullName: string | null } | null }> } | null } | null };

export type LinkOrganizationToCanonicalOrganizationMutationVariables = Exact<{
  input: LinkOrganizationToCanonicalOrganizationInput;
}>;


export type LinkOrganizationToCanonicalOrganizationMutation = { linkOrganizationToCanonicalOrganization: { __typename?: 'LinkOrganizationToCanonicalOrganizationPayload', outcome: LinkOrganizationToCanonicalOrganizationOutcome, conflictingId: string | null, redirectedFromMergedId: boolean, organization: { __typename?: 'Organization', id: string, canonical: { __typename?: 'CanonicalOrganization', id: string, displayName: string } | null } | null } };

export type AssignCanonicalOrganizationTerritoryMutationVariables = Exact<{
  input: AssignCanonicalOrganizationTerritoryInput;
}>;


export type AssignCanonicalOrganizationTerritoryMutation = { assignCanonicalOrganizationTerritory: { __typename?: 'AssignCanonicalOrganizationTerritoryPayload', outcome: AssignCanonicalOrganizationTerritoryOutcome, geometryStatus: string | null, redirectedFromMergedId: boolean, territory: { __typename?: 'CanonicalOrganizationTerritory', id: string, commonGridUtilityId: string, commonGridUtilitySlug: string, commonGridUtilityName: string | null, eiaId: string | null, territorySlug: string | null, isPrimary: boolean, source: OrgDataSource, observedAt: string, unlinkedAt: string | null, bbox: { __typename?: 'GeoBoundingBox', west: number, south: number, east: number, north: number } | null, assignedBy: { __typename?: 'User', id: string, fullName: string | null } | null } | null } };

export type RevokeCanonicalOrganizationTerritoryMutationVariables = Exact<{
  input: RevokeCanonicalOrganizationTerritoryInput;
}>;


export type RevokeCanonicalOrganizationTerritoryMutation = { revokeCanonicalOrganizationTerritory: { __typename?: 'RevokeCanonicalOrganizationTerritoryPayload', outcome: RevokeCanonicalOrganizationTerritoryOutcome, territory: { __typename?: 'CanonicalOrganizationTerritory', id: string, commonGridUtilityId: string, commonGridUtilitySlug: string, commonGridUtilityName: string | null, eiaId: string | null, territorySlug: string | null, isPrimary: boolean, source: OrgDataSource, observedAt: string, unlinkedAt: string | null, bbox: { __typename?: 'GeoBoundingBox', west: number, south: number, east: number, north: number } | null, assignedBy: { __typename?: 'User', id: string, fullName: string | null } | null } | null, promotedTerritory: { __typename?: 'CanonicalOrganizationTerritory', id: string, commonGridUtilityId: string, commonGridUtilitySlug: string, commonGridUtilityName: string | null, eiaId: string | null, territorySlug: string | null, isPrimary: boolean, source: OrgDataSource, observedAt: string, unlinkedAt: string | null, bbox: { __typename?: 'GeoBoundingBox', west: number, south: number, east: number, north: number } | null, assignedBy: { __typename?: 'User', id: string, fullName: string | null } | null } | null } };

export type GetOrganizationsQueryVariables = Exact<{
  input: OrganizationsInput;
}>;


export type GetOrganizationsQuery = { organizations: { __typename?: 'OrganizationPaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'Organization', id: string, name: string, logo: string | null, domain: string | null, industry: string | null, personal: boolean, createdAt: string, updatedAt: string, memberships: Array<{ __typename?: 'Membership', id: string }> | null, workspaces: Array<{ __typename?: 'Workspace', id: string }> | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasPreviousPage: boolean, hasNextPage: boolean, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null } };

export type GetProgramActivationsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;


export type GetProgramActivationsQuery = { adminWorkspaceProgramsForProgram: Array<{ __typename?: 'WorkspaceProgram', id: string, slug: string, title: string | null, workspaceId: string, organizationId: string, customFields: unknown | null, surfaces: { __typename?: 'ProgramSurfaceCapabilities', version: ProgramSurfaceVersion } }> };

export type GetProgramByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProgramByIdQuery = { adminProgram: { __typename?: 'Program', id: string, name: string, slug: string, description: string | null, states: Array<string>, active: boolean, public: boolean, year: number | null, endDate: string | null, eligibilityCriteria: string | null, programTerms: string | null, createdAt: string, updatedAt: string } | null };

export type GetAllProgramsQueryVariables = Exact<{
  includeInactive: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllProgramsQuery = { adminPrograms: Array<{ __typename?: 'Program', id: string, name: string, slug: string, description: string | null, states: Array<string>, active: boolean, public: boolean, year: number | null, createdAt: string, updatedAt: string }> };

export type SetWorkspaceProgramSurfacesMutationVariables = Exact<{
  input: SetWorkspaceProgramSurfacesInput;
}>;


export type SetWorkspaceProgramSurfacesMutation = { setWorkspaceProgramSurfaces: { __typename?: 'WorkspaceProgram', id: string, slug: string, customFields: unknown | null, surfaces: { __typename?: 'ProgramSurfaceCapabilities', version: ProgramSurfaceVersion } } };

export type UpdateOAuthApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOAuthApplicationInput;
}>;


export type UpdateOAuthApplicationMutation = { updateOAuthApplication: { __typename?: 'OAuthApplication', id: string, clientId: string, name: string, description: string | null, redirectUris: Array<string>, allowedScopes: Array<string>, type: OAuthApplicationType, isFirstParty: boolean, createdAt: string, updatedAt: string } };

export type UpdateProgramMutationVariables = Exact<{
  input: UpdateProgramInput;
}>;


export type UpdateProgramMutation = { updateProgram: { __typename?: 'Program', id: string, name: string, slug: string, description: string | null, states: Array<string>, active: boolean, public: boolean, year: number | null, endDate: string | null, eligibilityCriteria: string | null, programTerms: string | null, createdAt: string, updatedAt: string } };

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = { me: { __typename?: 'LoggedUser', id: string, profile: { __typename?: 'UserProfile', firstName: string | null, lastName: string | null, fullName: string | null, profilePhoto: string | null, preferredTemperatureUnit: PreferredTemperatureUnit | null, preferredTimeZone: string | null }, email: { __typename?: 'Email', email: string, verified: boolean } | null, memberships: Array<{ __typename?: 'Membership', id: string, role: Role, isAdmin: boolean, organization: { __typename?: 'Organization', id: string, name: string, preferredTemperatureUnit: PreferredTemperatureUnit } | null } | null> | null, authenticatedOrganization: { __typename?: 'Organization', id: string, name: string, preferredTemperatureUnit: PreferredTemperatureUnit } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { updateUserProfile: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null, profilePhoto: string | null, preferredTemperatureUnit: PreferredTemperatureUnit | null, preferredTimeZone: string | null } };

export type UpdateUserEmailMutationVariables = Exact<{
  input: UpdateUserEmailInput;
}>;


export type UpdateUserEmailMutation = { updateUserEmail: null | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { changePassword: null | null };

export type ResendVerificationEmailMutationVariables = Exact<{
  input: ResendVerificationEmailInput;
}>;


export type ResendVerificationEmailMutation = { resendVerificationEmail: null | null };

export type GetUserByIdForRecentlyViewedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserByIdForRecentlyViewedQuery = { user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', fullName: string | null, profilePhoto: string | null }, emails: Array<{ __typename?: 'Email', email: string } | null> | null } | null };

export type GetUserSettingsForAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingsForAdminQuery = { userSettings: { __typename?: 'UserSettings', id: string, userId: string, settings: unknown, createdAt: string } | null };

export type UpdateUserSettingsForAdminMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsForAdminMutation = { updateUserSettings: { __typename?: 'UserSettings', id: string, userId: string, settings: unknown, createdAt: string } };

export type SearchCanonicalOrganizationsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type SearchCanonicalOrganizationsQuery = { canonicalOrganizations: { __typename?: 'CanonicalOrganizationConnection', totalCount: number, edges: Array<{ __typename?: 'CanonicalOrganizationEdge', node: { __typename?: 'CanonicalOrganization', id: string, displayName: string, primaryDomain: string | null, externalIds: Array<{ __typename?: 'CanonicalOrganizationExternalId', source: OrgDataSource, externalId: string }>, organization: { __typename?: 'Organization', id: string, name: string } | null } }> } };

export type SearchCommonGridUtilitiesQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCommonGridUtilitiesQuery = { commonGridUtilitySearch: Array<{ __typename?: 'CommonGridUtilityCandidate', id: string, slug: string, name: string, eiaId: string | null, status: string | null, segment: string | null, jurisdiction: string | null, serviceTerritoryId: string | null, customerCount: number | null }> };

export type GetWorkspaceApiKeysQueryVariables = Exact<{
  input: ApiKeysInput;
}>;


export type GetWorkspaceApiKeysQuery = { apiKeys: { __typename?: 'ApiKeyPaginatedQueryPayload', data: Array<{ __typename?: 'ApiKey', id: string, name: string, key: string, type: ApiKeyType, revoked: boolean, createdAt: string, updatedAt: string }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } | null } };

export type GetWorkspaceByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWorkspaceByIdQuery = { workspace: { __typename?: 'Workspace', id: string, name: string, organizationId: string, deletionProtection: boolean, createdAt: string, updatedAt: string, organization: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type GetWorkspaceConnectSessionsQueryVariables = Exact<{
  input: ConnectSessionsInput;
}>;


export type GetWorkspaceConnectSessionsQuery = { connectSessions: { __typename?: 'ConnectSessionsResponse', meta: { __typename?: 'ListPayloadMeta', totalCount: number, totalPages: number, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null, data: Array<{ __typename?: 'ConnectSession', id: string, workspaceId: string, status: ConnectSessionStatus, customerId: string | null, siteId: string | null, manufacturer: string | null, tags: Array<string> | null, createdAt: string, updatedAt: string, expiresAt: string }> } };

export type GetWorkspaceDestinationsQueryVariables = Exact<{
  input: DestinationsInput;
}>;


export type GetWorkspaceDestinationsQuery = { destinations: { __typename?: 'DestinationListPayload', data: Array<{ __typename?: 'Destination', id: string, workspaceId: string, label: string | null, url: string | null, destinationType: DestinationType | null, deviceType: DeviceTypeScope | null, phoneNumber: string | null, email: string | null, eventTypes: Array<EventType>, createdAt: string, updatedAt: string } | null>, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } | null } };

export type GetWorkspaceOAuthApplicationsQueryVariables = Exact<{
  input: OAuthApplicationsInput;
}>;


export type GetWorkspaceOAuthApplicationsQuery = { oauthApplications: { __typename?: 'OAuthApplicationPaginatedQueryPayload', edges: Array<{ __typename?: 'OAuthApplicationEdge', node: { __typename?: 'OAuthApplication', id: string, clientId: string, name: string, description: string | null, redirectUris: Array<string>, allowedScopes: Array<string>, type: OAuthApplicationType, isFirstParty: boolean, createdAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type GetWorkspaceProgramByIdQueryVariables = Exact<{
  input: SlugOrIdInput;
}>;


export type GetWorkspaceProgramByIdQuery = { workspaceProgram: { __typename?: 'WorkspaceProgram', id: string, title: string | null, slug: string, workspaceId: string, program: { __typename?: 'Program', id: string, name: string, slug: string } } | null };

export type GetWorkspaceProgramsQueryVariables = Exact<{
  input: SlugOrIdInput;
}>;


export type GetWorkspaceProgramsQuery = { workspacePrograms: { __typename?: 'WorkspaceProgramPaginatedQueryPayload', data: Array<{ __typename?: 'WorkspaceProgram', id: string, title: string | null, slug: string, description: string | null, url: string, logoUrl: string | null, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: string, name: string, slug: string } }>, meta: { __typename?: 'ListPayloadMeta', totalCount: number } } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { __typename?: 'LoggedUser', id: string, profile: { __typename?: 'UserProfile', fullName: string | null, preferredTemperatureUnit: PreferredTemperatureUnit | null, preferredTimeZone: string | null, profilePhoto: string | null }, email: { __typename?: 'Email', email: string, verified: boolean } | null, memberships: Array<{ __typename?: 'Membership', id: string, role: Role, isAdmin: boolean, organization: { __typename?: 'Organization', id: string, name: string } | null } | null> | null } | null };

export const OrganizationAffiliationFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAffiliationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationAffiliation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<OrganizationAffiliationFieldsFragment, unknown>;
export const AssociationGrantFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssociationGrantFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssociationGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantorWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"grantorWorkspaceName"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceName"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"includesRelatedResources"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<AssociationGrantFieldsFragment, unknown>;
export const OrganizationAssociationFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAssociationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Association"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"otherOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"otherOrganizationName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantsFromUs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssociationGrantFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantsToUs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssociationGrantFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssociationGrantFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssociationGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantorWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"grantorWorkspaceName"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceName"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"includesRelatedResources"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<OrganizationAssociationFieldsFragment, unknown>;
export const ManufacturerAssignmentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ManufacturerAssignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManufacturerAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<ManufacturerAssignmentFieldsFragment, unknown>;
export const CanonicalOrganizationTerritoryFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CanonicalOrganizationTerritoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CanonicalOrganizationTerritory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilityId"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilitySlug"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilityName"}},{"kind":"Field","name":{"kind":"Name","value":"eiaId"}},{"kind":"Field","name":{"kind":"Name","value":"territorySlug"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"observedAt"}},{"kind":"Field","name":{"kind":"Name","value":"unlinkedAt"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"west"}},{"kind":"Field","name":{"kind":"Name","value":"south"}},{"kind":"Field","name":{"kind":"Name","value":"east"}},{"kind":"Field","name":{"kind":"Name","value":"north"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<CanonicalOrganizationTerritoryFieldsFragment, unknown>;
export const GetUsersCountForHomepageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersCountForHomepage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersCountForHomepageQuery, GetUsersCountForHomepageQueryVariables>;
export const GetSuperAdminCountForHomepageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSuperAdminCountForHomepage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuperAdminGrantsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superAdminGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetSuperAdminCountForHomepageQuery, GetSuperAdminCountForHomepageQueryVariables>;
export const UserForDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserForDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"isTextureEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserForDetailQuery, UserForDetailQueryVariables>;
export const SuperAdminGrantsForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuperAdminGrantsForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuperAdminGrantsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superAdminGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"revokedAt"}},{"kind":"Field","name":{"kind":"Name","value":"revokedReason"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"revokedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<SuperAdminGrantsForUserQuery, SuperAdminGrantsForUserQueryVariables>;
export const GrantSuperAdminAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GrantSuperAdminAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSuperAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantSuperAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GrantSuperAdminAccessMutation, GrantSuperAdminAccessMutationVariables>;
export const RevokeSuperAdminAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeSuperAdminAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RevokeSuperAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeSuperAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revokedAt"}}]}}]}}]} as unknown as DocumentNode<RevokeSuperAdminAccessMutation, RevokeSuperAdminAccessMutationVariables>;
export const AllUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"isTextureEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<AllUsersQuery, AllUsersQueryVariables>;
export const GetAffiliatedByOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAffiliatedByOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedByOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetAffiliatedByOrganizationsQuery, GetAffiliatedByOrganizationsQueryVariables>;
export const GetAllOrganizationsForGrowthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllOrganizationsForGrowth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllOrganizationsForGrowthQuery, GetAllOrganizationsForGrowthQueryVariables>;
export const GetRecentUsersForHomepageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecentUsersForHomepage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecentUsersForHomepageQuery, GetRecentUsersForHomepageQueryVariables>;
export const GisLayerSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GisLayerSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspaceGisLayerSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"layer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"activeUploadId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedUpload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"sourceCrs"}}]}}]}}]}}]} as unknown as DocumentNode<GisLayerSettingsQuery, GisLayerSettingsQueryVariables>;
export const RequestGisUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestGisUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GisLayerUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestServiceTerritoryUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"headers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<RequestGisUploadMutation, RequestGisUploadMutationVariables>;
export const ConfirmGisUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmGisUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmGisLayerUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uploadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ConfirmGisUploadMutation, ConfirmGisUploadMutationVariables>;
export const RetryGisUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetryGisUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retryGisLayerUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uploadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<RetryGisUploadMutation, RetryGisUploadMutationVariables>;
export const RemoveGisLayerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveGisLayer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"layerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeWorkspaceGisLayer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"layerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"layerId"}}}]}]}}]} as unknown as DocumentNode<RemoveGisLayerMutation, RemoveGisLayerMutationVariables>;
export const CreateAssociationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssociation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssociationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssociation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationAssociationFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssociationGrantFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssociationGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantorWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"grantorWorkspaceName"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceName"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"includesRelatedResources"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAssociationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Association"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"otherOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"otherOrganizationName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantsFromUs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssociationGrantFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantsToUs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssociationGrantFields"}}]}}]}}]} as unknown as DocumentNode<CreateAssociationMutation, CreateAssociationMutationVariables>;
export const CreateAssociationGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssociationGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssociationGrantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssociationGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceId"}}]}}]}}]} as unknown as DocumentNode<CreateAssociationGrantMutation, CreateAssociationGrantMutationVariables>;
export const CreateOrganizationAffiliationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganizationAffiliation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationAffiliationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganizationAffiliation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationAffiliationFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAffiliationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationAffiliation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<CreateOrganizationAffiliationMutation, CreateOrganizationAffiliationMutationVariables>;
export const EndAssociationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EndAssociation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endAssociation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}]}}]} as unknown as DocumentNode<EndAssociationMutation, EndAssociationMutationVariables>;
export const RelandAssociationGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RelandAssociationGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"landingWorkspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relandAssociationGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"landingWorkspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"landingWorkspaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceName"}}]}}]}}]} as unknown as DocumentNode<RelandAssociationGrantMutation, RelandAssociationGrantMutationVariables>;
export const RemoveOrganizationAffiliationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveOrganizationAffiliation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOrganizationAffiliation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveOrganizationAffiliationMutation, RemoveOrganizationAffiliationMutationVariables>;
export const RevokeAssociationGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeAssociationGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeAssociationGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RevokeAssociationGrantMutation, RevokeAssociationGrantMutationVariables>;
export const UnlandAssociationGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnlandAssociationGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlandAssociationGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceName"}}]}}]}}]} as unknown as DocumentNode<UnlandAssociationGrantMutation, UnlandAssociationGrantMutationVariables>;
export const GetOrganizationAffiliationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationAffiliations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationAffiliationFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAffiliationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationAffiliation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<GetOrganizationAffiliationsQuery, GetOrganizationAffiliationsQueryVariables>;
export const GetOrganizationAssociationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationAssociations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"associations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationAssociationFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssociationGrantFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssociationGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantorWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"grantorWorkspaceName"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"landingWorkspaceName"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"includesRelatedResources"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAssociationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Association"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"otherOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"otherOrganizationName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantsFromUs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssociationGrantFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantsToUs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssociationGrantFields"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationAssociationsQuery, GetOrganizationAssociationsQueryVariables>;
export const PlaceholderQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlaceholderQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<PlaceholderQueryQuery, PlaceholderQueryQueryVariables>;
export const GetAdminCommandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdminCommand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminCommand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"inputSchema"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"input"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"displayModelName"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"vectorIcon"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"executedAt"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgmentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgmentReason"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgmentReceivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"batchId"}}]}}]}}]} as unknown as DocumentNode<GetAdminCommandQuery, GetAdminCommandQueryVariables>;
export const GetAdminDeviceCommandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdminDeviceCommands"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDeviceCommands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"input"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"executedAt"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgmentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgmentReason"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgmentReceivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"batchId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetAdminDeviceCommandsQuery, GetAdminDeviceCommandsQueryVariables>;
export const AdminDeviceByAnyIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDeviceByAnyId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDeviceByAnyId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerDeviceId"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deviceOnWorkspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"displayModelName"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerDeviceId"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"disconnectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"streetOne"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchedVia"}}]}}]}}]} as unknown as DocumentNode<AdminDeviceByAnyIdQuery, AdminDeviceByAnyIdQueryVariables>;
export const GetAdminDeviceStateHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdminDeviceStateHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceOnWorkspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDeviceStateHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceOnWorkspaceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BatteryState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ingestDate"}},{"kind":"Field","name":{"kind":"Name","value":"charge"}},{"kind":"Field","name":{"kind":"Name","value":"chargePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"chargeRate"}},{"kind":"Field","name":{"kind":"Name","value":"chargingState"}},{"kind":"Field","name":{"kind":"Name","value":"backupReserve"}},{"kind":"Field","name":{"kind":"Name","value":"isStormModeActive"}},{"kind":"Field","name":{"kind":"Name","value":"isStormModeEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"strategy"}},{"kind":"Field","name":{"kind":"Name","value":"whConsumed"}},{"kind":"Field","name":{"kind":"Name","value":"gridEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"gridPower"}},{"kind":"Field","name":{"kind":"Name","value":"gridStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChargerState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ingestDate"}},{"kind":"Field","name":{"kind":"Name","value":"chargingState"}},{"kind":"Field","name":{"kind":"Name","value":"isPluggedIn"}},{"kind":"Field","name":{"kind":"Name","value":"chargerCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"chargerVoltage"}},{"kind":"Field","name":{"kind":"Name","value":"chargerWattage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InverterState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ingestDate"}},{"kind":"Field","name":{"kind":"Name","value":"power"}},{"kind":"Field","name":{"kind":"Name","value":"gridEnergy"}},{"kind":"Field","name":{"kind":"Name","value":"gridPower"}},{"kind":"Field","name":{"kind":"Name","value":"gridStatus"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeterState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"phaseAVoltage"}},{"kind":"Field","name":{"kind":"Name","value":"phaseACurrent"}},{"kind":"Field","name":{"kind":"Name","value":"phaseARealPower"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThermostatState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ingestDate"}},{"kind":"Field","name":{"kind":"Name","value":"ambientTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"operatingMode"}},{"kind":"Field","name":{"kind":"Name","value":"coolTarget"}},{"kind":"Field","name":{"kind":"Name","value":"heatTarget"}},{"kind":"Field","name":{"kind":"Name","value":"fanMode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VehicleState"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ingestDate"}},{"kind":"Field","name":{"kind":"Name","value":"charge"}},{"kind":"Field","name":{"kind":"Name","value":"chargePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"chargeCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"chargeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"chargingState"}},{"kind":"Field","name":{"kind":"Name","value":"isPluggedIn"}},{"kind":"Field","name":{"kind":"Name","value":"chargerCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"chargerVoltage"}},{"kind":"Field","name":{"kind":"Name","value":"chargerWattage"}},{"kind":"Field","name":{"kind":"Name","value":"range"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetAdminDeviceStateHistoryQuery, GetAdminDeviceStateHistoryQueryVariables>;
export const AdminCreateInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminCreateInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminCreateInvitationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminCreateInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AdminCreateInvitationMutation, AdminCreateInvitationMutationVariables>;
export const GetAdminWorkspacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdminWorkspaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminWorkspacesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminWorkspaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletionProtection"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetAdminWorkspacesQuery, GetAdminWorkspacesQueryVariables>;
export const AdminAgentEvalRunsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAgentEvalRuns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgentEvalRunsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentEvalRuns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"recordedByUserId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"gitSha"}},{"kind":"Field","name":{"kind":"Name","value":"suiteDir"}},{"kind":"Field","name":{"kind":"Name","value":"agents"}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"}},{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"overallPassRate"}},{"kind":"Field","name":{"kind":"Name","value":"trialCount"}},{"kind":"Field","name":{"kind":"Name","value":"digestJudge"}},{"kind":"Field","name":{"kind":"Name","value":"digestGeneratedAt"}},{"kind":"Field","name":{"kind":"Name","value":"recordedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AdminAgentEvalRunsQuery, AdminAgentEvalRunsQueryVariables>;
export const AdminAgentEvalRunDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAgentEvalRun"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"runId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NonEmptyString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentEvalRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"runId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"runId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"run"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"recordedByUserId"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"gitSha"}},{"kind":"Field","name":{"kind":"Name","value":"suiteDir"}},{"kind":"Field","name":{"kind":"Name","value":"agents"}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"}},{"kind":"Field","name":{"kind":"Name","value":"baseUrl"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}},{"kind":"Field","name":{"kind":"Name","value":"overallPassRate"}},{"kind":"Field","name":{"kind":"Name","value":"trialCount"}},{"kind":"Field","name":{"kind":"Name","value":"digest"}},{"kind":"Field","name":{"kind":"Name","value":"digestJudge"}},{"kind":"Field","name":{"kind":"Name","value":"digestGeneratedAt"}},{"kind":"Field","name":{"kind":"Name","value":"recordedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"taskId"}},{"kind":"Field","name":{"kind":"Name","value":"agent"}},{"kind":"Field","name":{"kind":"Name","value":"workspace"}},{"kind":"Field","name":{"kind":"Name","value":"trial"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"verdicts"}},{"kind":"Field","name":{"kind":"Name","value":"passed"}},{"kind":"Field","name":{"kind":"Name","value":"skipped"}},{"kind":"Field","name":{"kind":"Name","value":"payloadTruncated"}},{"kind":"Field","name":{"kind":"Name","value":"recordedAt"}}]}}]}}]}}]} as unknown as DocumentNode<AdminAgentEvalRunQuery, AdminAgentEvalRunQueryVariables>;
export const AdminAgentSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAgentSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgentSessionsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surface"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"clientConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"routes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"preview"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeCount"}},{"kind":"Field","name":{"kind":"Name","value":"callCount"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"lastError"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastTurnAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AdminAgentSessionsQuery, AdminAgentSessionsQueryVariables>;
export const AdminAgentSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminAgentSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agentSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surface"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"clientConversationId"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"routes"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeCount"}},{"kind":"Field","name":{"kind":"Name","value":"callCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastError"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastTurnAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeSeq"}},{"kind":"Field","name":{"kind":"Name","value":"iteration"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"userText"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"assistantText"}},{"kind":"Field","name":{"kind":"Name","value":"toolResults"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"errorClass"}},{"kind":"Field","name":{"kind":"Name","value":"occurredAt"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"cacheReadTokens"}},{"kind":"Field","name":{"kind":"Name","value":"cacheCreationTokens"}},{"kind":"Field","name":{"kind":"Name","value":"latencyMs"}},{"kind":"Field","name":{"kind":"Name","value":"stopReason"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"payloadTruncated"}}]}}]}}]}}]} as unknown as DocumentNode<AdminAgentSessionQuery, AdminAgentSessionQueryVariables>;
export const GetAllWorkspacesViaOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllWorkspacesViaOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"deletionProtection"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetAllWorkspacesViaOrganizationsQuery, GetAllWorkspacesViaOrganizationsQueryVariables>;
export const CreateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"personal"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreateProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProgramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateProgramMutation, CreateProgramMutationVariables>;
export const CreateDeviceModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDeviceModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDeviceModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDeviceModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerId"}}]}}]}}]} as unknown as DocumentNode<CreateDeviceModelMutation, CreateDeviceModelMutationVariables>;
export const UpdateDeviceModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeviceModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDeviceModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeviceModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerId"}}]}}]}}]} as unknown as DocumentNode<UpdateDeviceModelMutation, UpdateDeviceModelMutationVariables>;
export const DeleteDeviceModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDeviceModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDeviceModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteDeviceModelMutation, DeleteDeviceModelMutationVariables>;
export const GetFieldConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFieldConfigurations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"factKey"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"contexts"}},{"kind":"Field","name":{"kind":"Name","value":"configSchema"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetFieldConfigurationsQuery, GetFieldConfigurationsQueryVariables>;
export const SearchPlatformFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPlatformFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPlatformFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factKey"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<SearchPlatformFieldsQuery, SearchPlatformFieldsQueryVariables>;
export const UpsertFieldConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertFieldConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertFieldConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertFieldConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"factKey"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"contexts"}},{"kind":"Field","name":{"kind":"Name","value":"configSchema"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpsertFieldConfigurationMutation, UpsertFieldConfigurationMutationVariables>;
export const GetManufacturerAssignmentsForOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManufacturerAssignmentsForOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturerAssignmentsForOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ManufacturerAssignmentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ManufacturerAssignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManufacturerAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<GetManufacturerAssignmentsForOrganizationQuery, GetManufacturerAssignmentsForOrganizationQueryVariables>;
export const AssignManufacturerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignManufacturer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"manufacturerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignManufacturer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"manufacturerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"manufacturerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ManufacturerAssignmentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ManufacturerAssignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManufacturerAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<AssignManufacturerMutation, AssignManufacturerMutationVariables>;
export const RevokeManufacturerAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeManufacturerAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeManufacturerAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RevokeManufacturerAssignmentMutation, RevokeManufacturerAssignmentMutationVariables>;
export const GetManufacturerModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManufacturerModels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"models"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerId"}}]}}]}}]} as unknown as DocumentNode<GetManufacturerModelsQuery, GetManufacturerModelsQueryVariables>;
export const CreateDeviceManufacturerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDeviceManufacturer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDeviceManufacturerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDeviceManufacturer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"vectorIcon"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"supportsGridServices"}},{"kind":"Field","name":{"kind":"Name","value":"availableInTextureConnect"}}]}}]}}]} as unknown as DocumentNode<CreateDeviceManufacturerMutation, CreateDeviceManufacturerMutationVariables>;
export const UpdateDeviceManufacturerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeviceManufacturer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDeviceManufacturerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeviceManufacturer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"vectorIcon"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"supportsGridServices"}},{"kind":"Field","name":{"kind":"Name","value":"availableInTextureConnect"}}]}}]}}]} as unknown as DocumentNode<UpdateDeviceManufacturerMutation, UpdateDeviceManufacturerMutationVariables>;
export const DeleteDeviceManufacturerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDeviceManufacturer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDeviceManufacturer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteDeviceManufacturerMutation, DeleteDeviceManufacturerMutationVariables>;
export const GetManufacturersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManufacturers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"vectorIcon"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"supportsGridServices"}},{"kind":"Field","name":{"kind":"Name","value":"availableInTextureConnect"}}]}}]}}]} as unknown as DocumentNode<GetManufacturersQuery, GetManufacturersQueryVariables>;
export const GetOAuthApplicationByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOAuthApplicationById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oauthApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUris"}},{"kind":"Field","name":{"kind":"Name","value":"allowedScopes"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstParty"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetOAuthApplicationByIdQuery, GetOAuthApplicationByIdQueryVariables>;
export const AdminOrgTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminOrgTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"homepage"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}}]}}]}}]} as unknown as DocumentNode<AdminOrgTeamsQuery, AdminOrgTeamsQueryVariables>;
export const AdminApplyTeamTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminApplyTeamTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamTemplateKey"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyTeamTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"templateKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipped"}}]}}]}}]} as unknown as DocumentNode<AdminApplyTeamTemplateMutation, AdminApplyTeamTemplateMutationVariables>;
export const AdminDeleteTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminDeleteTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<AdminDeleteTeamMutation, AdminDeleteTeamMutationVariables>;
export const AdminRenameTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminRenameTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AdminRenameTeamMutation, AdminRenameTeamMutationVariables>;
export const AdminAddTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAddTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addTeamMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"membershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}}]}}]}}]} as unknown as DocumentNode<AdminAddTeamMemberMutation, AdminAddTeamMemberMutationVariables>;
export const AdminRemoveTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminRemoveTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeTeamMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"membershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}}]}]}}]} as unknown as DocumentNode<AdminRemoveTeamMemberMutation, AdminRemoveTeamMemberMutationVariables>;
export const GetOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authenticatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"mfaEmailOtpEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const UpdateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"mfaEmailOtpEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationLocationMutation, UpdateOrganizationLocationMutationVariables>;
export const GetOrganizationByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"personal"}},{"kind":"Field","name":{"kind":"Name","value":"billingId"}},{"kind":"Field","name":{"kind":"Name","value":"mfaEmailOtpEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoProvider"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"enphaseGridServicesOrganizationToken"}},{"kind":"Field","name":{"kind":"Name","value":"auth0OrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"auth0OrganizationName"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"streetOne"}},{"kind":"Field","name":{"kind":"Name","value":"streetTwo"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enabledPacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pack"}},{"kind":"Field","name":{"kind":"Name","value":"enabledAt"}},{"kind":"Field","name":{"kind":"Name","value":"enabledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>;
export const GetOrganizationMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export const EnablePackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnablePack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnablePackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enablePack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pack"}},{"kind":"Field","name":{"kind":"Name","value":"enabledAt"}},{"kind":"Field","name":{"kind":"Name","value":"enabledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<EnablePackMutation, EnablePackMutationVariables>;
export const DisablePackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisablePack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisablePackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disablePack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DisablePackMutation, DisablePackMutationVariables>;
export const GetOrganizationTerritoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTerritory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canonical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"primaryDomain"}},{"kind":"Field","name":{"kind":"Name","value":"externalIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"territories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CanonicalOrganizationTerritoryFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CanonicalOrganizationTerritoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CanonicalOrganizationTerritory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilityId"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilitySlug"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilityName"}},{"kind":"Field","name":{"kind":"Name","value":"eiaId"}},{"kind":"Field","name":{"kind":"Name","value":"territorySlug"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"observedAt"}},{"kind":"Field","name":{"kind":"Name","value":"unlinkedAt"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"west"}},{"kind":"Field","name":{"kind":"Name","value":"south"}},{"kind":"Field","name":{"kind":"Name","value":"east"}},{"kind":"Field","name":{"kind":"Name","value":"north"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationTerritoryQuery, GetOrganizationTerritoryQueryVariables>;
export const LinkOrganizationToCanonicalOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkOrganizationToCanonicalOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LinkOrganizationToCanonicalOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkOrganizationToCanonicalOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingId"}},{"kind":"Field","name":{"kind":"Name","value":"redirectedFromMergedId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canonical"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LinkOrganizationToCanonicalOrganizationMutation, LinkOrganizationToCanonicalOrganizationMutationVariables>;
export const AssignCanonicalOrganizationTerritoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignCanonicalOrganizationTerritory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignCanonicalOrganizationTerritoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignCanonicalOrganizationTerritory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"geometryStatus"}},{"kind":"Field","name":{"kind":"Name","value":"redirectedFromMergedId"}},{"kind":"Field","name":{"kind":"Name","value":"territory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CanonicalOrganizationTerritoryFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CanonicalOrganizationTerritoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CanonicalOrganizationTerritory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilityId"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilitySlug"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilityName"}},{"kind":"Field","name":{"kind":"Name","value":"eiaId"}},{"kind":"Field","name":{"kind":"Name","value":"territorySlug"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"observedAt"}},{"kind":"Field","name":{"kind":"Name","value":"unlinkedAt"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"west"}},{"kind":"Field","name":{"kind":"Name","value":"south"}},{"kind":"Field","name":{"kind":"Name","value":"east"}},{"kind":"Field","name":{"kind":"Name","value":"north"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<AssignCanonicalOrganizationTerritoryMutation, AssignCanonicalOrganizationTerritoryMutationVariables>;
export const RevokeCanonicalOrganizationTerritoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeCanonicalOrganizationTerritory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RevokeCanonicalOrganizationTerritoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeCanonicalOrganizationTerritory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"territory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CanonicalOrganizationTerritoryFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotedTerritory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CanonicalOrganizationTerritoryFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CanonicalOrganizationTerritoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CanonicalOrganizationTerritory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilityId"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilitySlug"}},{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilityName"}},{"kind":"Field","name":{"kind":"Name","value":"eiaId"}},{"kind":"Field","name":{"kind":"Name","value":"territorySlug"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"observedAt"}},{"kind":"Field","name":{"kind":"Name","value":"unlinkedAt"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"west"}},{"kind":"Field","name":{"kind":"Name","value":"south"}},{"kind":"Field","name":{"kind":"Name","value":"east"}},{"kind":"Field","name":{"kind":"Name","value":"north"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<RevokeCanonicalOrganizationTerritoryMutation, RevokeCanonicalOrganizationTerritoryMutationVariables>;
export const GetOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"personal"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetProgramActivationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProgramActivations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminWorkspaceProgramsForProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"surfaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}}]}}]}}]} as unknown as DocumentNode<GetProgramActivationsQuery, GetProgramActivationsQueryVariables>;
export const GetProgramByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProgramById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"states"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eligibilityCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"programTerms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetProgramByIdQuery, GetProgramByIdQueryVariables>;
export const GetAllProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeInactive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminPrograms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeInactive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeInactive"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"states"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAllProgramsQuery, GetAllProgramsQueryVariables>;
export const SetWorkspaceProgramSurfacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetWorkspaceProgramSurfaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetWorkspaceProgramSurfacesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setWorkspaceProgramSurfaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"surfaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"}}]}}]}}]} as unknown as DocumentNode<SetWorkspaceProgramSurfacesMutation, SetWorkspaceProgramSurfacesMutationVariables>;
export const UpdateOAuthApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOAuthApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOAuthApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOAuthApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUris"}},{"kind":"Field","name":{"kind":"Name","value":"allowedScopes"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstParty"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateOAuthApplicationMutation, UpdateOAuthApplicationMutationVariables>;
export const UpdateProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"states"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eligibilityCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"programTerms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateProgramMutation, UpdateProgramMutationVariables>;
export const GetUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTimeZone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authenticatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTimeZone"}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateUserEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendVerificationEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendVerificationEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendVerificationEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const GetUserByIdForRecentlyViewedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserByIdForRecentlyViewed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserByIdForRecentlyViewedQuery, GetUserByIdForRecentlyViewedQueryVariables>;
export const GetUserSettingsForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserSettingsForAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetUserSettingsForAdminQuery, GetUserSettingsForAdminQueryVariables>;
export const UpdateUserSettingsForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettingsForAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<UpdateUserSettingsForAdminMutation, UpdateUserSettingsForAdminMutationVariables>;
export const SearchCanonicalOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchCanonicalOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canonicalOrganizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"EnumValue","value":"DISPLAY_NAME_ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryDomain"}},{"kind":"Field","name":{"kind":"Name","value":"externalIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchCanonicalOrganizationsQuery, SearchCanonicalOrganizationsQueryVariables>;
export const SearchCommonGridUtilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchCommonGridUtilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commonGridUtilitySearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"eiaId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"jurisdiction"}},{"kind":"Field","name":{"kind":"Name","value":"serviceTerritoryId"}},{"kind":"Field","name":{"kind":"Name","value":"customerCount"}}]}}]}}]} as unknown as DocumentNode<SearchCommonGridUtilitiesQuery, SearchCommonGridUtilitiesQueryVariables>;
export const GetWorkspaceApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceApiKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApiKeysInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKeys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"revoked"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceApiKeysQuery, GetWorkspaceApiKeysQueryVariables>;
export const GetWorkspaceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"deletionProtection"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceByIdQuery, GetWorkspaceByIdQueryVariables>;
export const GetWorkspaceConnectSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceConnectSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectSessionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceConnectSessionsQuery, GetWorkspaceConnectSessionsQueryVariables>;
export const GetWorkspaceDestinationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceDestinations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DestinationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destinations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"destinationType"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceDestinationsQuery, GetWorkspaceDestinationsQueryVariables>;
export const GetWorkspaceOAuthApplicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceOAuthApplications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OAuthApplicationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oauthApplications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUris"}},{"kind":"Field","name":{"kind":"Name","value":"allowedScopes"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstParty"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceOAuthApplicationsQuery, GetWorkspaceOAuthApplicationsQueryVariables>;
export const GetWorkspaceProgramByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceProgramById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SlugOrIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspaceProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceProgramByIdQuery, GetWorkspaceProgramByIdQueryVariables>;
export const GetWorkspaceProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspacePrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SlugOrIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspacePrograms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceProgramsQuery, GetWorkspaceProgramsQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTimeZone"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;